import React, { useState, useEffect, useCallback, useMemo, useRef } from "react";
import {
  LayoutDashboard,
  Users,
  UserCheck,
  Briefcase,
  AlertTriangle,
  CreditCard,
  BarChart3,
  Bell,
  Settings,
  Menu,
  X,
  Search,
  ChevronRight,
  TrendingUp,
  TrendingDown,
  Eye,
  EyeOff,
  CheckCircle,
  XCircle,
  Clock,
  Star,
  MapPin,
  Phone,
  Mail,
  Calendar,
  DollarSign,
  FileText,
  Shield,
  LogOut,
  ChevronLeft,
  RefreshCw,
  Send,
  MessageSquare,
  Award,
  AlertCircle,
  Trash2,
  Lock,
  ChevronsLeft,
  ChevronsRight,
  FolderTree,
  Plus,
  Edit3,
  Flag,
  Ban,
  ShieldAlert,
  Timer,
} from "lucide-react";

// Firebase imports
import { auth, db, storage } from "./firebase";
import { ref as storageRef, getDownloadURL } from "firebase/storage";
import { getFunctions, httpsCallable } from "firebase/functions";
import {
  signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
  updatePassword,
  reauthenticateWithCredential,
  EmailAuthProvider,
} from "firebase/auth";
import {
  collection,
  getDoc,
  getDocs,
  setDoc,
  doc,
  onSnapshot,
  updateDoc,
  addDoc,
  deleteDoc,
  deleteField,
  query,
  where,
} from "firebase/firestore";


// ==================== UYGULAMA İKONU ====================
const APP_ICON = "data:image/png;base64,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";
// Production'da console.log'lari sustur
if (process.env.NODE_ENV === "production") {
  console.log = () => {};
}

// ==================== İÇERİK MODERASYONU ORTAK YARDIMCILARI ====================
// Apple Guideline 1.2: şikayet edilen içeriğe 24 saat içinde aksiyon alınmalı.
const SLA_HOURS = 24;
const SLA_MS = SLA_HOURS * 60 * 60 * 1000;
const SLA_WARN_MS = 12 * 60 * 60 * 1000; // 12 saatten sonra turuncu uyarı

// Firestore Timestamp / {seconds} / ISO string / Date — hepsini milisaniyeye çevirir
const toMillis = (value) => {
  if (!value) return 0;
  if (typeof value === "object" && typeof value.toDate === "function") return value.toDate().getTime();
  if (typeof value === "object" && value.seconds) return value.seconds * 1000;
  const t = new Date(value).getTime();
  return isNaN(t) ? 0 : t;
};

// 90000000 -> "1g 1s" gibi kısa yaş metni
const formatDuration = (ms) => {
  if (!ms || ms < 0) return "0dk";
  const mins = Math.floor(ms / 60000);
  const hours = Math.floor(mins / 60);
  const days = Math.floor(hours / 24);
  if (days > 0) return `${days}g ${hours % 24}s`;
  if (hours > 0) return `${hours}s ${mins % 60}dk`;
  return `${mins}dk`;
};

const formatDateTime = (value) => {
  const ms = toMillis(value);
  if (!ms) return "-";
  return new Date(ms).toLocaleString("tr-TR", {
    day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit",
  });
};

// reports.targetType -> içeriğin bulunabileceği koleksiyonlar.
// Cloud Functions'taki REPORT_TARGET_COLLECTIONS ile AYNI olmalı (functions/index.js).
const REPORT_TARGET_COLLECTIONS = {
  job: ["requests", "jobs"],
  review: ["reviews"],
  expert: ["users"],
  message: [], // sohbet içeriği gizlenmez, yalnızca admin incelemesi
};

const REPORT_TARGET_LABELS = {
  job: { label: "İş İlanı", icon: "💼", color: "#2563eb", bg: "#dbeafe" },
  expert: { label: "Uzman Profili", icon: "👨‍🔧", color: "#7c3aed", bg: "#ede9fe" },
  review: { label: "Yorum", icon: "⭐", color: "#d97706", bg: "#fef3c7" },
  message: { label: "Mesaj", icon: "💬", color: "#0891b2", bg: "#cffafe" },
};

const REPORT_REASON_LABELS = {
  harassment: "Taciz / Hakaret",
  inappropriate: "Uygunsuz İçerik",
  spam: "Spam",
  fraud: "Dolandırıcılık",
  other: "Diğer",
};

// ==================== YASAKLI KELİME LİSTESİ ====================
// Uygulamadaki DEFAULT_BANNED_WORDS'ün AYNASI (isinebak2/src/App.js), iki sürüm:
//   1.0.30 ve öncesi: `remoteBannedWords || DEFAULT_BANNED_WORDS` (aşağıdaki 19 kelime);
//     settings/moderation.bannedWords doluysa koddaki listenin YERİNE geçer.
//   1.0.31 ve sonrası: kod listesi TEMEL_BANNED_WORDS (31 kelime); bannedWords koddakine EKLENİR.
//     Sunucu denetimi de (functions/icerikDenetimi.js VARSAYILAN.tamKelimeler) aynı 31 kelimeyle başlar.
// Eski sürümler bu listeyi tek başına kullandığı için bannedWords her zaman temel kelimelerin hepsini içermeli.
const APP_DEFAULT_BANNED_WORDS = [
  "amk", "aq", "oç", "piç", "orospu", "kahpe", "yavşak", "şerefsiz", "godoş",
  "gavat", "sikeyim", "sikerim", "siktir", "amcık", "amına", "yarrak",
  "pezevenk", "ibne", "puşt",
];
const TEMEL_BANNED_WORDS = [
  ...APP_DEFAULT_BANNED_WORDS,
  "porno", "porn", "pornografi", "pornografik", "seks", "sex", "sikiş", "sakso", "fuhuş", "fahişe", "genelev", "onlyfans",
];

// Uygulamanın loadBannedWords'ü ile aynı normalizasyon (tr-TR küçük harf + trim)
const normalizeBannedWord = (w) => String(w || "").toLocaleLowerCase("tr-TR").trim();

// ==================== MODERASYON SONUCU BİLDİRİMLERİ ====================
// GİZLİLİK KURALLARI — metinler bilerek bu şekilde:
//  1) Şikayet edene HANGİ işlemin yapıldığı söylenmez (askıya alma/silme bilgisi
//     verilmez); yalnızca "incelendi ve gerekli işlem yapıldı" denir.
//  2) Şikayet edilene KİMİN şikayet ettiği ASLA bildirilmez — misilleme riski.
//  3) Şikayet edilene contentSnapshot / şikayet açıklaması gösterilmez.
// Bildirim dokümanına da reporterId, reportId, targetId GİBİ hiçbir iz yazılmaz.
const MODERATION_NOTICES = {
  // İçerik kaldırıldı
  removed: {
    reporter: {
      title: "Bildiriminiz İncelendi", icon: "✅", color: "#16a34a",
      message: "Bildiriminiz incelendi. Bildirdiğiniz içerik topluluk kurallarımıza aykırı bulundu ve kaldırıldı. Teşekkür ederiz.",
    },
    target: {
      title: "İçeriğiniz Kaldırıldı", icon: "⚠️", color: "#dc2626",
      message: "Paylaştığınız bir içerik topluluk kurallarımıza aykırı bulunduğu için kaldırıldı. Kurallara uymayan içerik paylaşımının tekrarı halinde hesabınız askıya alınabilir.",
    },
  },
  // Kullanıcı askıya alındı
  suspended: {
    reporter: {
      title: "Bildiriminiz İncelendi", icon: "✅", color: "#16a34a",
      message: "Bildiriminiz incelendi ve gerekli işlem yapıldı. Teşekkür ederiz.",
    },
    // Askıya alınan kullanıcı giriş yapamaz → bildirimi hiç göremez.
    // Askı bilgisi zaten giriş ekranında gösteriliyor.
    target: null,
  },
  // Şikayet reddedildi
  rejected: {
    reporter: {
      title: "Bildiriminiz İncelendi", icon: "ℹ️", color: "#512da8",
      message: "Bildiriminiz incelendi. Yapılan değerlendirme sonucunda içerikte topluluk kurallarımıza aykırı bir durum tespit edilmedi.",
    },
    // Hakkında işlem yapılmayan kullanıcıya haber vermek gereksiz endişe yaratır.
    target: null,
  },
  // Mesaj tipi — yalnızca incelendi olarak işaretlendi
  reviewed: {
    reporter: {
      title: "Bildiriminiz İncelendi", icon: "ℹ️", color: "#512da8",
      message: "Bildiriminiz incelendi. Teşekkür ederiz.",
    },
    target: null,
  },
};

// Bildirimleri kimin alacağına karar verir ve yazdırır.
// Firestore'a doğrudan dokunmaz — bağımlılıklar App içinden enjekte edilir
// (böylece kural değişikliği yapmadan doğrudan test edilebilir).
// GARANTİLER:
//  - notices.target null ise şikayet edilene ASLA yazılmaz
//  - uid yoksa (null) o taraf atlanır
//  - hesabı silinmiş kullanıcıya yazılmaz
//  - bir tarafın hatası diğerini ve ana aksiyonu bloklamaz
const runModerationNotifications = async (report, outcome, { isUserMissing, writeNotification }) => {
  const notices = MODERATION_NOTICES[outcome];
  if (!notices) return { sent: 0, skipped: 0, failed: 0 };
  const plan = [
    ["şikayet eden", notices.reporter, report?.reporterId],
    ["şikayet edilen", notices.target, report?.targetUserId],
  ];
  let sent = 0, skipped = 0, failed = 0;
  for (const [taraf, notice, uid] of plan) {
    if (!uid || !notice) { skipped++; continue; }
    try {
      if (isUserMissing(uid)) { skipped++; continue; }
      await writeNotification(uid, notice);
      sent++;
    } catch (e) {
      failed++;
      console.error(`Moderasyon bildirimi gönderilemedi (${taraf}):`, e);
    }
  }
  return { sent, skipped, failed };
};

// Askıya alınmış mı? Uygulama girişte İKİ alanı da kontrol ediyor
// (suspended === true VE status === "suspended"), panel de ikisini birden kabul eder.
const isSuspended = (u) => !!u && (u.suspended === true || u.status === "suspended");

// ==================== KULLANICI DURUMU (tek kaynak) ====================
// Rozet DE filtre DE bunu kullanır — "rozet Askıda diyor ama Askıda filtresine
// girmiyor" tutarsızlığı bu sayede yapısal olarak imkânsız.
//
// KRİTİK KURAL: status alanının YOKLUĞU askı anlamına GELMEZ.
// Kayıt akışlarının hiçbiri (e-posta, Google, Apple) users dokümanına status
// yazmıyordu; eski panel bu eksikliği "Askıda" diye gösteriyordu. Oysa uygulamanın
// giriş kapısı yalnızca deleted===true / suspended===true / status==="suspended"
// değerlerine bakar (isinebak2/src/App.js) — status'ü olmayan kullanıcı
// uygulamaya SORUNSUZ giriş yapabiliyor. Panel de artık onu aktif sayar.
const getUserState = (u) => {
  if (!u) return "active";
  if (u.deleted === true) return "deleted";
  if (isSuspended(u)) return "suspended";
  // Açık status varsa her zaman o kazanır
  if (u.status === "rejected") return "rejected";
  if (u.status === "active") return "active";
  if (u.status === "pending") return "pending";
  // status alanı hiç yok: uzmanda onay durumuna, müşteride aktife düş.
  // (Geriye dönük düzeltme scripti de aynı kuralı yazacak — ikisi uyumlu.)
  if (u.userType === "expert") return u.verified === true ? "active" : "pending";
  return "active";
};

// ==================== BELGE ONAY SAYAÇLARI ====================
// users listener'ı ağır belge alanlarını (base64 içerik) listeden ATIYOR.
// Bu yüzden sayaçlar, atma işleminden ÖNCE burada türetilir — ek Firestore
// okuması YOKTUR, veri zaten snapshot içinde.
//
// Sayım kuralları UserDetailModal'ın gösterdiği listeyle BİREBİR aynı olmalı,
// yoksa rozet "2 bekliyor" derken modalda 1 belge görünür:
//   - kayıt belgeleri: `documents` VARSA o, yoksa `uploadedDocs` (modal da öyle)
//   - aynı id hem kayıtta hem profilde ise TEK sayılır (profil üstün gelir)
//   - "yüklenmiş" = uploaded / fileData / storagePath (içeriği olan)
//   - documentDeleted (KVKK sonrası silinmiş) SAYILMAZ — incelenecek içerik yok
//   - status yoksa "pending" kabul edilir (modal da öyle yapıyor)
// ==================== TEKLİF HAZIRLIĞI: ANA UYGULAMANIN TEKLİF KAPILARI ====================
// Aşağıdaki iki fonksiyon ana uygulamadaki (isinebak2/src/App.js) mantığın BİREBİR
// kopyasıdır; yorum katılmamıştır. Ana uygulamada değişirse burası da güncellenmeli.
//   - Kimlik kapıları: getKimlikStatus (App.js:21959) + submitProposal kimlik kontrolü (App.js:9926)
//   - Abonelik kapısı: isSubscribed (App.js:68732–68782)
// Kimlik kapıları users dinleyicisinde ağır belge alanları ATILMADAN ÖNCE hesaplanır;
// ek Firestore okuması yoktur.
const teklifKimlikKapisi = (ud) => {
  const docs = ud?.documents || {};
  const kimlikFromDocs = docs["kimlik"] || docs["identity"] || docs["tc_kimlik"];
  // Uygulama `ud?.myDocuments || []` kullanır; dizi olmayan bir değerde uygulama .find'da
  // hata verir. Panelin dinleyicisi çökmesin diye YALNIZCA bu durumda boş dizi alınır.
  const myDocs = Array.isArray(ud?.myDocuments) ? ud.myDocuments : [];
  const kimlikFromMyDocs = myDocs.find(
    (d) =>
      d?.typeId === "kimlik" ||
      d?.id === "kimlik" ||
      d?.typeId === "identity" ||
      d?.id === "identity"
  );
  const kimlikDoc = kimlikFromDocs || kimlikFromMyDocs;
  const anyRejected =
    Object.values(docs).some((d) => d?.status === "rejected") ||
    myDocs.some((d) => d?.status === "rejected");
  return {
    kimlikYuklendi: kimlikDoc !== undefined && kimlikDoc !== null,
    kimlikDurumu: kimlikDoc ? (kimlikDoc.status === undefined ? null : kimlikDoc.status) : null,
    kimlikOnayli: kimlikDoc?.status === "approved",
    reddedilmisBelgeVar: anyRejected,
  };
};

// isSubscribed: premium geçerli YA DA deneme geçerli. Tarihler uygulamadaki gibi
// `new Date(x)` ile okunur (uygulamanın okuyamadığı bir tarihi burada da geçersiz say).
const teklifAbonelikGecerli = (u, now) => {
  const isPremiumValid =
    u.isPremium === true && (!u.premiumEndDate || new Date(u.premiumEndDate) > now);
  const isTrialValid =
    u.trialActive === true && !!u.trialEndDate && new Date(u.trialEndDate) > now;
  return isPremiumValid || isTrialValid;
};

// Görüntüleme için tarih (Timestamp / {seconds} / ISO string)
const teklifTarih = (d) => {
  if (!d) return null;
  if (typeof d === "object" && d.seconds) return new Date(d.seconds * 1000);
  if (typeof d === "object" && typeof d.toDate === "function") return d.toDate();
  const t = new Date(d);
  return isNaN(t.getTime()) ? null : t;
};

const countDocStatuses = (data) => {
  const registrationDocs = (data && (data.documents || data.uploadedDocs)) || {};
  const profileDocs = (data && Array.isArray(data.myDocuments) && data.myDocuments) || [];

  // Modal ile aynı birleştirme: kayıt belgeleri önce, profil belgeleri üzerine yazar
  const birlesik = new Map();
  Object.entries(registrationDocs).forEach(([docId, d]) => {
    if (d && typeof d === "object") birlesik.set(docId, d);
  });
  profileDocs.forEach((d) => {
    if (d && typeof d === "object") birlesik.set(d.id || d.typeId, d);
  });

  let pending = 0;
  let rejected = 0;
  // Bekleyen belgelerin EN ESKİ yükleme anı (ms). Dashboard'daki 48 saat
  // kırmızı kuralı bunu kullanır — belge tarihleri listeden atılan alanların
  // içinde olduğu için başka yerden hesaplanamaz. Ek Firestore okuması yok.
  let oldestPendingAt = 0;
  birlesik.forEach((d) => {
    if (d.documentDeleted === true) return;
    const yuklenmis = d.uploaded === true || !!d.fileData || !!d.storagePath;
    if (!yuklenmis) return;
    const s = d.status || "pending";
    if (s === "rejected") rejected++;
    else if (s !== "approved") {
      pending++;
      // İki ayrı alan adı var: kayıt belgeleri uploadDate, profil myDocuments uploadedAt
      const t = toMillis(d.uploadDate || d.uploadedAt);
      if (t && (oldestPendingAt === 0 || t < oldestPendingAt)) oldestPendingAt = t;
    }
  });
  return { pending, rejected, oldestPendingAt };
};

// ==================== İŞ / TALEP SINIFLARI ====================
// Admin İş İlanları listesi jobs + requests'in birleşimi (_source ile işaretli).
// Ana uygulamada (isinebak2):
//   - jobs     = AÇIK İLAN. Uzmanlar getPendingJobs() ile yalnızca jobs'u görür,
//                submitProposal teklifleri proposals[] dizisine yazar.
//   - requests = belirli BİR uzmana DOĞRUDAN TALEP (createServiceRequest).
//                proposals[] ALMAZ; uzman updateRequestStatus ile tek bir
//                "proposal" nesnesi yazar ve durumu "proposal_sent" yapar.
//   - requests içine requestType:"support_ticket" ile düşmüş destek talepleri
//                olabilir (supportTickets yazılamazsa fallback) — talep sayılmaz.
// "Herkese açık ilan" = jobs koleksiyonu (bir TÜR, durum değil). Eski adı
// isOpenListing'di ve "şu an açık" diye yanlış okunuyordu.
const isPublicListing = (j) => !!j && j._source === "jobs";
// Teklif almış mı: sayaç VEYA dizi — biri eksik/bayat olsa da yakalanır
const hasProposal = (j) =>
  !!j && ((j.proposalCount || 0) > 0 || (Array.isArray(j.proposals) && j.proposals.length > 0));
const CANCELLED_JOB_STATUSES = ["cancelled", "canceled", "iptal"];
// "Teklif alan ilan" oranının paydası: dönemde açılmış TÜM herkese açık ilanlar,
// durumdan bağımsız (kabul edilen / tamamlanan dahil); yalnızca iptaller hariç
const isProposalRateCandidate = (j) =>
  isPublicListing(j) && !CANCELLED_JOB_STATUSES.includes(j.status);
const isNoProposalListing = (j) =>
  isPublicListing(j) && j.status === "pending" && !hasProposal(j);
// Tüm herkese açık ilanlardaki EN YENİ teklif anı (ms) — dönemden bağımsız
const latestProposalAt = (jobs) =>
  (jobs || []).reduce((en, j) => {
    if (!isPublicListing(j) || !Array.isArray(j.proposals)) return en;
    for (const p of j.proposals) {
      const t = toMillis(p && p.createdAt);
      if (t > en) en = t;
    }
    return en;
  }, 0);
const isAwaitingExpertRequest = (j) =>
  !!j && j._source === "requests" && j.requestType !== "support_ticket" && j.status === "pending";

// jobs + requests'te kodun yazdığı/okuduğu TÜM durum değerleri (isinebak2 taraması).
// Tanınmayan bir değer ham haliyle, nötr renkle gösterilir — gizlenmez.
const JOB_STATUS_INFO = {
  pending: { text: "Bekliyor", bg: "#fef3c7", color: "#d97706" },
  open: { text: "Açık", bg: "#fef3c7", color: "#d97706" },
  active: { text: "Aktif", bg: "#dbeafe", color: "#2563eb" },
  proposal_sent: { text: "Teklif Gönderildi", bg: "#ede9fe", color: "#7c3aed" },
  quoted: { text: "Teklif Verildi", bg: "#ede9fe", color: "#7c3aed" },
  accepted: { text: "Kabul Edildi", bg: "#dbeafe", color: "#2563eb" },
  in_progress: { text: "Devam Ediyor", bg: "#dbeafe", color: "#2563eb" },
  pending_completion: { text: "Tamamlanma Onayı Bekliyor", bg: "#e0f2fe", color: "#0369a1" },
  completed: { text: "Tamamlandı", bg: "#dcfce7", color: "#16a34a" },
  rejected: { text: "Reddedildi", bg: "#fee2e2", color: "#dc2626" },
  withdrawn: { text: "Geri Çekildi", bg: "#f3f4f6", color: "#6b7280" },
  cancelled: { text: "İptal", bg: "#fee2e2", color: "#dc2626" },
  canceled: { text: "İptal", bg: "#fee2e2", color: "#dc2626" },
  closed: { text: "Kapatıldı", bg: "#f3f4f6", color: "#6b7280" },
  expired: { text: "Süresi Doldu", bg: "#f3f4f6", color: "#6b7280" },
  // Eski Türkçe ham değerler (functions CLOSED_STATUSES'ta geçiyor)
  tamamlandi: { text: "Tamamlandı", bg: "#dcfce7", color: "#16a34a" },
  "tamamlandı": { text: "Tamamlandı", bg: "#dcfce7", color: "#16a34a" },
  iptal: { text: "İptal", bg: "#fee2e2", color: "#dc2626" },
};
const jobStatusInfo = (s) =>
  JOB_STATUS_INFO[s] || { text: s ? String(s) : "Durum yok", bg: "#f1f5f9", color: "#64748b" };

// ==================== DASHBOARD DÖNEM HESAPLARI ====================
// Eski calculatePercentageChange takvim ayını geçen takvim ayıyla kıyaslıyordu:
// ayın 12'sinde 12 günlük sayı 30 günlük sayıyla karşılaştırılıyordu ve ekranda
// hangi döneme kıyaslandığı hiç yazmıyordu. Burada kıyas HER ZAMAN "önceki eşit
// uzunluktaki dönem" ile yapılır ve etiket kullanıcıya gösterilir.
const PERIODS = [
  { id: "today", label: "Bugün", gun: 1, kiyasEtiket: "önceki güne göre" },
  { id: "7d", label: "7 gün", gun: 7, kiyasEtiket: "önceki 7 güne göre" },
  { id: "30d", label: "30 gün", gun: 30, kiyasEtiket: "önceki 30 güne göre" },
];

const periodRange = (periodId) => {
  const p = PERIODS.find((x) => x.id === periodId) || PERIODS[1];
  const end = Date.now();
  const uzunluk = p.gun * 24 * 60 * 60 * 1000;
  const start = end - uzunluk;
  return { start, end, prevStart: start - uzunluk, prevEnd: start, label: p.kiyasEtiket, gun: p.gun };
};

// [start, end) aralığında kaç kayıt oluşmuş
const countInRange = (items, start, end, dateField = "createdAt") =>
  (items || []).reduce((n, item) => {
    const t = toMillis(item && item[dateField]);
    return t >= start && t < end ? n + 1 : n;
  }, 0);

// Önceki dönem 0 ise yüzde anlamsız — "yeni" denir, uydurma %100 yazılmaz
const deltaOf = (current, previous) => {
  if (previous === 0) {
    if (current > 0) return { kind: "new", text: "yeni" };
    return { kind: "flat", text: "" };
  }
  const pct = ((current - previous) / previous) * 100;
  const yuvarlak = Math.abs(pct) >= 10 ? Math.round(pct) : parseFloat(pct.toFixed(1));
  return { kind: pct >= 0 ? "up" : "down", text: `${Math.abs(yuvarlak)}%` };
};

// Sanal işlem: iOS'ta satın alma eklentisinin uygulama makbuzu için ürettiği
// işlem (transactionId "appstore.application"). Uygulama bunu gerçek satın alma
// sanıp hem payments'a hem kullanıcı belgesine yazdı; para girmedi.
const SANAL_ISLEM = { transactionId: "appstore.application", productId: "com.isebakapp.app" };

// TEK kaynak: payments kaydı ve kullanıcı belgesi için aynı kural — iki yere de
// handleApprovedTransaction aynı googlePlay* alanlarını yazıyor.
// Kullanıcıda sonradan elle premium verilmişse (admin_granted) alanlar eski
// kalır ama premium artık o kaynaktandır → geçersiz sayılmaz.
// Firestore'a yazılmaz; yalnızca gelir/sayı/abone hesaplarından çıkarılır.
const isGecersizOdeme = (p) =>
  !!p &&
  p.googlePlayTransactionId === SANAL_ISLEM.transactionId &&
  p.googlePlayProductId === SANAL_ISLEM.productId &&
  p.plan !== "admin_granted" &&
  p.premiumPlan !== "admin_granted";

// Aktif premiumlardan tahmini BRÜT aylık gelir.
// admin_granted HARİÇ (para girmedi). Aylıkta premiumPrice, yıllıkta /12.
// premiumPrice yoksa 0 sayılır ve ayrıca sayılır — sessizce eksik hesaplamayız.
// Sanal işlemle premium yazılmış hesaplar hiçbir kovaya girmez, ayrıca sayılır.
const premiumRevenueEstimate = (experts) => {
  let aylik = 0, yillik = 0, diger = 0, tahminiAylikGelir = 0, fiyatiOlmayan = 0, gecersiz = 0;
  (experts || []).forEach((e) => {
    if (getPremiumState(e) !== "active") return;
    if (isGecersizOdeme(e)) { gecersiz++; return; }
    const plan = e.premiumPlan;
    if (plan === "admin_granted") { diger++; return; }
    const fiyat = Number(e.premiumPrice) || 0;
    if (plan === "yearly") {
      yillik++;
      if (fiyat > 0) tahminiAylikGelir += fiyat / 12; else fiyatiOlmayan++;
    } else {
      aylik++; // plan yoksa aylık varsayılır (Premium Yönetimi de öyle etiketliyor)
      if (fiyat > 0) tahminiAylikGelir += fiyat; else fiyatiOlmayan++;
    }
  });
  return { aylik, yillik, adminVerilen: diger, tahminiAylikGelir: Math.round(tahminiAylikGelir), fiyatiOlmayan, gecersiz };
};

// ==================== TEST HESABI TANIMI (tek yer) ====================
// Sunucudaki isinebak2/functions/testTanimi.js'in aynası. Yalnızca admin'e açık getTestDefinition fonksiyonu yayına
// çıkınca liste oradan gelir (PanelVeriSaglayici); çıkana kadar ya da okunamazsa bu kopya kullanılır.
//   kesin test: admins üyesi (uid ya da e-posta), testAccounts işaretli uid (yalnızca sunucu listesinde), test e-postası/deseni
//   olası test: e-postanın yerel kısmında ya da adda demo / test / review / deneme.
//     "apple" BİLEREK yok: Apple girişindeki privaterelay.appleid.com adresleri yanlış eşleşirdi.
// Olası test de varsayılan olarak analizlerden, gelirden ve "test hariç" listelerden HARİÇ tutulur.
const PANEL_TEST_TANIMI = {
  kaynak: "panel",
  epostalar: ["saitklc94@gmail.com", "titanyazilimbilisim@gmail.com"],
  desenler: [/^saitklc94\+[^@]*@/i], // "+" içeren saitklc94 adresleri (saitklc94+test@gmail.com …)
  olasiDesen: /(^|[^a-z])(demo|test|review|deneme)([^a-z]|$)/i,
  uidler: new Set(),
};
// admin: { uids:Set, emails:Set, tanim } (PanelVeriSaglayici). Dönüş: "test" (kesin) | "olasi" | null
const testDurumu = ({ uid, email, ad } = {}, admin = null) => {
  const tanim = (admin && admin.tanim) || PANEL_TEST_TANIMI;
  const e = String(email || "").trim().toLowerCase();
  if (uid && ((admin && admin.uids && admin.uids.has(uid)) || tanim.uidler.has(uid))) return "test";
  if (e && ((admin && admin.emails && admin.emails.has(e)) || tanim.epostalar.includes(e) || tanim.desenler.some((re) => re.test(e)))) return "test";
  const yerel = e.split("@")[0];
  const adlar = (Array.isArray(ad) ? ad : [ad]).filter((x) => typeof x === "string" && x.trim());
  if ((yerel && tanim.olasiDesen.test(yerel)) || adlar.some((a) => tanim.olasiDesen.test(a))) return "olasi";
  return null;
};
// Kesin ya da olası test (analizlerde ikisi de varsayılan olarak hariç)
const testHesabiMi = (uid, email, admin, ad) => testDurumu({ uid, email, ad }, admin) !== null;
// resolveUser ile: kullanıcının test durumu (silinmiş hesapta yalnızca uid ve varsa ad bakılır)
const kullaniciTestDurumu = (uid, resolveUser, admin, ekAd = null) => {
  if (!uid) return null;
  const r = resolveUser ? resolveUser(uid) : null;
  const raw = (r && r.raw) || {};
  return testDurumu({ uid, email: (r && r.email) || raw.email, ad: [raw.name, raw.displayName, ekAd] }, admin);
};
// getTestDefinition yanıtı → tanım. Alan adları sunucu modülündekilerle (TEST_EPOSTALARI …) ya da camelCase
// karşılıklarıyla gelebilir; desenler RegExp kaynağı ("^saitklc94\\+…", "/…/i" ya da { source, flags }).
// Geçersizse null (panel kopyası kullanılır).
const testTaniminiCoz = (d) => {
  if (!d || typeof d !== "object") return null;
  const ilk = (...a) => a.find((x) => x !== undefined && x !== null);
  const desen = (x) => {
    try {
      if (x instanceof RegExp) return x;
      if (typeof x === "string") {
        const m = x.match(/^\/(.*)\/([a-z]*)$/);
        return m ? new RegExp(m[1], m[2]) : new RegExp(x, "i");
      }
      if (x && typeof (x.source ?? x.kaynak) === "string") return new RegExp(x.source ?? x.kaynak, x.flags ?? x.bayrak ?? "i");
    } catch (e) { /* geçersiz desen atlanır */ }
    return null;
  };
  const epostalar = ilk(d.testEpostalari, d.TEST_EPOSTALARI, d.epostalar);
  if (!Array.isArray(epostalar)) return null;
  const dizi = (x) => (Array.isArray(x) ? x : []);
  const kucuk = (l) => dizi(l).map((e) => String(e || "").trim().toLowerCase()).filter(Boolean);
  return {
    kaynak: "sunucu",
    epostalar: kucuk(epostalar),
    desenler: dizi(ilk(d.testEpostaDesenleri, d.TEST_EPOSTA_DESENLERI, d.desenler)).map(desen).filter(Boolean),
    olasiDesen: desen(ilk(d.olasiTestDeseni, d.OLASI_TEST_DESENI, d.olasiDesen)) || PANEL_TEST_TANIMI.olasiDesen,
    uidler: new Set(dizi(ilk(d.testUidleri, d.testAccounts, d.uidler)).filter((u) => typeof u === "string" && u)),
    adminUidleri: dizi(ilk(d.adminUidleri, d.adminUids)).filter((u) => typeof u === "string" && u),
    adminEpostalari: kucuk(ilk(d.adminEpostalari, d.adminEmails)),
  };
};

// ==================== ÖDEME SINIFLANDIRMASI (gerçek gelir) ====================
// Sunucu her kayda isTest, testNedeni, hesapSilinmis yazar (isinebak2/functions/odemeSiniflandirma.js; classifyNewPayment,
// markTestPayments). Gerçek gelir: isTest !== true. isTest alanı OLMAYAN kayıt ("işaretsiz") aynı kuralların panel kopyasıyla
// değerlendirilir ve ayrıca "işaretsiz" diye gösterilir; hesap bilgisi bellekteki kullanıcılardan (silinmiş hesabın e-postası
// bilinmez). Sınıflar ve sırası sunucudakiyle aynı (ilk uyan).
const ODEME_SINIF_AD = {
  sanal_islem: "Sanal işlem", admin_verdi: "Elle verilen", tutar_sifir: "Tutar 0", eski_kart_formu: "Eski kart formu",
  test_hesabi: "Test hesabı", silinmis_test_hesabi: "Silinmiş test hesabı", olasi_test: "Olası test",
  silinmis_hesap: "Silinmiş hesap", gercek: "Gerçek",
};
// Para girmeyen kayıtlar ("geçersiz"); kalan test sınıfları "test"
const ODEME_GECERSIZ_SINIFLARI = ["sanal_islem", "admin_verdi", "tutar_sifir", "eski_kart_formu"];
const odemeTutari = (v) => {
  const n = typeof v === "number" ? v : Number(String(v ?? "").replace(",", "."));
  return Number.isFinite(n) && n > 0 ? n : 0;
};
// Dönüş: { sinif, test, gecersiz, isaretli, hesapSilinmis, tutar, t }
const odemeSinifla = (p, resolveUser, admin) => {
  const tutar = odemeTutari(p && p.amount);
  const t = toMillis(p && p.createdAt);
  if (p && typeof p.isTest === "boolean") {
    const sinif = p.isTest ? (p.testNedeni || "test_hesabi") : p.hesapSilinmis === true ? "silinmis_hesap" : "gercek";
    return { sinif, test: p.isTest, gecersiz: p.isTest && ODEME_GECERSIZ_SINIFLARI.includes(sinif), isaretli: true, hesapSilinmis: p.hesapSilinmis === true, tutar, t };
  }
  const v = p || {};
  let sinif;
  let hesapSilinmis = false;
  if (v.googlePlayTransactionId === SANAL_ISLEM.transactionId) sinif = "sanal_islem";
  else if (v.plan === "admin_granted" || v.premiumPlan === "admin_granted" || v.grantedBy === "admin") sinif = "admin_verdi";
  else if (tutar === 0) sinif = "tutar_sifir";
  else if (v.cardLast4 !== undefined && v.cardLast4 !== null && !v.source) sinif = "eski_kart_formu";
  else {
    const r = v.userId && resolveUser ? resolveUser(v.userId) : null;
    hesapSilinmis = !!(r && (r.missing || r.deleted));
    const durum = v.userId ? testDurumu({ uid: v.userId, email: r && !hesapSilinmis ? (r.email || (r.raw && r.raw.email)) : "", ad: [r && r.raw && r.raw.name, v.userName] }, admin) : null;
    if (hesapSilinmis) sinif = durum ? "silinmis_test_hesabi" : "silinmis_hesap";
    else sinif = durum === "test" ? "test_hesabi" : durum === "olasi" ? "olasi_test" : "gercek";
  }
  const test = !["gercek", "silinmis_hesap"].includes(sinif);
  return { sinif, test, gecersiz: ODEME_GECERSIZ_SINIFLARI.includes(sinif), isaretli: false, hesapSilinmis, tutar, t };
};
// Sınıflanmış ödemelerin özeti: gerçek gelir (test hariç) ve sayılar
const odemeOzeti = (liste) => {
  const o = { gelir: 0, islem: 0, testDahilGelir: 0, testDahilIslem: 0, test: 0, testTutar: 0, gecersiz: 0, isaretsiz: 0, silinmis: 0 };
  for (const x of liste) {
    o.testDahilIslem++;
    o.testDahilGelir += x.s.tutar;
    if (!x.s.isaretli) o.isaretsiz++;
    if (x.s.hesapSilinmis) o.silinmis++;
    if (x.s.gecersiz) o.gecersiz++;
    else if (x.s.test) { o.test++; o.testTutar += x.s.tutar; }
    else { o.islem++; o.gelir += x.s.tutar; }
  }
  return o;
};
const paraYaz = (n) => `₺${(Math.round((Number(n) || 0) * 100) / 100).toLocaleString("tr-TR")}`;

// Giriş yapılınca bir kez yüklenen ortak veri: yönetici listesi, test tanımı, ödeme kayıtları
const PanelVeriBaglami = React.createContext(null);
const PANEL_VERI_YEDEK = { admin: { uids: new Set(), emails: new Set(), tanim: PANEL_TEST_TANIMI }, adminOkuma: "bekliyor", tanimDurum: "panel", odemeler: [], odemeDurum: "bekliyor", odemeleriYukle: () => {} };
const usePanelVeri = () => React.useContext(PanelVeriBaglami) || PANEL_VERI_YEDEK;

const USER_STATE_LABELS = {
  deleted: { text: "Silindi", bg: "#f3f4f6", color: "#6b7280" },
  suspended: { text: "Askıda", bg: "#fee2e2", color: "#dc2626" },
  rejected: { text: "Reddedildi", bg: "#fee2e2", color: "#dc2626" },
  pending: { text: "Bekliyor", bg: "#fef3c7", color: "#d97706" },
  active: { text: "Aktif", bg: "#dcfce7", color: "#16a34a" },
};

// ==================== PREMIUM DURUMU (tek kaynak) ====================
// getUserState ile aynı kalıp: rozet DE sayaçlar DA sekmeler DE butonlar DA
// bunu kullanır, böylece "rozet Aktif diyor ama tarihi geçmiş" olamaz.
//
// KRİTİK KURAL: premiumExpired SAKLANAN bir bayrak ve yalnızca kullanıcı
// uygulamaya giriş yaptığında güncelleniyor (isinebak2 onAuthStateChanged).
// Giriş yapmayan kullanıcıda bayrak bayat kalıyor — bu yüzden bayrağın YANINDA
// premiumEndDate de kontrol edilir. Tarih geçmişse bayrak ne derse desin "expired".
// Kullanıcının HİÇ premium'u oldu mu? premiumStartDate/premiumEndDate yalnızca
// premium verildiğinde/satın alındığında yazılır — gerçek "premium geçmişi" kanıtı
// bunlardır. premiumExpired/premiumCancelled bayrakları ise elle (Firebase Console)
// veya yanlışlıkla set edilmiş olabilir; TEK BAŞINA premium geçmişi sayılmaz.
// Aksi halde yalnızca deneme kullanmış bir kullanıcı "Süresi Doldu" görünür.
const hasPremiumHistory = (u) =>
  !!u && (u.isPremium === true || !!u.premiumStartDate || !!u.premiumEndDate);

const getPremiumState = (u) => {
  if (!u) return "none";
  // 1) Premium geçmişi yoksa premium dallarına hiç girme — trial dallarına düşsün
  if (!hasPremiumHistory(u)) return "none";
  // 2) İptal açık bir karardır, tarihten önce gelir
  if (u.premiumCancelled === true) return "cancelled";
  // 3-4) TARİH BAYRAKTAN ÖNCELİKLİDİR.
  // premiumEndDate varsa karar TAMAMEN tarihe göre verilir; premiumExpired ve
  // isPremium bayraklarına BAKILMAZ. Sebep: bu bayraklar yalnızca kullanıcı
  // uygulamaya girdiğinde güncelleniyor, bayat kalabiliyorlar. Bayat bir
  // premiumExpired:true, geçerli bir aboneliği "süresi dolmuş" gösteriyordu.
  const end = u.premiumEndDate ? toMillis(u.premiumEndDate) : 0;
  if (end) return end > Date.now() ? "active" : "expired";
  // 5) Tarih yok (veya okunamıyor) → ancak o zaman bayraklara güven
  if (u.premiumExpired === true) return "expired";
  if (u.isPremium !== true) return "expired";
  return "active"; // süresiz premium
};

const PREMIUM_STATE_LABELS = {
  active: { text: "Aktif", bg: "#dcfce7", color: "#16a34a" },
  expired: { text: "Süresi Doldu", bg: "#f3f4f6", color: "#6b7280" },
  cancelled: { text: "İptal Edildi", bg: "#fef3c7", color: "#d97706" },
  none: { text: "Premium Değil", bg: "#f1f5f9", color: "#94a3b8" },
};

const REPORT_STATUS_BADGES = {
  pending: { bg: "#fee2e2", color: "#dc2626", text: "Bekliyor" },
  reviewed: { bg: "#fef3c7", color: "#d97706", text: "İncelendi" },
  removed: { bg: "#dcfce7", color: "#16a34a", text: "Kaldırıldı" },
  rejected: { bg: "#f3f4f6", color: "#6b7280", text: "Reddedildi" },
};

// ==================== USER AVATAR COMPONENT ====================
const UserAvatar = ({ user, size = 40, borderRadius = "10px", fontSize = null }) => {
  const photo = user?.photo || user?.photoURL || user?.profileImage || user?.avatar || null;
  const name = user?.name || user?.displayName || "?";
  const isExpert = user?.userType === "expert";
  const computedFontSize = fontSize || (size > 50 ? "28px" : size > 36 ? "16px" : "14px");

  if (photo) {
    return (
      <img
        src={photo}
        alt={name}
        style={{
          width: `${size}px`,
          height: `${size}px`,
          borderRadius: borderRadius,
          objectFit: "cover",
          flexShrink: 0,
        }}
        onError={(e) => {
          // Fotoğraf yüklenemezse baş harf göster
          e.target.style.display = "none";
          e.target.nextSibling.style.display = "flex";
        }}
      />
    );
  }

  return (
    <div
      style={{
        width: `${size}px`,
        height: `${size}px`,
        background: isExpert ? "#fef3c7" : "#e0e7ff",
        borderRadius: borderRadius,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: "700",
        fontSize: computedFontSize,
        color: isExpert ? "#d97706" : "#4f46e5",
        flexShrink: 0,
      }}
    >
      {name[0].toUpperCase()}
    </div>
  );
};

// Fotoğraf + fallback wrapper (img hata verdiğinde fallback göster)
const UserAvatarWithFallback = ({ user, size = 40, borderRadius = "10px", fontSize = null }) => {
  const photo = user?.photo || user?.photoURL || user?.profileImage || user?.avatar || null;
  const name = user?.name || user?.displayName || "?";
  const isExpert = user?.userType === "expert";
  const computedFontSize = fontSize || (size > 50 ? "28px" : size > 36 ? "16px" : "14px");

  const fallbackStyle = {
    width: `${size}px`,
    height: `${size}px`,
    background: isExpert ? "#fef3c7" : "#e0e7ff",
    borderRadius: borderRadius,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontWeight: "700",
    fontSize: computedFontSize,
    color: isExpert ? "#d97706" : "#4f46e5",
    flexShrink: 0,
  };

  if (!photo) {
    return <div style={fallbackStyle}>{name[0].toUpperCase()}</div>;
  }

  return (
    <div style={{ position: "relative", width: `${size}px`, height: `${size}px`, flexShrink: 0 }}>
      <img
        src={photo}
        alt={name}
        style={{
          width: `${size}px`,
          height: `${size}px`,
          borderRadius: borderRadius,
          objectFit: "cover",
        }}
        onError={(e) => {
          e.target.parentElement.innerHTML = `<div style="width:${size}px;height:${size}px;background:${isExpert ? '#fef3c7' : '#e0e7ff'};border-radius:${borderRadius};display:flex;align-items:center;justify-content:center;font-weight:700;font-size:${computedFontSize};color:${isExpert ? '#d97706' : '#4f46e5'}">${name[0].toUpperCase()}</div>`;
        }}
      />
    </div>
  );
};

// ==================== PAGINATION HOOK ====================
const usePagination = (items, itemsPerPage = 10) => {
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(items.length / itemsPerPage);

  useEffect(() => {
    setCurrentPage(1);
  }, [items.length]);

  const paginatedItems = useMemo(() => {
    const start = (currentPage - 1) * itemsPerPage;
    return items.slice(start, start + itemsPerPage);
  }, [items, currentPage, itemsPerPage]);

  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) setCurrentPage(page);
  };

  return {
    currentPage,
    totalPages,
    paginatedItems,
    goToPage,
    totalItems: items.length,
    startIndex: (currentPage - 1) * itemsPerPage + 1,
    endIndex: Math.min(currentPage * itemsPerPage, items.length),
  };
};

// ==================== PAGINATION COMPONENT ====================
const PaginationBar = ({ currentPage, totalPages, goToPage, totalItems, startIndex, endIndex }) => {
  if (totalPages <= 1) return null;

  const getPageNumbers = () => {
    const pages = [];
    const maxVisible = 5;
    let start = Math.max(1, currentPage - Math.floor(maxVisible / 2));
    let end = Math.min(totalPages, start + maxVisible - 1);
    if (end - start + 1 < maxVisible) start = Math.max(1, end - maxVisible + 1);
    for (let i = start; i <= end; i++) pages.push(i);
    return pages;
  };

  const btnBase = {
    padding: "8px 12px",
    border: "1px solid #e2e8f0",
    borderRadius: "8px",
    fontSize: "13px",
    cursor: "pointer",
    background: "white",
    color: "#64748b",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: "36px",
    height: "36px",
  };

  return (
    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "16px 20px", borderTop: "1px solid #f1f5f9", flexWrap: "wrap", gap: "12px" }}>
      <span style={{ fontSize: "13px", color: "#64748b" }}>
        {totalItems} kayıttan {startIndex}-{endIndex} arası gösteriliyor
      </span>
      <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
        <button onClick={() => goToPage(1)} disabled={currentPage === 1}
          style={{ ...btnBase, opacity: currentPage === 1 ? 0.4 : 1, cursor: currentPage === 1 ? "not-allowed" : "pointer" }}>
          <ChevronsLeft size={16} />
        </button>
        <button onClick={() => goToPage(currentPage - 1)} disabled={currentPage === 1}
          style={{ ...btnBase, opacity: currentPage === 1 ? 0.4 : 1, cursor: currentPage === 1 ? "not-allowed" : "pointer" }}>
          <ChevronLeft size={16} />
        </button>
        {getPageNumbers().map((page) => (
          <button key={page} onClick={() => goToPage(page)}
            style={{ ...btnBase, background: currentPage === page ? "#1e1b4b" : "white", color: currentPage === page ? "white" : "#64748b", fontWeight: currentPage === page ? "600" : "400", borderColor: currentPage === page ? "#1e1b4b" : "#e2e8f0" }}>
            {page}
          </button>
        ))}
        <button onClick={() => goToPage(currentPage + 1)} disabled={currentPage === totalPages}
          style={{ ...btnBase, opacity: currentPage === totalPages ? 0.4 : 1, cursor: currentPage === totalPages ? "not-allowed" : "pointer" }}>
          <ChevronRight size={16} />
        </button>
        <button onClick={() => goToPage(totalPages)} disabled={currentPage === totalPages}
          style={{ ...btnBase, opacity: currentPage === totalPages ? 0.4 : 1, cursor: currentPage === totalPages ? "not-allowed" : "pointer" }}>
          <ChevronsRight size={16} />
        </button>
      </div>
    </div>
  );
};

// ==================== USER DETAIL MODAL ====================
// ==================== BİREYSEL BİLDİRİM (tek kullanıcıya) ====================
// Uygulama bildirimleri YALNIZCA kök notifications koleksiyonundan okur (where userId ==,
// orderBy createdAt). sendPushOnNewNotification (isinebak2/functions/index.js) aynı belgenin
// oluşmasıyla tetiklenir: users/{userId}.fcmToken'a title + message gönderir.
// Belge biçimi sunucudaki createServerNotification ile aynı (+ sentBy).
//
// Kural kısıtı (firestore.rules, değiştirilmedi): kök notifications'ı yalnızca sahibi
// okuyabilir; panel gönderdiğini geri okuyamaz. Bu yüzden aynı kimlikle bir kopya
// users/{uid}/notifications/{id}'ye yazılır (orayı admin okuyabilir) — liste o kopyadan gelir.
// Kopyada okundu / push durumu güncellenmez (onlar kök belgede).
const BIREYSEL_BILDIRIM_TURU = "admin_message";
const BILDIRIM_BASLIK_SINIRI = 80;
const BILDIRIM_METIN_SINIRI = 500;
// sendPushOnNewNotification'daki temizlik ile aynı karakter kümesi (push'ta görünecek hâl).
// "-" sınıfın sonunda: anlam aynı, kaçış gerekmez.
const PUSH_BASLIK_DISI = /[^\w\sğüşıöçĞÜŞİÖÇ.,!?:;'"()—–🎉🚀💬⭐⏳✅❌📢🔔💰📋🏆-]/gu;
const PUSH_METIN_DISI = /[^\w\sğüşıöçĞÜŞİÖÇ.,!?:;'"()—–-]/gu;
const PUSH_METIN_SINIRI = 200;
const pushOnizleme = (baslik, metin) => ({
  baslik: (baslik || "İşine Bak").replace(PUSH_BASLIK_DISI, "").trim(),
  metin: (metin || "").replace(PUSH_METIN_DISI, "").substring(0, PUSH_METIN_SINIRI),
});
// Push'ta silinecek işaretler (ör. & / % @ #) ve 200 karakter sınırı
const pushUyarilari = (baslik, metin) => {
  const silinen = (s, re) => [...new Set((String(s || "").match(re) || []).filter((c) => c.trim()))];
  const temizMetin = String(metin || "").replace(PUSH_METIN_DISI, "");
  return {
    baslikSilinen: silinen(baslik, PUSH_BASLIK_DISI),
    metinSilinen: silinen(metin, PUSH_METIN_DISI),
    metinUzunlugu: temizMetin.length,
    kesilir: temizMetin.length > PUSH_METIN_SINIRI,
  };
};
// Uygulama içi kart + push (sunucunun karakter temizliğinden sonraki hâl) + uyarılar
const PushOnizlemeKutusu = ({ baslik, metin }) => {
  const push = pushOnizleme(baslik, metin);
  const u = pushUyarilari(baslik, metin);
  const isaretler = [...new Set([...u.baslikSilinen, ...u.metinSilinen])];
  const uyari = { fontSize: "12px", color: "#92400e", background: "#fffbeb", border: "1px solid #fde68a", borderRadius: "8px", padding: "7px 10px", margin: "0 0 6px" };
  return (
    <>
      <p style={{ fontSize: "12px", fontWeight: "600", color: "#64748b", margin: "0 0 6px" }}>Önizleme</p>
      <div style={{ display: "flex", gap: "10px", alignItems: "flex-start", border: "1px solid #ede9fe", background: "#faf5ff", borderRadius: "12px", padding: "12px", marginBottom: "8px" }}>
        <div style={{ fontSize: "22px", lineHeight: 1 }}>📢</div>
        <div style={{ minWidth: 0 }}>
          <p style={{ margin: 0, fontSize: "14px", fontWeight: "700", color: "#512da8", wordBreak: "break-word" }}>{baslik || "Başlık"}</p>
          <p style={{ margin: "2px 0 0", fontSize: "13px", color: "#334155", whiteSpace: "pre-wrap", wordBreak: "break-word" }}>{metin || "Metin"}</p>
          <p style={{ margin: "4px 0 0", fontSize: "11px", color: "#94a3b8" }}>Uygulamada · Şimdi</p>
        </div>
      </div>
      <div style={{ border: "1px solid #e2e8f0", background: "#f8fafc", borderRadius: "12px", padding: "10px 12px", marginBottom: "6px" }}>
        <p style={{ margin: 0, display: "flex", justifyContent: "space-between", fontSize: "11px", color: "#94a3b8" }}>
          <span>Push</span>
          <span style={{ color: u.kesilir ? "#dc2626" : "#94a3b8" }}>{Math.min(u.metinUzunlugu, PUSH_METIN_SINIRI)}/{PUSH_METIN_SINIRI}</span>
        </p>
        <p style={{ margin: "2px 0 0", fontSize: "13px", fontWeight: "600", color: "#1e293b", wordBreak: "break-word" }}>{push.baslik || "İşine Bak"}</p>
        <p style={{ margin: "2px 0 0", fontSize: "12px", color: "#475569", whiteSpace: "pre-wrap", wordBreak: "break-word" }}>{push.metin}</p>
      </div>
      {isaretler.length > 0 && (
        <p style={uyari}>
          Push'ta silinecek işaretler: <strong style={{ fontFamily: "monospace", letterSpacing: "2px" }}>{isaretler.join(" ")}</strong>. Bu işaretleri kullanmayın
          (ör. "&" yerine "ve", "%" yerine "yüzde"); uygulama içinde metin olduğu gibi görünür.
        </p>
      )}
      {u.kesilir && (
        <p style={{ ...uyari, color: "#991b1b", background: "#fef2f2", borderColor: "#fecaca" }}>
          Metin push'ta {PUSH_METIN_SINIRI} karakterde kesilecek (şu an {u.metinUzunlugu}). Önemli kısmı başa yazın ya da kısaltın.
        </p>
      )}
    </>
  );
};

// Bir kullanıcıya daha önce gönderilmiş bireysel bildirimler (panel kopyası, yeniden eskiye)
const bireyselBildirimleriOku = async (uid) => {
  const snap = await getDocs(query(collection(db, "users", uid, "notifications"), where("type", "==", BIREYSEL_BILDIRIM_TURU)));
  return snap.docs
    .map((d) => ({ id: d.id, uid, ...d.data() }))
    .sort((a, b) => toMillis(b.createdAt) - toMillis(a.createdAt));
};

const BireyselBildirimModal = ({ user, onClose }) => {
  const [baslik, setBaslik] = useState("");
  const [metin, setMetin] = useState("");
  const [gonderiliyor, setGonderiliyor] = useState(false);
  const [sonuc, setSonuc] = useState(null); // { ok, id, uyari } | { ok: false, hata }
  const [gecmis, setGecmis] = useState({ durum: "yukleniyor", liste: [] });
  const ad = user.name || user.displayName || user.email || user.id;

  // Bu kullanıcıya önceki bireysel gönderimler (tek sorgu; mükerrer göndermemek için)
  useEffect(() => {
    let iptal = false;
    bireyselBildirimleriOku(user.id)
      .then((liste) => { if (!iptal) setGecmis({ durum: "tamam", liste }); })
      .catch((e) => { console.error("Bireysel bildirim geçmişi okunamadı:", e); if (!iptal) setGecmis({ durum: "hata", liste: [] }); });
    return () => { iptal = true; };
  }, [user.id]);

  const b = baslik.trim();
  const m = metin.trim();
  const gecerli = b.length > 0 && m.length > 0 && b.length <= BILDIRIM_BASLIK_SINIRI && m.length <= BILDIRIM_METIN_SINIRI;

  const gonder = async () => {
    if (!gecerli || gonderiliyor || (sonuc && sonuc.ok)) return;
    if (!window.confirm(`"${ad}" kullanıcısına bildirim gönderilecek.\n\n${b}\n${m}\n\nPush hemen gider; geri alınamaz.`)) return;
    setGonderiliyor(true);
    const veri = {
      userId: user.id,
      type: BIREYSEL_BILDIRIM_TURU,
      icon: "📢",
      title: b,
      message: m,
      read: false,
      actionable: false,
      color: "#512da8",
      data: {},
      createdAt: new Date().toISOString(),
      sentBy: (auth.currentUser && auth.currentUser.uid) || null,
    };
    try {
      const ref = await addDoc(collection(db, "notifications"), veri);
      let uyari = null;
      try {
        await setDoc(doc(db, "users", user.id, "notifications", ref.id), { ...veri, notificationId: ref.id });
      } catch (e) {
        console.error("Panel kopyası yazılamadı:", e);
        uyari = "Bildirim gönderildi ama panel kaydı yazılamadı; Bireysel gönderimler listesinde görünmeyecek.";
      }
      setSonuc({ ok: true, id: ref.id, uyari });
      setGecmis((g) => ({ ...g, liste: [{ id: ref.id, uid: user.id, ...veri }, ...g.liste] }));
    } catch (e) {
      console.error("Bireysel bildirim gönderilemedi:", e);
      setSonuc({ ok: false, hata: `${(e && e.code) || "hata"} · ${(e && e.message) || String(e)}` });
    } finally {
      setGonderiliyor(false);
    }
  };

  const alan = { width: "100%", padding: "10px 12px", border: "1px solid #e2e8f0", borderRadius: "10px", fontSize: "14px", outline: "none", boxSizing: "border-box", fontFamily: "inherit" };
  const sayac = (n, sinir) => <span style={{ fontSize: "11px", color: n > sinir ? "#dc2626" : "#94a3b8" }}>{n}/{sinir}</span>;

  return (
    <div onClick={(e) => { e.stopPropagation(); onClose(); }} style={{ position: "fixed", inset: 0, background: "rgba(15,23,42,0.55)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1100, padding: "16px" }}>
      <div onClick={(e) => e.stopPropagation()} style={{ background: "white", borderRadius: "16px", width: "100%", maxWidth: "520px", maxHeight: "90vh", overflowY: "auto", padding: "24px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "12px" }}>
          <div>
            <h3 style={{ margin: 0, fontSize: "17px", fontWeight: "700", color: "#1e293b" }}>Bildirim gönder</h3>
            <p style={{ margin: "2px 0 0", fontSize: "13px", color: "#64748b" }}>{ad}{user.userType ? ` · ${user.userType === "expert" ? "Uzman" : "Müşteri"}` : ""}</p>
          </div>
          <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", padding: "4px" }}><X size={20} color="#64748b" /></button>
        </div>

        {!user.fcmToken && (
          <p style={{ fontSize: "12px", color: "#b45309", background: "#fffbeb", border: "1px solid #fde68a", borderRadius: "8px", padding: "8px 10px", margin: "0 0 10px" }}>
            Bu kullanıcının push anahtarı (fcmToken) yok: push gitmez, bildirim yalnızca uygulamanın içinde görünür.
          </p>
        )}
        {isSuspended(user) && (
          <p style={{ fontSize: "12px", color: "#b91c1c", background: "#fef2f2", border: "1px solid #fecaca", borderRadius: "8px", padding: "8px 10px", margin: "0 0 10px" }}>
            Hesap askıda: kullanıcı uygulamaya giriş yapamıyor; push yine gidebilir.
          </p>
        )}

        <label style={{ display: "flex", justifyContent: "space-between", fontSize: "13px", fontWeight: "600", color: "#1e293b", marginBottom: "4px" }}>Başlık {sayac(b.length, BILDIRIM_BASLIK_SINIRI)}</label>
        <input value={baslik} onChange={(e) => setBaslik(e.target.value)} disabled={gonderiliyor || (sonuc && sonuc.ok)} style={{ ...alan, marginBottom: "10px" }} placeholder="Ör. Belgeniz hakkında" />
        <label style={{ display: "flex", justifyContent: "space-between", fontSize: "13px", fontWeight: "600", color: "#1e293b", marginBottom: "4px" }}>Metin {sayac(m.length, BILDIRIM_METIN_SINIRI)}</label>
        <textarea value={metin} onChange={(e) => setMetin(e.target.value)} disabled={gonderiliyor || (sonuc && sonuc.ok)} rows={4} style={{ ...alan, resize: "vertical", marginBottom: "12px" }} placeholder="Kullanıcının göreceği mesaj" />

        <PushOnizlemeKutusu baslik={b} metin={m} />

        {sonuc && sonuc.ok && (
          <p style={{ fontSize: "13px", color: "#15803d", background: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: "8px", padding: "8px 10px", margin: "8px 0" }}>
            Gönderildi (bildirim {sonuc.id}).{sonuc.uyari && <span style={{ display: "block", color: "#b45309", marginTop: "4px" }}>{sonuc.uyari}</span>}
          </p>
        )}
        {sonuc && !sonuc.ok && (
          <p style={{ fontSize: "13px", color: "#991b1b", background: "#fef2f2", border: "1px solid #fecaca", borderRadius: "8px", padding: "8px 10px", margin: "8px 0" }}>Gönderilemedi: {sonuc.hata}</p>
        )}

        <div style={{ display: "flex", gap: "10px", marginTop: "12px" }}>
          <button onClick={gonder} disabled={!gecerli || gonderiliyor || (sonuc && sonuc.ok)}
            style={{ flex: 1, padding: "12px", background: !gecerli || gonderiliyor || (sonuc && sonuc.ok) ? "#cbd5e1" : "#512da8", color: "white", border: "none", borderRadius: "10px", fontSize: "14px", fontWeight: "600", cursor: !gecerli || gonderiliyor || (sonuc && sonuc.ok) ? "default" : "pointer", display: "flex", alignItems: "center", justifyContent: "center", gap: "6px" }}>
            <Send size={16} /> {gonderiliyor ? "Gönderiliyor…" : sonuc && sonuc.ok ? "Gönderildi" : "Gönder"}
          </button>
          <button onClick={onClose} style={{ flex: 1, padding: "12px", background: "#f1f5f9", color: "#64748b", border: "none", borderRadius: "10px", fontSize: "14px", fontWeight: "600", cursor: "pointer" }}>Kapat</button>
        </div>

        <div style={{ marginTop: "16px", borderTop: "1px solid #f1f5f9", paddingTop: "12px" }}>
          <p style={{ fontSize: "12px", fontWeight: "600", color: "#64748b", margin: "0 0 6px" }}>Bu kullanıcıya önceki bireysel bildirimler</p>
          {gecmis.durum === "yukleniyor" && <p style={{ fontSize: "12px", color: "#94a3b8", margin: 0 }}>Yükleniyor…</p>}
          {gecmis.durum === "hata" && <p style={{ fontSize: "12px", color: "#dc2626", margin: 0 }}>Okunamadı.</p>}
          {gecmis.durum === "tamam" && gecmis.liste.length === 0 && <p style={{ fontSize: "12px", color: "#94a3b8", margin: 0 }}>Yok.</p>}
          {gecmis.liste.slice(0, 10).map((n) => (
            <div key={n.id} style={{ fontSize: "12px", color: "#334155", padding: "6px 0", borderBottom: "1px solid #f8fafc" }}>
              <span style={{ color: "#94a3b8" }}>{formatDateTime(n.createdAt)}</span> · <strong>{n.title}</strong> — {String(n.message || "").slice(0, 120)}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const UserDetailModal = ({ user, onClose, onToggleSuspend, userType, jobs = [] }) => {
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [updatingDoc, setUpdatingDoc] = useState(null);
  const [fullUserData, setFullUserData] = useState(null);
  const [loadingDocs, setLoadingDocs] = useState(false);
  // Storage'daki belgeler icin cozulmus indirme URL'leri: { storagePath: url }
  const [docUrls, setDocUrls] = useState({});
  const [bildirimAcik, setBildirimAcik] = useState(false);

  // Kullanıcının tam verisini (belgeler dahil) Firestore'dan çek
  useEffect(() => {
    if (!user?.id) return;
    const fetchFullData = async () => {
      setLoadingDocs(true);
      try {
        const userDoc = await getDoc(doc(db, "users", user.id));
        if (userDoc.exists()) {
          setFullUserData({ id: userDoc.id, ...userDoc.data() });
        }
      } catch (e) {
        console.error("Kullanıcı detay çekme hatası:", e);
      } finally {
        setLoadingDocs(false);
      }
    };
    fetchFullData();
  }, [user?.id]);

  // GERİ UYUMLU BELGE GÖRÜNTÜLEME (hook'lar koşulsuz olmalı — erken return'den ÖNCE):
  //  - Eski kayıtlar: fileData (base64) doğrudan gösterilir
  //  - Yeni kayıtlar: storagePath -> getDownloadURL ile çözülür
  // Admin, storage.rules'taki admins/{uid} kontrolü sayesinde okuyabilir.
  const storagePathsKey = useMemo(() => {
    const src = fullUserData || {};
    const fromRegistration = Object.values(src.documents || src.uploadedDocs || {});
    const fromProfile = src.myDocuments || [];
    return [...fromRegistration, ...fromProfile]
      .map((d) => d && d.storagePath)
      .filter(Boolean)
      .join("|");
  }, [fullUserData]);

  useEffect(() => {
    const paths = storagePathsKey ? storagePathsKey.split("|") : [];
    if (paths.length === 0) return;
    let cancelled = false;
    (async () => {
      const resolved = {};
      for (const path of paths) {
        try {
          resolved[path] = await getDownloadURL(storageRef(storage, path));
        } catch (e) {
          console.error("Belge URL alinamadi:", path, e);
          resolved[path] = null; // hata: arayüzde görsel boş kalır
        }
      }
      if (!cancelled) setDocUrls((prev) => ({ ...prev, ...resolved }));
    })();
    return () => { cancelled = true; };
  }, [storagePathsKey]);

  // Bir belgenin gösterilecek kaynağı (eski base64 veya çözülmüş Storage URL'i)
  const getDocSrc = (d) => d?.fileData || (d?.storagePath ? docUrls[d.storagePath] : null);

  if (!user) return null;

  // Tam veri yüklendiyse onu kullan, yoksa hafif veriyi kullan
  const userData = fullUserData || user;

  const isExpert = userType === "expert";

  // Uzmanın tamamladığı işleri hesapla
  const completedJobs = jobs.filter(j => 
    (j.expertId === user.id || j.assignedExpertId === user.id || j.acceptedExpertId === user.id) && 
    j.status === "completed"
  );
  
  const completedJobsCount = completedJobs.length;
  
  // Toplam kazancı hesapla
  const totalEarnings = completedJobs.reduce((sum, job) => {
    let rawAmount = job.agreedPrice || job.acceptedPrice || job.proposal?.price || job.finalPrice || job.budget || job.price || 0;
    let amount = 0;
    if (typeof rawAmount === 'string') {
      const match = rawAmount.match(/\d+/);
      amount = match ? parseInt(match[0], 10) : 0;
    } else {
      amount = Number(rawAmount) || 0;
    }
    return sum + amount;
  }, 0);

  // Hizmetleri al
  const services = user.categories || user.services || user.subCategories || [];

  // Belgeleri al - hem documents hem myDocuments alanlarını birleştir
  const registrationDocs = userData.documents || userData.uploadedDocs || {};
  const profileDocs = userData.myDocuments || [];
  
  // Registration docs'u listeye çevir
  const registrationDocList = Object.entries(registrationDocs).map(([docId, docData]) => ({
    id: docId,
    source: 'registration', // Kayıt sırasında yüklenen
    ...docData
  }));
  
  // Profile docs'u ekle (myDocuments array formatında)
  const profileDocList = profileDocs.map(docData => ({
    id: docData.id || docData.typeId,
    source: 'profile', // Profil üzerinden yüklenen
    fileName: docData.fileName,
    fileType: docData.fileType,
    fileData: docData.fileData,   // ESKİ kayıtlar (base64) — geçiş bitince kalkacak
    storagePath: docData.storagePath, // YENİ kayıtlar (Storage yolu)
    documentDeleted: docData.documentDeleted, // KVKK gereği silinmiş
    deletedAt: docData.deletedAt,
    status: docData.status || 'pending',
    uploadDate: docData.uploadedAt ? new Date(docData.uploadedAt).toLocaleDateString('tr-TR') : null,
    uploaded: true,
    typeName: docData.typeName,
  }));
  
  // Birleştir (aynı ID'li belgeler varsa profile doc'u tercih et - daha güncel)
  const allDocsMap = new Map();
  registrationDocList.forEach(doc => allDocsMap.set(doc.id, doc));
  profileDocList.forEach(doc => allDocsMap.set(doc.id, doc)); // Üzerine yazar
  const documentList = Array.from(allDocsMap.values()).filter(d => d.uploaded || d.fileData || d.storagePath || d.documentDeleted);



  // Belge durumunu güncelle
  const handleDocumentStatus = async (docId, newStatus) => {
    setUpdatingDoc(docId);
    try {
      const userRef = doc(db, "users", user.id);
      
      // Belgenin hangi alanda olduğunu bul
      const docInfo = allDocsMap.get(docId);
      const isProfileDoc = docInfo?.source === 'profile';
      
      if (isProfileDoc) {
        // myDocuments array'ini güncelle
        const updatedMyDocs = (userData.myDocuments || []).map(d => {
          if (d.id === docId || d.typeId === docId) {
            return { ...d, status: newStatus, reviewedAt: new Date().toISOString(), reviewedBy: "admin" };
          }
          return d;
        });
        await updateDoc(userRef, { myDocuments: updatedMyDocs });
      } else {
        // documents objesini güncelle
        const docPath = userData.documents ? "documents" : "uploadedDocs";
        await updateDoc(userRef, {
          [`${docPath}.${docId}.status`]: newStatus,
          [`${docPath}.${docId}.reviewedAt`]: new Date().toISOString(),
          [`${docPath}.${docId}.reviewedBy`]: "admin"
        });
      }
      alert(newStatus === "approved" ? "Belge onaylandı!" : "Belge reddedildi!");
      // Modal'ı kapat ve listeyi yenile
      onClose();
    } catch (error) {
      console.error("Belge durumu güncellenirken hata:", error);
      alert("Bir hata oluştu!");
    } finally {
      setUpdatingDoc(null);
    }
  };

  // Belge adını Türkçeleştir
  const getDocumentName = (docId, docData = null) => {
    // Eğer typeName varsa onu kullan (myDocuments'tan gelen)
    if (docData?.typeName) return docData.typeName;
    
    const names = {
      "identity": "Kimlik Fotokopisi",
      "criminal_record": "Adli Sicil Kaydı",
      "bio_certificate": "Biyosidal Ürün Sertifikası",
      "trade_certificate": "Esnaf Sicil Belgesi",
      "diploma": "Diploma/Sertifika",
      "insurance": "Sigorta Belgesi",
      // Türkçe ID'ler
      "kimlik": "Kimlik Fotokopisi",
      "adli_sicil": "Adli Sicil Kaydı",
      "biyosidal": "Biyosidal Ürün Sertifikası",
      "ustalik": "Ustalık Belgesi",
      "ehliyet": "Ehliyet",
      "src": "SRC Belgesi",
      "isletme_ruhsati": "İşletme Ruhsatı",
      "vergi_levhasi": "Vergi Levhası",
      "yetki_belgesi": "Yetki Belgesi",
      "sigorta": "Sigorta Poliçesi",
      "ogretmenlik_sertifikasi": "Öğretmenlik Sertifikası",
      "dil_belgesi": "Dil Yeterlilik Belgesi",
      "egitmenlik_sertifikasi": "Eğitmenlik Sertifikası",
    };
    return names[docId] || docId;
  };

  // Belge durum rengi
  const getStatusColor = (status) => {
    switch(status) {
      case "approved": return { bg: "#dcfce7", color: "#16a34a", text: "Onaylandı" };
      case "rejected": return { bg: "#fee2e2", color: "#dc2626", text: "Reddedildi" };
      default: return { bg: "#fef3c7", color: "#d97706", text: "İnceleme Bekliyor" };
    }
  };

  return (
    <div style={{ position: "fixed", inset: 0, zIndex: 100, display: "flex", alignItems: "center", justifyContent: "center", padding: "20px" }}>
      <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", backdropFilter: "blur(4px)" }} onClick={onClose} />
      <div style={{ position: "relative", background: "white", borderRadius: "20px", width: "100%", maxWidth: "600px", maxHeight: "90vh", overflowY: "auto", boxShadow: "0 25px 60px rgba(0,0,0,0.3)" }}>
        {/* Header */}
        <div style={{ padding: "24px", borderBottom: "1px solid #f1f5f9", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <h2 style={{ fontSize: "18px", fontWeight: "700", color: "#1e293b", margin: 0 }}>Kullanıcı Detayı</h2>
          <button onClick={onClose} style={{ background: "#f1f5f9", border: "none", borderRadius: "10px", padding: "8px", cursor: "pointer" }}>
            <X size={20} color="#64748b" />
          </button>
        </div>

        {/* Profile */}
        <div style={{ padding: "24px" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "16px", marginBottom: "24px" }}>
            <UserAvatarWithFallback user={user} size={72} borderRadius="16px" fontSize="28px" />
            <div>
              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <h3 style={{ fontSize: "20px", fontWeight: "700", color: "#1e293b", margin: 0 }}>
                  {user.name || user.displayName || "İsimsiz"}
                </h3>
                {user.verified && <CheckCircle size={18} color="#16a34a" />}
                {/* Yıldız yalnızca gerçekten aktif premiumda (ham bayrak bayat kalabiliyor) */}
                {getPremiumState(userData) === "active" && <Star size={18} color="#d97706" fill="#d97706" />}
              </div>
              {/* Listelerle AYNI getUserState kaynağı — burada hâlâ ham user.status
                  okunuyordu ve status alanı olmayan kullanıcı "Askıda" görünüyordu. */}
              <span style={{ display: "inline-block", marginTop: "6px", padding: "4px 12px", borderRadius: "20px", fontSize: "12px", fontWeight: "600",
                background: USER_STATE_LABELS[getUserState(userData)].bg,
                color: USER_STATE_LABELS[getUserState(userData)].color
              }}>
                {USER_STATE_LABELS[getUserState(userData)].text}
              </span>
            </div>
          </div>

          {/* Silinmiş Hesap Uyarısı */}
          {userData.deleted && (
            <div style={{ padding: "14px 16px", background: "#fef2f2", borderRadius: "12px", marginBottom: "20px", border: "1px solid #fecaca" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <Trash2 size={18} color="#dc2626" />
                <div>
                  <p style={{ fontSize: "14px", fontWeight: "600", color: "#991b1b", margin: "0 0 2px 0" }}>Bu hesap kullanıcı tarafından silindi</p>
                  <p style={{ fontSize: "12px", color: "#b91c1c", margin: 0 }}>
                    Silinme tarihi: {userData.deletedAt ? new Date(userData.deletedAt).toLocaleString("tr-TR") : "Bilinmiyor"}
                    {userData.deletionReason === "user_requested" && " • Kullanıcı talebi"}
                  </p>
                </div>
              </div>
            </div>
          )}

          {/* Info Grid */}
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "16px", marginBottom: "24px" }}>
            {[
              { icon: Mail, label: "E-posta", value: user.email || "-" },
              { icon: Phone, label: "Telefon", value: user.phone || "-" },
              { icon: MapPin, label: "Konum", value: `${user.city || "-"}, ${user.district || "-"}` },
              { icon: Calendar, label: "Kayıt Tarihi", value: user.createdAt ? new Date(typeof user.createdAt === "object" && user.createdAt.seconds ? user.createdAt.seconds * 1000 : user.createdAt).toLocaleDateString("tr-TR") : "-" },
            ].map((item, i) => (
              <div key={i} style={{ padding: "14px", background: "#f8fafc", borderRadius: "12px" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "6px" }}>
                  <item.icon size={16} color="#94a3b8" />
                  <span style={{ fontSize: "12px", color: "#94a3b8", fontWeight: "500" }}>{item.label}</span>
                </div>
                <p style={{ fontSize: "14px", fontWeight: "600", color: "#1e293b", margin: 0, wordBreak: "break-all" }}>{item.value}</p>
              </div>
            ))}
          </div>

          {/* Expert-specific */}
          {isExpert && (
            <>
              <div style={{ marginBottom: "20px" }}>
                <h4 style={{ fontSize: "14px", fontWeight: "600", color: "#1e293b", margin: "0 0 10px 0" }}>Hizmetler</h4>
                <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
                  {services.length > 0 ? services.map((s, i) => (
                    <span key={i} style={{ padding: "6px 12px", background: "#e0e7ff", borderRadius: "8px", fontSize: "13px", color: "#4f46e5", fontWeight: "500" }}>{typeof s === 'string' ? s : s?.name || s?.title || s}</span>
                  )) : <span style={{ fontSize: "14px", color: "#94a3b8" }}>Hizmet belirtilmemiş</span>}
                </div>
              </div>

              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "12px", marginBottom: "20px" }}>
                <div style={{ padding: "16px", background: "#fef3c7", borderRadius: "12px", textAlign: "center" }}>
                  <Star size={20} color="#f59e0b" style={{ marginBottom: "6px" }} />
                  <p style={{ fontSize: "20px", fontWeight: "700", color: "#1e293b", margin: "0 0 2px 0" }}>{user.rating || "-"}</p>
                  <p style={{ fontSize: "12px", color: "#64748b", margin: 0 }}>Puan</p>
                </div>
                <div style={{ padding: "16px", background: "#dcfce7", borderRadius: "12px", textAlign: "center" }}>
                  <CheckCircle size={20} color="#16a34a" style={{ marginBottom: "6px" }} />
                  <p style={{ fontSize: "20px", fontWeight: "700", color: "#1e293b", margin: "0 0 2px 0" }}>{completedJobsCount}</p>
                  <p style={{ fontSize: "12px", color: "#64748b", margin: 0 }}>Tamamlanan İş</p>
                </div>
                <div style={{ padding: "16px", background: "#dbeafe", borderRadius: "12px", textAlign: "center" }}>
                  <DollarSign size={20} color="#3b82f6" style={{ marginBottom: "6px" }} />
                  <p style={{ fontSize: "20px", fontWeight: "700", color: "#1e293b", margin: "0 0 2px 0" }}>₺{totalEarnings.toLocaleString()}</p>
                  <p style={{ fontSize: "12px", color: "#64748b", margin: 0 }}>Toplam Kazanç</p>
                </div>
              </div>

              {/* Belgeler Bölümü */}
              <div style={{ marginBottom: "20px" }}>
                <h4 style={{ fontSize: "14px", fontWeight: "600", color: "#1e293b", margin: "0 0 12px 0", display: "flex", alignItems: "center", gap: "8px" }}>
                  <FileText size={16} color="#6366f1" />
                  Yüklenen Belgeler
                  {documentList.length > 0 && (
                    <span style={{ padding: "2px 8px", background: "#e0e7ff", borderRadius: "10px", fontSize: "12px", color: "#4f46e5" }}>
                      {documentList.length} belge
                    </span>
                  )}
                </h4>
                
                {loadingDocs ? (
                  <div style={{ padding: "24px", textAlign: "center", color: "#94a3b8" }}>
                    <RefreshCw size={20} style={{ animation: "spin 1s linear infinite", marginBottom: "8px" }} />
                    <p style={{ fontSize: "13px", margin: 0 }}>Belgeler yükleniyor...</p>
                  </div>
                ) : documentList.length > 0 ? (
                  <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                    {documentList.map((docItem) => {
                      const statusInfo = getStatusColor(docItem.status);
                      return (
                        <div key={docItem.id} style={{ 
                          padding: "14px", 
                          background: "#f8fafc", 
                          borderRadius: "12px",
                          border: "1px solid #e2e8f0"
                        }}>
                          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "10px" }}>
                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                              <div style={{ 
                                width: "40px", 
                                height: "40px", 
                                background: docItem.fileType?.includes("pdf") ? "#fef3c7" : "#dbeafe",
                                borderRadius: "10px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center"
                              }}>
                                <FileText size={20} color={docItem.fileType?.includes("pdf") ? "#d97706" : "#3b82f6"} />
                              </div>
                              <div>
                                <p style={{ fontSize: "14px", fontWeight: "600", color: "#1e293b", margin: 0 }}>
                                  {getDocumentName(docItem.id, docItem)}
                                </p>
                                <p style={{ fontSize: "12px", color: "#64748b", margin: "2px 0 0 0" }}>
                                  {docItem.fileName || "Belge"} • {docItem.uploadDate || "Tarih yok"}
                                </p>
                              </div>
                            </div>
                            <span style={{ 
                              padding: "4px 10px", 
                              background: statusInfo.bg, 
                              color: statusInfo.color,
                              borderRadius: "8px",
                              fontSize: "12px",
                              fontWeight: "600"
                            }}>
                              {statusInfo.text}
                            </span>
                          </div>

                          {/* Belge Önizleme — eski base64 VEYA Storage URL'i */}
                          {/* KVKK gereği silinmiş belge: dosya yok, doğrulama izi var */}
                          {docItem.documentDeleted &&
                            !docItem.storagePath &&
                            !docItem.fileData && (
                              <div
                                style={{
                                  marginBottom: "10px",
                                  padding: "12px",
                                  background: "#f0fdf4",
                                  border: "1px solid #bbf7d0",
                                  borderRadius: "8px",
                                  fontSize: "12px",
                                  color: "#166534",
                                  lineHeight: "1.5",
                                }}
                              >
                                ✓ Doğrulandı — belge KVKK gereği silindi
                                {docItem.deletedAt
                                  ? " (" +
                                    new Date(docItem.deletedAt).toLocaleDateString("tr-TR") +
                                    ")"
                                  : ""}
                              </div>
                            )}

                          {(docItem.fileData || docItem.storagePath) && (
                            <div style={{ marginBottom: "10px" }}>
                              {docItem.fileType?.startsWith("image/") ? (
                                <img 
                                  src={getDocSrc(docItem) || ""} 
                                  alt={docItem.fileName}
                                  onClick={() => setSelectedDoc(docItem)}
                                  style={{ 
                                    width: "100%", 
                                    maxHeight: "150px", 
                                    objectFit: "cover", 
                                    borderRadius: "8px",
                                    cursor: "pointer",
                                    border: "1px solid #e2e8f0"
                                  }} 
                                />
                              ) : (
                                <div 
                                  onClick={() => setSelectedDoc(docItem)}
                                  style={{ 
                                    padding: "20px", 
                                    background: "#fff", 
                                    borderRadius: "8px", 
                                    textAlign: "center",
                                    cursor: "pointer",
                                    border: "1px dashed #e2e8f0"
                                  }}
                                >
                                  <FileText size={32} color="#d97706" />
                                  <p style={{ fontSize: "13px", color: "#64748b", margin: "8px 0 0 0" }}>PDF dosyasını görüntülemek için tıklayın</p>
                                </div>
                              )}
                            </div>
                          )}

                          {/* Onay/Red Butonları */}
                          {docItem.status !== "approved" && (
                            <div style={{ display: "flex", gap: "8px" }}>
                              <button 
                                onClick={() => handleDocumentStatus(docItem.id, "approved")}
                                disabled={updatingDoc === docItem.id}
                                style={{ 
                                  flex: 1, 
                                  padding: "10px", 
                                  background: "#dcfce7", 
                                  color: "#16a34a", 
                                  border: "none", 
                                  borderRadius: "8px", 
                                  fontSize: "13px", 
                                  fontWeight: "600", 
                                  cursor: updatingDoc === docItem.id ? "not-allowed" : "pointer",
                                  opacity: updatingDoc === docItem.id ? 0.6 : 1,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  gap: "6px"
                                }}
                              >
                                <CheckCircle size={16} /> Onayla
                              </button>
                              <button 
                                onClick={() => handleDocumentStatus(docItem.id, "rejected")}
                                disabled={updatingDoc === docItem.id}
                                style={{ 
                                  flex: 1, 
                                  padding: "10px", 
                                  background: "#fee2e2", 
                                  color: "#dc2626", 
                                  border: "none", 
                                  borderRadius: "8px", 
                                  fontSize: "13px", 
                                  fontWeight: "600", 
                                  cursor: updatingDoc === docItem.id ? "not-allowed" : "pointer",
                                  opacity: updatingDoc === docItem.id ? 0.6 : 1,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                  gap: "6px"
                                }}
                              >
                                <XCircle size={16} /> Reddet
                              </button>
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                ) : (
                  <div style={{ 
                    padding: "24px", 
                    background: "#f8fafc", 
                    borderRadius: "12px", 
                    textAlign: "center",
                    border: "1px dashed #e2e8f0"
                  }}>
                    <FileText size={32} color="#94a3b8" style={{ marginBottom: "8px" }} />
                    <p style={{ fontSize: "14px", color: "#64748b", margin: 0 }}>Henüz belge yüklenmemiş</p>
                  </div>
                )}
              </div>
            </>
          )}

          {/* Belge Önizleme Modalı */}
          {selectedDoc && (
            <div 
              onClick={() => setSelectedDoc(null)}
              style={{ 
                position: "fixed", 
                inset: 0, 
                background: "rgba(0,0,0,0.9)", 
                zIndex: 200,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "20px"
              }}
            >
              <button 
                onClick={() => setSelectedDoc(null)}
                style={{ 
                  position: "absolute", 
                  top: "20px", 
                  right: "20px", 
                  background: "white", 
                  border: "none", 
                  borderRadius: "50%", 
                  width: "40px", 
                  height: "40px",
                  cursor: "pointer",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center"
                }}
              >
                <X size={24} color="#333" />
              </button>
              <div onClick={(e) => e.stopPropagation()} style={{ maxWidth: "90%", maxHeight: "90%" }}>
                {selectedDoc.fileType?.startsWith("image/") ? (
                  <img 
                    src={getDocSrc(selectedDoc) || ""} 
                    alt={selectedDoc.fileName}
                    style={{ maxWidth: "100%", maxHeight: "80vh", borderRadius: "12px" }} 
                  />
                ) : (
                  <iframe 
                    src={getDocSrc(selectedDoc) || ""}
                    title={selectedDoc.fileName}
                    style={{ width: "80vw", height: "80vh", border: "none", borderRadius: "12px", background: "white" }}
                  />
                )}
                <p style={{ textAlign: "center", color: "white", marginTop: "12px", fontSize: "14px" }}>
                  {getDocumentName(selectedDoc.id)} - {selectedDoc.fileName}
                </p>
              </div>
            </div>
          )}

          {/* Askı uyarısı — modalın en altında, aksiyonların hemen üstünde */}
          {isSuspended(userData) && (
            <div style={{ padding: "14px 16px", background: "#fef2f2", border: "1px solid #fecaca", borderRadius: "12px", marginBottom: "16px", display: "flex", alignItems: "center", gap: "10px" }}>
              <Ban size={20} color="#dc2626" />
              <div>
                <p style={{ margin: 0, fontSize: "14px", fontWeight: "700", color: "#dc2626" }}>Bu hesap askıya alınmış</p>
                <p style={{ margin: "2px 0 0", fontSize: "12px", color: "#b91c1c" }}>
                  Kullanıcı uygulamaya giriş yapamıyor.
                  {userData.suspendedAt ? ` Askıya alınma: ${formatDateTime(userData.suspendedAt)}` : ""}
                  {userData.suspendedReason === "content_report" ? " · Sebep: içerik şikayeti" : ""}
                </p>
              </div>
            </div>
          )}

          {/* Actions */}
          <div style={{ display: "flex", gap: "10px", paddingTop: "16px", borderTop: "1px solid #f1f5f9" }}>
            {isSuspended(userData) ? (
              <button onClick={() => { onToggleSuspend(userData, false); onClose(); }}
                style={{ flex: 1, padding: "12px", background: "#dcfce7", color: "#16a34a", border: "none", borderRadius: "10px", fontSize: "14px", fontWeight: "600", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", gap: "6px" }}>
                <CheckCircle size={18} /> Askıyı Kaldır
              </button>
            ) : (
              <button onClick={() => { onToggleSuspend(userData, true); onClose(); }}
                style={{ flex: 1, padding: "12px", background: "#fee2e2", color: "#dc2626", border: "none", borderRadius: "10px", fontSize: "14px", fontWeight: "600", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", gap: "6px" }}>
                <Ban size={18} /> Askıya Al
              </button>
            )}
            {userData.deleted !== true && (
              <button onClick={() => setBildirimAcik(true)}
                style={{ flex: 1, padding: "12px", background: "#ede9fe", color: "#512da8", border: "none", borderRadius: "10px", fontSize: "14px", fontWeight: "600", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", gap: "6px" }}>
                <Send size={18} /> Bildirim gönder
              </button>
            )}
            <button onClick={onClose}
              style={{ flex: 1, padding: "12px", background: "#f1f5f9", color: "#64748b", border: "none", borderRadius: "10px", fontSize: "14px", fontWeight: "600", cursor: "pointer" }}>
              Kapat
            </button>
          </div>
          {bildirimAcik && <BireyselBildirimModal user={{ ...user, ...userData, userType: userData.userType || userType }} onClose={() => setBildirimAcik(false)} />}
        </div>
      </div>
    </div>
  );
};

// ==================== YÖNETİCİ DOĞRULAMA ====================
// İki giriş yolu da (giriş formu ve onAuthStateChanged / kayıtlı oturum) aynı denetimi ve
// aynı oturum süresini kullanır. admins/{uid} yoksa oturum açılmaz, dinleyici kurulmaz.
const ADMIN_OTURUM_MS = 8 * 60 * 60 * 1000;
const YETKI_YOK_MESAJI = "Bu hesabın yönetici yetkisi yok";

// true: admins/{uid} var. false: yok ya da kural okumayı reddetti (yönetici değil).
// Ağ vb. başka bir hata fırlatılır — yetki ne verilir ne de kesin olarak reddedilir.
const yoneticiMi = async (uid) => {
  try {
    const snap = await getDoc(doc(db, "admins", uid));
    return snap.exists();
  } catch (e) {
    if (e && e.code === "permission-denied") return false;
    throw e;
  }
};

const yeniAdminOturumu = (user) => ({
  email: user.email,
  uid: user.uid,
  role: "super_admin",
  name: "Süper Admin",
  loginTime: new Date().toISOString(),
  expiresAt: new Date(Date.now() + ADMIN_OTURUM_MS).toISOString(),
});

// ==================== ADMIN LOGIN SCREEN ====================
// bildirim: App'in oturum denetiminden gelen mesaj ({ mesaj, at }) — ör. yetkisiz hesap
const AdminLoginScreen = ({ onLogin, bildirim = null }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [attempts, setAttempts] = useState(0);
  const [locked, setLocked] = useState(false);
  const [lockTimer, setLockTimer] = useState(0);

  // Admin e-posta adresleri — sadece bu adresler admin paneline girebilir
  const ADMIN_EMAILS = ["admin@isinebak.com"];

  const MAX_ATTEMPTS = 5;
  const LOCK_DURATION = 60;

  useEffect(() => {
    let interval;
    if (locked && lockTimer > 0) {
      interval = setInterval(() => {
        setLockTimer((prev) => {
          if (prev <= 1) { setLocked(false); setAttempts(0); return 0; }
          return prev - 1;
        });
      }, 1000);
    }
    return () => clearInterval(interval);
  }, [locked, lockTimer]);

  useEffect(() => {
    if (bildirim && bildirim.mesaj) setError(bildirim.mesaj);
  }, [bildirim]);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (locked) return;
    setError("");
    setLoading(true);

    try {
      // Admin e-posta kontrolü
      if (!ADMIN_EMAILS.includes(email.trim().toLowerCase())) {
        const newAttempts = attempts + 1;
        setAttempts(newAttempts);
        if (newAttempts >= MAX_ATTEMPTS) {
          setLocked(true); setLockTimer(LOCK_DURATION);
          setError(`Çok fazla başarısız deneme! ${LOCK_DURATION} saniye bekleyin.`);
        } else {
          setError(`${YETKI_YOK_MESAJI} (${MAX_ATTEMPTS - newAttempts} deneme hakkınız kaldı)`);
        }
        setLoading(false);
        return;
      }

      // Firebase Auth ile giriş
      const userCredential = await signInWithEmailAndPassword(auth, email.trim().toLowerCase(), password);
      const user = userCredential.user;

      // Firestore'da admin yetkisi kontrolü (onAuthStateChanged yolu da aynısını yapar)
      let yetkili;
      try {
        yetkili = await yoneticiMi(user.uid);
      } catch (e2) {
        console.error("Yönetici yetkisi doğrulanamadı:", e2);
        await signOut(auth);
        setError("Yönetici yetkisi doğrulanamadı. Bağlantınızı kontrol edip tekrar deneyin.");
        setLoading(false);
        return;
      }
      if (!yetkili) {
        await signOut(auth);
        localStorage.removeItem("adminSession");
        setError(YETKI_YOK_MESAJI);
        setLoading(false);
        return;
      }

      const session = yeniAdminOturumu(user);
      localStorage.setItem("adminSession", JSON.stringify(session));
      onLogin(session);
    } catch (firebaseError) {
      console.error("Firebase Auth hatası:", firebaseError.code);
      const newAttempts = attempts + 1;
      setAttempts(newAttempts);
      if (newAttempts >= MAX_ATTEMPTS) {
        setLocked(true); setLockTimer(LOCK_DURATION);
        setError(`Çok fazla başarısız deneme! ${LOCK_DURATION} saniye bekleyin.`);
      } else {
        let msg = "Giriş başarısız!";
        if (firebaseError.code === "auth/user-not-found") msg = "Bu e-posta ile kayıtlı hesap bulunamadı!";
        else if (firebaseError.code === "auth/wrong-password" || firebaseError.code === "auth/invalid-credential") msg = "E-posta veya şifre hatalı!";
        else if (firebaseError.code === "auth/too-many-requests") msg = "Çok fazla deneme! Bir süre bekleyin.";
        else if (firebaseError.code === "auth/invalid-email") msg = "Geçersiz e-posta adresi!";
        setError(`${msg} (${MAX_ATTEMPTS - newAttempts} deneme hakkınız kaldı)`);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: "100vh", background: "linear-gradient(135deg, #1e1b4b 0%, #312e81 50%, #4338ca 100%)", display: "flex", alignItems: "center", justifyContent: "center", padding: "20px" }}>
      <div style={{ position: "fixed", inset: 0, backgroundImage: "radial-gradient(circle at 25% 25%, rgba(255,255,255,0.05) 0%, transparent 50%), radial-gradient(circle at 75% 75%, rgba(212,175,55,0.08) 0%, transparent 50%)", pointerEvents: "none" }} />
      <div style={{ width: "100%", maxWidth: "420px", position: "relative", zIndex: 1 }}>
        <div style={{ textAlign: "center", marginBottom: "32px" }}>
          <div style={{ width: "72px", height: "72px", borderRadius: "20px", overflow: "hidden", margin: "0 auto 16px auto", boxShadow: "0 8px 32px rgba(212,175,55,0.3)" }}>
            <img src={APP_ICON} alt="İŞE BAK" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
          </div>
          <h1 style={{ fontSize: "24px", fontWeight: "800", color: "white", margin: "0 0 4px 0" }}>İŞE BAK</h1>
          <p style={{ fontSize: "14px", color: "rgba(255,255,255,0.6)", margin: 0 }}>Admin Panel Girişi</p>
        </div>

        <div style={{ background: "rgba(255,255,255,0.95)", backdropFilter: "blur(20px)", borderRadius: "20px", padding: "32px", boxShadow: "0 20px 60px rgba(0,0,0,0.3)" }}>
          <form onSubmit={handleLogin}>
            {error && (
              <div style={{ padding: "12px 16px", background: "#fef2f2", border: "1px solid #fecaca", borderRadius: "12px", marginBottom: "20px", display: "flex", alignItems: "center", gap: "10px" }}>
                <AlertCircle size={18} color="#dc2626" />
                <p style={{ fontSize: "13px", color: "#dc2626", margin: 0 }}>{error}</p>
              </div>
            )}
            {locked && (
              <div style={{ padding: "16px", background: "#fef3c7", border: "1px solid #fde68a", borderRadius: "12px", marginBottom: "20px", textAlign: "center" }}>
                <Lock size={24} color="#d97706" style={{ marginBottom: "8px" }} />
                <p style={{ fontSize: "14px", fontWeight: "600", color: "#92400e", margin: "0 0 4px 0" }}>Hesap Kilitlendi</p>
                <p style={{ fontSize: "24px", fontWeight: "700", color: "#d97706", margin: "0 0 4px 0" }}>{lockTimer}s</p>
                <p style={{ fontSize: "12px", color: "#a16207", margin: 0 }}>Tekrar denemek için bekleyin</p>
              </div>
            )}
            <div style={{ marginBottom: "16px" }}>
              <label style={{ display: "block", fontSize: "14px", fontWeight: "600", color: "#1e293b", marginBottom: "8px" }}>E-posta Adresi</label>
              <div style={{ position: "relative" }}>
                <Mail size={18} color="#94a3b8" style={{ position: "absolute", left: "14px", top: "50%", transform: "translateY(-50%)" }} />
                <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="E-posta adresinizi girin" required disabled={locked}
                  style={{ width: "100%", padding: "14px 16px 14px 44px", border: "2px solid #e2e8f0", borderRadius: "12px", fontSize: "14px", outline: "none", boxSizing: "border-box", background: locked ? "#f1f5f9" : "white" }} />
              </div>
            </div>
            <div style={{ marginBottom: "24px" }}>
              <label style={{ display: "block", fontSize: "14px", fontWeight: "600", color: "#1e293b", marginBottom: "8px" }}>Şifre</label>
              <div style={{ position: "relative" }}>
                <Lock size={18} color="#94a3b8" style={{ position: "absolute", left: "14px", top: "50%", transform: "translateY(-50%)" }} />
                <input type={showPassword ? "text" : "password"} value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••" required disabled={locked}
                  style={{ width: "100%", padding: "14px 48px 14px 44px", border: "2px solid #e2e8f0", borderRadius: "12px", fontSize: "14px", outline: "none", boxSizing: "border-box", background: locked ? "#f1f5f9" : "white" }} />
                <button type="button" onClick={() => setShowPassword(!showPassword)}
                  style={{ position: "absolute", right: "14px", top: "50%", transform: "translateY(-50%)", background: "none", border: "none", cursor: "pointer", padding: "4px" }}>
                  {showPassword ? <EyeOff size={18} color="#94a3b8" /> : <Eye size={18} color="#94a3b8" />}
                </button>
              </div>
            </div>
            <button type="submit" disabled={loading || locked}
              style={{ width: "100%", padding: "14px", background: loading || locked ? "#94a3b8" : "linear-gradient(135deg, #1e1b4b, #312e81)", color: "white", border: "none", borderRadius: "12px", fontSize: "15px", fontWeight: "700", cursor: loading || locked ? "not-allowed" : "pointer", display: "flex", alignItems: "center", justifyContent: "center", gap: "8px", boxShadow: "0 4px 16px rgba(30,27,75,0.3)" }}>
              {loading ? (<><RefreshCw size={18} style={{ animation: "spin 1s linear infinite" }} />Giriş yapılıyor...</>) : (<><Shield size={18} />Giriş Yap</>)}
            </button>
          </form>
          <div style={{ marginTop: "20px", textAlign: "center" }}>
            <p style={{ fontSize: "12px", color: "#94a3b8", margin: 0 }}>Yetkisiz erişim girişimleri kayıt altına alınmaktadır.</p>
          </div>
        </div>
        <p style={{ textAlign: "center", fontSize: "12px", color: "rgba(255,255,255,0.4)", marginTop: "24px" }}>© 2025 İşe Bak — Tüm hakları saklıdır.</p>
      </div>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
};

// ==================== ADMIN PANEL WITH FIREBASE ====================
export default function App() {
  const [adminSession, setAdminSession] = useState(null);
  const [firebaseUser, setFirebaseUser] = useState(null); // Gerçek Firebase Auth kullanıcısı
  const [authChecking, setAuthChecking] = useState(true);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [currentPage, setCurrentPage] = useState("dashboard");
  // Dashboard'daki "Dikkat gerektirenler" satırları sayfayı FİLTRELİ açar.
  // Sayfa filtreleri her sayfanın kendi içinde useState olduğu için değer
  // buradan initialFilter prop'u ile geçilir.
  const [pageFilter, setPageFilter] = useState(null);
  // Hedef sayfaya gidildikten sonra sıfırlanır: menüden ELLE girişte filtre yapışmasın.
  const goToPage = useCallback((page, filter = null) => {
    setPageFilter(filter);
    setCurrentPage(page);
  }, []);
  const goToPagePlain = useCallback((page) => {
    setPageFilter(null);
    setCurrentPage(page);
  }, []);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(true);
  const [lastRefresh, setLastRefresh] = useState(null);

  const [customers, setCustomers] = useState([]);
  const [experts, setExperts] = useState([]);
  const [jobs, setJobs] = useState([]);
  const [complaints, setComplaints] = useState([]);
  const [supportTickets, setSupportTickets] = useState([]);
  const [deletedUsers, setDeletedUsers] = useState([]);
  // ====== İÇERİK MODERASYONU (Apple Guideline 1.2) ======
  const [contentReports, setContentReports] = useState([]);
  const [userBlocks, setUserBlocks] = useState([]);
  const [deletedAccounts, setDeletedAccounts] = useState([]);
  const [stats, setStats] = useState({
    totalCustomers: 0, totalExperts: 0, activeJobs: 0, monthlyRevenue: 0,
    pendingApplications: 0, openComplaints: 0, openSupportTickets: 0,
    customersChange: 0, expertsChange: 0, jobsChange: 0, revenueChange: 0,
    deletedAccounts: 0,
  });
  const [recentActivities, setRecentActivities] = useState([]);

  // Giriş ekranında gösterilecek oturum denetimi mesajı ({ mesaj, at })
  const [authBildirim, setAuthBildirim] = useState(null);

  // ====== AUTH CHECK (Firebase Auth + localStorage) ======
  // Kayıtlı Firebase oturumu (sayfa yenileme) ve giriş formu bu olaydan geçer.
  // admins/{uid} doğrulanmadan firebaseUser ve adminSession set EDİLMEZ; dinleyiciler
  // ikisine bağlı olduğu için yetkisiz hesapta hiçbir dinleyici kurulmaz.
  useEffect(() => {
    // Ardışık olaylarda (çıkış, başka hesapla giriş) yalnızca EN SON olayın sonucu uygulanır
    let sira = 0;
    const unsubAuth = onAuthStateChanged(auth, async (user) => {
      const benim = ++sira;
      const guncel = () => benim === sira;
      // Doğrulama bitene kadar önceki hesabın oturumu ve dinleyicileri kapalı
      setFirebaseUser(null);
      setAdminSession(null);
      if (!user) {
        localStorage.removeItem("adminSession");
        setAuthChecking(false);
        return;
      }

      let yetkili;
      try {
        yetkili = await yoneticiMi(user.uid);
      } catch (e) {
        if (!guncel()) return;
        console.error("Yönetici yetkisi doğrulanamadı:", e);
        setAuthBildirim({ mesaj: "Yönetici yetkisi doğrulanamadı. Bağlantınızı kontrol edip tekrar giriş yapın.", at: Date.now() });
        setAuthChecking(false);
        return;
      }
      if (!guncel()) return;
      if (!yetkili) {
        localStorage.removeItem("adminSession");
        setAuthBildirim({ mesaj: YETKI_YOK_MESAJI, at: Date.now() });
        setAuthChecking(false);
        signOut(auth).catch((e) => console.error("Çıkış hatası:", e));
        return;
      }

      // Kayıtlı oturum aynı hesaba aitse ve süresi dolmadıysa kullanılır; süresi dolduysa
      // yeniden giriş istenir. Başka hesaba ait ya da okunamayan kayıt yok sayılır.
      let session = null;
      try {
        const kayitli = JSON.parse(localStorage.getItem("adminSession") || "null");
        if (kayitli && kayitli.uid === user.uid) {
          if (new Date(kayitli.expiresAt) > new Date()) session = kayitli;
          else {
            localStorage.removeItem("adminSession");
            setAuthBildirim({ mesaj: "Oturum süresi doldu. Tekrar giriş yapın.", at: Date.now() });
            setAuthChecking(false);
            signOut(auth).catch((e) => console.error("Çıkış hatası:", e));
            return;
          }
        }
      } catch (e) { /* bozuk kayıt: yeni oturum yazılır */ }
      if (!session) {
        session = yeniAdminOturumu(user);
        localStorage.setItem("adminSession", JSON.stringify(session));
      }
      setAuthBildirim(null);
      setFirebaseUser(user);
      setAdminSession(session);
      setAuthChecking(false);
    });
    return () => { sira++; unsubAuth(); };
  }, []);

  const handleLogin = (session) => {
    setAuthBildirim(null);
    setAdminSession(session);
  };

  const handleLogout = async () => {
    try {
      await signOut(auth);
    } catch (e) {
      console.error("Çıkış hatası:", e);
    }
    localStorage.removeItem("adminSession");
    setAdminSession(null);
    goToPagePlain("dashboard");
  };

  // ====== GERÇEK YÜZDE HESAPLAMA ======
  const calculatePercentageChange = (items, dateField = "createdAt") => {
    const now = new Date();
    const thisMonthStart = new Date(now.getFullYear(), now.getMonth(), 1);
    const lastMonthStart = new Date(now.getFullYear(), now.getMonth() - 1, 1);
    const lastMonthEnd = new Date(now.getFullYear(), now.getMonth(), 0);
    let thisMonth = 0, lastMonth = 0;

    items.forEach((item) => {
      const dv = item[dateField];
      if (!dv) return;
      let date;
      if (dv && typeof dv === "object" && dv.toDate) date = dv.toDate();
      else if (dv && typeof dv === "object" && dv.seconds) date = new Date(dv.seconds * 1000);
      else date = new Date(dv);
      if (isNaN(date.getTime())) return;
      if (date >= thisMonthStart) thisMonth++;
      else if (date >= lastMonthStart && date <= lastMonthEnd) lastMonth++;
    });

    if (lastMonth === 0) return thisMonth > 0 ? 100 : 0;
    return parseFloat((((thisMonth - lastMonth) / lastMonth) * 100).toFixed(1));
  };

  // ====== HELPER: Tarih sıralama ======
  const sortByDate = useCallback((arr) => [...arr].sort((a, b) => {
    const getTime = (d) => {
      if (!d) return 0;
      if (typeof d === "object" && d.seconds) return d.seconds * 1000;
      if (typeof d === "object" && d.toDate) return d.toDate().getTime();
      return new Date(d).getTime() || 0;
    };
    return getTime(b.createdAt) - getTime(a.createdAt);
  }), []);

  // ====== HELPER: Stats hesapla ======
  const recalcStats = useCallback((customersList, expertsList, jobsList, complaintsList, ticketsList = []) => {
    const pendingExperts = expertsList.filter((e) => e.verified === false || e.status === "pending");
    const activeJobs = jobsList.filter((j) => j.status === "pending" || j.status === "in_progress").length;
    // open veya pending durumundaki şikayetleri say
    const openComplaints = complaintsList.filter((c) => c.status === "open" || c.status === "pending" || c.status === "in_progress").length;
    // Açık destek taleplerini say
    const openSupportTickets = ticketsList.filter((t) => t.status === "pending" || t.status === "in_progress").length;

    setStats({
      totalCustomers: customersList.length,
      totalExperts: expertsList.length,
      activeJobs,
      monthlyRevenue: 0,
      pendingApplications: pendingExperts.length,
      openComplaints,
      openSupportTickets,
      customersChange: calculatePercentageChange(customersList),
      expertsChange: calculatePercentageChange(expertsList),
      jobsChange: calculatePercentageChange(jobsList),
      revenueChange: 0,
    });

    // Son aktiviteler
    const activities = [];
    sortByDate(expertsList).slice(0, 3).forEach((expert) => {
      activities.push({ id: `expert-${expert.id}`, type: "application", message: `Yeni uzman: ${expert.name || expert.displayName || "İsimsiz"}`, time: formatTimeAgo(expert.createdAt), icon: UserCheck, color: "#3b82f6" });
    });
    sortByDate(jobsList).slice(0, 3).forEach((job) => {
      activities.push({ id: `job-${job.id}`, type: "job", message: `Yeni iş: ${job.title || job.service || "İş"} - ${job.location?.district || ""}`, time: formatTimeAgo(job.createdAt), icon: Briefcase, color: "#8b5cf6" });
    });
    setRecentActivities(activities.slice(0, 6));
    setLastRefresh(new Date());
  }, [sortByDate]);

  // ====== REAL-TIME LISTENERS (onSnapshot) ======
  // Dinleyiciler oturum NESNESİNE değil, oturumdaki uid'e bağlı. Girişte oturum iki kez
  // yazılıyor (onAuthStateChanged + giriş formu, farklı nesneler); nesneye bağlıyken
  // 8 dinleyici kapatılıp yeniden açılıyor ve her şey ikinci kez iniyordu (~13 MB).
  // Aynı uid kaldıkça dinleyiciler açık kalır; çıkışta ya da başka hesapla girişte yenilenir.
  // firebaseUser yalnızca admins/{uid} doğrulandıktan sonra set edilir (AUTH CHECK)
  const listenerUid =
    firebaseUser && adminSession && adminSession.uid === firebaseUser.uid ? firebaseUser.uid : null;
  useEffect(() => {
    // Firebase Auth kullanıcısı VE admin session'ı hazır olmalı
    if (!listenerUid) return;
    setLoading(true);

    // Geçici veri tutucular — her snapshot geldiğinde güncel listeyle stats hesaplayabilmek için
    let latestCustomers = [];
    let latestExperts = [];
    let latestJobs = [];
    let latestRequests = [];
    let latestComplaints = [];
    let latestTickets = [];
    let initialLoadCount = 0;
    // users, jobs, requests, complaints, supportTickets, reports, blocks, deletedAccounts
    const TOTAL_COLLECTIONS = 8;

    const checkInitialLoad = () => {
      initialLoadCount++;
      if (initialLoadCount >= TOTAL_COLLECTIONS) {
        setLoading(false);
      }
    };

    // HELPER: jobs + requests birleştir (aynı ID varsa jobs öncelikli)
    const mergeJobsAndRequests = (jobsList, requestsList) => {
      const merged = new Map();
      // Önce requests ekle
      requestsList.forEach((r) => merged.set(r.id, { ...r, _source: "requests" }));
      // Sonra jobs ekle (aynı ID varsa jobs üstün gelir)
      jobsList.forEach((j) => merged.set(j.id, { ...j, _source: "jobs" }));
      return Array.from(merged.values());
    };

    // 1) Users koleksiyonu (müşteriler + uzmanlar)
    // NOT: documents ve myDocuments alanları çok büyük (base64 verisi).
    // Listede bunlara gerek yok, detay açıldığında ayrıca çekilecek.
    const unsubUsers = onSnapshot(
      collection(db, "users"),
      (snapshot) => {
        const allUsers = snapshot.docs.map((d) => {
          const data = d.data();
          // Belge onay sayaçları ağır alanlar ATILMADAN ÖNCE türetilir
          const docCounts = countDocStatuses(data);
          // Teklif kapıları (ana uygulamayla birebir) — Raporlar > Teklif Hazırlığı
          const teklifKimlik = teklifKimlikKapisi(data);
          // Ağır alanları çıkar - sadece belge sayısını tut
          const { documents, myDocuments, uploadedDocs, ...lightData } = data;
          return {
            id: d.id,
            ...lightData,
            _hasDocuments: !!(documents || myDocuments || uploadedDocs),
            _docCount: Object.keys(documents || {}).length + (myDocuments || []).length,
            _pendingDocCount: docCounts.pending,
            _rejectedDocCount: docCounts.rejected,
            _oldestPendingDocAt: docCounts.oldestPendingAt,
            _teklifKimlik: teklifKimlik,
          };
        });
        latestCustomers = allUsers.filter((u) => u.userType === "customer" && !u.deleted);
        latestExperts = allUsers.filter((u) => u.userType === "expert" && !u.deleted);
        const deletedUsers = allUsers.filter((u) => u.deleted === true);
        setCustomers(latestCustomers);
        setExperts(latestExperts);
        setDeletedUsers(deletedUsers);
        const allJobs = mergeJobsAndRequests(latestJobs, latestRequests);
        recalcStats(latestCustomers, latestExperts, allJobs, latestComplaints);
        checkInitialLoad();
      },
      (error) => {
        console.error("Users listener hatası:", error);
        checkInitialLoad();
      }
    );

    // 2) Jobs koleksiyonu
    const unsubJobs = onSnapshot(
      collection(db, "jobs"),
      (snapshot) => {
        latestJobs = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
        const allJobs = mergeJobsAndRequests(latestJobs, latestRequests);
        setJobs(allJobs);
        recalcStats(latestCustomers, latestExperts, allJobs, latestComplaints);
        checkInitialLoad();
      },
      (error) => {
        console.error("Jobs listener hatası:", error);
        checkInitialLoad();
      }
    );

    // 3) Requests koleksiyonu (uygulama iş taleplerini buraya da yazar)
    const unsubRequests = onSnapshot(
      collection(db, "requests"),
      (snapshot) => {
        latestRequests = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
        const allJobs = mergeJobsAndRequests(latestJobs, latestRequests);
        setJobs(allJobs);
        recalcStats(latestCustomers, latestExperts, allJobs, latestComplaints);
        checkInitialLoad();
      },
      (error) => {
        console.error("Requests listener hatası:", error);
        checkInitialLoad();
      }
    );

    // 4) Complaints koleksiyonu
    const unsubComplaints = onSnapshot(
      collection(db, "complaints"),
      (snapshot) => {
        latestComplaints = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
        setComplaints(latestComplaints);
        const allJobs = mergeJobsAndRequests(latestJobs, latestRequests);
        recalcStats(latestCustomers, latestExperts, allJobs, latestComplaints, latestTickets);
        checkInitialLoad();
      },
      (error) => {
        console.error("Complaints listener hatası:", error);
        latestComplaints = [];
        setComplaints([]);
        checkInitialLoad();
      }
    );

    // Support Tickets listener
    const unsubTickets = onSnapshot(
      collection(db, "supportTickets"),
      (snapshot) => {
        latestTickets = snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
        setSupportTickets(latestTickets);
        const allJobs = mergeJobsAndRequests(latestJobs, latestRequests);
        recalcStats(latestCustomers, latestExperts, allJobs, latestComplaints, latestTickets);
        checkInitialLoad();
      },
      (error) => {
        console.error("Support tickets listener hatası:", error);
        latestTickets = [];
        setSupportTickets([]);
        checkInitialLoad();
      }
    );

    // 6) Reports koleksiyonu — içerik şikayetleri (Apple Guideline 1.2)
    // NOT: where/orderBy KULLANILMIYOR — composite index gerektirir.
    // Hacim düşük, filtreleme ve sıralama client-side yapılıyor (mevcut desenle aynı).
    const unsubReports = onSnapshot(
      collection(db, "reports"),
      (snapshot) => {
        setContentReports(snapshot.docs.map((d) => ({ id: d.id, ...d.data() })));
        checkInitialLoad();
      },
      (error) => {
        console.error("Reports listener hatası:", error);
        setContentReports([]);
        checkInitialLoad();
      }
    );

    // 7) Blocks koleksiyonu — kullanıcı engellemeleri (salt-okunur)
    const unsubBlocks = onSnapshot(
      collection(db, "blocks"),
      (snapshot) => {
        setUserBlocks(snapshot.docs.map((d) => ({ id: d.id, ...d.data() })));
        checkInitialLoad();
      },
      (error) => {
        console.error("Blocks listener hatası:", error);
        setUserBlocks([]);
        checkInitialLoad();
      }
    );

    // 8) DeletedAccounts koleksiyonu — silinen hesap izleri (PII içermez)
    const unsubDeletedAccounts = onSnapshot(
      collection(db, "deletedAccounts"),
      (snapshot) => {
        setDeletedAccounts(snapshot.docs.map((d) => ({ id: d.id, ...d.data() })));
        checkInitialLoad();
      },
      (error) => {
        console.error("DeletedAccounts listener hatası:", error);
        setDeletedAccounts([]);
        checkInitialLoad();
      }
    );

    // Cleanup: component unmount veya session değiştiğinde tüm listener'ları kapat
    return () => {
      unsubUsers();
      unsubJobs();
      unsubRequests();
      unsubComplaints();
      unsubTickets();
      unsubReports();
      unsubBlocks();
      unsubDeletedAccounts();
    };
  }, [listenerUid, recalcStats]);

  // ====== SİLİNEN KULLANICI FALLBACK'İ ======
  // deleteMyAccount artık users dokümanını TAMAMEN siliyor (soft-delete değil).
  // Bu yüzden reports/blocks içindeki uid'ler users listesinde bulunmayabilir.
  // Tek merkezî çözümleyici: bulunamayan uid için çökmek yerine "Silinmiş Kullanıcı" döner.
  const userIndex = useMemo(() => {
    const map = new Map();
    [...customers, ...experts, ...deletedUsers].forEach((u) => map.set(u.id, u));
    return map;
  }, [customers, experts, deletedUsers]);

  const deletedAccountIndex = useMemo(() => {
    const map = new Map();
    deletedAccounts.forEach((d) => map.set(d.id, d));
    return map;
  }, [deletedAccounts]);

  const resolveUser = useCallback(
    (uid) => {
      if (!uid) {
        return { id: null, name: "—", email: "", userType: null, missing: true, deleted: false, suspended: false, raw: null, deletedAt: null };
      }
      const found = userIndex.get(uid);
      if (found) {
        return {
          id: uid,
          name: found.name || found.displayName || found.email || `${uid.slice(0, 8)}…`,
          email: found.email || "",
          userType: found.userType || null,
          missing: false,
          deleted: found.deleted === true,
          suspended: found.suspended === true || found.status === "suspended",
          raw: found,
          deletedAt: found.deletedAt || null,
        };
      }
      // users'ta yok — kalıcı silinmiş (tombstone varsa tarihi de biliyoruz)
      const tomb = deletedAccountIndex.get(uid);
      return {
        id: uid,
        name: "Silinmiş Kullanıcı",
        email: "",
        userType: tomb?.userType || null,
        missing: true,
        deleted: true,
        suspended: false,
        raw: null,
        deletedAt: tomb?.deletedAt || null,
      };
    },
    [userIndex, deletedAccountIndex]
  );

  // ====== SİLİNMİŞ HESAPLAR: ESKİ + YENİ YÖNTEM BİRLEŞİK ======
  // ESKİ: users dokümanında deleted:true (soft-delete) — geriye dönük uyumluluk.
  // YENİ: deleteMyAccount users dokümanını siliyor, geriye deletedAccounts/{uid}
  //       tombstone'u kalıyor ({deletedAt, userType} — KİŞİSEL VERİ YOK).
  // Bu birleşim olmadan "Silinmiş Hesaplar" filtresi kalıcı olarak boş kalırdı.
  const allDeletedUsers = useMemo(() => {
    const legacyIds = new Set(deletedUsers.map((u) => u.id));
    const tombstones = deletedAccounts
      .filter((d) => !legacyIds.has(d.id)) // aynı kullanıcı iki listede sayılmasın
      .map((d) => ({
        id: d.id,
        name: "Silinmiş Hesap",
        email: "",
        userType: d.userType || null,
        deleted: true,
        deletedAt: d.deletedAt || null,
        _tombstone: true, // kişisel veri yok — sadece uid + tarih gösterilebilir
      }));
    return [...deletedUsers, ...tombstones];
  }, [deletedUsers, deletedAccounts]);

  // ====== MODERASYON SAYAÇLARI (SLA) ======
  const moderationStats = useMemo(() => {
    const now = Date.now();
    const pending = contentReports.filter((r) => (r.status || "pending") === "pending");
    // createdAt yoksa (bozuk kayıt) yaş hesaplanamaz — SLA ihlali sayılmaz
    const slaBreached = pending.filter((r) => {
      const created = toMillis(r.createdAt);
      return created > 0 && now - created > SLA_MS;
    });
    return { pending: pending.length, slaBreached: slaBreached.length, total: contentReports.length };
  }, [contentReports]);

  const formatTimeAgo = (dateValue) => {
    if (!dateValue) return "Bilinmiyor";
    let date;
    if (dateValue && typeof dateValue === "object" && dateValue.toDate) date = dateValue.toDate();
    else if (dateValue && typeof dateValue === "object" && dateValue.seconds) date = new Date(dateValue.seconds * 1000);
    else date = new Date(dateValue);
    if (isNaN(date.getTime())) return "Bilinmiyor";
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);
    if (diffMins < 1) return "Az önce";
    if (diffMins < 60) return `${diffMins} dk önce`;
    if (diffHours < 24) return `${diffHours} saat önce`;
    if (diffDays < 30) return `${diffDays} gün önce`;
    return `${Math.floor(diffDays / 30)} ay önce`;
  };

  // ====== ASKIYA ALMA / ASKIYI KALDIRMA ======
  // (Eski updateUserStatus kaldırıldı: yalnızca status alanını yazıyordu, bu yüzden
  //  suspended:true ile yazılmış askılar panelden kaldırılamıyordu.)
  // Uygulama girişte HEM suspended:true HEM status:"suspended" kontrolü yapıyor
  // (isinebak2/src/App.js). İkisi birden yazılır ki hangi yoldan bakılırsa bakılsın
  // kullanıcı çıkışa zorlansın.
  // Askıyı kaldırırken önceki durum geri yüklenir — onay bekleyen bir uzman
  // askıdan çıkınca yanlışlıkla "active" olup onaylanmış görünmesin.
  const setUserSuspended = async (user, suspend) => {
    const userId = typeof user === "string" ? user : user?.id;
    if (!userId) return;
    const name = typeof user === "object" ? (user.name || user.displayName || user.email || userId) : userId;
    if (!window.confirm(
      suspend
        ? `"${name}" ASKIYA ALINACAK.\n\nUygulamadan çıkışa zorlanır ve tekrar giriş yapamaz.\n\nDevam edilsin mi?`
        : `"${name}" üzerindeki askı KALDIRILACAK.\n\nKullanıcı tekrar giriş yapabilir.\n\nDevam edilsin mi?`
    )) return;

    try {
      const nowIso = new Date().toISOString();
      let patch;
      if (suspend) {
        const prev = typeof user === "object" ? user.status : null;
        patch = {
          suspended: true,
          status: "suspended",
          // Askı öncesi durumu sakla (pending/rejected uzman yanlışlıkla aktifleşmesin)
          previousStatus: prev && prev !== "suspended" ? prev : "active",
          suspendedAt: nowIso,
          suspendedReason: "admin_manual",
          updatedAt: nowIso,
        };
      } else {
        const restore = (typeof user === "object" && user.previousStatus) || "active";
        patch = {
          suspended: false,
          status: restore,
          unsuspendedAt: nowIso,
          updatedAt: nowIso,
        };
      }
      await updateDoc(doc(db, "users", userId), patch);
      setCustomers((prev) => prev.map((c) => (c.id === userId ? { ...c, ...patch } : c)));
      setExperts((prev) => prev.map((e) => (e.id === userId ? { ...e, ...patch } : e)));
      alert(suspend ? "Kullanıcı askıya alındı." : `Askı kaldırıldı (durum: ${patch.status}).`);
    } catch (error) {
      console.error("Askıya alma hatası:", error);
      alert("Hata oluştu! İşlem tamamlanamadı.");
    }
  };

  const approveExpert = async (expertId) => {
    try {
      await updateDoc(doc(db, "users", expertId), { verified: true, status: "active", verifiedAt: new Date().toISOString(), updatedAt: new Date().toISOString() });
      setExperts((prev) => prev.map((e) => (e.id === expertId ? { ...e, verified: true, status: "active" } : e)));
      const notifData = { type: "verification", icon: "✅", title: "Hesabınız Onaylandı!", message: "Uzman hesabınız admin tarafından onaylandı. Artık iş teklifleri alabilirsiniz.", color: "#16a34a", read: false, createdAt: new Date().toISOString() };
      try {
        await addDoc(collection(db, "users", expertId, "notifications"), notifData);
        await addDoc(collection(db, "notifications"), { ...notifData, userId: expertId });
      } catch (e) {}
      alert("Uzman onaylandı!");
    } catch (error) { console.error("Onaylama hatası:", error); alert("Hata oluştu!"); }
  };

  const rejectExpert = async (expertId) => {
    try {
      await updateDoc(doc(db, "users", expertId), { verified: false, status: "rejected", rejectedAt: new Date().toISOString(), updatedAt: new Date().toISOString() });
      setExperts((prev) => prev.map((e) => (e.id === expertId ? { ...e, verified: false, status: "rejected" } : e)));
      const notifData = { type: "verification", icon: "❌", title: "Başvurunuz Reddedildi", message: "Uzman başvurunuz reddedildi. Detaylar için destek ile iletişime geçin.", color: "#dc2626", read: false, createdAt: new Date().toISOString() };
      try {
        await addDoc(collection(db, "users", expertId, "notifications"), notifData);
        await addDoc(collection(db, "notifications"), { ...notifData, userId: expertId });
      } catch (e) {}
      alert("Uzman reddedildi!");
    } catch (error) { console.error("Reddetme hatası:", error); alert("Hata oluştu!"); }
  };

  // Toplu bildirim: hedef listesi NotificationsPage'de seçilir (kitle, kategori, test hariç) ve onaylanır.
  // Dönüş: { gonderilen, hata }. Bir kullanıcıda hata olursa diğerlerine devam edilir.
  const sendBulkNotification = async (targetUsers, title, message, onIlerleme = null) => {
    let gonderilen = 0;
    let hata = 0;
    for (const user of targetUsers) {
      try {
        const notifData = { type: "admin_notification", icon: "📢", title, message, color: "#512da8", read: false, createdAt: new Date().toISOString() };
        // Hem subcollection hem root collection'a yaz (uygulama uyumluluğu; push root'tan gider)
        await addDoc(collection(db, "users", user.id, "notifications"), notifData);
        await addDoc(collection(db, "notifications"), { ...notifData, userId: user.id });
        gonderilen++;
      } catch (error) {
        console.error(`Bildirim gönderme hatası (${user.id}):`, error);
        hata++;
      }
      if (onIlerleme) onIlerleme(gonderilen + hata, targetUsers.length);
    }
    return { gonderilen, hata };
  };

  const updateJobStatus = async (jobId, newStatus) => {
    try {
      // İş hangi koleksiyondan geldiyse oraya yaz
      const job = jobs.find((j) => j.id === jobId);
      const targetCollection = job?._source === "requests" ? "requests" : "jobs";
      await updateDoc(doc(db, targetCollection, jobId), { status: newStatus, updatedAt: new Date().toISOString() });
      // İki koleksiyonda da varsa ikisini de güncelle
      if (targetCollection === "requests") {
        try { await updateDoc(doc(db, "jobs", jobId), { status: newStatus, updatedAt: new Date().toISOString() }); } catch (e) { /* jobs'ta yoksa sorun değil */ }
      } else {
        try { await updateDoc(doc(db, "requests", jobId), { status: newStatus, updatedAt: new Date().toISOString() }); } catch (e) { /* requests'te yoksa sorun değil */ }
      }
      setJobs((prev) => prev.map((j) => (j.id === jobId ? { ...j, status: newStatus } : j)));
      alert(`İş durumu "${newStatus}" olarak güncellendi`);
    } catch (error) { console.error("İş güncelleme hatası:", error); alert("Hata oluştu!"); }
  };

  // Destek talebi güncelleme
  const updateSupportTicket = async (ticketId, newStatus, responseText) => {
    try {
      const updateData = { 
        status: newStatus, 
        updatedAt: new Date().toISOString() 
      };
      
      if (responseText) {
        // Yeni mesaj ekle
        const ticket = supportTickets.find(t => t.id === ticketId);
        const existingMessages = ticket?.messages || [];
        updateData.messages = [
          ...existingMessages,
          {
            sender: "admin",
            message: responseText,
            timestamp: new Date().toISOString(),
          }
        ];
        updateData.lastResponseAt = new Date().toISOString();
      }
      
      if (newStatus === "resolved") updateData.resolvedAt = new Date().toISOString();
      if (newStatus === "closed") updateData.closedAt = new Date().toISOString();
      
      await updateDoc(doc(db, "supportTickets", ticketId), updateData);
      
      // Kullanıcıya bildirim gönder
      const ticket = supportTickets.find(t => t.id === ticketId);
      if (ticket?.userId && ticket.userId !== "anonymous") {
        const statusText = newStatus === "resolved" ? "Çözüldü" : 
                          newStatus === "in_progress" ? "İnceleniyor" : 
                          newStatus === "closed" ? "Kapatıldı" : newStatus;
        
        await addDoc(collection(db, "notifications"), {
          userId: ticket.userId,
          type: "support_update",
          title: "Destek Talebi Güncellendi",
          message: `#${ticketId.slice(-6).toUpperCase()} numaralı destek talebiniz "${statusText}" olarak güncellendi.${responseText ? " Yanıt eklendi." : ""}`,
          ticketId: ticketId,
          read: false,
          createdAt: new Date().toISOString(),
        });
      }
      
      setSupportTickets((prev) => prev.map((t) => (t.id === ticketId ? { ...t, ...updateData } : t)));
      alert(`Destek talebi güncellendi: ${newStatus === "resolved" ? "Çözüldü" : newStatus === "in_progress" ? "İnceleniyor" : newStatus === "closed" ? "Kapatıldı" : newStatus}`);
    } catch (error) { 
      console.error("Destek talebi güncelleme hatası:", error); 
      alert("Hata oluştu!"); 
    }
  };

 const updateComplaintStatus = async (complaintId, newStatus, responseText) => {
  try {
    const updateData = { status: newStatus, updatedAt: new Date().toISOString() };
    if (responseText) {
      updateData.adminResponse = responseText;
      updateData.respondedAt = new Date().toISOString();
    }
    if (newStatus === "resolved") updateData.resolvedAt = new Date().toISOString();
    if (newStatus === "rejected") updateData.rejectedAt = new Date().toISOString();
    await updateDoc(doc(db, "complaints", complaintId), updateData);
    
    // Şikayeti bul ve kullanıcıya bildirim gönder
    const complaint = complaints.find(c => c.id === complaintId);
    if (complaint) {
      const userId = complaint.expertId || complaint.customerId;
      const statusText = newStatus === "resolved" ? "Çözüldü" : 
                        newStatus === "in_progress" ? "İnceleniyor" : 
                        newStatus === "rejected" ? "Reddedildi" : newStatus;
      
      if (userId) {
        await addDoc(collection(db, "notifications"), {
          userId: userId,
          userType: complaint.userType || "customer",
          type: "complaint_update",
          title: "Şikayet Güncellendi",
          message: `#${complaintId.slice(-6).toUpperCase()} numaralı şikayetiniz "${statusText}" olarak güncellendi.${responseText ? " Admin yanıtı eklendi." : ""}`,
          complaintId: complaintId,
          read: false,
          createdAt: new Date().toISOString(),
        });
      }
    }
    
    setComplaints((prev) => prev.map((c) => (c.id === complaintId ? { ...c, ...updateData } : c)));
    alert(`Şikayet durumu güncellendi: ${newStatus === "resolved" ? "Çözüldü" : newStatus === "in_progress" ? "İnceleniyor" : newStatus === "rejected" ? "Reddedildi" : newStatus}`);
  } catch (error) { console.error("Şikayet güncelleme hatası:", error); alert("Hata oluştu!"); }
};

  // ====== İÇERİK MODERASYONU AKSİYONLARI (Apple Guideline 1.2) ======
  // Şikayet dokümanına YALNIZCA karar alanları yazılır — güvenlik kuralı
  // status/reviewedAt/reviewedBy/adminNote dışına yazmayı reddeder.
  const markReport = async (reportId, status, adminNote) => {
    const payload = {
      status,
      reviewedAt: new Date().toISOString(),
      reviewedBy: adminSession?.email || "admin",
    };
    if (adminNote) payload.adminNote = adminNote;
    await updateDoc(doc(db, "reports", reportId), payload);
  };

  // Hedef içeriği gizler. Bir iş hem requests hem jobs'ta olabildiği için
  // (bkz. mergeJobsAndRequests) BULUNAN HER koleksiyonda gizlenir — birinde
  // bırakılırsa içerik uygulamada görünmeye devam edebilir.
  const hideReportedContent = async (report) => {
    const collections = REPORT_TARGET_COLLECTIONS[report.targetType] || [];
    if (collections.length === 0) return { hidden: false, reason: "no_target" };
    const hiddenIn = [];
    for (const coll of collections) {
      try {
        const ref = doc(db, coll, report.targetId);
        const snap = await getDoc(ref);
        if (snap.exists()) {
          await updateDoc(ref, {
            hidden: true,
            hiddenReason: "admin_review",
            hiddenAt: new Date().toISOString(),
          });
          hiddenIn.push(coll);
        }
      } catch (e) {
        console.error(`İçerik gizleme hatası (${coll}):`, e);
      }
    }
    return { hidden: hiddenIn.length > 0, collections: hiddenIn, reason: hiddenIn.length ? null : "not_found" };
  };

  // Moderasyon sonucu bildirimlerini gönderir.
  // Uygulama bildirimleri top-level "notifications" koleksiyonundan userId ile
  // okuyor (isinebak2/src/App.js:68149); alt koleksiyon okunmuyor —
  // updateComplaintStatus ile aynı desen. notifications/{id} onCreate
  // tetikleyicisi ayrıca push gönderiyor.
  // Bildirim hatası ana aksiyonu (içerik kaldırma / askıya alma) BLOKLAMAZ.
  const notifyModerationOutcome = async (report, outcome) => {
    const sonuc = await runModerationNotifications(report, outcome, {
      isUserMissing: (uid) => resolveUser(uid).missing,
      writeNotification: (uid, notice) =>
        addDoc(collection(db, "notifications"), {
          userId: uid,
          type: "moderation",
          icon: notice.icon,
          title: notice.title,
          message: notice.message,
          color: notice.color,
          read: false,
          createdAt: new Date().toISOString(),
          // GİZLİLİK: reportId / reporterId / targetId BİLEREK yazılmıyor —
          // bildirim dokümanı üzerinden şikayetçi kimliği sızdırılamaz.
        }),
    });
    if (!sonuc.sent && !sonuc.failed) return "";
    return ` ${sonuc.sent} bildirim gönderildi.` +
      (sonuc.failed ? ` ${sonuc.failed} bildirim GÖNDERİLEMEDİ (işlem yine de tamamlandı).` : "");
  };

  // 1) İçeriği kaldır
  const removeReportedContent = async (report) => {
    const isMessage = report.targetType === "message";
    const question = isMessage
      ? "Bu şikayet 'incelendi' olarak işaretlenecek. Mesaj içeriği teknik olarak gizlenemez.\n\n" +
        "📩 Şikayet edene bilgilendirme bildirimi gönderilecek.\n\nDevam edilsin mi?"
      : "Şikayet edilen içerik GİZLENECEK (uygulamada görünmeyecek) ve şikayet kapatılacak.\n\n" +
        "📩 Şikayet edene ve içerik sahibine bilgilendirme bildirimi gönderilecek " +
        "(kimin şikayet ettiği paylaşılmaz).\n\nDevam edilsin mi?";
    if (!window.confirm(question)) return;
    try {
      if (isMessage) {
        await markReport(report.id, "reviewed");
        const bildirim = await notifyModerationOutcome(report, "reviewed");
        alert("Şikayet 'incelendi' olarak işaretlendi." + bildirim);
        return;
      }
      const res = await hideReportedContent(report);
      await markReport(report.id, "removed");
      const bildirim = await notifyModerationOutcome(report, "removed");
      if (res.hidden) {
        alert(`İçerik gizlendi (${res.collections.join(", ")}) ve şikayet kapatıldı.` + bildirim);
      } else {
        alert("Şikayet kapatıldı ANCAK içerik bulunamadı — muhtemelen zaten silinmiş." + bildirim);
      }
    } catch (error) {
      console.error("İçerik kaldırma hatası:", error);
      alert("Hata oluştu! İşlem tamamlanamadı.");
    }
  };

  // 2) Kullanıcıyı askıya al — Apple şartı: içeriği kaldır VE kullanıcıyı at
  const suspendReportedUser = async (report) => {
    if (!report.targetUserId) {
      alert("Bu şikayette hedef kullanıcı bilgisi yok.");
      return;
    }
    if (!window.confirm(
      "Kullanıcı ASKIYA ALINACAK (uygulamadan çıkışa zorlanır, giriş yapamaz) " +
      "ve şikayet edilen içerik gizlenecek.\n\n" +
      "📩 Yalnızca şikayet edene bildirim gönderilecek — hangi işlemin yapıldığı " +
      "belirtilmez. Askıya alınan kullanıcı giriş yapamayacağı için bildirim almaz.\n\n" +
      "Devam edilsin mi?"
    )) return;
    try {
      const userRef = doc(db, "users", report.targetUserId);
      const userSnap = await getDoc(userRef);
      if (!userSnap.exists()) {
        // Hesap kalıcı silinmiş — askıya alacak bir şey yok, şikayeti yine de kapat
        await hideReportedContent(report);
        await markReport(report.id, "removed", "Kullanıcı hesabı zaten silinmiş");
        const bildirimSilinmis = await notifyModerationOutcome(report, "suspended");
        alert("Kullanıcı hesabı bulunamadı (silinmiş). İçerik gizlendi ve şikayet kapatıldı." + bildirimSilinmis);
        return;
      }
      await updateDoc(userRef, {
        suspended: true,
        status: "suspended",
        suspendedAt: new Date().toISOString(),
        suspendedReason: "content_report",
        updatedAt: new Date().toISOString(),
      });
      const res = await hideReportedContent(report);
      await markReport(report.id, "removed", "Kullanıcı askıya alındı");
      const bildirim = await notifyModerationOutcome(report, "suspended");
      alert(
        `Kullanıcı askıya alındı.` +
        (res.hidden ? ` İçerik gizlendi (${res.collections.join(", ")}).` : " (İçerik bulunamadı.)") +
        bildirim
      );
    } catch (error) {
      console.error("Askıya alma hatası:", error);
      alert("Hata oluştu! İşlem tamamlanamadı.");
    }
  };

  // 3) Şikayeti reddet
  const rejectReport = async (report) => {
    if (!window.confirm(
      "Şikayet REDDEDİLECEK. İçerik ve kullanıcı olduğu gibi kalacak.\n\n" +
      "📩 Yalnızca şikayet edene bilgilendirme bildirimi gönderilecek. " +
      "Şikayet edilen kullanıcıya haber verilmez.\n\nDevam edilsin mi?"
    )) return;
    try {
      await markReport(report.id, "rejected");
      const bildirim = await notifyModerationOutcome(report, "rejected");
      alert("Şikayet reddedildi." + bildirim);
    } catch (error) {
      console.error("Şikayet reddetme hatası:", error);
      alert("Hata oluştu!");
    }
  };

  // onSnapshot zaten gerçek zamanlı: ekrandaki veri her an günceldir. "Yenile" yalnızca
  // zaman damgasını günceller. Dinleyicileri yeniden BAŞLATMAZ — önceden oturum nesnesini
  // değiştirip 8 dinleyiciyi kapatıp açıyordu ve her tıklamada tüm koleksiyonlar (~13 MB)
  // yeniden iniyordu.
  const refreshData = () => {
    setLastRefresh(new Date());
  };

  const menuItems = [
    { id: "dashboard", label: "Dashboard", icon: LayoutDashboard },
    { id: "customers", label: "Müşteriler", icon: Users, badge: stats.totalCustomers },
    { id: "experts", label: "Uzmanlar", icon: UserCheck, badge: stats.totalExperts },
    { id: "applications", label: "Başvurular", icon: FileText, badge: stats.pendingApplications, highlight: stats.pendingApplications > 0 },
    { id: "jobs", label: "İş İlanları", icon: Briefcase, badge: stats.activeJobs },
    // DİKKAT: id "moderation" — "reports" değil. "reports" zaten Raporlar/analitik sayfası.
    { id: "moderation", label: "İçerik Şikayetleri", icon: Flag, badge: moderationStats.pending, highlight: moderationStats.pending > 0 },
    { id: "complaints", label: "Şikayetler", icon: AlertTriangle, badge: stats.openComplaints, highlight: stats.openComplaints > 0 },
    { id: "support", label: "Destek Talepleri", icon: MessageSquare, badge: stats.openSupportTickets, highlight: stats.openSupportTickets > 0 },
    { id: "payments", label: "Ödemeler", icon: CreditCard },
    { id: "premium", label: "Premium Yönetimi", icon: Award, highlight: true },
    { id: "categories", label: "Kategoriler", icon: FolderTree },
    { id: "reports", label: "Raporlar", icon: BarChart3 },
    { id: "notifications", label: "Bildirimler", icon: Bell },
    { id: "settings", label: "Ayarlar", icon: Settings },
  ];

  // ====== AUTH GUARD ======
  if (authChecking) {
    return (
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100vh", background: "#1e1b4b" }}>
        <RefreshCw size={48} color="#d4af37" style={{ animation: "spin 1s linear infinite" }} />
        <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      </div>
    );
  }
  if (!adminSession) return <AdminLoginScreen onLogin={handleLogin} bildirim={authBildirim} />;

  // ====== GLOBAL ARAMA FİLTRESİ ======
  const globalSearchFilter = (items, fields) => {
    if (!searchQuery.trim()) return items;
    const q = searchQuery.toLowerCase().trim();
    return items.filter((item) =>
      fields.some((field) => {
        const value = field.split(".").reduce((obj, key) => obj?.[key], item);
        if (Array.isArray(value)) return value.some((v) => String(v).toLowerCase().includes(q));
        return String(value || "").toLowerCase().includes(q);
      })
    );
  };

  const renderContent = () => {
    if (loading) {
      return (
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%", padding: "40px" }}>
          <div style={{ textAlign: "center" }}>
            <RefreshCw size={48} color="#6366f1" style={{ animation: "spin 1s linear infinite" }} />
            <p style={{ marginTop: "16px", color: "#64748b" }}>Veriler yükleniyor...</p>
          </div>
        </div>
      );
    }
    switch (currentPage) {
      case "dashboard": return <DashboardPage customers={customers} experts={experts} jobs={jobs} contentReports={contentReports} complaints={complaints} supportTickets={supportTickets} recentActivities={recentActivities} goToPage={goToPage} goToPagePlain={goToPagePlain} pendingApplications={stats.pendingApplications} openJobs={stats.activeJobs} resolveUser={resolveUser} />;
      case "customers": return <CustomersPage customers={globalSearchFilter(customers, ["name", "displayName", "email", "city", "district"])} allCustomers={customers} setUserSuspended={setUserSuspended} deletedUsers={allDeletedUsers} initialFilter={pageFilter} />;
      case "experts": return <ExpertsPage experts={globalSearchFilter(experts, ["name", "displayName", "email", "city", "district", "services"])} allExperts={experts} setUserSuspended={setUserSuspended} jobs={jobs} deletedUsers={allDeletedUsers} initialFilter={pageFilter} />;
      case "applications": return <ApplicationsPage experts={experts} approveExpert={approveExpert} rejectExpert={rejectExpert} />;
      case "jobs": return <JobsPage jobs={globalSearchFilter(jobs, ["title", "service", "customerName", "city", "district"])} allJobs={jobs} updateJobStatus={updateJobStatus} initialFilter={pageFilter} resolveUser={resolveUser} onToggleSuspend={setUserSuspended} />;
      case "moderation": return <ModerationPage reports={globalSearchFilter(contentReports, ["contentSnapshot", "description", "reason", "targetId", "targetUserId", "reporterId"])} allReports={contentReports} blocks={userBlocks} resolveUser={resolveUser} setUserSuspended={setUserSuspended} onRemoveContent={removeReportedContent} onSuspendUser={suspendReportedUser} onRejectReport={rejectReport} pendingCount={moderationStats.pending} />;
      case "complaints": return <ComplaintsPage complaints={globalSearchFilter(complaints, ["subject", "description", "customerName", "expertName"])} allComplaints={complaints} updateComplaintStatus={updateComplaintStatus} initialFilter={pageFilter} />;
      case "support": return <SupportTicketsPage tickets={globalSearchFilter(supportTickets, ["subject", "message", "userName", "userEmail"])} allTickets={supportTickets} updateTicket={updateSupportTicket} initialFilter={pageFilter} />;
      case "payments": return <PaymentsPage resolveUser={resolveUser} />;
      case "premium": return <PremiumManagementPage experts={experts} resolveUser={resolveUser} initialFilter={pageFilter} />;
      case "categories": return <CategoriesPage />;
      case "reports": return <ReportsPage stats={stats} customers={customers} experts={experts} jobs={jobs} deletedCount={allDeletedUsers.length} resolveUser={resolveUser} onToggleSuspend={setUserSuspended} updateJobStatus={updateJobStatus} />;
      case "notifications": return <NotificationsPage sendBulkNotification={sendBulkNotification} users={[...customers, ...experts]} customers={customers} experts={experts} resolveUser={resolveUser} />;
      case "settings": return <SettingsPage />;
      default: return <DashboardPage stats={stats} recentActivities={recentActivities} setCurrentPage={setCurrentPage} />;
    }
  };

  return (
    <div style={{ display: "flex", minHeight: "100vh", background: "#f1f5f9" }}>
      {sidebarOpen && <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", zIndex: 40 }} onClick={() => setSidebarOpen(false)} />}

      {/* Sidebar */}
      <aside style={{ position: "fixed", top: 0, left: sidebarOpen ? 0 : "-280px", width: "280px", height: "100vh", background: "linear-gradient(180deg, #1e1b4b 0%, #312e81 100%)", zIndex: 50, transition: "left 0.3s ease", display: "flex", flexDirection: "column", boxShadow: "4px 0 20px rgba(0,0,0,0.1)" }} className="sidebar-desktop">
        <div style={{ padding: "24px", borderBottom: "1px solid rgba(255,255,255,0.1)" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <div style={{ width: "44px", height: "44px", borderRadius: "12px", overflow: "hidden" }}>
              <img src={APP_ICON} alt="İŞE BAK" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
            </div>
            <div>
              <h1 style={{ fontSize: "18px", fontWeight: "800", color: "white", margin: 0 }}>İŞE BAK</h1>
              <p style={{ fontSize: "11px", color: "rgba(255,255,255,0.6)", margin: 0 }}>Admin Panel</p>
            </div>
          </div>
        </div>

        <nav style={{ flex: 1, padding: "16px 12px", overflowY: "auto" }}>
          {menuItems.map((item) => (
            <button key={item.id} onClick={() => { goToPagePlain(item.id); setSidebarOpen(false); }}
              style={{ width: "100%", display: "flex", alignItems: "center", gap: "12px", padding: "12px 16px", marginBottom: "4px", background: currentPage === item.id ? "rgba(255,255,255,0.15)" : "transparent", border: "none", borderRadius: "10px", cursor: "pointer", transition: "all 0.2s ease" }}>
              <item.icon size={20} color={currentPage === item.id ? "#d4af37" : "rgba(255,255,255,0.7)"} />
              <span style={{ flex: 1, textAlign: "left", fontSize: "14px", fontWeight: currentPage === item.id ? "600" : "500", color: currentPage === item.id ? "white" : "rgba(255,255,255,0.7)" }}>{item.label}</span>
              {item.badge !== undefined && (
                <span style={{ padding: "2px 8px", background: item.highlight ? "#ef4444" : "rgba(255,255,255,0.2)", borderRadius: "10px", fontSize: "11px", fontWeight: "600", color: "white" }}>{item.badge}</span>
              )}
            </button>
          ))}
        </nav>

        <div style={{ padding: "16px", borderTop: "1px solid rgba(255,255,255,0.1)" }}>
          <div style={{ display: "flex", alignItems: "center", gap: "12px", padding: "12px", background: "rgba(255,255,255,0.1)", borderRadius: "12px" }}>
            <div style={{ width: "40px", height: "40px", background: "linear-gradient(135deg, #d4af37, #f4e4a6)", borderRadius: "10px", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: "700", color: "#1e1b4b" }}>
              {adminSession.name?.[0] || "A"}
            </div>
            <div style={{ flex: 1 }}>
              <p style={{ fontSize: "14px", fontWeight: "600", color: "white", margin: 0 }}>{adminSession.name || "Admin"}</p>
              <p style={{ fontSize: "12px", color: "rgba(255,255,255,0.6)", margin: 0 }}>{adminSession.role === "super_admin" ? "Süper Yönetici" : "Yönetici"}</p>
            </div>
            <button onClick={handleLogout} title="Çıkış Yap" style={{ background: "none", border: "none", cursor: "pointer", padding: "8px" }}>
              <LogOut size={18} color="rgba(255,255,255,0.6)" />
            </button>
          </div>
        </div>
      </aside>

      {/* Main Content */}
      <main style={{ flex: 1, marginLeft: "0", transition: "margin-left 0.3s ease" }} className="main-content">
        <header style={{ background: "white", padding: "16px 24px", display: "flex", alignItems: "center", gap: "16px", boxShadow: "0 1px 3px rgba(0,0,0,0.05)", position: "sticky", top: 0, zIndex: 30 }}>
          <button onClick={() => setSidebarOpen(true)} style={{ background: "none", border: "none", cursor: "pointer", padding: "8px" }} className="menu-button">
            <Menu size={24} color="#64748b" />
          </button>

          <div style={{ flex: 1, maxWidth: "400px", position: "relative" }}>
            <Search size={20} color="#94a3b8" style={{ position: "absolute", left: "12px", top: "50%", transform: "translateY(-50%)" }} />
            <input type="text" placeholder="Kullanıcı, uzman, iş ara..." value={searchQuery} onChange={(e) => setSearchQuery(e.target.value)}
              style={{ width: "100%", padding: "10px 40px 10px 44px", border: "1px solid #e2e8f0", borderRadius: "10px", fontSize: "14px", outline: "none", boxSizing: "border-box" }} />
            {searchQuery && (
              <button onClick={() => setSearchQuery("")} style={{ position: "absolute", right: "12px", top: "50%", transform: "translateY(-50%)", background: "none", border: "none", cursor: "pointer", padding: "4px" }}>
                <X size={16} color="#94a3b8" />
              </button>
            )}
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
            <div style={{ display: "flex", alignItems: "center", gap: "4px", padding: "4px 10px", background: "#f0fdf4", borderRadius: "20px", border: "1px solid #bbf7d0" }}>
              <div style={{ width: "7px", height: "7px", background: "#16a34a", borderRadius: "50%", animation: "pulse 2s infinite" }} />
              <span style={{ fontSize: "11px", fontWeight: "600", color: "#16a34a" }}>Canlı</span>
            </div>
            <button onClick={refreshData} title="Yeniden Bağlan" style={{ background: "none", border: "none", cursor: "pointer", padding: "8px", display: "flex", alignItems: "center" }}>
              <RefreshCw size={18} color="#64748b" />
            </button>
            {lastRefresh && (
              <span style={{ fontSize: "11px", color: "#94a3b8", whiteSpace: "nowrap" }}>
                {lastRefresh.toLocaleTimeString("tr-TR", { hour: "2-digit", minute: "2-digit" })}
              </span>
            )}
          </div>

          <button onClick={() => goToPagePlain("notifications")} style={{ position: "relative", background: "none", border: "none", cursor: "pointer", padding: "8px" }}>
            <Bell size={24} color="#64748b" />
            {stats.pendingApplications > 0 && <span style={{ position: "absolute", top: "4px", right: "4px", width: "8px", height: "8px", background: "#ef4444", borderRadius: "50%" }} />}
          </button>

          <div onClick={handleLogout} title="Çıkış Yap" style={{ width: "36px", height: "36px", background: "linear-gradient(135deg, #1e1b4b, #312e81)", borderRadius: "10px", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: "600", fontSize: "14px", color: "#d4af37", cursor: "pointer" }}>
            {adminSession.name?.[0] || "A"}
          </div>
        </header>

        <div style={{ padding: "24px" }}><PanelVeriSaglayici>{renderContent()}</PanelVeriSaglayici></div>
      </main>

      <style>{`
        @media (min-width: 1024px) {
          .sidebar-desktop { left: 0 !important; }
          .main-content { margin-left: 280px !important; }
          .menu-button { display: none !important; }
        }
        @keyframes spin { to { transform: rotate(360deg); } }
        @keyframes pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.4; } }
      `}</style>
    </div>
  );
}

// ==================== DASHBOARD PAGE ====================
const DashboardPage = ({
  customers, experts, jobs, contentReports, complaints, supportTickets,
  recentActivities, goToPage, goToPagePlain,
  // Soldaki menü rozetleriyle BİREBİR aynı olsunlar diye yeniden hesaplanmaz;
  // recalcStats'ın ürettiği değerler doğrudan gelir.
  pendingApplications = 0, openJobs = 0, resolveUser = null,
}) => {
  const [period, setPeriod] = useState("7d");
  // Premium kartı: gerçek gelir (payments, test hariç) — Ödemeler sayfasıyla aynı hesap
  const siniflanmisOdemeler = useSiniflanmisOdemeler(resolveUser);
  const { odemeDurum } = usePanelVeri();

  // Tüm metrikler TEK memo'da. Dönem değişince Firestore'a hiç gidilmez —
  // veri 8 listener üzerinden zaten bellekte.
  const m = useMemo(() => {
    const { start, end, prevStart, prevEnd, label } = periodRange(period);
    const now = Date.now();

    const say = (list) => countInRange(list, start, end);
    const sayOnceki = (list) => countInRange(list, prevStart, prevEnd);
    const aktifSayisi = (list) => (list || []).filter((u) => getUserState(u) === "active").length;

    // --- Teklif alan ilan oranı: dönemde açılan ilanların yüzde kaçı teklif aldı
    const arada = (j, a, b) => {
      const t = toMillis(j.createdAt);
      return t >= a && t < b;
    };
    // "Yeni ilan" kartı jobs + requests birleşik sayar (İş İlanları sayfasıyla aynı toplam).
    const donemIlanlari = (jobs || []).filter((j) => arada(j, start, end));
    const onceDonemIlanlari = (jobs || []).filter((j) => arada(j, prevStart, prevEnd));
    // Teklif oranı:
    //   PAYDA = dönemde oluşturulan TÜM jobs, durumdan bağımsız, iptaller hariç.
    //           (requests dahil değil: belirli uzmana doğrudan talep, proposals[] almaz)
    //   PAY   = bunlardan proposalCount > 0 VEYA proposals[] dolu olanlar
    const donemPayda = donemIlanlari.filter(isProposalRateCandidate);
    const oncePayda = onceDonemIlanlari.filter(isProposalRateCandidate);
    const teklifAlan = donemPayda.filter(hasProposal).length;
    const onceTeklifAlan = oncePayda.filter(hasProposal).length;
    const oran = donemPayda.length > 0 ? Math.round((teklifAlan / donemPayda.length) * 100) : 0;
    const onceOran = oncePayda.length > 0 ? Math.round((onceTeklifAlan / oncePayda.length) * 100) : 0;
    // Son teklif: TÜM jobs içindeki proposals[].createdAt'in en yenisi (dönemden bağımsız)
    const sonTeklifAt = latestProposalAt(jobs);
    const sonTeklifGun = sonTeklifAt ? Math.floor((now - sonTeklifAt) / (24 * 60 * 60 * 1000)) : null;
    const sonTeklifMetin =
      sonTeklifGun === null ? "son teklif: kayıt yok"
      : sonTeklifGun <= 0 ? "son teklif: bugün"
      : `son teklif: ${sonTeklifGun} gün önce`;

    // --- Premium
    const gelir = premiumRevenueEstimate(experts);
    const odemeArasi = (a, b) => odemeOzeti(siniflanmisOdemeler.filter((x) => x.s.t >= a && x.s.t < b));
    const donemOdeme = odemeArasi(start, end);
    const onceOdeme = odemeArasi(prevStart, prevEnd);
    const aktifPremium = (experts || []).filter((e) => getPremiumState(e) === "active" && !isGecersizOdeme(e));

    // --- Dikkat gerektirenler
    const BIR_GUN = 24 * 60 * 60 * 1000;
    const belgeBekleyen = (experts || []).filter((e) => (e._pendingDocCount || 0) > 0);
    const onayliBelgeBekleyen = belgeBekleyen.filter((e) => e.verified === true);
    const enEskiBelge = belgeBekleyen.reduce((en, e) => {
      const t = e._oldestPendingDocAt || 0;
      return t && (en === 0 || t < en) ? t : en;
    }, 0);
    const belgeAcilMi = enEskiBelge > 0 && now - enEskiBelge > 2 * BIR_GUN;

    // JobsPage'deki no_proposal filtresiyle AYNI kural (isNoProposalListing)
    const teklifsizAcik = (jobs || []).filter(isNoProposalListing);
    const teklifsiz24 = teklifsizAcik.filter((j) => {
      const t = toMillis(j.createdAt);
      return t > 0 && now - t > BIR_GUN;
    });
    // Doğrudan talep: uzman henüz yanıt vermemiş (request_pending filtresiyle AYNI kural)
    const yanitBekleyenTalep = (jobs || []).filter(isAwaitingExpertRequest);
    const yanitBekleyen24 = yanitBekleyenTalep.filter((j) => {
      const t = toMillis(j.createdAt);
      return t > 0 && now - t > BIR_GUN;
    });

    const acikDestek = (supportTickets || []).filter(
      (t) => t.status === "pending" || t.status === "in_progress"
    );
    const bekleyenRapor = (contentReports || []).filter((r) => (r.status || "pending") === "pending");
    const acikSikayet = (complaints || []).filter(
      (c) => c.status === "open" || c.status === "pending" || c.status === "in_progress"
    );
    const bitecekPremium = aktifPremium.filter((e) => {
      const t = toMillis(e.premiumEndDate);
      return t > 0 && t > now && t < now + 7 * BIR_GUN;
    });

    const dikkat = [
      {
        // Sayı soldaki menüdeki Başvurular rozetiyle aynı kaynaktan (stats.pendingApplications)
        id: "applications", sayi: pendingApplications, metin: "bekleyen uzman başvurusu",
        seviye: "bekliyor", icon: FileText,
        git: () => goToPagePlain("applications"),
      },
      {
        id: "docs", sayi: belgeBekleyen.length, metin: "uzmanın belgesi onay bekliyor",
        ipucu: belgeAcilMi ? "En eskisi 48 saati aştı" : null,
        seviye: belgeAcilMi ? "acil" : "bekliyor", icon: FileText,
        git: () => goToPage("experts", "docs_pending"),
      },
      {
        id: "docsVerified", sayi: onayliBelgeBekleyen.length, metin: "onaylı uzmanın belgesi bekliyor",
        seviye: "bekliyor", icon: UserCheck,
        git: () => goToPage("experts", "verified_docs_pending"),
      },
      {
        id: "noProposal", sayi: teklifsizAcik.length, metin: "açık ilan hiç teklif almamış",
        ipucu: teklifsiz24.length > 0 ? `24 saati geçen: ${teklifsiz24.length}` : null,
        seviye: teklifsiz24.length > 0 ? "bekliyor" : "bilgi", icon: Briefcase,
        git: () => goToPage("jobs", "no_proposal"),
      },
      {
        id: "requestPending", sayi: yanitBekleyenTalep.length, metin: "talep uzman yanıtı bekliyor",
        ipucu: yanitBekleyen24.length > 0 ? `24 saati geçen: ${yanitBekleyen24.length}` : null,
        seviye: yanitBekleyen24.length > 0 ? "bekliyor" : "bilgi", icon: Send,
        git: () => goToPage("jobs", "request_pending"),
      },
      {
        id: "support", sayi: acikDestek.length, metin: "açık destek talebi",
        seviye: "bekliyor", icon: MessageSquare,
        git: () => goToPage("support", "pending"),
      },
      {
        id: "reports", sayi: bekleyenRapor.length, metin: "içerik şikayeti bekliyor",
        seviye: "acil", icon: Flag,
        git: () => goToPagePlain("moderation"),
      },
      {
        id: "complaints", sayi: acikSikayet.length, metin: "açık şikayet",
        seviye: "bekliyor", icon: AlertTriangle,
        git: () => goToPage("complaints", "pending"),
      },
      {
        id: "expiring", sayi: bitecekPremium.length, metin: "premium 7 gün içinde bitiyor",
        seviye: "bilgi", icon: Award,
        git: () => goToPage("premium", "expiring"),
      },
    ]
      .filter((x) => x.sayi > 0)
      .sort((a, b) => {
        const w = { acil: 0, bekliyor: 1, bilgi: 2 };
        return w[a.seviye] - w[b.seviye];
      });

    return {
      label,
      kartlar: [
        {
          id: "experts", baslik: "Yeni uzman", deger: say(experts),
          delta: deltaOf(say(experts), sayOnceki(experts)),
          alt: `toplam ${(experts || []).length} (${aktifSayisi(experts)} aktif)`,
          icon: UserCheck, renk: "#10b981", git: () => goToPagePlain("experts"),
        },
        {
          id: "customers", baslik: "Yeni müşteri", deger: say(customers),
          delta: deltaOf(say(customers), sayOnceki(customers)),
          alt: `toplam ${(customers || []).length} (${aktifSayisi(customers)} aktif)`,
          icon: Users, renk: "#3b82f6", git: () => goToPagePlain("customers"),
        },
        {
          id: "jobs", baslik: "Yeni ilan", deger: donemIlanlari.length,
          delta: deltaOf(donemIlanlari.length, onceDonemIlanlari.length),
          // "açık" = soldaki menüdeki İş İlanları rozeti (stats.activeJobs: pending + in_progress)
          alt: `toplam ${(jobs || []).length} · ${openJobs} açık`,
          icon: Briefcase, renk: "#f59e0b", git: () => goToPagePlain("jobs"),
        },
        {
          id: "proposalRate", baslik: "Teklif alan ilan", deger: `%${oran}`,
          // Oran kartında yüzdenin yüzdesi anlamsız (%10→%20 "+100%" olurdu) — fark PUAN
          // olarak gösterilir. "yeni" yalnızca önceki dönemde HİÇ açık ilan yoksa.
          delta: oncePayda.length === 0
            ? (donemPayda.length > 0 ? { kind: "new", text: "yeni" } : { kind: "flat", text: "" })
            : oran === onceOran
              ? { kind: "flat", text: "" }
              : { kind: oran > onceOran ? "up" : "down", text: `${Math.abs(oran - onceOran)} puan` },
          alt: `${teklifAlan} / ${donemPayda.length} ilan`,
          alt2: sonTeklifMetin,
          alt2Title: sonTeklifAt ? `En yeni teklif: ${formatDateTime(new Date(sonTeklifAt).toISOString())}` : undefined,
          icon: TrendingUp, renk: "#8b5cf6", git: () => goToPage("jobs", "no_proposal"),
        },
        {
          // Gerçek gelir: dönemdeki ödeme kayıtları, test hariç (Ödemeler sayfasıyla aynı hesap).
          // Aktif aboneliklerden tahmin ayrı satırda ve "tahmini" etiketli.
          id: "premium", baslik: "Premium gerçek gelir",
          deger: odemeDurum === "bekliyor" ? "…" : paraYaz(donemOdeme.gelir),
          delta: odemeDurum !== "tamam" ? { kind: "flat", text: "" } : deltaOf(donemOdeme.gelir, onceOdeme.gelir),
          alt: `${donemOdeme.islem} gerçek işlem · test hariç${donemOdeme.test + donemOdeme.gecersiz ? ` (${donemOdeme.test + donemOdeme.gecersiz} kayıt)` : ""} · ${aktifPremium.length} aktif premium`,
          alt2: `${gelir.aylik} aylık · ${gelir.yillik} yıllık · ${gelir.adminVerilen} elle tanımlı abonelik`,
          ekstra: `tahmini: ~₺${gelir.tahminiAylikGelir.toLocaleString()}/ay (aktif aboneliklerin liste fiyatı)`,
          not: [
            odemeDurum === "hata" ? "ödeme kayıtları okunamadı" : null,
            donemOdeme.isaretsiz > 0 ? `${donemOdeme.isaretsiz} kayıt işaretsiz (panel kuralı)` : null,
          ].filter(Boolean).join(" · ") || null,
          icon: Award, renk: "#d4af37", git: () => goToPagePlain("payments"),
        },
      ],
      dikkat,
    };
  }, [period, customers, experts, jobs, contentReports, complaints, supportTickets, goToPage, goToPagePlain, pendingApplications, openJobs, siniflanmisOdemeler, odemeDurum]);

  const SEVIYE = {
    acil: { bg: "#fef2f2", border: "#fecaca", renk: "#dc2626", ikonBg: "#fee2e2" },
    bekliyor: { bg: "#fffbeb", border: "#fde68a", renk: "#d97706", ikonBg: "#fef3c7" },
    bilgi: { bg: "#f8fafc", border: "#e2e8f0", renk: "#64748b", ikonBg: "#f1f5f9" },
  };

  return (
    <div>
      {/* Başlık + dönem seçici */}
      <div style={{ display: "flex", alignItems: "flex-end", justifyContent: "space-between", marginBottom: "24px", flexWrap: "wrap", gap: "12px" }}>
        <div>
          <h1 style={{ fontSize: "24px", fontWeight: "700", color: "#1e293b", margin: "0 0 4px 0" }}>Dashboard</h1>
          <p style={{ fontSize: "14px", color: "#64748b", margin: 0 }}>Hoş geldin! İşte seçili dönemin özeti.</p>
        </div>
        <div style={{ display: "flex", gap: "6px", background: "#f1f5f9", padding: "4px", borderRadius: "12px" }}>
          {PERIODS.map((p) => (
            <button key={p.id} onClick={() => setPeriod(p.id)}
              style={{ padding: "8px 16px", background: period === p.id ? "white" : "transparent", color: period === p.id ? "#1e1b4b" : "#64748b", border: "none", borderRadius: "9px", fontSize: "13px", fontWeight: period === p.id ? "700" : "500", cursor: "pointer", boxShadow: period === p.id ? "0 1px 3px rgba(0,0,0,0.1)" : "none" }}>
              {p.label}
            </button>
          ))}
        </div>
      </div>

      {/* Ana kartlar */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(230px, 1fr))", gap: "20px", marginBottom: "24px" }}>
        {m.kartlar.map((k) => (
          <button key={k.id} onClick={k.git}
            style={{ background: "white", borderRadius: "16px", padding: "20px", boxShadow: "0 1px 3px rgba(0,0,0,0.05)", border: "none", cursor: "pointer", textAlign: "left", display: "block", width: "100%" }}>
            <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", marginBottom: "12px" }}>
              <div style={{ width: "48px", height: "48px", background: `${k.renk}15`, borderRadius: "12px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <k.icon size={24} color={k.renk} />
              </div>
              {k.delta.kind === "new" && (
                <span style={{ padding: "4px 10px", background: "#dcfce7", color: "#16a34a", borderRadius: "8px", fontSize: "12px", fontWeight: "700" }}>yeni</span>
              )}
              {(k.delta.kind === "up" || k.delta.kind === "down") && (
                <div style={{ display: "flex", alignItems: "center", gap: "4px", padding: "4px 8px", background: k.delta.kind === "up" ? "#dcfce7" : "#fee2e2", borderRadius: "8px" }}>
                  {k.delta.kind === "up" ? <TrendingUp size={14} color="#16a34a" /> : <TrendingDown size={14} color="#dc2626" />}
                  <span style={{ fontSize: "12px", fontWeight: "600", color: k.delta.kind === "up" ? "#16a34a" : "#dc2626" }}>{k.delta.text}</span>
                </div>
              )}
            </div>
            <p style={{ fontSize: "28px", fontWeight: "700", color: "#1e293b", margin: "0 0 2px 0" }}>{k.deger}</p>
            <p style={{ fontSize: "13px", color: "#64748b", margin: "0 0 8px 0" }}>{k.baslik}</p>
            {k.delta.kind !== "flat" && (
              <p style={{ fontSize: "11px", color: "#94a3b8", margin: "0 0 2px 0" }}>{m.label}</p>
            )}
            <p style={{ fontSize: "11px", color: "#94a3b8", margin: 0 }}>{k.alt}</p>
            {k.alt2 && <p title={k.alt2Title} style={{ fontSize: "11px", color: "#94a3b8", margin: "2px 0 0" }}>{k.alt2}</p>}
            {k.ekstra && <p style={{ fontSize: "11px", color: "#92400e", fontWeight: "600", margin: "4px 0 0" }}>{k.ekstra}</p>}
            {k.not && <p style={{ fontSize: "10px", color: "#dc2626", margin: "2px 0 0" }}>⚠ {k.not}</p>}
          </button>
        ))}
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: "20px" }}>
        {/* Dikkat gerektirenler */}
        <div style={{ background: "white", borderRadius: "16px", padding: "20px", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
          <h2 style={{ fontSize: "16px", fontWeight: "600", color: "#1e293b", margin: "0 0 16px 0", display: "flex", alignItems: "center", gap: "8px" }}>
            <ShieldAlert size={18} color="#d97706" /> Dikkat gerektirenler
          </h2>
          {m.dikkat.length === 0 ? (
            <div style={{ padding: "28px 20px", textAlign: "center", background: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: "12px" }}>
              <CheckCircle size={32} color="#16a34a" style={{ marginBottom: "8px" }} />
              <p style={{ fontSize: "15px", fontWeight: "700", color: "#166534", margin: 0 }}>Her şey yolunda ✓</p>
              <p style={{ fontSize: "12px", color: "#15803d", margin: "4px 0 0" }}>Bekleyen iş yok.</p>
            </div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
              {m.dikkat.map((d) => {
                const s = SEVIYE[d.seviye];
                return (
                  <button key={d.id} onClick={d.git}
                    style={{ width: "100%", display: "flex", alignItems: "center", gap: "12px", padding: "12px 14px", background: s.bg, border: `1px solid ${s.border}`, borderRadius: "12px", cursor: "pointer", textAlign: "left" }}>
                    <div style={{ width: "36px", height: "36px", background: s.ikonBg, borderRadius: "10px", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                      <d.icon size={18} color={s.renk} />
                    </div>
                    <div style={{ flex: 1 }}>
                      <p style={{ fontSize: "14px", fontWeight: "600", color: "#1e293b", margin: 0 }}>
                        <span style={{ color: s.renk, fontWeight: "800" }}>{d.sayi}</span> {d.metin}
                      </p>
                      {d.ipucu && <p style={{ fontSize: "11px", color: s.renk, margin: "2px 0 0", fontWeight: "600" }}>{d.ipucu}</p>}
                    </div>
                    <ChevronRight size={18} color="#94a3b8" />
                  </button>
                );
              })}
            </div>
          )}
        </div>

        {/* Son aktiviteler */}
        <div style={{ background: "white", borderRadius: "16px", padding: "20px", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
          <h2 style={{ fontSize: "16px", fontWeight: "600", color: "#1e293b", margin: "0 0 16px 0" }}>Son Aktiviteler</h2>
          <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
            {recentActivities.length === 0 ? (
              <p style={{ fontSize: "14px", color: "#64748b", textAlign: "center", padding: "20px" }}>Henüz aktivite yok</p>
            ) : (
              recentActivities.map((a) => (
                <div key={a.id} style={{ display: "flex", alignItems: "center", gap: "12px", padding: "12px", background: "#f8fafc", borderRadius: "10px" }}>
                  <div style={{ width: "36px", height: "36px", background: `${a.color}15`, borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center" }}><a.icon size={18} color={a.color} /></div>
                  <div style={{ flex: 1 }}><p style={{ fontSize: "13px", color: "#1e293b", margin: 0 }}>{a.message}</p><p style={{ fontSize: "11px", color: "#94a3b8", margin: "2px 0 0 0" }}>{a.time}</p></div>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

// ==================== CUSTOMERS PAGE (with Pagination + Detail Modal) ====================
const CustomersPage = ({ customers, allCustomers, setUserSuspended, deletedUsers = [], initialFilter = null }) => {
  // initialFilter yalnızca Dashboard'dan filtreli geliş için; menüden elle
  // girişte App() pageFilter'ı null'a çektiği için "all" olur.
  const [filter, setFilter] = useState(initialFilter || "all");
  const [selectedUser, setSelectedUser] = useState(null);
  const [bildirimHedef, setBildirimHedef] = useState(null); // "Bildirim gönder" penceresi
  // userType'ı bilinmeyen tombstone'lar (silme sırasında users okunamamışsa null kalır)
  // burada gösterilir — aksi halde hiçbir listede görünmez, sessizce kaybolurlardı.
  const deletedCustomers = deletedUsers.filter((u) => u.userType === "customer" || !u.userType);
  // Filtre, rozetle AYNI getUserState kaynağını kullanır — status alanı olmayan
  // kullanıcılar artık "Aktif" filtresine giriyor (eskiden hiçbirine girmiyorlardı)
  const filtered =
    filter === "all" ? customers
    : filter === "deleted" ? deletedCustomers
    : customers.filter((c) => getUserState(c) === filter);
  const { currentPage, totalPages, paginatedItems, goToPage, totalItems, startIndex, endIndex } = usePagination(filtered, 10);

  return (
    <div>
      {selectedUser && <UserDetailModal user={selectedUser} onClose={() => setSelectedUser(null)} onToggleSuspend={setUserSuspended} userType="customer" />}
      {bildirimHedef && <BireyselBildirimModal user={{ ...bildirimHedef, userType: "customer" }} onClose={() => setBildirimHedef(null)} />}

      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "24px", flexWrap: "wrap", gap: "12px" }}>
        <div>
          <h1 style={{ fontSize: "24px", fontWeight: "700", color: "#1e293b", margin: "0 0 4px 0" }}>Müşteriler</h1>
          <p style={{ fontSize: "14px", color: "#64748b", margin: 0 }}>
            {filter === "deleted" 
              ? `${deletedCustomers.length} silinmiş müşteri` 
              : customers.length !== allCustomers.length ? `${customers.length} / ${allCustomers.length} müşteri (arama sonucu)` : `Toplam ${customers.length} müşteri`}
            {deletedCustomers.length > 0 && filter !== "deleted" && <span style={{ color: "#dc2626", marginLeft: "8px" }}>({deletedCustomers.length} silinmiş)</span>}
          </p>
        </div>
        <select value={filter} onChange={(e) => setFilter(e.target.value)} style={{ padding: "10px 16px", border: "1px solid #e2e8f0", borderRadius: "10px", fontSize: "14px", outline: "none" }}>
          <option value="all">Tümü</option><option value="active">Aktif</option><option value="suspended">Askıya Alınmış</option><option value="deleted">Silinmiş Hesaplar</option>
        </select>
      </div>

      {filtered.length === 0 ? (
        <div style={{ background: "white", borderRadius: "16px", padding: "60px 20px", textAlign: "center", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
          <Users size={48} color="#94a3b8" style={{ marginBottom: "16px" }} />
          <p style={{ fontSize: "16px", fontWeight: "600", color: "#1e293b", margin: "0 0 8px 0" }}>Sonuç bulunamadı</p>
        </div>
      ) : (
        <div style={{ background: "white", borderRadius: "16px", overflow: "hidden", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
          <div style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead><tr style={{ background: "#f8fafc" }}>
                <th style={{ padding: "14px 16px", textAlign: "left", fontSize: "13px", fontWeight: "600", color: "#64748b" }}>Müşteri</th>
                <th style={{ padding: "14px 16px", textAlign: "left", fontSize: "13px", fontWeight: "600", color: "#64748b" }}>Konum</th>
                <th style={{ padding: "14px 16px", textAlign: "left", fontSize: "13px", fontWeight: "600", color: "#64748b" }}>Kayıt Tarihi</th>
                <th style={{ padding: "14px 16px", textAlign: "left", fontSize: "13px", fontWeight: "600", color: "#64748b" }}>Durum</th>
                <th style={{ padding: "14px 16px", textAlign: "right", fontSize: "13px", fontWeight: "600", color: "#64748b" }}>İşlemler</th>
              </tr></thead>
              <tbody>
                {paginatedItems.map((c) => (
                  // Silinmiş kayıtta detay modalı AÇILMAZ: users dokümanı yok,
                  // getDoc boş döner ve modal anlamsız/boş görünürdü.
                  <tr key={c.id} style={{ borderTop: "1px solid #f1f5f9", cursor: c.deleted ? "default" : "pointer" }} onClick={() => { if (!c.deleted) setSelectedUser(c); }}>
                    <td style={{ padding: "14px 16px" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                        <UserAvatarWithFallback user={{ ...c, userType: "customer" }} size={40} borderRadius="10px" />
                        <div>
                          <p style={{ fontSize: "14px", fontWeight: "600", color: c._tombstone ? "#94a3b8" : "#1e293b", margin: 0, fontStyle: c._tombstone ? "italic" : "normal" }}>
                            {c.name || c.displayName || "İsimsiz"}
                            {c._tombstone && !c.userType && <span style={{ marginLeft: "6px", padding: "1px 6px", background: "#f1f5f9", color: "#94a3b8", borderRadius: "4px", fontSize: "10px", fontWeight: "700" }}>TİP BİLİNMİYOR</span>}
                          </p>
                          {/* Tombstone'da kişisel veri YOK — e-posta yerine uid gösterilir */}
                          <p style={{ fontSize: "12px", color: "#64748b", margin: 0, fontFamily: c._tombstone ? "monospace" : "inherit" }}>
                            {c._tombstone ? c.id : (c.email || "-")}
                          </p>
                        </div>
                      </div>
                    </td>
                    <td style={{ padding: "14px 16px", fontSize: "14px", color: "#64748b" }}>{c._tombstone ? "—" : `${c.city || "-"}, ${c.district || "-"}`}</td>
                    <td style={{ padding: "14px 16px", fontSize: "14px", color: "#64748b" }}>{c.createdAt ? new Date(typeof c.createdAt === "object" && c.createdAt.seconds ? c.createdAt.seconds * 1000 : c.createdAt).toLocaleDateString("tr-TR") : "-"}</td>
                    <td style={{ padding: "14px 16px" }}>
                      {/* Rozet ve filtre AYNI getUserState kaynağını kullanır.
                          status alanının yokluğu ARTIK "Askıda" demek değil. */}
                      <span style={{ padding: "4px 10px", borderRadius: "20px", fontSize: "12px", fontWeight: "500", background: USER_STATE_LABELS[getUserState(c)].bg, color: USER_STATE_LABELS[getUserState(c)].color }}>
                        {USER_STATE_LABELS[getUserState(c)].text}
                      </span>
                    </td>
                    <td style={{ padding: "14px 16px", textAlign: "right" }} onClick={(e) => e.stopPropagation()}>
                      {c.deleted ? (
                        <span style={{ fontSize: "12px", color: "#9ca3af" }}>{c.deletedAt ? new Date(c.deletedAt).toLocaleDateString("tr-TR") : "—"}</span>
                      ) : (
                      <div style={{ display: "inline-flex", gap: "6px" }}>
                      <button onClick={() => setBildirimHedef(c)} title="Bu kullanıcıya bildirim gönder"
                        style={{ padding: "6px 10px", background: "#ede9fe", color: "#512da8", border: "none", borderRadius: "6px", fontSize: "12px", fontWeight: "500", cursor: "pointer", whiteSpace: "nowrap" }}>
                        Bildirim gönder
                      </button>
                      <button onClick={() => setUserSuspended(c, !isSuspended(c))}
                        style={{ padding: "6px 12px", background: isSuspended(c) ? "#dcfce7" : "#fee2e2", color: isSuspended(c) ? "#16a34a" : "#dc2626", border: "none", borderRadius: "6px", fontSize: "12px", fontWeight: "500", cursor: "pointer" }}>
                        {isSuspended(c) ? "Askıyı Kaldır" : "Askıya Al"}
                      </button>
                      </div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <PaginationBar currentPage={currentPage} totalPages={totalPages} goToPage={goToPage} totalItems={totalItems} startIndex={startIndex} endIndex={endIndex} />
        </div>
      )}
    </div>
  );
};

// ==================== EXPERTS PAGE (with Pagination + Detail Modal) ====================
// ==================== UZMAN KATEGORİLERİ (filtre ve toplu bildirim) ====================
// Uygulamanın yazdığı alanlar (isinebak2 uzmanTamamlamaVerisi): users.categories = ana kategori adları,
// users.subCategories = alt kategori adları (eski kayıtlarda { name }). Karşılaştırma Türkçe katlanmış adla.
// Seçenekler bellekteki uzmanlardan çıkar (yeni okuma yok). Alt kategori seçenekleri: seçili ana kategorideki
// uzmanların alt kategorileri (birden çok ana kategorisi olan uzmanın alt kategorisi hangi ana kategoriye ait
// bilinmediği için onunkiler de listelenir).
const uzmanAnaKategorileri = (e) => arzTalepAdListesi(e && e.categories);
const uzmanAltKategorileri = (e) => arzTalepAdListesi(e && e.subCategories);
const kategoriSecenekleri = (liste, adlar) => {
  const m = new Map();
  for (const e of liste || []) {
    const goruldu = new Set();
    for (const ad of adlar(e)) {
      const k = arzTalepAnahtar(ad);
      if (!k || goruldu.has(k)) continue;
      goruldu.add(k);
      if (!m.has(k)) m.set(k, { k, ad: ad.trim(), sayi: 0 });
      m.get(k).sayi++;
    }
  }
  return [...m.values()].sort((a, b) => a.ad.localeCompare(b.ad, "tr"));
};
// ana / alt: kategori anahtarı (arzTalepAnahtar) ya da "" (hepsi)
const uzmanKategorideMi = (e, ana, alt) =>
  (!ana || uzmanAnaKategorileri(e).some((x) => arzTalepAnahtar(x) === ana)) &&
  (!alt || uzmanAltKategorileri(e).some((x) => arzTalepAnahtar(x) === alt));
// Ana + isteğe bağlı alt kategori seçimi (Uzmanlar sayfası ve toplu bildirim)
const KategoriSecici = ({ uzmanlar, ana, alt, setAna, setAlt, stil }) => {
  const anaSecenekler = useMemo(() => kategoriSecenekleri(uzmanlar, uzmanAnaKategorileri), [uzmanlar]);
  const altSecenekler = useMemo(
    () => (ana ? kategoriSecenekleri((uzmanlar || []).filter((e) => uzmanKategorideMi(e, ana, "")), uzmanAltKategorileri) : []),
    [uzmanlar, ana]
  );
  const secimStili = { padding: "10px 14px", border: "1px solid #e2e8f0", borderRadius: "10px", fontSize: "14px", outline: "none", background: "white", ...(stil || {}) };
  return (
    <>
      <select value={ana} onChange={(ev) => { setAna(ev.target.value); setAlt(""); }} style={secimStili} title="Ana kategori">
        <option value="">Tüm kategoriler</option>
        {anaSecenekler.map((o) => <option key={o.k} value={o.k}>{o.ad} ({o.sayi})</option>)}
      </select>
      {ana && (
        <select value={alt} onChange={(ev) => setAlt(ev.target.value)} style={secimStili} title="Alt kategori (isteğe bağlı)">
          <option value="">Tüm alt kategoriler</option>
          {altSecenekler.map((o) => <option key={o.k} value={o.k}>{o.ad} ({o.sayi})</option>)}
        </select>
      )}
    </>
  );
};

const ExpertsPage = ({ experts, allExperts, setUserSuspended, jobs = [], deletedUsers = [], initialFilter = null }) => {
  const [filter, setFilter] = useState(initialFilter || "all");
  const [anaKategori, setAnaKategori] = useState("");
  const [altKategori, setAltKategori] = useState("");
  const [selectedUser, setSelectedUser] = useState(null);
  const [bildirimHedef, setBildirimHedef] = useState(null); // "Bildirim gönder" penceresi
  const deletedExperts = deletedUsers.filter((u) => u.userType === "expert");
  // Filtre, rozetle AYNI getUserState kaynağını kullanır. status'ü olmayan uzman
  // verified'a göre "active"/"pending" sayılır — Başvurular sayfasıyla tutarlı olur.
  // BELGE filtreleri hesap durumundan bağımsızdır (getUserState'e dokunulmaz):
  // _pendingDocCount listener'da türetiliyor, belge alanları atılmadan önce.
  const durumaGore =
    filter === "all" ? experts
    : filter === "deleted" ? deletedExperts
    : filter === "docs_pending" ? experts.filter((e) => (e._pendingDocCount || 0) > 0)
    : filter === "verified_docs_pending" ? experts.filter((e) => e.verified === true && (e._pendingDocCount || 0) > 0)
    : experts.filter((e) => getUserState(e) === filter);
  // Kategori filtresi durum filtresinin üstüne uygulanır (silinmiş kayıtta kategori yok: orada kapalı)
  const kategoriAcik = filter !== "deleted" && !!anaKategori;
  const filtered = kategoriAcik ? durumaGore.filter((e) => uzmanKategorideMi(e, anaKategori, altKategori)) : durumaGore;
  const { currentPage, totalPages, paginatedItems, goToPage, totalItems, startIndex, endIndex } = usePagination(filtered, 10);

  // Uzmanın tamamladığı iş sayısını hesapla
  const getCompletedJobsCount = (expertId) => {
    return jobs.filter(j => 
      (j.expertId === expertId || j.assignedExpertId === expertId || j.acceptedExpertId === expertId) && 
      j.status === "completed"
    ).length;
  };

  return (
    <div>
      {selectedUser && <UserDetailModal user={selectedUser} onClose={() => setSelectedUser(null)} onToggleSuspend={setUserSuspended} userType="expert" jobs={jobs} />}
      {bildirimHedef && <BireyselBildirimModal user={{ ...bildirimHedef, userType: "expert" }} onClose={() => setBildirimHedef(null)} />}

      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "24px", flexWrap: "wrap", gap: "12px" }}>
        <div>
          <h1 style={{ fontSize: "24px", fontWeight: "700", color: "#1e293b", margin: "0 0 4px 0" }}>Uzmanlar</h1>
          <p style={{ fontSize: "14px", color: "#64748b", margin: 0 }}>
            {filter === "deleted" 
              ? `${deletedExperts.length} silinmiş uzman` 
              : experts.length !== allExperts.length ? `${experts.length} / ${allExperts.length} uzman (arama sonucu)` : `Toplam ${experts.length} uzman`}
            {deletedExperts.length > 0 && filter !== "deleted" && <span style={{ color: "#dc2626", marginLeft: "8px" }}>({deletedExperts.length} silinmiş)</span>}
            {kategoriAcik && <span style={{ color: "#4f46e5", marginLeft: "8px" }}>· kategoride {filtered.length}</span>}
          </p>
        </div>
        <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
        {filter !== "deleted" && (
          <KategoriSecici uzmanlar={experts} ana={anaKategori} alt={altKategori} setAna={setAnaKategori} setAlt={setAltKategori} />
        )}
        <select value={filter} onChange={(e) => setFilter(e.target.value)} style={{ padding: "10px 16px", border: "1px solid #e2e8f0", borderRadius: "10px", fontSize: "14px", outline: "none" }}>
          <option value="all">Tümü</option><option value="active">Aktif</option><option value="pending">Onay Bekliyor</option><option value="rejected">Reddedildi</option><option value="suspended">Askıya Alınmış</option><option value="deleted">Silinmiş Hesaplar</option>
          <option value="docs_pending">📄 Belgesi Onay Bekliyor</option>
          <option value="verified_docs_pending">📄 Onaylı Uzman, Belge Bekliyor</option>
        </select>
        </div>
      </div>

      {filtered.length === 0 ? (
        <div style={{ background: "white", borderRadius: "16px", padding: "60px 20px", textAlign: "center", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
          <UserCheck size={48} color="#94a3b8" style={{ marginBottom: "16px" }} />
          <p style={{ fontSize: "16px", fontWeight: "600", color: "#1e293b", margin: "0 0 8px 0" }}>Sonuç bulunamadı</p>
        </div>
      ) : (
        <div style={{ background: "white", borderRadius: "16px", overflow: "hidden", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
          <div style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead><tr style={{ background: "#f8fafc" }}>
                <th style={{ padding: "14px 16px", textAlign: "left", fontSize: "13px", fontWeight: "600", color: "#64748b" }}>Uzman</th>
                <th style={{ padding: "14px 16px", textAlign: "left", fontSize: "13px", fontWeight: "600", color: "#64748b" }}>Hizmetler</th>
                <th style={{ padding: "14px 16px", textAlign: "left", fontSize: "13px", fontWeight: "600", color: "#64748b" }}>Puan</th>
                <th style={{ padding: "14px 16px", textAlign: "left", fontSize: "13px", fontWeight: "600", color: "#64748b" }}>Tamamlanan İş</th>
                <th style={{ padding: "14px 16px", textAlign: "left", fontSize: "13px", fontWeight: "600", color: "#64748b" }}>Deneme/Premium</th>
                <th style={{ padding: "14px 16px", textAlign: "left", fontSize: "13px", fontWeight: "600", color: "#64748b" }}>Durum</th>
                <th style={{ padding: "14px 16px", textAlign: "right", fontSize: "13px", fontWeight: "600", color: "#64748b" }}>İşlemler</th>
              </tr></thead>
              <tbody>
                {paginatedItems.map((e) => (
                  // Silinmiş kayıtta detay modalı AÇILMAZ (users dokümanı yok)
                  <tr key={e.id} style={{ borderTop: "1px solid #f1f5f9", cursor: e.deleted ? "default" : "pointer" }} onClick={() => { if (!e.deleted) setSelectedUser(e); }}>
                    <td style={{ padding: "14px 16px" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                        <UserAvatarWithFallback user={{ ...e, userType: "expert" }} size={40} borderRadius="10px" />
                        <div>
                          <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                            <p style={{ fontSize: "14px", fontWeight: "600", color: e._tombstone ? "#94a3b8" : "#1e293b", margin: 0, fontStyle: e._tombstone ? "italic" : "normal" }}>{e.name || e.displayName || "İsimsiz"}</p>
                            {e.verified && <CheckCircle size={14} color="#16a34a" />}
                            {/* Yıldız yalnızca GERÇEKTEN aktif premiumda — ham isPremium
                                bayrağı süresi dolduğunda bayat kalıyor */}
                            {getPremiumState(e) === "active" && <Star size={14} color="#d97706" fill="#d97706" />}
                            {/* Belge onay kuyruğu rozeti — _pendingDocCount listener'da türetiliyor */}
                            {(e._pendingDocCount || 0) > 0 && (
                              <span
                                title="İncelenmeyi bekleyen belge var — detayı açıp onaylayın"
                                style={{ display: "inline-flex", alignItems: "center", gap: "3px", padding: "2px 7px", background: "#fef3c7", color: "#92400e", borderRadius: "20px", fontSize: "11px", fontWeight: "700", whiteSpace: "nowrap" }}
                              >
                                📄 {e._pendingDocCount} belge bekliyor
                              </span>
                            )}
                          </div>
                          {/* Tombstone'da kişisel veri YOK — e-posta yerine uid gösterilir */}
                          <p style={{ fontSize: "12px", color: "#64748b", margin: 0, fontFamily: e._tombstone ? "monospace" : "inherit" }}>{e._tombstone ? e.id : (e.email || "-")}</p>
                        </div>
                      </div>
                    </td>
                    <td style={{ padding: "14px 16px" }}>
  <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
    {(e.categories || e.services || e.subCategories || []).length > 0 ? (
      <>
        {(e.categories || e.services || e.subCategories || []).slice(0, 2).map((s, i) => (<span key={i} style={{ padding: "2px 8px", background: "#e0e7ff", borderRadius: "4px", fontSize: "11px", color: "#4f46e5" }}>{typeof s === 'string' ? s : s?.name || s?.title || s}</span>))}
        {(e.categories || e.services || e.subCategories || []).length > 2 && <span style={{ padding: "2px 8px", background: "#f1f5f9", borderRadius: "4px", fontSize: "11px", color: "#64748b" }}>+{(e.categories || e.services || e.subCategories || []).length - 2}</span>}
      </>
    ) : (
      <span style={{ fontSize: "12px", color: "#94a3b8" }}>Hizmet yok</span>
    )}
  </div>
</td>
                    <td style={{ padding: "14px 16px" }}><div style={{ display: "flex", alignItems: "center", gap: "4px" }}><Star size={14} color="#f59e0b" fill="#f59e0b" /><span style={{ fontSize: "14px", fontWeight: "600", color: "#1e293b" }}>{e.rating || "-"}</span></div></td>
                    <td style={{ padding: "14px 16px", fontSize: "14px", fontWeight: "600", color: "#1e293b" }}>{getCompletedJobsCount(e.id)} iş</td>
                    <td style={{ padding: "14px 16px" }}>
                      {/* Premium durumu Premium Yönetimi sayfasıyla AYNI kaynaktan gelir.
                          Trial dallarına dokunulmadı — yalnızca premium'u olmayanlar oraya düşer. */}
                      {getPremiumState(e) === "active" ? (
                        <span style={{ padding: "4px 10px", borderRadius: "20px", fontSize: "12px", fontWeight: "600", background: "linear-gradient(135deg, #fef3c7, #fde68a)", color: "#92400e", display: "inline-flex", alignItems: "center", gap: "4px" }}>👑 Premium</span>
                      ) : getPremiumState(e) === "expired" ? (
                        <span style={{ padding: "4px 10px", borderRadius: "20px", fontSize: "12px", fontWeight: "500", background: "#f3f4f6", color: "#6b7280", display: "inline-flex", alignItems: "center", gap: "4px" }}>👑 Süresi Doldu</span>
                      ) : getPremiumState(e) === "cancelled" ? (
                        <span style={{ padding: "4px 10px", borderRadius: "20px", fontSize: "12px", fontWeight: "500", background: "#fef3c7", color: "#d97706", display: "inline-flex", alignItems: "center", gap: "4px" }}>👑 İptal Edildi</span>
                      ) : e.trialActive && e.trialEndDate && new Date(e.trialEndDate) > new Date() ? (
                        <span style={{ padding: "4px 10px", borderRadius: "20px", fontSize: "12px", fontWeight: "500", background: "#ede9fe", color: "#7c3aed" }}>
                          🎁 {Math.ceil((new Date(e.trialEndDate) - new Date()) / (1000 * 60 * 60 * 24))} gün
                        </span>
                      ) : e.trialEndDate ? (
                        <span style={{ padding: "4px 10px", borderRadius: "20px", fontSize: "12px", fontWeight: "500", background: "#fee2e2", color: "#dc2626" }}>⏰ Doldu</span>
                      ) : (
                        <span style={{ fontSize: "12px", color: "#94a3b8" }}>—</span>
                      )}
                    </td>
                    <td style={{ padding: "14px 16px" }}>
                      {/* Rozet ve filtre AYNI getUserState kaynağını kullanır.
                          pending/rejected dalları korunur; status yoksa verified'a düşer. */}
                      <span style={{ padding: "4px 10px", borderRadius: "20px", fontSize: "12px", fontWeight: "500", background: USER_STATE_LABELS[getUserState(e)].bg, color: USER_STATE_LABELS[getUserState(e)].color }}>
                        {USER_STATE_LABELS[getUserState(e)].text}
                      </span>
                    </td>
                    <td style={{ padding: "14px 16px", textAlign: "right" }} onClick={(ev) => ev.stopPropagation()}>
                      {e.deleted ? (
                        <span style={{ fontSize: "12px", color: "#9ca3af" }}>{e.deletedAt ? new Date(e.deletedAt).toLocaleDateString("tr-TR") : "—"}</span>
                      ) : (
                      <div style={{ display: "inline-flex", gap: "6px" }}>
                      <button onClick={() => setBildirimHedef(e)} title="Bu kullanıcıya bildirim gönder"
                        style={{ padding: "6px 10px", background: "#ede9fe", color: "#512da8", border: "none", borderRadius: "6px", fontSize: "12px", fontWeight: "500", cursor: "pointer", whiteSpace: "nowrap" }}>
                        Bildirim gönder
                      </button>
                      <button onClick={() => setUserSuspended(e, !isSuspended(e))}
                        style={{ padding: "6px 12px", background: isSuspended(e) ? "#dcfce7" : "#fee2e2", color: isSuspended(e) ? "#16a34a" : "#dc2626", border: "none", borderRadius: "6px", fontSize: "12px", fontWeight: "500", cursor: "pointer" }}>
                        {isSuspended(e) ? "Askıyı Kaldır" : "Askıya Al"}
                      </button>
                      </div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <PaginationBar currentPage={currentPage} totalPages={totalPages} goToPage={goToPage} totalItems={totalItems} startIndex={startIndex} endIndex={endIndex} />
        </div>
      )}
    </div>
  );
};

// ==================== APPLICATIONS PAGE ====================
const ApplicationsPage = ({ experts, approveExpert, rejectExpert }) => {
  const pending = experts.filter((e) => !e.verified || e.status === "pending");
  const { currentPage, totalPages, paginatedItems, goToPage, totalItems, startIndex, endIndex } = usePagination(pending, 10);

  return (
    <div>
      <div style={{ marginBottom: "24px" }}>
        <h1 style={{ fontSize: "24px", fontWeight: "700", color: "#1e293b", margin: "0 0 4px 0" }}>Uzman Başvuruları</h1>
        <p style={{ fontSize: "14px", color: "#64748b", margin: 0 }}>{pending.length} başvuru onay bekliyor</p>
      </div>
      {pending.length === 0 ? (
        <div style={{ background: "white", borderRadius: "16px", padding: "60px 20px", textAlign: "center", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
          <CheckCircle size={48} color="#16a34a" style={{ marginBottom: "16px" }} />
          <p style={{ fontSize: "16px", fontWeight: "600", color: "#1e293b", margin: "0 0 8px 0" }}>Tüm başvurular incelendi!</p>
          <p style={{ fontSize: "14px", color: "#64748b", margin: 0 }}>Bekleyen başvuru bulunmuyor.</p>
        </div>
      ) : (
        <>
          <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
            {paginatedItems.map((e) => (
              <div key={e.id} style={{ background: "white", borderRadius: "16px", padding: "20px", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
                <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", flexWrap: "wrap", gap: "16px" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
                    <UserAvatarWithFallback user={{ ...e, userType: "expert" }} size={56} borderRadius="12px" fontSize="20px" />
                    <div>
                      <h3 style={{ fontSize: "16px", fontWeight: "600", color: "#1e293b", margin: "0 0 4px 0" }}>{e.name || e.displayName || "İsimsiz"}</h3>
                      <p style={{ fontSize: "13px", color: "#64748b", margin: "0 0 4px 0" }}>{e.email || "-"}</p>
                      <p style={{ fontSize: "13px", color: "#64748b", margin: 0 }}>{e.phone || "-"}</p>
                    </div>
                  </div>
                  <div style={{ display: "flex", gap: "8px" }}>
                    <button onClick={() => rejectExpert(e.id)} style={{ padding: "10px 20px", background: "#fee2e2", color: "#dc2626", border: "none", borderRadius: "10px", fontSize: "14px", fontWeight: "600", cursor: "pointer", display: "flex", alignItems: "center", gap: "6px" }}><XCircle size={18} /> Reddet</button>
                    <button onClick={() => approveExpert(e.id)} style={{ padding: "10px 20px", background: "#16a34a", color: "white", border: "none", borderRadius: "10px", fontSize: "14px", fontWeight: "600", cursor: "pointer", display: "flex", alignItems: "center", gap: "6px" }}><CheckCircle size={18} /> Onayla</button>
                  </div>
                </div>
                <div style={{ marginTop: "16px", paddingTop: "16px", borderTop: "1px solid #f1f5f9", display: "flex", flexWrap: "wrap", gap: "24px" }}>
                  <div><p style={{ fontSize: "12px", color: "#94a3b8", margin: "0 0 4px 0" }}>Konum</p><p style={{ fontSize: "14px", color: "#1e293b", margin: 0 }}>{e.city || "-"}, {e.district || "-"}</p></div>
                  <div><p style={{ fontSize: "12px", color: "#94a3b8", margin: "0 0 4px 0" }}>Hizmetler</p><div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>{(e.services || []).map((s, i) => (<span key={i} style={{ padding: "2px 8px", background: "#e0e7ff", borderRadius: "4px", fontSize: "12px", color: "#4f46e5" }}>{s}</span>))}</div></div>
                  <div><p style={{ fontSize: "12px", color: "#94a3b8", margin: "0 0 4px 0" }}>Başvuru Tarihi</p><p style={{ fontSize: "14px", color: "#1e293b", margin: 0 }}>{e.createdAt ? new Date(typeof e.createdAt === "object" && e.createdAt.seconds ? e.createdAt.seconds * 1000 : e.createdAt).toLocaleDateString("tr-TR") : "-"}</p></div>
                </div>
              </div>
            ))}
          </div>
          {totalPages > 1 && (
            <div style={{ background: "white", borderRadius: "16px", marginTop: "16px", overflow: "hidden" }}>
              <PaginationBar currentPage={currentPage} totalPages={totalPages} goToPage={goToPage} totalItems={totalItems} startIndex={startIndex} endIndex={endIndex} />
            </div>
          )}
        </>
      )}
    </div>
  );
};

// ==================== JOBS PAGE (with Pagination) ====================
// ==================== DOĞRUDAN TALEP: UZMAN TEŞHİSİ ====================
// "Uzman yanıtı bekleyen talep" listesinde admin'in kime, neden ulaşacağını
// görmesi için. Veri bellekteki users listesinden gelir (resolveUser); ek
// Firestore okuması YOK.
//
// Ana uygulamadaki kapılar (isinebak2/src/App.js):
//   - Talebe TEKLİF göndermek (handleSendQuote → "proposal_sent") isSubscribed
//     ister: premium VEYA deneme geçerli. Kimlik kontrolü bu yolda YOKTUR
//     (kimlik onayı yalnızca açık ilana teklifte, submitProposal'da aranır).
//   - Talebi REDDETMEK için kapı yok.
//   - Askıya alınmış / silinmiş hesap giriş yapamaz.
// Ana uygulamada "son giriş" alanı YOK. En yakın vekil fcmTokenUpdatedAt:
//   - push izni verilmiş her oturum açılışında token ile birlikte yazılır
//   - çıkışta fcmToken:null ile birlikte yazılır
const formatWaiting = (ms) => {
  if (!ms || ms < 0) return "—";
  const dk = Math.floor(ms / 60000);
  if (dk < 60) return `${Math.max(dk, 1)} dk`;
  const saat = Math.floor(dk / 60);
  if (saat < 24) return `${saat} saat`;
  return `${Math.floor(saat / 24)} gün`;
};

// Test hesabı: ortak tanım (testDurumu, dosyanın başında). admin bağlamı PanelVeriSaglayici'dan.
const talepUzmanTeshisi = (uid, resolveUser, now = Date.now(), admin = null) => {
  if (!uid) {
    return { yok: true, silinmis: false, hesap: null, yanitVerebilir: false, engel: "Talepte uzman kaydı yok" };
  }
  const r = resolveUser(uid);
  if (r.missing || r.deleted || !r.raw) {
    return {
      uid, ad: r.name, silinmis: true, hesap: "deleted", raw: null,
      yanitVerebilir: false, engel: "Uzman hesabı silinmiş",
      silinmeAt: toMillis(r.deletedAt),
    };
  }
  const u = r.raw;
  const hesap = getUserState(u); // active | suspended | pending | rejected
  const abonelik = teklifAbonelikGecerli(u, new Date(now));
  const kimlik = u._teklifKimlik || null;
  const tokenAt = toMillis(u.fcmTokenUpdatedAt);
  const oturum = u.fcmToken
    ? (tokenAt ? { tur: "aktif", at: tokenAt } : { tur: "aktif", at: 0 })
    : (tokenAt ? { tur: "cikis", at: tokenAt } : { tur: "yok", at: 0 });

  // Teklif gönderebilmek için uygulamanın aradığı koşullar
  let engel = null;
  if (hesap === "suspended") engel = "Hesap askıda — giriş yapamaz";
  else if (!abonelik) engel = "Abonelik/deneme yok — teklif gönderemez (reddedebilir)";

  return {
    uid, ad: r.name, raw: u, silinmis: false, hesap,
    iletisim: u.phone || u.email || "",
    push: !!u.fcmToken, pushGecersizAt: toMillis(u.fcmTokenInvalidAt),
    abonelik,
    trialde: u.trialActive === true && toMillis(u.trialEndDate) > now,
    kimlikYuklendi: !!(kimlik && kimlik.kimlikYuklendi),
    kimlikOnayli: !!(kimlik && kimlik.kimlikOnayli),
    oturum,
    platform: u.devicePlatform || null,
    elleMi: u.premiumPlan === "admin_granted",
    elleAktifMi: u.premiumPlan === "admin_granted" && getPremiumState(u) === "active",
    testMi: testDurumu({ uid, email: u.email, ad: [u.name, u.displayName] }, admin) !== null,
    yanitVerebilir: !engel,
    engel,
  };
};

// ==================== İLAN / TALEP AYRINTI PENCERESİ ====================
// Veri bellekteki jobs/requests'ten gelir (canlı). Tek ek okuma: ana belgede adres ya da
// telefon yoksa {jobs|requests}/{id}/private/contact (pencere açılınca, bir kez).
// Kural notu (isinebak2/firestore.rules, 29 Ekim): private/{docId} için kural YOK — admin
// dahil kimse okuyamaz. İzin, yayınlanmamış 3.2 kural paketinde (docs/kural_paketi_3_2).
const ILAN_TARIH_ALANLARI = [
  ["createdAt", "Oluşturuldu"], ["updatedAt", "Son güncelleme"], ["acceptedAt", "Kabul edildi"],
  ["startedAt", "Başladı"], ["completedAt", "Tamamlandı"], ["cancelledAt", "İptal edildi"],
  ["rejectedAt", "Reddedildi"], ["expiredAt", "Süresi doldu"],
];
const ILAN_ACILIYET = { normal: "Normal", urgent: "Acil", acil: "Acil", flexible: "Esnek", asap: "En kısa sürede" };
const ILAN_BUTCE_TURU = { fixed: "sabit", hourly: "saatlik", negotiable: "pazarlıklı", starting: "başlangıç" };
const resimKaynagiMi = (v) => typeof v === "string" && /^(data:image\/|https?:\/\/)/i.test(v);

// Müşterinin yazdığı metinler (isinebak2/src/App.js, 29 Ekim):
//   createJob (ilan formu)            → title, description
//   akıllı eşleştirme (smart_match)   → description
//   uzman profili "Teklif İste"       → description, additionalNotes (source: expert_profile)
//   hizmet siparişi (createServiceRequest) → description (formdaki "notlar"; source yazılmaz)
//   destek talebi yedeği (requests)   → message (+ messages[])
// Eski / başka yollardan gelebilecek adlar da listede; bilinmeyenler "Diğer alanlar"da görünür.
const MUSTERI_METIN_ALANLARI = [
  ["description", "Açıklama"], ["additionalNotes", "Ek notlar"], ["notes", "Müşteri notu"],
  ["customerNote", "Müşteri notu"], ["customerNotes", "Müşteri notları"], ["message", "Mesaj"],
  ["details", "Ayrıntı"], ["requestText", "Talep metni"],
];
const musteriMetinleri = (j) =>
  MUSTERI_METIN_ALANLARI.filter(([k]) => typeof j[k] === "string" && j[k].trim()).map(([k, ad]) => ({ k, ad, metin: j[k] }));
const TALEP_KAYNAK_AD = { smart_match: "Akıllı eşleştirme", expert_profile: "Uzman profilinden Teklif İste", service_order: "Hizmet siparişi" };
const talepKaynagi = (j) => {
  if (j.requestType === "support_ticket") return { ad: "Destek talebi (yedek kayıt)", alan: "requestType" };
  if (j.source) return { ad: TALEP_KAYNAK_AD[j.source] || j.source, alan: "source" };
  // createServiceRequest source yazmıyor; estimatedPrice yalnızca o yolda yazılıyor
  if (j._source === "requests" && "estimatedPrice" in j) return { ad: "Hizmet siparişi", tahmin: true };
  return null;
};
// Pencerede ayrıca gösterilen ya da gösterilmesi gerekmeyen alanlar; geri kalan her şey "Diğer alanlar"
const ILAN_BILINEN_ALANLAR = new Set([
  "id", "_source", "title", "service", "category", "subCategory", "city", "district", "location", "address",
  "customerPhone", "phone", "budget", "budgetType", "budgetRange", "budgetPreference", "estimatedPrice",
  "agreedPrice", "acceptedPrice", "finalPrice", "urgency", "preferredDate", "preferredTime", "canBeOnline",
  "status", "statusHistory", "cancelReason", "customerId", "customerName", "customerEmail", "customerPhoto",
  "expertId", "expertName", "expertPhoto", "expertEmail", "assignedExpertId", "acceptedExpertId",
  "images", "photos", "proposals", "proposalCount", "source", "requestType", "contactPhone", "contactChat",
  "moderation", "moderationStatus", "hidden", "hiddenReason", "hiddenAt", "hiddenBy", "flagged", "flagReason",
  ...MUSTERI_METIN_ALANLARI.map(([k]) => k),
]);
// Görüntülenebilir hâl: base64 içerik yerine boyut yazılır
const alanDegeriMetni = (v) => JSON.stringify(v, (k, x) => (typeof x === "string" && /^data:/i.test(x) ? `[base64 ${Math.round(x.length / 1024)} KB]` : x), 2);
const digerAlanlar = (j) =>
  Object.keys(j)
    .filter((k) => !ILAN_BILINEN_ALANLAR.has(k) && !(/At$/.test(k) && toMillis(j[k])) && !/Photo$/i.test(k))
    .filter((k) => j[k] !== undefined && j[k] !== null && j[k] !== "" && !(Array.isArray(j[k]) && j[k].length === 0))
    .sort((a, b) => a.localeCompare(b))
    .map((k) => ({ k, metin: typeof j[k] === "string" ? (/^data:/i.test(j[k]) ? `[base64 ${Math.round(j[k].length / 1024)} KB]` : j[k]) : typeof j[k] === "object" ? alanDegeriMetni(j[k]) : String(j[k]) }));
// Listedeki kısa önizleme: ilk müşteri metni ~120 karakter; ipucunda bütün metinler
const ILAN_ONIZLEME_SINIRI = 120;
const ilanOnizlemesi = (j) => {
  const metinler = musteriMetinleri(j);
  if (!metinler.length) return null;
  const ilk = metinler[0].metin.replace(/\s+/g, " ").trim();
  return {
    kisa: ilk.length > ILAN_ONIZLEME_SINIRI ? ilk.slice(0, ILAN_ONIZLEME_SINIRI).trimEnd() + "…" : ilk,
    tam: metinler.map((m) => (metinler.length > 1 ? `${m.ad}: ${m.metin}` : m.metin)).join("\n\n"),
  };
};

const IlanDetayModal = ({ ilan, resolveUser, onClose, updateJobStatus, onToggleSuspend }) => {
  const [iletisim, setIletisim] = useState({ durum: "gerekmiyor" }); // gerekmiyor | yukleniyor | tamam | yok | hata
  const [buyukResim, setBuyukResim] = useState(null);
  const [acikKullanici, setAcikKullanici] = useState(null); // { user, userType }
  const [bildirimHedef, setBildirimHedef] = useState(null);
  const j = ilan;
  const talepMi = j._source === "requests";
  const koleksiyon = talepMi ? "requests" : "jobs";
  const anaAdres = typeof j.address === "string" && j.address.trim() ? j.address : "";
  const anaTelefon = [j.customerPhone, j.phone].find((v) => typeof v === "string" && v.trim()) || "";

  // Adres ya da telefon ana belgede yoksa alt belgeyi dene (yalnızca pencere açılınca)
  useEffect(() => {
    if (anaAdres && anaTelefon) { setIletisim({ durum: "gerekmiyor" }); return undefined; }
    let iptal = false;
    setIletisim({ durum: "yukleniyor" });
    getDoc(doc(db, koleksiyon, j.id, "private", "contact"))
      .then((s) => { if (!iptal) setIletisim(s.exists() ? { durum: "tamam", veri: s.data() || {} } : { durum: "yok" }); })
      .catch((e) => { if (!iptal) setIletisim({ durum: "hata", kod: (e && e.code) || "hata" }); });
    return () => { iptal = true; };
  }, [koleksiyon, j.id, anaAdres, anaTelefon]);

  const alt = iletisim.durum === "tamam" ? iletisim.veri : {};
  const adres = anaAdres || alt.address || "";
  const telefon = anaTelefon || alt.customerPhone || alt.phone || "";
  const kaynak = (anaDeger, altDeger) => (anaDeger ? "ilan" : altDeger ? "private/contact" : null);

  const musteriUid = j.customerId || j.userId || j.createdBy || null;
  const musteri = musteriUid && resolveUser ? resolveUser(musteriUid) : null;
  const musteriRaw = musteri && !musteri.missing ? musteri.raw : null;
  const musteriDurum = musteriRaw ? getUserState(musteriRaw) : musteri && musteri.missing ? "deleted" : null;
  const musteriEposta = (musteri && (musteri.email || (musteri.raw && musteri.raw.email))) || j.customerEmail || "";
  const musteriTelefon = (musteriRaw && musteriRaw.phone) || "";

  const uzmanBilgi = (uid, yedekAd) => {
    if (!uid) return null;
    const r = resolveUser ? resolveUser(uid) : null;
    return { uid, r, ad: (r && !r.missing && r.name) || yedekAd || (r && r.missing ? "Silinmiş Kullanıcı" : uid) };
  };
  const hedefUzman = uzmanBilgi(j.expertId || j.assignedExpertId, j.expertName);
  const kabulEdilen = !talepMi ? uzmanBilgi(j.acceptedExpertId, null) : null;
  const teklifler = Array.isArray(j.proposals) ? [...j.proposals].sort((a, b) => toMillis(a.createdAt) - toMillis(b.createdAt)) : [];

  const resimler = [...(Array.isArray(j.images) ? j.images : []), ...(Array.isArray(j.photos) ? j.photos : [])]
    .map((x) => (x && typeof x === "object" ? x.url || x.src : x))
    .filter((x) => typeof x === "string" && x.trim());

  const tarihler = [
    ...ILAN_TARIH_ALANLARI.filter(([k]) => j[k]).map(([k, ad]) => ({ ad, at: j[k] })),
    // Listede olmayan *At alanları (ör. ileride eklenenler)
    ...Object.keys(j).filter((k) => /At$/.test(k) && !ILAN_TARIH_ALANLARI.some(([a]) => a === k) && toMillis(j[k])).map((k) => ({ ad: k, at: j[k] })),
  ].sort((a, b) => toMillis(a.at) - toMillis(b.at));
  const gecmis = Array.isArray(j.statusHistory) ? j.statusHistory : [];
  const moderasyon = ["moderation", "moderationStatus", "hidden", "hiddenReason", "hiddenAt", "hiddenBy", "flagged", "flagReason"]
    .filter((k) => j[k] !== undefined && j[k] !== null && j[k] !== "");

  const metinler = musteriMetinleri(j);
  const kaynakBilgisi = talepKaynagi(j);
  const digerler = digerAlanlar(j);
  const durum = jobStatusInfo(j.status);
  const iptalEdilebilir = j.status !== "cancelled";
  const iptalEt = () => {
    if (!iptalEdilebilir) return;
    if (!window.confirm(`"${j.title || j.service || "İş"}" ${talepMi ? "talebi" : "ilanı"} İPTAL edilecek (durum: cancelled).\n\nDevam edilsin mi?`)) return;
    updateJobStatus(j.id, "cancelled");
  };
  // setUserSuspended kendi onay penceresini açar
  const askiDegistir = () => { if (musteriRaw && onToggleSuspend) onToggleSuspend(musteriRaw, !isSuspended(musteriRaw)); };
  const bildirimAc = () => {
    if (!musteriRaw) return;
    if (!window.confirm(`"${musteri.name}" kullanıcısına bildirim penceresi açılacak.\n\nDevam edilsin mi?`)) return;
    setBildirimHedef({ ...musteriRaw, userType: "customer" });
  };

  const bolum = (baslik, icerik) => (
    <div style={{ marginBottom: "16px" }}>
      <p style={{ fontSize: "12px", fontWeight: "700", color: "#64748b", textTransform: "uppercase", letterSpacing: "0.03em", margin: "0 0 6px" }}>{baslik}</p>
      {icerik}
    </div>
  );
  const satir = (ad, deger, ek) => (
    <div style={{ display: "flex", gap: "10px", fontSize: "13px", padding: "4px 0", borderBottom: "1px solid #f8fafc" }}>
      <span style={{ width: "130px", flexShrink: 0, color: "#94a3b8" }}>{ad}</span>
      <span style={{ color: "#1e293b", wordBreak: "break-word", whiteSpace: "pre-wrap" }}>{deger === undefined || deger === null || deger === "" ? <span style={{ color: "#cbd5e1" }}>—</span> : deger}{ek}</span>
    </div>
  );
  const kaynakEtiketi = (k) => k === "private/contact" ? <span style={{ marginLeft: "6px", fontSize: "11px", color: "#6d28d9" }}>(private/contact)</span> : null;
  const kisiDugmesi = (bilgi, userType) => bilgi && bilgi.r && !bilgi.r.missing && bilgi.r.raw ? (
    <button onClick={() => setAcikKullanici({ user: bilgi.r.raw, userType })} style={{ background: "none", border: "none", padding: 0, color: "#4f46e5", textDecoration: "underline", cursor: "pointer", fontSize: "13px", fontWeight: "600" }}>{bilgi.ad}</button>
  ) : <span style={{ color: "#94a3b8", fontStyle: "italic" }}>{bilgi ? bilgi.ad : "—"}</span>;
  const islemDugmesi = (renk, arka, pasif) => ({ flex: "1 1 160px", padding: "11px", background: pasif ? "#f1f5f9" : arka, color: pasif ? "#94a3b8" : renk, border: "none", borderRadius: "10px", fontSize: "13px", fontWeight: "600", cursor: pasif ? "default" : "pointer", display: "flex", alignItems: "center", justifyContent: "center", gap: "6px" });

  return (
    <div onClick={onClose} style={{ position: "fixed", inset: 0, background: "rgba(15,23,42,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 90, padding: "16px" }}>
      {acikKullanici && (
        <div onClick={(e) => e.stopPropagation()}>
          <UserDetailModal user={acikKullanici.user} onClose={() => setAcikKullanici(null)} onToggleSuspend={onToggleSuspend || (() => {})} userType={acikKullanici.userType} />
        </div>
      )}
      {bildirimHedef && <div onClick={(e) => e.stopPropagation()}><BireyselBildirimModal user={bildirimHedef} onClose={() => setBildirimHedef(null)} /></div>}
      {buyukResim && (
        <div onClick={(e) => { e.stopPropagation(); setBuyukResim(null); }} style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.85)", zIndex: 1200, display: "flex", alignItems: "center", justifyContent: "center", padding: "24px", cursor: "zoom-out" }}>
          <img src={buyukResim} alt="İlan fotoğrafı" style={{ maxWidth: "100%", maxHeight: "100%", borderRadius: "8px" }} />
        </div>
      )}
      <div onClick={(e) => e.stopPropagation()} style={{ background: "white", borderRadius: "16px", width: "100%", maxWidth: "760px", maxHeight: "92vh", overflowY: "auto", padding: "24px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: "12px", marginBottom: "12px" }}>
          <div style={{ minWidth: 0 }}>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "6px", marginBottom: "6px" }}>
              <span style={{ padding: "3px 10px", borderRadius: "20px", fontSize: "12px", fontWeight: "600", background: talepMi ? "#e0f2fe" : "#ede9fe", color: talepMi ? "#075985" : "#5b21b6" }}>{talepMi ? "Doğrudan talep" : "Açık ilan"}</span>
              <span style={{ padding: "3px 10px", borderRadius: "20px", fontSize: "12px", fontWeight: "600", background: durum.bg, color: durum.color }}>{durum.text}</span>
              {j.canBeOnline === true && <span style={{ padding: "3px 10px", borderRadius: "20px", fontSize: "12px", fontWeight: "600", background: "#ecfeff", color: "#0e7490" }}>🌐 Online da olabilir</span>}
              {kaynakBilgisi && (
                <span title={kaynakBilgisi.tahmin ? "Belgede source alanı yok; yalnızca hizmet siparişi yolunun yazdığı estimatedPrice alanından çıkarıldı" : `${kaynakBilgisi.alan}: ${j[kaynakBilgisi.alan]}`}
                  style={{ padding: "3px 10px", borderRadius: "20px", fontSize: "12px", fontWeight: "600", background: "#fef3c7", color: "#92400e" }}>
                  Kaynak: {kaynakBilgisi.ad}{kaynakBilgisi.tahmin ? " (tahmin)" : ""}
                </span>
              )}
            </div>
            <h2 style={{ fontSize: "19px", fontWeight: "700", color: "#1e293b", margin: 0, wordBreak: "break-word" }}>{j.title || j.service || j.subCategory || "İş"}</h2>
            <p style={{ fontSize: "11px", color: "#94a3b8", margin: "4px 0 0", fontFamily: "monospace" }}>{koleksiyon}/{j.id}</p>
          </div>
          <button onClick={onClose} style={{ background: "none", border: "none", cursor: "pointer", padding: "4px" }}><X size={22} color="#64748b" /></button>
        </div>

        {/* Müşterinin yazdığı her metin ayrı etiketle; bilinmeyen alanlar en altta "Diğer alanlar" */}
        {metinler.length === 0 ? bolum("Müşterinin yazdıkları", (
          <p style={{ fontSize: "13px", color: "#94a3b8", margin: 0 }}>
            Bilinen metin alanlarının ({MUSTERI_METIN_ALANLARI.map(([k]) => k).join(", ")}) hepsi boş.{digerler.length ? " Belgedeki diğer alanlar en altta." : ""}
          </p>
        )) : metinler.map((m) => (
          <React.Fragment key={m.k}>
            {bolum(m.ad, (
              <p title={m.k} style={{ fontSize: "14px", color: "#1e293b", whiteSpace: "pre-wrap", wordBreak: "break-word", margin: 0, background: "#f8fafc", borderRadius: "10px", padding: "12px" }}>{m.metin}</p>
            ))}
          </React.Fragment>
        ))}

        {bolum("Ayrıntılar", (
          <>
            {satir("Kategori", j.category)}
            {satir("Alt kategori", j.subCategory || j.service)}
            {satir("İl", j.city)}
            {satir("İlçe", j.district)}
            {satir("Konum metni", typeof j.location === "string" ? j.location : null)}
            {satir("Adres", adres, kaynakEtiketi(kaynak(anaAdres, alt.address)))}
            {satir("Telefon", telefon, kaynakEtiketi(kaynak(anaTelefon, alt.customerPhone || alt.phone)))}
            {iletisim.durum === "yukleniyor" && <p style={{ fontSize: "11px", color: "#94a3b8", margin: "4px 0 0" }}>private/contact okunuyor…</p>}
            {iletisim.durum === "yok" && <p style={{ fontSize: "11px", color: "#94a3b8", margin: "4px 0 0" }}>private/contact alt belgesi yok.</p>}
            {iletisim.durum === "hata" && (
              <p style={{ fontSize: "11px", color: "#b45309", margin: "4px 0 0" }}>
                private/contact okunamadı ({iletisim.kod}). {iletisim.kod === "permission-denied" ? "Bu yol için admin okuma kuralı henüz yayında değil (3.2 kural paketi)." : ""}
              </p>
            )}
            {/* "Teklif İste" yolunda budget bir seçenek kimliği (aralık adı budgetRange'de) — yalnızca sayıya ₺ */}
            {satir("Bütçe", j.budget ? `${/^\d+([.,]\d+)?$/.test(String(j.budget).trim()) ? "₺" : ""}${j.budget}${j.budgetType ? ` (${ILAN_BUTCE_TURU[j.budgetType] || j.budgetType})` : ""}` : null)}
            {(j.agreedPrice || j.acceptedPrice || j.finalPrice) && satir("Anlaşılan fiyat", `₺${j.agreedPrice || j.acceptedPrice || j.finalPrice}`)}
            {j.budgetRange && satir("Bütçe aralığı", j.budgetRange)}
            {j.budgetPreference && satir("Bütçe tercihi", j.budgetPreference)}
            {j.estimatedPrice ? satir("Tahmini fiyat", `₺${j.estimatedPrice}`) : null}
            {satir("Aciliyet", j.urgency ? ILAN_ACILIYET[j.urgency] || j.urgency : null)}
            {(j.preferredDate || j.preferredTime) && satir("Tercih edilen zaman", [j.preferredDate, j.preferredTime].filter(Boolean).join(" "))}
            {satir("Online da olabilir", j.canBeOnline === true ? "Evet" : j.canBeOnline === false ? "Hayır" : null)}
          </>
        ))}

        {resimler.length > 0 && bolum(`Fotoğraflar (${resimler.length})`, (
          <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
            {resimler.map((src, i) => resimKaynagiMi(src) ? (
              <img key={i} src={src} alt={`Fotoğraf ${i + 1}`} onClick={() => setBuyukResim(src)}
                style={{ width: "96px", height: "96px", objectFit: "cover", borderRadius: "8px", cursor: "zoom-in", border: "1px solid #e2e8f0" }} />
            ) : (
              <span key={i} title="Görsel değil (ör. örnek veride emoji)" style={{ width: "96px", height: "96px", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "28px", background: "#f8fafc", borderRadius: "8px", border: "1px solid #e2e8f0" }}>{src.slice(0, 4)}</span>
            ))}
          </div>
        ))}

        {bolum("Tarihler ve durum", (
          <>
            {satir("Durum", `${durum.text}${j.status ? ` (${j.status})` : ""}`)}
            {tarihler.map((t) => <React.Fragment key={t.ad}>{satir(t.ad, formatDateTime(t.at))}</React.Fragment>)}
            {j.cancelReason && satir("İptal nedeni", j.cancelReason)}
            {gecmis.length > 0 && (
              <div style={{ marginTop: "6px" }}>
                {gecmis.map((g, i) => (
                  <div key={i} style={{ fontSize: "12px", color: "#334155" }}>
                    {formatDateTime(g.at || g.changedAt || g.createdAt)} · {jobStatusInfo(g.status || g.to).text}{g.by ? ` · ${g.by}` : ""}
                  </div>
                ))}
              </div>
            )}
            {gecmis.length === 0 && <p style={{ fontSize: "11px", color: "#94a3b8", margin: "4px 0 0" }}>Ayrı bir durum geçmişi kaydı yok; yukarıdaki zaman damgaları belgedeki alanlardan.</p>}
          </>
        ))}

        {bolum("Müşteri", musteriUid ? (
          <>
            {satir("Ad", musteriRaw ? kisiDugmesi({ r: musteri, ad: musteri.name }, "customer") : (musteri && musteri.name) || j.customerName)}
            {satir("E-posta", musteriEposta)}
            {satir("Telefon (profil)", musteriTelefon)}
            {satir("Hesap durumu", musteriDurum ? (
              <span style={{ padding: "2px 8px", borderRadius: "10px", fontSize: "12px", fontWeight: "600", background: USER_STATE_LABELS[musteriDurum].bg, color: USER_STATE_LABELS[musteriDurum].color }}>{USER_STATE_LABELS[musteriDurum].text}</span>
            ) : null)}
          </>
        ) : <p style={{ fontSize: "13px", color: "#94a3b8", margin: 0 }}>Oluşturan alanı boş (customerId yok).</p>)}

        {talepMi
          ? bolum("Hedef uzman", hedefUzman ? satir("Uzman", kisiDugmesi(hedefUzman, "expert")) : <p style={{ fontSize: "13px", color: "#94a3b8", margin: 0 }}>Talepte uzman kaydı yok.</p>)
          : (
            <>
              {(hedefUzman || kabulEdilen) && bolum("Atanan uzman", (
                <>
                  {hedefUzman && satir("expertId", kisiDugmesi(hedefUzman, "expert"))}
                  {kabulEdilen && satir("Kabul edilen", kisiDugmesi(kabulEdilen, "expert"))}
                </>
              ))}
              {bolum(`Gelen teklifler (${teklifler.length})`, teklifler.length === 0 ? <p style={{ fontSize: "13px", color: "#94a3b8", margin: 0 }}>Teklif yok.</p> : (
                <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                  {teklifler.map((p, i) => {
                    const u = uzmanBilgi(p.expertId, p.expertName);
                    const pd = jobStatusInfo(p.status);
                    return (
                      <div key={p.id || i} style={{ border: "1px solid #e2e8f0", borderRadius: "10px", padding: "10px 12px" }}>
                        <div style={{ display: "flex", justifyContent: "space-between", gap: "8px", flexWrap: "wrap", alignItems: "center" }}>
                          <span>{u ? kisiDugmesi(u, "expert") : <span style={{ color: "#94a3b8" }}>{p.expertName || "Uzman"}</span>}</span>
                          <span style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                            <strong style={{ fontSize: "14px", color: "#1e293b" }}>{p.price !== undefined && p.price !== "" ? `₺${p.price}` : "—"}</strong>
                            <span style={{ padding: "2px 8px", borderRadius: "10px", fontSize: "11px", fontWeight: "600", background: pd.bg, color: pd.color }}>{p.status ? pd.text : "—"}</span>
                          </span>
                        </div>
                        <p style={{ fontSize: "13px", color: "#334155", whiteSpace: "pre-wrap", wordBreak: "break-word", margin: "6px 0 4px" }}>{p.message || <span style={{ color: "#94a3b8" }}>Mesaj yok</span>}</p>
                        <p style={{ fontSize: "11px", color: "#94a3b8", margin: 0 }}>
                          {p.createdAt ? formatDateTime(p.createdAt) : ""}
                          {p.estimatedDays ? ` · tahmini ${p.estimatedDays} gün` : ""}
                          {p.availableDate ? ` · uygun tarih ${p.availableDate}` : ""}
                        </p>
                      </div>
                    );
                  })}
                </div>
              ))}
            </>
          )}

        {bolum("Moderasyon", moderasyon.length === 0 ? <p style={{ fontSize: "13px", color: "#94a3b8", margin: 0 }}>Moderasyon kaydı yok.</p> : (
          <>
            {moderasyon.map((k) => <React.Fragment key={k}>{satir(k, typeof j[k] === "object" ? JSON.stringify(j[k], null, 2) : /At$/.test(k) ? formatDateTime(j[k]) : String(j[k]))}</React.Fragment>)}
          </>
        ))}

        {bolum(`Diğer alanlar (${digerler.length})`, digerler.length === 0 ? <p style={{ fontSize: "13px", color: "#94a3b8", margin: 0 }}>Yukarıda gösterilmeyen alan yok.</p> : (
          <>
            <p style={{ fontSize: "11px", color: "#94a3b8", margin: "0 0 4px" }}>Belgede olup yukarıda ayrıca gösterilmeyen bütün alanlar (fotoğraf alanları hariç; base64 içerik boyutuyla yazılır).</p>
            {digerler.map((d) => <React.Fragment key={d.k}>{satir(d.k, d.metin)}</React.Fragment>)}
          </>
        ))}

        <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", paddingTop: "16px", borderTop: "1px solid #f1f5f9" }}>
          <button onClick={iptalEt} disabled={!iptalEdilebilir} style={islemDugmesi("#dc2626", "#fee2e2", !iptalEdilebilir)}>
            <XCircle size={16} /> {iptalEdilebilir ? "İptal et" : "Zaten iptal"}
          </button>
          <button onClick={askiDegistir} disabled={!musteriRaw} style={islemDugmesi(musteriRaw && isSuspended(musteriRaw) ? "#16a34a" : "#b91c1c", musteriRaw && isSuspended(musteriRaw) ? "#dcfce7" : "#fef2f2", !musteriRaw)}>
            <Ban size={16} /> {musteriRaw && isSuspended(musteriRaw) ? "Müşterinin askısını kaldır" : "Müşteriyi askıya al"}
          </button>
          <button onClick={bildirimAc} disabled={!musteriRaw} style={islemDugmesi("#512da8", "#ede9fe", !musteriRaw)}>
            <Send size={16} /> Müşteriye bildirim gönder
          </button>
        </div>
      </div>
    </div>
  );
};

// ==================== ANLAŞILAN İŞLER (ilan + talep) ====================
// Eski "Ödemeler" sayfasındaki iş cirosu listesi buraya taşındı. Veri bellekteki jobs/requests'ten; yeni okuma yok.
// Uygulamanın yazdığı tarihler (isinebak2 updateJobStatus / teklif kabulü / updateRequestStatus):
//   kabul: ayrı alan YOK (acceptedAt yalnızca bazı eski tekliflerde) → durumu "accepted" iken updatedAt "yaklaşık";
//          devam eden / tamamlanan işte startedAt varsa "başlama" (kabul en geç bu tarih)
//   tamamlanma: completedAt (updateJobStatus); doğrudan talepler updateRequestStatus ile tamamlanır ve completedAt
//          yazmaz → updatedAt "yaklaşık". Onay bekleyende completionRequestedAt.
const ANLASILAN_DURUMLAR = {
  kabul: ["accepted"],
  devam: ["in_progress", "pending_completion"],
  tamam: ["completed", "tamamlandi", "tamamlandı"],
};
ANLASILAN_DURUMLAR.hepsi = [...ANLASILAN_DURUMLAR.kabul, ...ANLASILAN_DURUMLAR.devam, ...ANLASILAN_DURUMLAR.tamam];
const ANLASILAN_BOS = []; // JobsPage: Anlaşılan işler görünümünde normal liste boş (sabit dizi: memo bağımlılığı değişmesin)
const ANLASILAN_SEKMELER = [["hepsi", "Hepsi"], ["kabul", "Kabul edildi"], ["devam", "Devam ediyor"], ["tamam", "Tamamlandı"]];
// "1.500 TL", "1500" gibi metinlerden ilk sayı (binlik noktası atılır)
const fiyatSayisi = (v) => {
  if (typeof v === "number") return Number.isFinite(v) && v > 0 ? v : 0;
  const m = String(v || "").match(/\d[\d.\s]*(,\d+)?/);
  if (!m) return 0;
  const n = Number(m[0].replace(/[.\s]/g, "").replace(",", "."));
  return Number.isFinite(n) && n > 0 ? n : 0;
};
// Anlaşılan fiyat ve kaynağı. Bütçe anlaşma değildir: gösterilir ama toplama katılmaz.
const anlasilanFiyat = (j) => {
  const adaylar = [
    [j.agreedPrice, "anlaşılan"], [j.acceptedPrice, "kabul edilen teklif"], [j.proposal && j.proposal.price, "teklif"],
    [j.finalPrice, "son fiyat"], [j.budget, "bütçe"], [j.price, "bütçe"],
  ];
  for (const [v, kaynak] of adaylar) {
    const n = fiyatSayisi(v);
    if (n > 0) return { tutar: n, kaynak, butce: kaynak === "bütçe" };
  }
  return { tutar: 0, kaynak: null, butce: false };
};
const anlasilanIsSatiri = (j, resolveUser, admin) => {
  const musteriId = j.customerId || j.userId || j.createdBy || null;
  const uzmanId = j.expertId || j.assignedExpertId || null;
  const ad = (uid, yedek) => yedek || (uid && resolveUser ? resolveUser(uid).name : "-");
  const kabulTeklif = Array.isArray(j.proposals) ? j.proposals.find((p) => p && p.status === "accepted" && p.acceptedAt) : null;
  let kabul = null;
  if (toMillis(j.acceptedAt)) kabul = { t: toMillis(j.acceptedAt), etiket: null };
  else if (kabulTeklif) kabul = { t: toMillis(kabulTeklif.acceptedAt), etiket: null };
  else if (j.status === "accepted" && toMillis(j.updatedAt)) kabul = { t: toMillis(j.updatedAt), etiket: "yaklaşık" };
  else if (toMillis(j.startedAt)) kabul = { t: toMillis(j.startedAt), etiket: "başlama" };
  let tamam = null;
  if (ANLASILAN_DURUMLAR.tamam.includes(j.status)) {
    tamam = toMillis(j.completedAt) ? { t: toMillis(j.completedAt), etiket: null } : toMillis(j.updatedAt) ? { t: toMillis(j.updatedAt), etiket: "yaklaşık" } : null;
  } else if (j.status === "pending_completion" && toMillis(j.completionRequestedAt)) {
    tamam = { t: toMillis(j.completionRequestedAt), etiket: "onay istendi" };
  }
  const durumlar = [kullaniciTestDurumu(musteriId, resolveUser, admin, j.customerName), kullaniciTestDurumu(uzmanId, resolveUser, admin, j.expertName)];
  const test = durumlar.includes("test") ? "test" : durumlar.includes("olasi") ? "olasi" : null;
  return {
    j, musteriId, uzmanId,
    musteri: ad(musteriId, j.customerName), uzman: ad(uzmanId, j.expertName),
    kategori: j.category || j.subCategory || j.service || "-",
    altKategori: j.category && j.subCategory && j.subCategory !== j.category ? j.subCategory : null,
    fiyat: anlasilanFiyat(j), kabul, tamam, test,
    sirala: (tamam && tamam.t) || (kabul && kabul.t) || toMillis(j.updatedAt) || toMillis(j.createdAt) || 0,
  };
};
const tarihEtiketli = (x) => x ? (
  <>
    <span>{formatDateTime(new Date(x.t).toISOString())}</span>
    {x.etiket && <span style={{ marginLeft: "6px", padding: "1px 6px", borderRadius: "6px", fontSize: "10px", fontWeight: "600", background: "#f1f5f9", color: "#64748b" }}>{x.etiket}</span>}
  </>
) : <span style={{ color: "#cbd5e1" }}>—</span>;
const testRozeti = (t) => t === "test"
  ? <span title="Müşteri ya da uzman test hesabı" style={{ padding: "1px 7px", borderRadius: "6px", fontSize: "10px", fontWeight: "700", background: "#fef3c7", color: "#92400e" }}>Test</span>
  : t === "olasi"
    ? <span title="Olası test: e-postada ya da adda demo / test / review / deneme" style={{ padding: "1px 7px", borderRadius: "6px", fontSize: "10px", fontWeight: "700", background: "#fff7ed", color: "#c2410c" }}>Olası test</span>
    : null;

const AnlasilanIsler = ({ jobs, resolveUser, admin, durum, onDurum, onAc }) => {
  const [testHaric, setTestHaric] = useState(true);
  const kume = ANLASILAN_DURUMLAR[durum] || ANLASILAN_DURUMLAR.hepsi;
  const tumSatirlar = useMemo(
    () => (jobs || [])
      .filter((j) => j && j.requestType !== "support_ticket" && kume.includes(j.status))
      .map((j) => anlasilanIsSatiri(j, resolveUser, admin))
      .sort((a, b) => b.sirala - a.sirala),
    [jobs, resolveUser, admin, kume]
  );
  const testSayisi = tumSatirlar.filter((x) => x.test).length;
  const satirlar = testHaric ? tumSatirlar.filter((x) => !x.test) : tumSatirlar;
  const toplam = satirlar.reduce((t, x) => t + (x.fiyat.butce ? 0 : x.fiyat.tutar), 0);
  const butceli = satirlar.filter((x) => x.fiyat.butce).length;
  const fiyatsiz = satirlar.filter((x) => !x.fiyat.kaynak).length;
  const { currentPage, totalPages, paginatedItems, goToPage, totalItems, startIndex, endIndex } = usePagination(satirlar, 15);
  const th = { padding: "12px 14px", textAlign: "left", fontSize: "12px", fontWeight: "600", color: "#64748b", whiteSpace: "nowrap" };
  const td = { padding: "12px 14px", fontSize: "13px", color: "#334155", verticalAlign: "top" };
  return (
    <div>
      <div style={{ display: "flex", gap: "8px", flexWrap: "wrap", alignItems: "center", marginBottom: "16px" }}>
        {ANLASILAN_SEKMELER.map(([id, etiket]) => (
          <button key={id} onClick={() => onDurum(id)}
            style={{ padding: "8px 16px", background: durum === id ? "#1e1b4b" : "white", color: durum === id ? "white" : "#64748b", border: "1px solid #e2e8f0", borderRadius: "10px", fontSize: "13px", fontWeight: "500", cursor: "pointer" }}>
            {etiket}
          </button>
        ))}
        <label style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: "6px", fontSize: "13px", color: "#475569", cursor: "pointer" }}>
          <input type="checkbox" checked={testHaric} onChange={(e) => setTestHaric(e.target.checked)} />
          Test hariç ({testSayisi} test / olası test işi)
        </label>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: "16px", marginBottom: "16px" }}>
        {[
          ["İş", satirlar.length, testHaric ? "test hariç" : "test dahil"],
          ["Anlaşılan tutar toplamı", paraYaz(toplam), `${testHaric ? "test hariç" : "test dahil"}; platform geliri değil (iş bedeli)`],
          ["Fiyatı bütçeden", butceli, "anlaşma tutarı yok; toplama katılmadı"],
          ["Fiyatı yok", fiyatsiz, ""],
        ].map(([etiket, deger, not]) => (
          <div key={etiket} style={{ background: "white", borderRadius: "16px", padding: "16px 18px", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
            <p style={{ fontSize: "22px", fontWeight: "700", color: "#1e293b", margin: "0 0 2px 0" }}>{deger}</p>
            <p style={{ fontSize: "13px", color: "#64748b", margin: 0 }}>{etiket}</p>
            {not && <p style={{ fontSize: "11px", color: "#94a3b8", margin: "2px 0 0" }}>{not}</p>}
          </div>
        ))}
      </div>
      {satirlar.length === 0 ? (
        <div style={{ background: "white", borderRadius: "16px", padding: "60px 20px", textAlign: "center", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
          <Briefcase size={48} color="#94a3b8" style={{ marginBottom: "16px" }} /><p style={{ fontSize: "16px", fontWeight: "600", color: "#1e293b", margin: 0 }}>Bu durumda iş yok</p>
        </div>
      ) : (
        <div style={{ background: "white", borderRadius: "16px", overflow: "hidden", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
          <div style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead><tr style={{ background: "#f8fafc" }}>
                {["İş", "Müşteri", "Uzman", "Kategori", "Anlaşılan fiyat", "Kabul", "Tamamlanma", "Durum"].map((b) => <th key={b} style={th}>{b}</th>)}
              </tr></thead>
              <tbody>
                {paginatedItems.map((x) => {
                  const j = x.j;
                  const sc = jobStatusInfo(j.status);
                  return (
                    <tr key={`${j._source}/${j.id}`} onClick={() => onAc(j)} style={{ borderTop: "1px solid #f1f5f9", cursor: "pointer", background: x.test ? "#fffbeb" : undefined }} title="Ayrıntı için tıklayın">
                      <td style={td}>
                        <div style={{ fontWeight: "600", color: "#1e293b" }}>{j.title || j.service || j.subCategory || "İş"}</div>
                        <div style={{ display: "flex", gap: "6px", alignItems: "center", marginTop: "2px" }}>
                          <span style={{ fontSize: "11px", color: "#94a3b8" }}>{j._source === "requests" ? "Doğrudan talep" : "İlan"}</span>
                          {testRozeti(x.test)}
                        </div>
                      </td>
                      <td style={td}>{x.musteri}</td>
                      <td style={td}>{x.uzman}</td>
                      <td style={td}>{x.kategori}{x.altKategori && <div style={{ fontSize: "11px", color: "#94a3b8" }}>{x.altKategori}</div>}</td>
                      <td style={{ ...td, whiteSpace: "nowrap" }}>
                        {x.fiyat.kaynak ? (
                          <>
                            <span style={{ fontWeight: "600", color: x.fiyat.butce ? "#94a3b8" : "#1e293b" }}>{paraYaz(x.fiyat.tutar)}</span>
                            {x.fiyat.kaynak !== "anlaşılan" && <div style={{ fontSize: "10px", color: x.fiyat.butce ? "#b45309" : "#94a3b8" }}>{x.fiyat.butce ? "bütçe (anlaşma değil)" : x.fiyat.kaynak}</div>}
                          </>
                        ) : <span style={{ color: "#cbd5e1" }}>—</span>}
                      </td>
                      <td style={{ ...td, whiteSpace: "nowrap" }}>{tarihEtiketli(x.kabul)}</td>
                      <td style={{ ...td, whiteSpace: "nowrap" }}>{tarihEtiketli(x.tamam)}</td>
                      <td style={td}><span style={{ padding: "4px 10px", borderRadius: "20px", fontSize: "12px", fontWeight: "500", background: sc.bg, color: sc.color, whiteSpace: "nowrap" }}>{sc.text}</span></td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <PaginationBar currentPage={currentPage} totalPages={totalPages} goToPage={goToPage} totalItems={totalItems} startIndex={startIndex} endIndex={endIndex} />
        </div>
      )}
      <p style={{ fontSize: "11px", color: "#94a3b8", margin: "10px 0 0" }}>
        "yaklaşık": uygulama bu tarihi ayrıca yazmıyor, son güncelleme zamanı gösteriliyor. "başlama": kabul tarihi yok, işin başladığı an (kabul en geç bu tarih).
        Test: müşteri ya da uzman test hesabı (kesin ya da olası).
      </p>
    </div>
  );
};

const JobsPage = ({ jobs, allJobs, updateJobStatus, initialFilter = null, resolveUser = null, onToggleSuspend = null }) => {
  const [filter, setFilter] = useState(initialFilter || "all");
  // "no_proposal" durum değeri DEĞİL, türetilmiş bir filtre: açık ve hiç teklif
  // almamış ilanlar. 24 saat eşiği BİLEREK yok — o yalnızca dashboard'un uyarı
  // eşiği; burada teklifsiz tüm açık ilanlar görünür.
  // Türetilmiş filtreler dashboard'daki satırlarla AYNI yardımcıları kullanır
  // "anlasilan_*": Anlaşılan işler görünümü (ilan + talep; ayrı tablo, AnlasilanIsler)
  const anlasilanModu = String(filter).startsWith("anlasilan_");
  const { admin } = usePanelVeri();
  const filtered =
    filter === "all" ? jobs
    : anlasilanModu ? ANLASILAN_BOS
    : filter === "no_proposal" ? jobs.filter(isNoProposalListing)
    : filter === "request_pending" ? jobs.filter(isAwaitingExpertRequest)
    : jobs.filter((j) => j.status === filter);
  // Talep modu: hangi uzmanın kaç gündür yanıt vermediği görünsün diye
  // EN UZUN bekleyen en üstte
  const talepModu = filter === "request_pending" && !!resolveUser;
  const liste = useMemo(
    () => (talepModu ? [...filtered].sort((a, b) => (toMillis(a.createdAt) || Infinity) - (toMillis(b.createdAt) || Infinity)) : filtered),
    [filtered, talepModu]
  );
  const [seciliUzman, setSeciliUzman] = useState(null);
  // Ayrıntı penceresi: kimlik + kaynak saklanır, veri her çizimde canlı listeden alınır
  const [seciliIlan, setSeciliIlan] = useState(null); // { id, _source }
  const acikIlan = seciliIlan ? (allJobs || jobs).find((x) => x.id === seciliIlan.id && x._source === seciliIlan._source) || null : null;
  const simdi = Date.now();
  const { currentPage, totalPages, paginatedItems, goToPage, totalItems, startIndex, endIndex } = usePagination(liste, 10);
  const getStatusLabel = (s) => jobStatusInfo(s).text;
  const getStatusColor = (s) => jobStatusInfo(s);

  return (
    <div>
      {seciliUzman && (
        <UserDetailModal user={seciliUzman} onClose={() => setSeciliUzman(null)}
          onToggleSuspend={onToggleSuspend || (() => {})} userType="expert" jobs={allJobs} />
      )}
      {acikIlan && (
        <IlanDetayModal ilan={acikIlan} resolveUser={resolveUser} onClose={() => setSeciliIlan(null)}
          updateJobStatus={updateJobStatus} onToggleSuspend={onToggleSuspend} />
      )}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "24px", flexWrap: "wrap", gap: "12px" }}>
        <div>
          <h1 style={{ fontSize: "24px", fontWeight: "700", color: "#1e293b", margin: "0 0 4px 0" }}>İş İlanları</h1>
          <p style={{ fontSize: "14px", color: "#64748b", margin: 0 }}>{anlasilanModu ? "Anlaşılan işler: kabul edilen, devam eden ve tamamlanan ilan ve talepler" : filtered.length !== allJobs.length ?`${filtered.length} / ${allJobs.length} iş${jobs.length !== allJobs.length ? " (arama sonucu)" : ""}` : `Toplam ${allJobs.length} iş`}</p>
        </div>
        <select value={filter} onChange={(e) => setFilter(e.target.value)} style={{ padding: "10px 16px", border: "1px solid #e2e8f0", borderRadius: "10px", fontSize: "14px", outline: "none" }}>
          <option value="all">Tümü</option><option value="pending">Bekliyor</option><option value="in_progress">Devam Ediyor</option><option value="completed">Tamamlandı</option><option value="cancelled">İptal</option>
          <option value="no_proposal">⚠ Teklif Almamış (açık ilan)</option>
          <option value="request_pending">⏳ Uzman Yanıtı Bekleyen Talep</option>
          <optgroup label="Anlaşılan işler (ilan + talep)">
            <option value="anlasilan_hepsi">Anlaşılan işler: hepsi</option>
            <option value="anlasilan_kabul">Anlaşılan işler: kabul edildi</option>
            <option value="anlasilan_devam">Anlaşılan işler: devam ediyor</option>
            <option value="anlasilan_tamam">Anlaşılan işler: tamamlandı</option>
          </optgroup>
        </select>
      </div>

      {anlasilanModu ? (
        <AnlasilanIsler jobs={jobs} resolveUser={resolveUser} admin={admin} durum={filter.slice("anlasilan_".length)}
          onDurum={(d) => setFilter(`anlasilan_${d}`)} onAc={(j) => setSeciliIlan({ id: j.id, _source: j._source })} />
      ) : filtered.length === 0 ? (
        <div style={{ background: "white", borderRadius: "16px", padding: "60px 20px", textAlign: "center", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
          <Briefcase size={48} color="#94a3b8" style={{ marginBottom: "16px" }} /><p style={{ fontSize: "16px", fontWeight: "600", color: "#1e293b", margin: "0 0 8px 0" }}>Sonuç bulunamadı</p>
        </div>
      ) : (
        <div style={{ background: "white", borderRadius: "16px", overflow: "hidden", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
          <div style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead><tr style={{ background: "#f8fafc" }}>
                <th style={{ padding: "14px 16px", textAlign: "left", fontSize: "13px", fontWeight: "600", color: "#64748b" }}>İş</th>
                <th style={{ padding: "14px 16px", textAlign: "left", fontSize: "13px", fontWeight: "600", color: "#64748b" }}>Müşteri</th>
                <th style={{ padding: "14px 16px", textAlign: "left", fontSize: "13px", fontWeight: "600", color: "#64748b" }}>Konum</th>
                <th style={{ padding: "14px 16px", textAlign: "left", fontSize: "13px", fontWeight: "600", color: "#64748b" }}>Bütçe</th>
                {talepModu ? (
                  <>
                    <th style={{ padding: "14px 16px", textAlign: "left", fontSize: "13px", fontWeight: "600", color: "#64748b" }}>Uzman</th>
                    <th style={{ padding: "14px 16px", textAlign: "left", fontSize: "13px", fontWeight: "600", color: "#64748b" }}>Bekleme</th>
                    <th style={{ padding: "14px 16px", textAlign: "left", fontSize: "13px", fontWeight: "600", color: "#64748b" }}>Uzman durumu</th>
                    <th style={{ padding: "14px 16px", textAlign: "left", fontSize: "13px", fontWeight: "600", color: "#64748b" }}>Hesap türü</th>
                  </>
                ) : (
                  <th style={{ padding: "14px 16px", textAlign: "left", fontSize: "13px", fontWeight: "600", color: "#64748b" }}>Durum</th>
                )}
                <th style={{ padding: "14px 16px", textAlign: "right", fontSize: "13px", fontWeight: "600", color: "#64748b" }}>İşlemler</th>
              </tr></thead>
              <tbody>
                {paginatedItems.map((j) => { const sc = getStatusColor(j.status); return (
                  <tr key={j._source + "/" + j.id} onClick={() => setSeciliIlan({ id: j.id, _source: j._source })} title="Ayrıntıyı aç"
                    style={{ borderTop: "1px solid #f1f5f9", cursor: "pointer" }}>
                    <td style={{ padding: "14px 16px", maxWidth: "340px" }}>
                      <p style={{ fontSize: "14px", fontWeight: "600", color: "#1e293b", margin: 0 }}>{j.title || j.service || "İş"}</p>
                      {(() => {
                        // İlk müşteri metni (açıklama ya da not), en çok 2 satır; ipucunda tamamı
                        const o = ilanOnizlemesi(j);
                        return o ? (
                          <p title={o.tam} style={{ fontSize: "12px", color: "#64748b", margin: "2px 0 0", display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden", wordBreak: "break-word" }}>{o.kisa}</p>
                        ) : <p style={{ fontSize: "12px", color: "#cbd5e1", margin: "2px 0 0", fontStyle: "italic" }}>metin yok</p>;
                      })()}
                    </td>
                    <td style={{ padding: "14px 16px", fontSize: "14px", color: "#64748b" }}>{j.customerName || "-"}</td>
                    {/* DİKKAT: createJob location'ı DÜZ METİN yazıyor ("Kadıköy, İstanbul").
                        Eskiden j.location?.city okunuyordu ve sütun her satırda "-, -" çıkıyordu.
                        Şehir/ilçe ayrı alanlarda: j.city, j.district */}
                    {/* İl/ilçe yoksa adres metninin başı gri (ipucunda tamamı) */}
                    {j.city || j.district ? (
                      <td style={{ padding: "14px 16px", fontSize: "14px", color: "#64748b" }}>{[j.city, j.district].filter(Boolean).join(", ")}</td>
                    ) : typeof j.address === "string" && j.address.trim() ? (
                      <td title={j.address} style={{ padding: "14px 16px", fontSize: "13px", color: "#94a3b8", maxWidth: "180px" }}>
                        {j.address.trim().length > 32 ? j.address.trim().slice(0, 32).trimEnd() + "…" : j.address.trim()}
                      </td>
                    ) : (
                      <td style={{ padding: "14px 16px", fontSize: "14px", color: "#94a3b8", fontStyle: "italic" }}>Belirtilmemiş</td>
                    )}
                    <td style={{ padding: "14px 16px", fontSize: "14px", fontWeight: "600", color: "#1e293b" }}>₺{j.agreedPrice || j.acceptedPrice || j.proposal?.price || j.finalPrice || j.budget || j.price || "-"}</td>
                    {talepModu ? (() => {
                      const t = talepUzmanTeshisi(j.expertId, resolveUser, simdi, admin);
                      const bekleme = toMillis(j.createdAt) ? simdi - toMillis(j.createdAt) : 0;
                      const GUN = 24 * 60 * 60 * 1000;
                      const rozet = (metin, iyi, title) => (
                        <span title={title} style={{ display: "inline-block", padding: "2px 7px", borderRadius: "6px", fontSize: "11px", fontWeight: "600", whiteSpace: "nowrap",
                          background: iyi === true ? "#dcfce7" : iyi === false ? "#fee2e2" : "#f1f5f9",
                          color: iyi === true ? "#166534" : iyi === false ? "#b91c1c" : "#64748b" }}>{metin}</span>
                      );
                      return (
                        <>
                          {/* Uzman */}
                          <td style={{ padding: "14px 16px", minWidth: "160px" }}>
                            {t.yok ? (
                              <span style={{ fontSize: "13px", color: "#94a3b8", fontStyle: "italic" }}>Uzman kaydı yok</span>
                            ) : t.silinmis ? (
                              <div>
                                <p style={{ margin: 0, fontSize: "14px", fontWeight: "600", color: "#94a3b8", fontStyle: "italic" }}>Silinmiş Kullanıcı</p>
                                <p style={{ margin: 0, fontSize: "11px", color: "#cbd5e1", fontFamily: "monospace" }}>{String(t.uid).slice(0, 14)}…</p>
                              </div>
                            ) : (
                              <button onClick={(ev) => { ev.stopPropagation(); setSeciliUzman(t.raw); }} title="Uzman detayını aç"
                                style={{ background: "none", border: "none", padding: 0, cursor: "pointer", textAlign: "left" }}>
                                <p style={{ margin: 0, fontSize: "14px", fontWeight: "600", color: "#4f46e5", textDecoration: "underline" }}>{t.ad}</p>
                                {t.iletisim && <p style={{ margin: 0, fontSize: "11px", color: "#64748b" }}>{t.iletisim}</p>}
                              </button>
                            )}
                          </td>
                          {/* Bekleme */}
                          <td style={{ padding: "14px 16px", fontSize: "14px", fontWeight: "700", whiteSpace: "nowrap",
                            color: bekleme > 3 * GUN ? "#dc2626" : bekleme > GUN ? "#d97706" : "#64748b" }}
                            title={toMillis(j.createdAt) ? formatDateTime(j.createdAt) : "Oluşturma tarihi yok"}>
                            {formatWaiting(bekleme)}
                          </td>
                          {/* Uzman durumu */}
                          <td style={{ padding: "14px 16px", minWidth: "230px" }}>
                            {t.yok ? null : t.silinmis ? (
                              <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
                                {rozet("Hesap silinmiş", false)}
                                {t.silinmeAt ? rozet(`${formatWaiting(simdi - t.silinmeAt)} önce silindi`, null) : null}
                              </div>
                            ) : (
                              <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
                                {rozet(USER_STATE_LABELS[t.hesap].text, t.hesap === "suspended" ? false : t.hesap === "active" ? true : null, "Hesap durumu")}
                                {rozet(t.push ? "Push açık" : (t.pushGecersizAt ? "Push token geçersiz" : "Push yok"), t.push,
                                  t.push ? "fcmToken kayıtlı — bildirim telefona gider" : "fcmToken yok — bildirim yalnızca uygulama içinde görünür")}
                                {rozet(t.abonelik ? (t.trialde ? "Deneme geçerli" : "Abonelik geçerli") : "Abonelik yok", t.abonelik,
                                  "Talebe teklif göndermek için abonelik veya deneme şart")}
                                {rozet(t.kimlikOnayli ? "Kimlik onaylı" : t.kimlikYuklendi ? "Kimlik onay bekliyor" : "Kimlik yok",
                                  t.kimlikOnayli ? true : null, "Doğrudan talebe yanıt için kimlik ŞART DEĞİL (yalnızca açık ilana teklifte aranır)")}
                                {rozet(
                                  t.oturum.tur === "aktif" ? (t.oturum.at ? `Son oturum: ${formatWaiting(simdi - t.oturum.at)} önce` : "Oturum açık (tarih yok)")
                                    : t.oturum.tur === "cikis" ? `Çıkış yaptı: ${formatWaiting(simdi - t.oturum.at)} önce`
                                    : "Oturum kaydı yok",
                                  null,
                                  "Son giriş alanı yok; push kaydı zamanından (fcmTokenUpdatedAt) türetildi. Push izni vermeyen uzmanda kayıt oluşmaz."
                                )}
                                {t.engel && (
                                  <p style={{ width: "100%", margin: "4px 0 0", fontSize: "11px", fontWeight: "700", color: "#b91c1c" }}>⛔ {t.engel}</p>
                                )}
                              </div>
                            )}
                          </td>
                          {/* Hesap türü */}
                          <td style={{ padding: "14px 16px" }}>
                            {t.yok || t.silinmis ? <span style={{ fontSize: "12px", color: "#cbd5e1" }}>—</span> : (
                              <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
                                {t.elleMi && rozet(t.elleAktifMi ? "Elle premium" : "Elle premium (bitmiş)", null, "premiumPlan: admin_granted")}
                                {t.testMi && (
                                  <span title="Ayrı bir alan yok — e-posta ya da isimde demo/test/review/deneme geçiyor"
                                    style={{ padding: "2px 7px", borderRadius: "6px", fontSize: "11px", fontWeight: "600", background: "#ede9fe", color: "#6d28d9", whiteSpace: "nowrap" }}>
                                    Olası test hesabı
                                  </span>
                                )}
                                {!t.elleMi && !t.testMi && <span style={{ fontSize: "12px", color: "#94a3b8" }}>Normal</span>}
                              </div>
                            )}
                          </td>
                        </>
                      );
                    })() : (
                      <td style={{ padding: "14px 16px" }}><span style={{ padding: "4px 10px", borderRadius: "20px", fontSize: "12px", fontWeight: "500", background: sc.bg, color: sc.color }}>{getStatusLabel(j.status)}</span></td>
                    )}
                    <td style={{ padding: "14px 16px", textAlign: "right" }} onClick={(ev) => ev.stopPropagation()}>
                      <select value={j.status || ""} onChange={(e) => updateJobStatus(j.id, e.target.value)} style={{ padding: "6px 10px", border: "1px solid #e2e8f0", borderRadius: "6px", fontSize: "12px", outline: "none" }}>
                        {/* Mevcut durum standart 4 seçenekte yoksa (ör. rejected, proposal_sent)
                            seçilemez bir satır olarak gösterilir — yoksa select yanlışlıkla
                            "Bekliyor" seçiliymiş gibi görünür */}
                        {!["pending", "in_progress", "completed", "cancelled"].includes(j.status) && (
                          <option value={j.status || ""} disabled>{jobStatusInfo(j.status).text}</option>
                        )}
                        <option value="pending">Bekliyor</option><option value="in_progress">Devam Ediyor</option><option value="completed">Tamamlandı</option><option value="cancelled">İptal</option>
                      </select>
                    </td>
                  </tr>); })}
              </tbody>
            </table>
          </div>
          <PaginationBar currentPage={currentPage} totalPages={totalPages} goToPage={goToPage} totalItems={totalItems} startIndex={startIndex} endIndex={endIndex} />
        </div>
      )}
    </div>
  );
};

// ==================== ENGELLEMELER (salt-okunur + kötü aktör sinyali) ====================
// blocks koleksiyonuna YALNIZCA Cloud Functions yazar (blockUser). Panel sadece okur.
// Asıl değer tekil kayıtlarda değil, TEKRARDA: aynı kullanıcıyı kaç FARKLI kişi engellemiş?
const BLOCK_SIGNAL_THRESHOLD = 3; // functions/index.js'teki AUTO_HIDE_THRESHOLD ile aynı

const UserBlocksPanel = ({ blocks, resolveUser, setUserSuspended }) => {
  // Hedefe göre grupla. Aynı kişi engelle-kaldır-engelle yaparsa birden fazla kayıt
  // oluşabilir; bu yüzden sinyal olarak TEKİL engelleyen sayısı kullanılır.
  const grouped = useMemo(() => {
    const map = new Map();
    (blocks || []).forEach((b) => {
      if (!b.targetUserId) return;
      const entry = map.get(b.targetUserId) || {
        targetUserId: b.targetUserId, kayitSayisi: 0, blockers: new Set(), lastAt: 0, reasons: [],
      };
      entry.kayitSayisi++;
      if (b.blockerId) entry.blockers.add(b.blockerId);
      const t = toMillis(b.createdAt);
      if (t > entry.lastAt) entry.lastAt = t;
      if (b.reason) entry.reasons.push(b.reason);
      map.set(b.targetUserId, entry);
    });
    return Array.from(map.values()).sort(
      (a, b) => b.blockers.size - a.blockers.size || b.lastAt - a.lastAt
    );
  }, [blocks]);

  const repeatTargets = grouped.filter((g) => g.blockers.size > 1);
  const flagged = grouped.filter((g) => g.blockers.size >= BLOCK_SIGNAL_THRESHOLD);

  const sortedBlocks = useMemo(
    () => [...(blocks || [])].sort((a, b) => toMillis(b.createdAt) - toMillis(a.createdAt)),
    [blocks]
  );
  const { currentPage, totalPages, paginatedItems, goToPage, totalItems, startIndex, endIndex } = usePagination(sortedBlocks, 15);

  const SuspendCell = ({ uid }) => {
    const u = resolveUser(uid);
    if (u.missing) return <span style={{ fontSize: "12px", color: "#94a3b8", fontStyle: "italic" }}>Hesap silinmiş</span>;
    if (u.suspended) return <span style={{ padding: "4px 10px", background: "#fee2e2", color: "#dc2626", borderRadius: "6px", fontSize: "12px", fontWeight: "700" }}>ASKIDA</span>;
    return (
      <button onClick={() => setUserSuspended(u.raw, true)}
        style={{ padding: "6px 12px", background: "#fee2e2", color: "#dc2626", border: "none", borderRadius: "6px", fontSize: "12px", fontWeight: "600", cursor: "pointer" }}>
        Askıya Al
      </button>
    );
  };

  return (
    <div>
      {/* Özet */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: "16px", marginBottom: "24px" }}>
        {[
          { v: (blocks || []).length, l: "Toplam engelleme kaydı", c: "#64748b", bg: "#f1f5f9", I: Ban },
          { v: grouped.length, l: "Engellenen farklı kullanıcı", c: "#7c3aed", bg: "#ede9fe", I: Users },
          { v: flagged.length, l: `${BLOCK_SIGNAL_THRESHOLD}+ kişi tarafından engellenen`, c: "#dc2626", bg: "#fee2e2", I: ShieldAlert },
        ].map((s, i) => (
          <div key={i} style={{ background: "white", borderRadius: "16px", padding: "18px 20px", boxShadow: "0 1px 3px rgba(0,0,0,0.05)", display: "flex", alignItems: "center", gap: "14px" }}>
            <div style={{ width: "44px", height: "44px", borderRadius: "12px", background: s.bg, display: "flex", alignItems: "center", justifyContent: "center" }}>
              <s.I size={22} color={s.c} />
            </div>
            <div>
              <p style={{ fontSize: "24px", fontWeight: "700", color: "#1e293b", margin: 0 }}>{s.v}</p>
              <p style={{ fontSize: "13px", color: "#64748b", margin: 0 }}>{s.l}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Kötü aktör sinyali */}
      <div style={{ background: "white", borderRadius: "16px", padding: "20px", boxShadow: "0 1px 3px rgba(0,0,0,0.05)", marginBottom: "24px" }}>
        <h2 style={{ fontSize: "16px", fontWeight: "700", color: "#1e293b", margin: "0 0 4px 0" }}>Tekrar Eden Hedefler</h2>
        <p style={{ fontSize: "13px", color: "#64748b", margin: "0 0 16px 0" }}>
          Birden fazla kişi tarafından engellenen kullanıcılar. {BLOCK_SIGNAL_THRESHOLD} ve üzeri güçlü bir kötüye kullanım sinyalidir.
        </p>
        {repeatTargets.length === 0 ? (
          <p style={{ fontSize: "14px", color: "#94a3b8", margin: 0, padding: "20px 0", textAlign: "center" }}>
            Birden fazla kişi tarafından engellenen kullanıcı yok.
          </p>
        ) : (
          <div style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead><tr style={{ background: "#f8fafc" }}>
                {["Kullanıcı", "Farklı engelleyen", "Toplam kayıt", "Son engelleme", "İşlem"].map((h, i) => (
                  <th key={i} style={{ padding: "12px 16px", textAlign: i === 4 ? "right" : "left", fontSize: "13px", fontWeight: "600", color: "#64748b" }}>{h}</th>
                ))}
              </tr></thead>
              <tbody>
                {repeatTargets.map((g) => {
                  const u = resolveUser(g.targetUserId);
                  const alarm = g.blockers.size >= BLOCK_SIGNAL_THRESHOLD;
                  return (
                    <tr key={g.targetUserId} style={{ borderTop: "1px solid #f1f5f9", background: alarm ? "#fef2f2" : "transparent" }}>
                      <td style={{ padding: "12px 16px" }}>
                        <p style={{ margin: 0, fontSize: "14px", fontWeight: "600", color: u.missing ? "#94a3b8" : "#1e293b", fontStyle: u.missing ? "italic" : "normal" }}>{u.name}</p>
                        <p style={{ margin: 0, fontSize: "11px", color: "#cbd5e1", fontFamily: "monospace" }}>{g.targetUserId}</p>
                      </td>
                      <td style={{ padding: "12px 16px" }}>
                        <span style={{ padding: "4px 12px", borderRadius: "20px", fontSize: "13px", fontWeight: "700", background: alarm ? "#dc2626" : "#fef3c7", color: alarm ? "white" : "#d97706" }}>
                          {alarm ? "⚠ " : ""}{g.blockers.size} kişi
                        </span>
                      </td>
                      <td style={{ padding: "12px 16px", fontSize: "14px", color: "#64748b" }}>{g.kayitSayisi}</td>
                      <td style={{ padding: "12px 16px", fontSize: "13px", color: "#64748b" }}>{g.lastAt ? formatDateTime(new Date(g.lastAt).toISOString()) : "-"}</td>
                      <td style={{ padding: "12px 16px", textAlign: "right" }}><SuspendCell uid={g.targetUserId} /></td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Tüm kayıtlar */}
      <div style={{ background: "white", borderRadius: "16px", overflow: "hidden", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
        <div style={{ padding: "20px 20px 0" }}>
          <h2 style={{ fontSize: "16px", fontWeight: "700", color: "#1e293b", margin: "0 0 4px 0" }}>Tüm Engelleme Kayıtları</h2>
          <p style={{ fontSize: "13px", color: "#64748b", margin: "0 0 16px 0" }}>Salt okunur — engellemeyi yalnızca kullanıcı kendisi kaldırabilir.</p>
        </div>
        {sortedBlocks.length === 0 ? (
          <p style={{ fontSize: "14px", color: "#94a3b8", margin: 0, padding: "0 20px 30px", textAlign: "center" }}>Henüz engelleme kaydı yok.</p>
        ) : (
          <>
            <div style={{ overflowX: "auto" }}>
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead><tr style={{ background: "#f8fafc" }}>
                  {["Engelleyen", "Engellenen", "Sebep", "Tarih"].map((h, i) => (
                    <th key={i} style={{ padding: "12px 16px", textAlign: "left", fontSize: "13px", fontWeight: "600", color: "#64748b" }}>{h}</th>
                  ))}
                </tr></thead>
                <tbody>
                  {paginatedItems.map((b) => {
                    const blocker = resolveUser(b.blockerId);
                    const target = resolveUser(b.targetUserId);
                    return (
                      <tr key={b.id} style={{ borderTop: "1px solid #f1f5f9" }}>
                        {[blocker, target].map((u, i) => (
                          <td key={i} style={{ padding: "12px 16px" }}>
                            <p style={{ margin: 0, fontSize: "14px", fontWeight: "500", color: u.missing ? "#94a3b8" : "#1e293b", fontStyle: u.missing ? "italic" : "normal" }}>{u.name}</p>
                            {u.id && <p style={{ margin: 0, fontSize: "11px", color: "#cbd5e1", fontFamily: "monospace" }}>{String(u.id).slice(0, 14)}…</p>}
                          </td>
                        ))}
                        <td style={{ padding: "12px 16px", fontSize: "13px", color: "#64748b", maxWidth: "260px" }}>{b.reason || <span style={{ color: "#cbd5e1" }}>—</span>}</td>
                        <td style={{ padding: "12px 16px", fontSize: "13px", color: "#64748b", whiteSpace: "nowrap" }}>{formatDateTime(b.createdAt)}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            {totalPages > 1 && <PaginationBar currentPage={currentPage} totalPages={totalPages} goToPage={goToPage} totalItems={totalItems} startIndex={startIndex} endIndex={endIndex} />}
          </>
        )}
      </div>
    </div>
  );
};

// ==================== MODERASYON SAYFASI (sekmeli kapsayıcı) ====================
const ModerationPage = ({ reports, allReports, blocks, resolveUser, setUserSuspended, onRemoveContent, onSuspendUser, onRejectReport, pendingCount }) => {
  const [tab, setTab] = useState("reports");
  const tabs = [
    { id: "reports", label: "İçerik Şikayetleri", icon: Flag, badge: pendingCount },
    { id: "blocks", label: "Engellemeler", icon: Ban, badge: (blocks || []).length },
    { id: "otomatik", label: "Otomatik Denetim", icon: Shield, badge: 0 },
  ];
  return (
    <div>
      <div style={{ display: "flex", gap: "8px", marginBottom: "24px", flexWrap: "wrap" }}>
        {tabs.map((t) => (
          <button key={t.id} onClick={() => setTab(t.id)}
            style={{ padding: "10px 20px", background: tab === t.id ? "#1e1b4b" : "white", color: tab === t.id ? "white" : "#64748b", border: "1px solid #e2e8f0", borderRadius: "10px", fontSize: "14px", fontWeight: "500", cursor: "pointer", display: "flex", alignItems: "center", gap: "8px" }}>
            <t.icon size={18} />{t.label}
            {t.badge > 0 && (
              <span style={{ padding: "2px 8px", borderRadius: "10px", fontSize: "12px", fontWeight: "700", background: tab === t.id ? "rgba(255,255,255,0.2)" : "#f1f5f9", color: tab === t.id ? "white" : "#64748b" }}>{t.badge}</span>
            )}
          </button>
        ))}
      </div>
      {tab === "reports" ? (
        <ContentReportsPage reports={reports} allReports={allReports} resolveUser={resolveUser}
          onRemoveContent={onRemoveContent} onSuspendUser={onSuspendUser} onRejectReport={onRejectReport} />
      ) : tab === "otomatik" ? (
        <IcerikDenetimiPanel resolveUser={resolveUser} />
      ) : (
        <UserBlocksPanel blocks={blocks} resolveUser={resolveUser} setUserSuspended={setUserSuspended} />
      )}
    </div>
  );
};

// ==================== CONTENT REPORTS PAGE (Apple Guideline 1.2) ====================
// Şikayet edilen KULLANICI İÇERİĞİ kuyruğu. "complaints" koleksiyonundan farklıdır:
// burası içerik kaldırma / kullanıcı atma aksiyonlarının alındığı moderasyon kuyruğudur.
// Apple şartı: şikayete 24 SAAT içinde aksiyon alınmalı.
const ContentReportsPage = ({ reports, allReports, resolveUser, onRemoveContent, onSuspendUser, onRejectReport }) => {
  const [filter, setFilter] = useState("pending");
  const [expanded, setExpanded] = useState(null);
  // SLA sayacı canlı kalsın — dakikada bir yeniden hesapla
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 60000);
    return () => clearInterval(t);
  }, []);

  const statusOf = (r) => r.status || "pending";

  // Aynı içeriğe kaç şikayet geldiği (tekrar = güçlü sinyal)
  const reportCountByTarget = useMemo(() => {
    const map = new Map();
    (allReports || []).forEach((r) => {
      if (!r.targetId) return;
      map.set(r.targetId, (map.get(r.targetId) || 0) + 1);
    });
    return map;
  }, [allReports]);

  const filtered = useMemo(() => {
    const list = filter === "all" ? reports : reports.filter((r) => statusOf(r) === filter);
    // KARAR: bekleyen kuyrukta EN ESKİ ÜSTTE — SLA riski önce görünsün.
    // Kapanmış kayıtlarda ise en yeni üstte (son işlem geçmişi).
    // createdAt'i olmayan bozuk kayıtlar her iki yönde de EN SONA atılır.
    const asc = filter === "pending";
    return [...list].sort((a, b) => {
      const ta = toMillis(a.createdAt);
      const tb = toMillis(b.createdAt);
      if (!ta && !tb) return 0;
      if (!ta) return 1;
      if (!tb) return -1;
      return asc ? ta - tb : tb - ta;
    });
  }, [reports, filter]);

  const { currentPage, totalPages, paginatedItems, goToPage, totalItems, startIndex, endIndex } = usePagination(filtered, 10);

  const pendingAll = (allReports || []).filter((r) => statusOf(r) === "pending");
  // createdAt yoksa yaş hesaplanamaz — epoch'tan beri geçen süreyi SLA ihlali saymayız
  const breachedAll = pendingAll.filter((r) => {
    const created = toMillis(r.createdAt);
    return created > 0 && now - created > SLA_MS;
  });

  const slaOf = (report) => {
    const created = toMillis(report.createdAt);
    if (statusOf(report) !== "pending") return { level: "done", age: created ? now - created : 0 };
    if (!created) return { level: "unknown", age: 0 }; // bozuk/eksik kayıt
    const age = now - created;
    if (age > SLA_MS) return { level: "breach", age };
    if (age > SLA_WARN_MS) return { level: "warn", age };
    return { level: "ok", age };
  };

  const slaStyles = {
    breach: { border: "2px solid #dc2626", bg: "#fef2f2", chipBg: "#dc2626", chipColor: "white" },
    warn: { border: "1px solid #fed7aa", bg: "white", chipBg: "#fef3c7", chipColor: "#d97706" },
    ok: { border: "1px solid #e2e8f0", bg: "white", chipBg: "#f1f5f9", chipColor: "#64748b" },
    done: { border: "1px solid #e2e8f0", bg: "white", chipBg: "#f1f5f9", chipColor: "#94a3b8" },
    unknown: { border: "1px dashed #cbd5e1", bg: "white", chipBg: "#f1f5f9", chipColor: "#94a3b8" },
  };

  const UserChip = ({ uid, label }) => {
    const u = resolveUser(uid);
    return (
      <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
        <span style={{ fontSize: "11px", color: "#94a3b8", fontWeight: "600", textTransform: "uppercase", letterSpacing: "0.4px" }}>{label}</span>
        <span style={{ fontSize: "13px", fontWeight: "600", color: u.missing ? "#94a3b8" : "#1e293b", fontStyle: u.missing ? "italic" : "normal" }}>
          {u.name}
          {u.suspended && <span style={{ marginLeft: "6px", padding: "1px 6px", background: "#fee2e2", color: "#dc2626", borderRadius: "4px", fontSize: "10px", fontWeight: "700" }}>ASKIDA</span>}
        </span>
        {uid && <span style={{ fontSize: "11px", color: "#cbd5e1", fontFamily: "monospace" }}>{uid.slice(0, 12)}…</span>}
      </div>
    );
  };

  const filterOptions = [
    { id: "pending", label: "Bekleyen" },
    { id: "removed", label: "Kaldırıldı" },
    { id: "reviewed", label: "İncelendi" },
    { id: "rejected", label: "Reddedildi" },
    { id: "all", label: "Tümü" },
  ];

  return (
    <div>
      {/* Başlık + SLA özeti */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "20px", flexWrap: "wrap", gap: "12px" }}>
        <div>
          <h1 style={{ fontSize: "24px", fontWeight: "700", color: "#1e293b", margin: "0 0 4px 0", display: "flex", alignItems: "center", gap: "10px" }}>
            <Flag size={24} color="#dc2626" /> İçerik Şikayetleri
          </h1>
          <p style={{ fontSize: "14px", color: "#64748b", margin: 0 }}>
            Kullanıcıların bildirdiği uygunsuz içerikler — App Store Guideline 1.2
          </p>
        </div>
        <select value={filter} onChange={(e) => setFilter(e.target.value)}
          style={{ padding: "10px 16px", border: "1px solid #e2e8f0", borderRadius: "10px", fontSize: "14px", outline: "none" }}>
          {filterOptions.map((o) => <option key={o.id} value={o.id}>{o.label}</option>)}
        </select>
      </div>

      {/* SLA panosu */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))", gap: "16px", marginBottom: "24px" }}>
        <div style={{ background: "white", borderRadius: "16px", padding: "18px 20px", boxShadow: "0 1px 3px rgba(0,0,0,0.05)", display: "flex", alignItems: "center", gap: "14px" }}>
          <div style={{ width: "44px", height: "44px", borderRadius: "12px", background: "#fee2e2", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <Flag size={22} color="#dc2626" />
          </div>
          <div>
            <p style={{ fontSize: "24px", fontWeight: "700", color: "#1e293b", margin: 0 }}>{pendingAll.length}</p>
            <p style={{ fontSize: "13px", color: "#64748b", margin: 0 }}>Bekleyen şikayet</p>
          </div>
        </div>
        <div style={{ background: breachedAll.length > 0 ? "#fef2f2" : "white", border: breachedAll.length > 0 ? "2px solid #dc2626" : "none", borderRadius: "16px", padding: "18px 20px", boxShadow: "0 1px 3px rgba(0,0,0,0.05)", display: "flex", alignItems: "center", gap: "14px" }}>
          <div style={{ width: "44px", height: "44px", borderRadius: "12px", background: breachedAll.length > 0 ? "#dc2626" : "#f1f5f9", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <Timer size={22} color={breachedAll.length > 0 ? "white" : "#94a3b8"} />
          </div>
          <div>
            <p style={{ fontSize: "24px", fontWeight: "700", color: breachedAll.length > 0 ? "#dc2626" : "#1e293b", margin: 0 }}>{breachedAll.length}</p>
            <p style={{ fontSize: "13px", color: breachedAll.length > 0 ? "#dc2626" : "#64748b", margin: 0, fontWeight: breachedAll.length > 0 ? "600" : "400" }}>
              {SLA_HOURS} saati aşan {breachedAll.length > 0 ? "— ACİL" : ""}
            </p>
          </div>
        </div>
        <div style={{ background: "white", borderRadius: "16px", padding: "18px 20px", boxShadow: "0 1px 3px rgba(0,0,0,0.05)", display: "flex", alignItems: "center", gap: "14px" }}>
          <div style={{ width: "44px", height: "44px", borderRadius: "12px", background: "#dcfce7", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <CheckCircle size={22} color="#16a34a" />
          </div>
          <div>
            <p style={{ fontSize: "24px", fontWeight: "700", color: "#1e293b", margin: 0 }}>{(allReports || []).length - pendingAll.length}</p>
            <p style={{ fontSize: "13px", color: "#64748b", margin: 0 }}>Karara bağlanan</p>
          </div>
        </div>
      </div>

      {breachedAll.length > 0 && (
        <div style={{ padding: "14px 18px", background: "#dc2626", color: "white", borderRadius: "12px", marginBottom: "20px", display: "flex", alignItems: "center", gap: "12px" }}>
          <ShieldAlert size={20} />
          <p style={{ margin: 0, fontSize: "14px", fontWeight: "600" }}>
            {breachedAll.length} şikayet {SLA_HOURS} saatlik Apple sınırını aştı. App Store incelemesi için derhal aksiyon alın.
          </p>
        </div>
      )}

      {filtered.length === 0 ? (
        <div style={{ background: "white", borderRadius: "16px", padding: "60px 20px", textAlign: "center", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
          <CheckCircle size={48} color="#16a34a" style={{ marginBottom: "16px" }} />
          <p style={{ fontSize: "16px", fontWeight: "600", color: "#1e293b", margin: "0 0 8px 0" }}>
            {filter === "pending" ? "Bekleyen şikayet yok" : "Kayıt bulunamadı"}
          </p>
          <p style={{ fontSize: "14px", color: "#64748b", margin: 0 }}>
            {filter === "pending" ? "Kuyruk temiz — 24 saat kuralı ihlal edilmiyor." : "Bu filtreye uyan şikayet yok."}
          </p>
        </div>
      ) : (
        <>
          <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
            {paginatedItems.map((r) => {
              const sla = slaOf(r);
              const s = slaStyles[sla.level];
              const status = statusOf(r);
              const badge = REPORT_STATUS_BADGES[status] || REPORT_STATUS_BADGES.pending;
              const target = REPORT_TARGET_LABELS[r.targetType] || { label: r.targetType || "Bilinmiyor", icon: "❓", color: "#64748b", bg: "#f1f5f9" };
              const dupCount = reportCountByTarget.get(r.targetId) || 1;
              const isPending = status === "pending";
              const isMessage = r.targetType === "message";

              return (
                <div key={r.id} style={{ background: s.bg, border: s.border, borderRadius: "16px", padding: "20px", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
                  {/* Üst satır */}
                  <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: "12px", marginBottom: "14px", flexWrap: "wrap" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap" }}>
                      <span style={{ padding: "4px 10px", borderRadius: "6px", fontSize: "12px", fontWeight: "600", background: target.bg, color: target.color }}>
                        {target.icon} {target.label}
                      </span>
                      <span style={{ padding: "4px 10px", borderRadius: "6px", fontSize: "12px", fontWeight: "600", background: "#fee2e2", color: "#dc2626" }}>
                        {REPORT_REASON_LABELS[r.reason] || r.reason || "Diğer"}
                      </span>
                      {dupCount > 1 && (
                        <span style={{ padding: "4px 10px", borderRadius: "6px", fontSize: "12px", fontWeight: "700", background: "#7c2d12", color: "white" }}>
                          ⚠ Bu içeriğe {dupCount} şikayet
                        </span>
                      )}
                    </div>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <span style={{ padding: "4px 10px", borderRadius: "20px", fontSize: "12px", fontWeight: "700", background: s.chipBg, color: s.chipColor, display: "inline-flex", alignItems: "center", gap: "4px" }}>
                        <Clock size={12} />
                        {sla.level === "unknown"
                          ? "Tarih yok"
                          : sla.level === "breach"
                          ? `SLA AŞILDI — ${formatDuration(sla.age)}`
                          : formatDuration(sla.age)}
                      </span>
                      <span style={{ padding: "4px 10px", borderRadius: "20px", fontSize: "12px", fontWeight: "500", background: badge.bg, color: badge.color }}>
                        {badge.text}
                      </span>
                    </div>
                  </div>

                  {/* Şikayet anındaki içerik kopyası — asıl kanıt */}
                  <div style={{ marginBottom: "14px" }}>
                    <p style={{ fontSize: "11px", fontWeight: "700", color: "#94a3b8", margin: "0 0 6px 0", textTransform: "uppercase", letterSpacing: "0.4px" }}>
                      Şikayet Anındaki İçerik
                    </p>
                    {r.contentSnapshot ? (
                      <pre style={{ margin: 0, padding: "14px", background: "#0f172a", color: "#e2e8f0", borderRadius: "10px", fontSize: "13px", lineHeight: "1.6", whiteSpace: "pre-wrap", wordBreak: "break-word", fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace", maxHeight: expanded === r.id ? "none" : "160px", overflow: "hidden" }}>
                        {r.contentSnapshot}
                      </pre>
                    ) : (
                      <p style={{ margin: 0, padding: "14px", background: "#f8fafc", borderRadius: "10px", fontSize: "13px", color: "#94a3b8", fontStyle: "italic" }}>
                        İçerik kopyası kaydedilmemiş.
                      </p>
                    )}
                    {r.contentSnapshot && r.contentSnapshot.length > 400 && (
                      <button onClick={() => setExpanded(expanded === r.id ? null : r.id)}
                        style={{ marginTop: "6px", padding: "4px 10px", background: "none", border: "none", color: "#4f46e5", fontSize: "12px", fontWeight: "600", cursor: "pointer" }}>
                        {expanded === r.id ? "▲ Daralt" : "▼ Tamamını göster"}
                      </button>
                    )}
                  </div>

                  {/* Şikayetçi açıklaması */}
                  {r.description && (
                    <div style={{ marginBottom: "14px" }}>
                      <p style={{ fontSize: "11px", fontWeight: "700", color: "#94a3b8", margin: "0 0 6px 0", textTransform: "uppercase", letterSpacing: "0.4px" }}>
                        Şikayetçinin Açıklaması
                      </p>
                      <p style={{ margin: 0, padding: "12px", background: "#f8fafc", borderRadius: "10px", fontSize: "14px", color: "#475569", lineHeight: "1.5" }}>
                        {r.description}
                      </p>
                    </div>
                  )}

                  {/* Taraflar */}
                  <div style={{ display: "flex", gap: "32px", flexWrap: "wrap", padding: "14px", background: "#f8fafc", borderRadius: "10px", marginBottom: "14px" }}>
                    <UserChip uid={r.reporterId} label="Şikayet Eden" />
                    <UserChip uid={r.targetUserId} label="Hedef Kullanıcı" />
                    <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
                      <span style={{ fontSize: "11px", color: "#94a3b8", fontWeight: "600", textTransform: "uppercase", letterSpacing: "0.4px" }}>Tarih</span>
                      <span style={{ fontSize: "13px", fontWeight: "600", color: "#1e293b" }}>{formatDateTime(r.createdAt)}</span>
                      <span style={{ fontSize: "11px", color: "#cbd5e1", fontFamily: "monospace" }}>hedef: {String(r.targetId || "-").slice(0, 12)}…</span>
                    </div>
                  </div>

                  {/* Alınmış karar */}
                  {!isPending && (
                    <div style={{ padding: "12px 16px", background: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: "10px", marginBottom: "12px" }}>
                      <p style={{ fontSize: "13px", color: "#166534", margin: 0 }}>
                        <strong>{badge.text}</strong>
                        {r.reviewedBy ? ` — ${r.reviewedBy}` : ""}
                        {r.reviewedAt ? ` · ${formatDateTime(r.reviewedAt)}` : ""}
                      </p>
                      {r.adminNote && <p style={{ fontSize: "12px", color: "#15803d", margin: "4px 0 0" }}>Not: {r.adminNote}</p>}
                    </div>
                  )}

                  {/* Aksiyonlar */}
                  {isPending && (
                    <div style={{ display: "flex", gap: "8px", paddingTop: "14px", borderTop: "1px solid #f1f5f9", flexWrap: "wrap" }}>
                      <button onClick={() => onRemoveContent(r)}
                        style={{ padding: "10px 16px", background: "#fee2e2", color: "#dc2626", border: "none", borderRadius: "8px", fontSize: "13px", fontWeight: "600", cursor: "pointer", display: "flex", alignItems: "center", gap: "6px" }}>
                        <EyeOff size={16} /> {isMessage ? "İncelendi İşaretle" : "İçeriği Kaldır"}
                      </button>
                      <button onClick={() => onSuspendUser(r)} disabled={!r.targetUserId}
                        title={!r.targetUserId ? "Bu şikayette hedef kullanıcı bilgisi yok" : "İçeriği gizler ve kullanıcıyı askıya alır"}
                        style={{ padding: "10px 16px", background: r.targetUserId ? "#dc2626" : "#e2e8f0", color: r.targetUserId ? "white" : "#94a3b8", border: "none", borderRadius: "8px", fontSize: "13px", fontWeight: "600", cursor: r.targetUserId ? "pointer" : "not-allowed", display: "flex", alignItems: "center", gap: "6px" }}>
                        <Ban size={16} /> Kullanıcıyı Askıya Al
                      </button>
                      <button onClick={() => onRejectReport(r)}
                        style={{ padding: "10px 16px", background: "#f1f5f9", color: "#64748b", border: "none", borderRadius: "8px", fontSize: "13px", fontWeight: "600", cursor: "pointer", display: "flex", alignItems: "center", gap: "6px" }}>
                        <XCircle size={16} /> Reddet
                      </button>
                      {isMessage && (
                        <span style={{ padding: "10px 0", fontSize: "12px", color: "#94a3b8", alignSelf: "center" }}>
                          Mesaj içeriği teknik olarak gizlenemez — kullanıcıyı askıya alma seçeneğini kullanın.
                        </span>
                      )}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
          {totalPages > 1 && (
            <div style={{ background: "white", borderRadius: "16px", marginTop: "16px", overflow: "hidden" }}>
              <PaginationBar currentPage={currentPage} totalPages={totalPages} goToPage={goToPage} totalItems={totalItems} startIndex={startIndex} endIndex={endIndex} />
            </div>
          )}
        </>
      )}
    </div>
  );
};

// ==================== COMPLAINTS PAGE (with Status Update + Response) ====================
const ComplaintsPage = ({ complaints, allComplaints, updateComplaintStatus, initialFilter = null }) => {
  const [filter, setFilter] = useState(initialFilter || "all");
  const [respondingTo, setRespondingTo] = useState(null);
  const [responseText, setResponseText] = useState("");
  const [selectedComplaint, setSelectedComplaint] = useState(null);
  
  // Status değerlerini normalize et (open -> pending uyumu)
  const normalizeStatus = (status) => {
    if (status === "open") return "pending";
    return status;
  };
  
  const filtered = filter === "all" ? complaints : complaints.filter((c) => normalizeStatus(c.status) === filter);
  const { currentPage, totalPages, paginatedItems, goToPage, totalItems, startIndex, endIndex } = usePagination(filtered, 10);

  const handleRespond = (complaintId, newStatus) => {
    updateComplaintStatus(complaintId, newStatus, responseText);
    setRespondingTo(null);
    setResponseText("");
  };

  const getStatusBadge = (status) => {
    const s = normalizeStatus(status);
    const config = {
      pending: { bg: "#fee2e2", color: "#dc2626", text: "Beklemede" },
      in_progress: { bg: "#fef3c7", color: "#d97706", text: "İnceleniyor" },
      in_review: { bg: "#fef3c7", color: "#d97706", text: "İnceleniyor" },
      resolved: { bg: "#dcfce7", color: "#16a34a", text: "Çözüldü" },
      rejected: { bg: "#f3f4f6", color: "#6b7280", text: "Reddedildi" },
    };
    return config[s] || config.pending;
  };

  return (
    <div>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "24px", flexWrap: "wrap", gap: "12px" }}>
        <div>
          <h1 style={{ fontSize: "24px", fontWeight: "700", color: "#1e293b", margin: "0 0 4px 0" }}>Şikayetler</h1>
          <p style={{ fontSize: "14px", color: "#64748b", margin: 0 }}>{complaints.length !== allComplaints.length ? `${complaints.length} / ${allComplaints.length} şikayet (arama sonucu)` : `Toplam ${complaints.length} şikayet`}</p>
        </div>
        <select value={filter} onChange={(e) => setFilter(e.target.value)} style={{ padding: "10px 16px", border: "1px solid #e2e8f0", borderRadius: "10px", fontSize: "14px", outline: "none" }}>
          <option value="all">Tümü</option>
          <option value="pending">Beklemede</option>
          <option value="in_progress">İnceleniyor</option>
          <option value="resolved">Çözüldü</option>
          <option value="rejected">Reddedildi</option>
        </select>
      </div>

      {filtered.length === 0 ? (
        <div style={{ background: "white", borderRadius: "16px", padding: "60px 20px", textAlign: "center", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
          <CheckCircle size={48} color="#16a34a" style={{ marginBottom: "16px" }} />
          <p style={{ fontSize: "16px", fontWeight: "600", color: "#1e293b", margin: "0 0 8px 0" }}>Harika!</p>
          <p style={{ fontSize: "14px", color: "#64748b", margin: 0 }}>Şikayet bulunmuyor.</p>
        </div>
      ) : (
        <>
          <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
            {paginatedItems.map((c) => {
              const statusBadge = getStatusBadge(c.status);
              return (
              <div key={c.id} style={{ background: "white", borderRadius: "16px", padding: "20px", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
                <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", marginBottom: "12px" }}>
                  <div>
                    <h3 style={{ fontSize: "16px", fontWeight: "600", color: "#1e293b", margin: "0 0 4px 0" }}>{c.subject || "Şikayet"}</h3>
                    <p style={{ fontSize: "13px", color: "#64748b", margin: 0 }}>Ticket #{c.id.slice(-6).toUpperCase()}</p>
                  </div>
                  <span style={{ padding: "4px 10px", borderRadius: "20px", fontSize: "12px", fontWeight: "500", background: statusBadge.bg, color: statusBadge.color }}>
                    {statusBadge.text}
                  </span>
                </div>

                {/* Kategori ve Öncelik */}
                <div style={{ display: "flex", gap: "8px", marginBottom: "12px", flexWrap: "wrap" }}>
                  {c.category && (
                    <span style={{ padding: "4px 10px", background: "#f1f5f9", borderRadius: "6px", fontSize: "12px", color: "#64748b" }}>
                      📁 {c.category}
                    </span>
                  )}
                  {c.priority && (
                    <span style={{ 
                      padding: "4px 10px", 
                      borderRadius: "6px", 
                      fontSize: "12px",
                      background: c.priority === "urgent" ? "#fee2e2" : c.priority === "high" ? "#fef3c7" : "#f1f5f9",
                      color: c.priority === "urgent" ? "#dc2626" : c.priority === "high" ? "#d97706" : "#64748b"
                    }}>
                      {c.priority === "urgent" ? "🔴 Acil" : c.priority === "high" ? "🟠 Yüksek" : "🔵 Normal"}
                    </span>
                  )}
                  {c.userType && (
                    <span style={{ padding: "4px 10px", background: c.userType === "expert" ? "#ede9fe" : "#dbeafe", borderRadius: "6px", fontSize: "12px", color: c.userType === "expert" ? "#7c3aed" : "#2563eb" }}>
                      {c.userType === "expert" ? "👨‍🔧 Uzman" : "👤 Müşteri"}
                    </span>
                  )}
                </div>

                <p style={{ fontSize: "14px", color: "#64748b", margin: "0 0 12px 0", lineHeight: "1.5", background: "#f8fafc", padding: "12px", borderRadius: "8px" }}>{c.description || "-"}</p>

                <div style={{ display: "flex", gap: "16px", fontSize: "13px", color: "#94a3b8", marginBottom: "16px", flexWrap: "wrap" }}>
                  {c.userName && <span>👤 Gönderen: <strong style={{ color: "#1e293b" }}>{c.userName}</strong></span>}
                  {!c.userName && c.customerName && <span>👤 Müşteri: <strong style={{ color: "#64748b" }}>{c.customerName}</strong></span>}
                  {!c.userName && c.expertName && <span>👨‍🔧 Uzman: <strong style={{ color: "#64748b" }}>{c.expertName}</strong></span>}
                  {(c.userEmail || c.customerEmail || c.expertEmail) && <span>📧 <strong style={{ color: "#64748b" }}>{c.userEmail || c.customerEmail || c.expertEmail}</strong></span>}
                  <span>📅 {c.createdAt ? new Date(typeof c.createdAt === "object" && c.createdAt.seconds ? c.createdAt.seconds * 1000 : c.createdAt).toLocaleDateString("tr-TR", { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "-"}</span>
                </div>

                {/* Admin Response (if exists) */}
                {c.adminResponse && (
                  <div style={{ padding: "12px 16px", background: "#f0fdf4", border: "1px solid #bbf7d0", borderRadius: "10px", marginBottom: "12px" }}>
                    <p style={{ fontSize: "12px", fontWeight: "600", color: "#16a34a", margin: "0 0 4px 0" }}>✅ Admin Yanıtı:</p>
                    <p style={{ fontSize: "13px", color: "#166534", margin: 0 }}>{c.adminResponse}</p>
                    {c.respondedAt && <p style={{ fontSize: "11px", color: "#86efac", margin: "4px 0 0" }}>{new Date(c.respondedAt).toLocaleString("tr-TR")}</p>}
                  </div>
                )}

                {/* Response Form */}
                {respondingTo === c.id && (
                  <div style={{ padding: "16px", background: "#f8fafc", borderRadius: "10px", marginBottom: "12px" }}>
                    <label style={{ display: "block", fontSize: "13px", fontWeight: "600", color: "#374151", marginBottom: "8px" }}>Yanıtınız (kullanıcıya iletilecek):</label>
                    <textarea value={responseText} onChange={(e) => setResponseText(e.target.value)} placeholder="Şikayetle ilgili yanıtınızı yazın..." rows={4}
                      style={{ width: "100%", padding: "12px", border: "1px solid #e2e8f0", borderRadius: "8px", fontSize: "14px", outline: "none", resize: "vertical", boxSizing: "border-box", marginBottom: "12px" }} />
                    <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
                      <button onClick={() => handleRespond(c.id, "in_progress")}
                        style={{ padding: "10px 16px", background: "#fef3c7", color: "#d97706", border: "none", borderRadius: "8px", fontSize: "13px", fontWeight: "600", cursor: "pointer" }}>
                        📋 İncelemeye Al
                      </button>
                      <button onClick={() => handleRespond(c.id, "resolved")}
                        style={{ padding: "10px 16px", background: "#16a34a", color: "white", border: "none", borderRadius: "8px", fontSize: "13px", fontWeight: "600", cursor: "pointer" }}>
                        ✅ Çözüldü Olarak İşaretle
                      </button>
                      <button onClick={() => handleRespond(c.id, "rejected")}
                        style={{ padding: "10px 16px", background: "#6b7280", color: "white", border: "none", borderRadius: "8px", fontSize: "13px", fontWeight: "600", cursor: "pointer" }}>
                        ❌ Reddet
                      </button>
                      <button onClick={() => { setRespondingTo(null); setResponseText(""); }}
                        style={{ padding: "10px 16px", background: "#f1f5f9", color: "#64748b", border: "none", borderRadius: "8px", fontSize: "13px", fontWeight: "600", cursor: "pointer" }}>
                        İptal
                      </button>
                    </div>
                  </div>
                )}

                {/* Action Buttons */}
                {normalizeStatus(c.status) !== "resolved" && normalizeStatus(c.status) !== "rejected" && respondingTo !== c.id && (
                  <div style={{ display: "flex", gap: "8px", paddingTop: "12px", borderTop: "1px solid #f1f5f9", flexWrap: "wrap" }}>
                    <button onClick={() => { setRespondingTo(c.id); setResponseText(""); }}
                      style={{ padding: "10px 16px", background: "#e0e7ff", color: "#4f46e5", border: "none", borderRadius: "8px", fontSize: "13px", fontWeight: "600", cursor: "pointer", display: "flex", alignItems: "center", gap: "6px" }}>
                      <MessageSquare size={16} /> Yanıtla
                    </button>
                    {normalizeStatus(c.status) === "pending" && (
                      <button onClick={() => updateComplaintStatus(c.id, "in_progress", "")}
                        style={{ padding: "10px 16px", background: "#fef3c7", color: "#d97706", border: "none", borderRadius: "8px", fontSize: "13px", fontWeight: "600", cursor: "pointer" }}>
                        📋 İncelemeye Al
                      </button>
                    )}
                    <button onClick={() => updateComplaintStatus(c.id, "resolved", "")}
                      style={{ padding: "10px 16px", background: "#dcfce7", color: "#16a34a", border: "none", borderRadius: "8px", fontSize: "13px", fontWeight: "600", cursor: "pointer" }}>
                      ✅ Çözüldü
                    </button>
                  </div>
                )}
              </div>
            )})}
          </div>
          {totalPages > 1 && (
            <div style={{ background: "white", borderRadius: "16px", marginTop: "16px", overflow: "hidden" }}>
              <PaginationBar currentPage={currentPage} totalPages={totalPages} goToPage={goToPage} totalItems={totalItems} startIndex={startIndex} endIndex={endIndex} />
            </div>
          )}
        </>
      )}
    </div>
  );
};

// ==================== PREMIUM MANAGEMENT PAGE ====================
const PremiumManagementPage = ({ experts, resolveUser, initialFilter = null }) => {
  const [activeTab, setActiveTab] = useState("members");
  // Ödemeler ortak kaynaktan (PanelVeriSaglayici; giriş yapılınca bir kez okunur). Gelir Ödemeler sayfasıyla aynı hesap.
  const { odemeDurum, odemeleriYukle } = usePanelVeri();
  const tumOdemeler = useSiniflanmisOdemeler(resolveUser);
  const loading = odemeDurum === "bekliyor";
  const [filter, setFilter] = useState(initialFilter || "all");
  const [selectedUser, setSelectedUser] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [modalAction, setModalAction] = useState(null);
  const [premiumDays, setPremiumDays] = useState(30);

  // Premium üyeler (roster): premium GEÇMİŞİ olan herkes — aktif + süresi dolmuş + iptal.
  // Ham isPremium okumak sekme sayısı ile liste satır sayısını ayrıştırıyordu
  // ("Aktif Premium 0" ama "Premium Üyeler 3" gibi); artık o da getPremiumState'ten.
  // Sanal işlemle premium yazılmış hesaplar (isGecersizOdeme) abone sayılmaz.
  // Varsayılan olarak listelerden de çıkar; "Geçersizleri göster" açıkken gri
  // etiketle listeye döner. Üstteki istatistik kartları her zaman onlarsız sayar.
  const [gecersizGoster, setGecersizGoster] = useState(false);
  const premiumKaynak = useMemo(() => {
    return gecersizGoster ? experts : experts.filter(e => !isGecersizOdeme(e));
  }, [experts, gecersizGoster]);
  const gecersizUyeSayisi = useMemo(() => {
    return experts.filter(e => getPremiumState(e) !== "none" && isGecersizOdeme(e)).length;
  }, [experts]);

  const premiumMembers = useMemo(() => {
    return premiumKaynak.filter(e => getPremiumState(e) !== "none");
  }, [premiumKaynak]);

  // Aşağıdaki üçü de rozetle AYNI getPremiumState kaynağını kullanır —
  // tarihi geçmiş premium artık "Aktif" sayılmıyor.
  const cancelledMembers = useMemo(() => {
    return premiumKaynak.filter(e => getPremiumState(e) === "cancelled");
  }, [premiumKaynak]);

  const expiredMembers = useMemo(() => {
    return premiumKaynak.filter(e => getPremiumState(e) === "expired");
  }, [premiumKaynak]);

  const activeMembers = useMemo(() => {
    return premiumKaynak.filter(e => getPremiumState(e) === "active");
  }, [premiumKaynak]);

  // 7 gün içinde bitecek aktif abonelikler (dashboard "Dikkat gerektirenler" ile aynı kural)
  const expiringMembers = useMemo(() => {
    const now = Date.now();
    const yediGun = 7 * 24 * 60 * 60 * 1000;
    return premiumKaynak.filter((e) => {
      if (getPremiumState(e) !== "active") return false;
      const t = toMillis(e.premiumEndDate);
      return t > 0 && t > now && t < now + yediGun;
    });
  }, [premiumKaynak]);

  // Trial üyeleri filtrele
  const trialMembers = useMemo(() => {
    return experts.filter(e => e.trialActive === true);
  }, [experts]);

  const activeTrialMembers = useMemo(() => {
    return trialMembers.filter(e => e.trialEndDate && new Date(e.trialEndDate) > new Date());
  }, [trialMembers]);

  const expiredTrialMembers = useMemo(() => {
    return experts.filter(e => {
      if (e.isPremium) return false;
      if (!e.trialEndDate) return false;
      return new Date(e.trialEndDate) <= new Date();
    });
  }, [experts]);

  // Ödeme geçmişi: premium abonelik kayıtları, yeniden eskiye (sınıfı ile). Elle premium verilince yeniden okunur.
  const payments = useMemo(() => tumOdemeler.filter((x) => x.p.type === "premium_subscription"), [tumOdemeler]);
  const fetchPayments = odemeleriYukle;

  // Premium aç/kapat
  const handlePremiumToggle = async (user, action) => {
    try {
      const userRef = doc(db, "users", user.id);
      
      if (action === "activate") {
        const endDate = new Date();
        endDate.setDate(endDate.getDate() + premiumDays);
        
        await updateDoc(userRef, {
          isPremium: true,
          premiumPlan: "admin_granted",
          premiumStartDate: new Date().toISOString(),
          premiumEndDate: endDate.toISOString(),
          premiumCancelled: false,
          premiumExpired: false,
          premiumGrantedBy: "admin",
          premiumGrantedAt: new Date().toISOString(),
          // Trial'ı kapat — artık premium
          trialActive: false,
        });

        // Kullanıcıya bildirim gönder
        const notifData = {
          type: "premium_activated",
          icon: "👑",
          title: "Premium Üyelik Aktif!",
          message: `Tebrikler! ${premiumDays} günlük Premium üyeliğiniz aktifleştirildi. Tüm özelliklerden yararlanabilirsiniz.`,
          color: "#d97706",
          read: false,
          createdAt: new Date().toISOString(),
        };
        try {
          await addDoc(collection(db, "users", user.id, "notifications"), notifData);
          await addDoc(collection(db, "notifications"), { ...notifData, userId: user.id });
        } catch (e) {}

        // Ödeme kaydı oluştur
        await addDoc(collection(db, "payments"), {
          userId: user.id,
          userName: user.name || user.displayName,
          type: "premium_subscription",
          plan: "admin_granted",
          amount: 0,
          duration: premiumDays,
          status: "completed",
          grantedBy: "admin",
          createdAt: new Date().toISOString(),
        });
        // Yeni kayıt Ödeme Geçmişi'nde görünsün (önceden users değişikliği yeniden okumayı tetikliyordu)
        fetchPayments();

        alert(`${user.name || user.displayName} için ${premiumDays} günlük Premium aktifleştirildi!`);
      } else if (action === "deactivate") {
        // premiumEndDate ŞİMDİ'ye çekilir — ZORUNLU.
        // Artık premium durumu tarihe göre belirleniyor; bitiş tarihi gelecekte
        // bırakılırsa kullanıcı iptalden hemen sonra tekrar "Aktif" görünür ve
        // uygulama tarafındaki isPremiumValid de onu premium saymaya devam eder.
        await updateDoc(userRef, {
          isPremium: false,
          premiumCancelled: false,
          premiumExpired: true,
          premiumEndDate: new Date().toISOString(),
          premiumExpiredAt: new Date().toISOString(),
          premiumDeactivatedBy: "admin",
        });

        // Kullanıcıya bildirim gönder
        const notifData = {
          type: "premium_deactivated",
          icon: "⏰",
          title: "Premium Üyelik Sona Erdi",
          message: "Premium üyeliğiniz sona erdi. Devam etmek için yeni bir abonelik planı seçebilirsiniz.",
          color: "#dc2626",
          read: false,
          createdAt: new Date().toISOString(),
        };
        try {
          await addDoc(collection(db, "users", user.id, "notifications"), notifData);
          await addDoc(collection(db, "notifications"), { ...notifData, userId: user.id });
        } catch (e) {}

        alert(`${user.name || user.displayName} premium üyeliği iptal edildi.`);
      } else if (action === "extend") {
        const currentEnd = user.premiumEndDate ? new Date(user.premiumEndDate) : new Date();
        currentEnd.setDate(currentEnd.getDate() + premiumDays);
        
        await updateDoc(userRef, {
          premiumEndDate: currentEnd.toISOString(),
          premiumExtendedBy: "admin",
          premiumExtendedAt: new Date().toISOString(),
        });

        // Kullanıcıya bildirim gönder
        const notifData = {
          type: "premium_extended",
          icon: "🎉",
          title: "Premium Süreniz Uzatıldı!",
          message: `Premium üyeliğiniz ${premiumDays} gün daha uzatıldı.`,
          color: "#16a34a",
          read: false,
          createdAt: new Date().toISOString(),
        };
        try {
          await addDoc(collection(db, "users", user.id, "notifications"), notifData);
          await addDoc(collection(db, "notifications"), { ...notifData, userId: user.id });
        } catch (e) {}

        alert(`${user.name || user.displayName} premium süresi ${premiumDays} gün uzatıldı!`);
      }

      setShowModal(false);
      setSelectedUser(null);
    } catch (error) {
      console.error("Premium güncelleme hatası:", error);
      alert("İşlem başarısız oldu!");
    }
  };

  // Ödemeler: test ve geçersiz kayıtlar (isTest; işaretsizde panel kuralı) gelirden HER ZAMAN çıkar;
  // listede yalnızca "Test ve geçersizleri göster" açıkken görünür.
  const gecerliOdemeler = useMemo(() => payments.filter((x) => !x.s.test), [payments]);
  const gecersizOdemeSayisi = payments.length - gecerliOdemeler.length;
  const gosterilenOdemeler = gecersizGoster ? payments : gecerliOdemeler;

  // İstatistikler — geçersizler göster/gizle seçiminden bağımsız olarak hariç
  const gecerliMi = (e) => !isGecersizOdeme(e);
  const stats = [
    { label: "Aktif Premium", value: activeMembers.filter(gecerliMi).length, icon: Award, color: "#d97706", bg: "linear-gradient(135deg, #fef3c7, #fde68a)" },
    { label: "Aktif Deneme", value: activeTrialMembers.length, icon: Clock, color: "#7c3aed", bg: "linear-gradient(135deg, #ede9fe, #ddd6fe)" },
    { label: "Deneme Dolmuş", value: expiredTrialMembers.length, icon: AlertCircle, color: "#ea580c", bg: "#fff7ed" },
    { label: "İptal Edilenler", value: cancelledMembers.filter(gecerliMi).length, icon: XCircle, color: "#dc2626", bg: "#fee2e2" },
    { label: "Süresi Dolanlar", value: expiredMembers.filter(gecerliMi).length, icon: Clock, color: "#6b7280", bg: "#f3f4f6" },
    { label: "Toplam Gelir (test hariç)", value: odemeDurum === "bekliyor" ? "…" : paraYaz(odemeOzeti(tumOdemeler).gelir), icon: DollarSign, color: "#16a34a", bg: "#dcfce7" },
  ];

  // Sekme sayıları listedeki satır sayısıyla aynıdır (seçime göre değişir)
  const tabs = [
    { id: "members", label: "Premium Üyeler", count: premiumMembers.length },
    { id: "trial", label: "Deneme Süreleri", count: activeTrialMembers.length + expiredTrialMembers.length },
    { id: "payments", label: "Ödeme Geçmişi", count: gosterilenOdemeler.length },
    { id: "expired", label: "Süresi Dolanlar", count: expiredMembers.length },
  ];

  // Filtreleme
  const getFilteredMembers = () => {
    let list = [];
    if (activeTab === "members") {
      list = premiumMembers;
      if (filter === "active") list = activeMembers;
      else if (filter === "cancelled") list = cancelledMembers;
      else if (filter === "expired") list = expiredMembers;
      else if (filter === "expiring") list = expiringMembers;
    } else if (activeTab === "expired") {
      list = expiredMembers;
    } else if (activeTab === "trial") {
      if (filter === "active") list = activeTrialMembers;
      else if (filter === "expired_trial") list = expiredTrialMembers;
      else list = [...activeTrialMembers, ...expiredTrialMembers];
    }
    return list;
  };

  const filteredMembers = getFilteredMembers();
  const { currentPage, totalPages, paginatedItems, goToPage, totalItems, startIndex, endIndex } = usePagination(
    activeTab === "payments" ? gosterilenOdemeler : filteredMembers,
    10
  );

  const formatDate = (dateStr) => {
    if (!dateStr) return "-";
    return new Date(dateStr).toLocaleDateString("tr-TR", { day: "numeric", month: "short", year: "numeric" });
  };

  return (
    <div>
      {/* Header */}
      <div style={{ marginBottom: "24px" }}>
        <h1 style={{ fontSize: "24px", fontWeight: "700", color: "#1e293b", margin: "0 0 4px 0", display: "flex", alignItems: "center", gap: "10px" }}>
          <Award size={28} color="#d97706" />
          Premium Yönetimi
        </h1>
        <p style={{ fontSize: "14px", color: "#64748b", margin: 0 }}>Premium üyelikleri yönetin, ödemeleri takip edin</p>
      </div>

      {/* Stats */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: "16px", marginBottom: "24px" }}>
        {stats.map((s, i) => (
          <div key={i} style={{ background: "white", borderRadius: "16px", padding: "20px", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
            <div style={{ width: "48px", height: "48px", background: s.bg, borderRadius: "12px", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "12px" }}>
              <s.icon size={24} color={s.color} />
            </div>
            <p style={{ fontSize: "28px", fontWeight: "700", color: "#1e293b", margin: "0 0 4px 0" }}>{s.value}</p>
            <p style={{ fontSize: "13px", color: "#64748b", margin: 0 }}>{s.label}</p>
          </div>
        ))}
      </div>

      {/* Tabs */}
      <div style={{ display: "flex", gap: "8px", marginBottom: "20px", flexWrap: "wrap" }}>
        {tabs.map(t => (
          <button
            key={t.id}
            onClick={() => setActiveTab(t.id)}
            style={{
              padding: "10px 20px",
              background: activeTab === t.id ? "linear-gradient(135deg, #d4af37, #f4e4a6)" : "white",
              color: activeTab === t.id ? "#1a0536" : "#64748b",
              border: "1px solid #e2e8f0",
              borderRadius: "10px",
              fontSize: "14px",
              fontWeight: "600",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            {t.label}
            <span style={{
              background: activeTab === t.id ? "rgba(0,0,0,0.15)" : "#f1f5f9",
              padding: "2px 8px",
              borderRadius: "10px",
              fontSize: "12px",
            }}>
              {t.count}
            </span>
          </button>
        ))}
      </div>

      {/* Geçersiz (sanal işlem) kayıtlar — üyeler ve ödemeler sekmesinde */}
      {(activeTab === "members" || activeTab === "payments") && (
        <div style={{ display: "flex", justifyContent: "flex-start", marginBottom: activeTab === "members" ? "8px" : "16px" }}>
          <label
            title={`googlePlayTransactionId = "${SANAL_ISLEM.transactionId}" ve googlePlayProductId = "${SANAL_ISLEM.productId}" olan kayıtlar. Gelir, ödeme ve abone sayılarına hiçbir zaman katılmaz.`}
            style={{ display: "flex", alignItems: "center", gap: "8px", fontSize: "13px", color: "#64748b", cursor: "pointer", userSelect: "none" }}
          >
            <input type="checkbox" checked={gecersizGoster} onChange={(e) => setGecersizGoster(e.target.checked)} />
            {activeTab === "payments" ? `Test ve geçersizleri göster (${gecersizOdemeSayisi})` : `Geçersizleri göster (${gecersizUyeSayisi} sanal işlem)`}
          </label>
        </div>
      )}

      {/* Filter for members tab */}
      {(activeTab === "members" || activeTab === "trial") && (
        <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "16px" }}>
          <select
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
            style={{ padding: "10px 16px", border: "1px solid #e2e8f0", borderRadius: "10px", fontSize: "14px", outline: "none" }}
          >
            {activeTab === "members" ? (
              <>
                <option value="all">Tümü</option>
                <option value="active">Aktif</option>
                <option value="expiring">⏳ 7 Gün İçinde Bitiyor</option>
                <option value="expired">Süresi Dolanlar</option>
                <option value="cancelled">İptal Edilenler</option>
              </>
            ) : (
              <>
                <option value="all">Tümü</option>
                <option value="active">Aktif Deneme</option>
                <option value="expired_trial">Süresi Dolmuş</option>
              </>
            )}
          </select>
        </div>
      )}

      {/* Content */}
      {loading ? (
        <div style={{ background: "white", borderRadius: "16px", padding: "60px", textAlign: "center" }}>
          <RefreshCw size={40} color="#6366f1" style={{ animation: "spin 1s linear infinite" }} />
          <p style={{ marginTop: "16px", color: "#64748b" }}>Yükleniyor...</p>
        </div>
      ) : activeTab === "trial" ? (
        /* Trial Members Table */
        <div style={{ background: "white", borderRadius: "16px", overflow: "hidden", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
          {filteredMembers.length === 0 ? (
            <div style={{ padding: "60px", textAlign: "center" }}>
              <Clock size={48} color="#94a3b8" style={{ marginBottom: "16px" }} />
              <p style={{ fontSize: "16px", fontWeight: "600", color: "#1e293b" }}>Deneme süresi olan uzman bulunamadı</p>
            </div>
          ) : (
            <>
              <div style={{ overflowX: "auto" }}>
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <thead>
                    <tr style={{ background: "#f8fafc" }}>
                      <th style={{ padding: "14px 16px", textAlign: "left", fontSize: "13px", fontWeight: "600", color: "#64748b" }}>Uzman</th>
                      <th style={{ padding: "14px 16px", textAlign: "left", fontSize: "13px", fontWeight: "600", color: "#64748b" }}>Başlangıç</th>
                      <th style={{ padding: "14px 16px", textAlign: "left", fontSize: "13px", fontWeight: "600", color: "#64748b" }}>Bitiş</th>
                      <th style={{ padding: "14px 16px", textAlign: "left", fontSize: "13px", fontWeight: "600", color: "#64748b" }}>Kalan Süre</th>
                      <th style={{ padding: "14px 16px", textAlign: "left", fontSize: "13px", fontWeight: "600", color: "#64748b" }}>Durum</th>
                      <th style={{ padding: "14px 16px", textAlign: "center", fontSize: "13px", fontWeight: "600", color: "#64748b" }}>İşlemler</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedItems.map((u) => {
                      const trialEnd = u.trialEndDate ? new Date(u.trialEndDate) : null;
                      const now = new Date();
                      const isActive = trialEnd && trialEnd > now;
                      const daysLeft = trialEnd ? Math.max(0, Math.ceil((trialEnd - now) / (1000 * 60 * 60 * 24))) : 0;
                      const totalDays = 30;
                      const progressPercent = isActive ? Math.min(100, (daysLeft / totalDays) * 100) : 0;

                      return (
                        <tr key={u.id} style={{ borderTop: "1px solid #f1f5f9" }}>
                          <td style={{ padding: "14px 16px" }}>
                            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                              <UserAvatarWithFallback user={{ ...u, userType: "expert" }} size={40} borderRadius="10px" />
                              <div>
                                <p style={{ margin: 0, fontSize: "14px", fontWeight: "600", color: "#1e293b" }}>{u.name || u.displayName || "İsimsiz"}</p>
                                <p style={{ margin: 0, fontSize: "12px", color: "#64748b" }}>{u.email}</p>
                              </div>
                            </div>
                          </td>
                          <td style={{ padding: "14px 16px", fontSize: "14px", color: "#64748b" }}>{formatDate(u.trialStartDate)}</td>
                          <td style={{ padding: "14px 16px", fontSize: "14px", color: "#64748b" }}>{formatDate(u.trialEndDate)}</td>
                          <td style={{ padding: "14px 16px" }}>
                            {isActive ? (
                              <div style={{ minWidth: "120px" }}>
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "6px" }}>
                                  <span style={{ fontSize: "14px", fontWeight: "700", color: daysLeft <= 7 ? "#dc2626" : daysLeft <= 15 ? "#d97706" : "#16a34a" }}>{daysLeft} gün</span>
                                  <span style={{ fontSize: "11px", color: "#94a3b8" }}>{Math.round(progressPercent)}%</span>
                                </div>
                                <div style={{ background: "#f1f5f9", borderRadius: "4px", height: "6px", overflow: "hidden" }}>
                                  <div style={{
                                    width: `${progressPercent}%`,
                                    height: "100%",
                                    borderRadius: "4px",
                                    background: daysLeft <= 7 ? "linear-gradient(90deg, #dc2626, #ef4444)" : daysLeft <= 15 ? "linear-gradient(90deg, #d97706, #f59e0b)" : "linear-gradient(90deg, #16a34a, #22c55e)",
                                    transition: "width 0.3s ease",
                                  }} />
                                </div>
                              </div>
                            ) : (
                              <span style={{ fontSize: "14px", fontWeight: "600", color: "#dc2626" }}>Süre doldu</span>
                            )}
                          </td>
                          <td style={{ padding: "14px 16px" }}>
                            <span style={{
                              padding: "4px 10px",
                              borderRadius: "20px",
                              fontSize: "12px",
                              fontWeight: "500",
                              background: isActive ? "#ede9fe" : "#fee2e2",
                              color: isActive ? "#7c3aed" : "#dc2626",
                            }}>
                              {isActive ? "Deneme Aktif" : "Deneme Doldu"}
                            </span>
                          </td>
                          <td style={{ padding: "14px 16px", textAlign: "center" }}>
                            <button
                              onClick={() => { setSelectedUser(u); setModalAction("activate"); setShowModal(true); }}
                              style={{ padding: "6px 12px", background: "linear-gradient(135deg, #d4af37, #f4e4a6)", border: "none", borderRadius: "8px", fontSize: "12px", fontWeight: "600", color: "#1a0536", cursor: "pointer" }}
                            >
                              Premium Yap
                            </button>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
              <PaginationBar currentPage={currentPage} totalPages={totalPages} goToPage={goToPage} totalItems={totalItems} startIndex={startIndex} endIndex={endIndex} />
            </>
          )}
        </div>
      ) : activeTab === "payments" ? (
        /* Payments Table */
        <div style={{ background: "white", borderRadius: "16px", overflow: "hidden", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
          {gosterilenOdemeler.length === 0 ? (
            <div style={{ padding: "60px", textAlign: "center" }}>
              <CreditCard size={48} color="#94a3b8" style={{ marginBottom: "16px" }} />
              <p style={{ fontSize: "16px", fontWeight: "600", color: "#1e293b" }}>Henüz ödeme kaydı yok</p>
            </div>
          ) : (
            <>
              <div style={{ overflowX: "auto" }}>
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <thead>
                    <tr style={{ background: "#f8fafc" }}>
                      <th style={{ padding: "14px 16px", textAlign: "left", fontSize: "13px", fontWeight: "600", color: "#64748b" }}>Kullanıcı</th>
                      <th style={{ padding: "14px 16px", textAlign: "left", fontSize: "13px", fontWeight: "600", color: "#64748b" }}>Plan</th>
                      <th style={{ padding: "14px 16px", textAlign: "right", fontSize: "13px", fontWeight: "600", color: "#64748b" }}>Tutar</th>
                      <th style={{ padding: "14px 16px", textAlign: "left", fontSize: "13px", fontWeight: "600", color: "#64748b" }}>Tarih</th>
                      <th style={{ padding: "14px 16px", textAlign: "left", fontSize: "13px", fontWeight: "600", color: "#64748b" }}>Durum</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedItems.map(({ p, s }) => {
                      const gecersiz = s.test;
                      return (
                      <tr key={p.id} style={{ borderTop: "1px solid #f1f5f9", background: gecersiz ? "#f8fafc" : undefined, opacity: gecersiz ? 0.75 : 1 }}>
                        <td style={{ padding: "14px 16px" }}>
                          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                            <div style={{ width: "36px", height: "36px", background: "linear-gradient(135deg, #d4af37, #f4e4a6)", borderRadius: "10px", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "14px", fontWeight: "600", color: "#1a0536" }}>
                              {(p.userName || resolveUser(p.userId).name || "?").substring(0, 2).toUpperCase()}
                            </div>
                            <span style={{ fontSize: "14px", fontWeight: "600", color: "#1e293b" }}>{p.userName || resolveUser(p.userId).name}</span>
                          </div>
                        </td>
                        <td style={{ padding: "14px 16px", fontSize: "14px", color: "#64748b" }}>
                          {p.plan === "yearly" ? "Yıllık" : p.plan === "monthly" ? "Aylık" : p.plan === "admin_granted" ? "Admin" : p.plan}
                        </td>
                        <td style={{ padding: "14px 16px", fontSize: "14px", fontWeight: "600", color: gecersiz ? "#94a3b8" : "#1e293b", textAlign: "right", textDecoration: gecersiz ? "line-through" : "none" }}>
                          {s.tutar > 0 ? paraYaz(s.tutar) : "Ücretsiz"}
                        </td>
                        <td style={{ padding: "14px 16px", fontSize: "14px", color: "#64748b", whiteSpace: "nowrap" }}>{s.t ? formatDateTime(new Date(s.t).toISOString()) : "tarih yok"}</td>
                        <td style={{ padding: "14px 16px" }}>
                          {gecersiz || s.hesapSilinmis || !s.isaretli ? odemeSinifRozeti(s) : (
                            <span style={{ padding: "4px 10px", borderRadius: "20px", fontSize: "12px", fontWeight: "500", background: "#dcfce7", color: "#16a34a" }}>
                              Tamamlandı
                            </span>
                          )}
                        </td>
                      </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
              <PaginationBar currentPage={currentPage} totalPages={totalPages} goToPage={goToPage} totalItems={totalItems} startIndex={startIndex} endIndex={endIndex} />
            </>
          )}
        </div>
      ) : (
        /* Members Table */
        <div style={{ background: "white", borderRadius: "16px", overflow: "hidden", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
          {filteredMembers.length === 0 ? (
            <div style={{ padding: "60px", textAlign: "center" }}>
              <Award size={48} color="#94a3b8" style={{ marginBottom: "16px" }} />
              <p style={{ fontSize: "16px", fontWeight: "600", color: "#1e293b" }}>Üye bulunamadı</p>
            </div>
          ) : (
            <>
              <div style={{ overflowX: "auto" }}>
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <thead>
                    <tr style={{ background: "#f8fafc" }}>
                      <th style={{ padding: "14px 16px", textAlign: "left", fontSize: "13px", fontWeight: "600", color: "#64748b" }}>Uzman</th>
                      <th style={{ padding: "14px 16px", textAlign: "left", fontSize: "13px", fontWeight: "600", color: "#64748b" }}>Plan</th>
                      <th style={{ padding: "14px 16px", textAlign: "left", fontSize: "13px", fontWeight: "600", color: "#64748b" }}>Başlangıç</th>
                      <th style={{ padding: "14px 16px", textAlign: "left", fontSize: "13px", fontWeight: "600", color: "#64748b" }}>Bitiş</th>
                      <th style={{ padding: "14px 16px", textAlign: "left", fontSize: "13px", fontWeight: "600", color: "#64748b" }}>Durum</th>
                      <th style={{ padding: "14px 16px", textAlign: "center", fontSize: "13px", fontWeight: "600", color: "#64748b" }}>İşlemler</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedItems.map((u) => (
                      <tr key={u.id} style={{ borderTop: "1px solid #f1f5f9" }}>
                        <td style={{ padding: "14px 16px" }}>
                          <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                            <div style={{ width: "40px", height: "40px", background: "linear-gradient(135deg, #d4af37, #f4e4a6)", borderRadius: "10px", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "14px", fontWeight: "600", color: "#1a0536" }}>
                              {(u.name || u.displayName || "?").substring(0, 2).toUpperCase()}
                            </div>
                            <div>
                              <p style={{ margin: 0, fontSize: "14px", fontWeight: "600", color: "#1e293b" }}>{u.name || u.displayName}</p>
                              <p style={{ margin: 0, fontSize: "12px", color: "#64748b" }}>{u.email}</p>
                            </div>
                          </div>
                        </td>
                        <td style={{ padding: "14px 16px", fontSize: "14px", color: "#64748b" }}>
                          {u.premiumPlan === "yearly" ? "Yıllık" : u.premiumPlan === "monthly" ? "Aylık" : u.premiumPlan === "admin_granted" ? "Admin" : "Aylık"}
                        </td>
                        <td style={{ padding: "14px 16px", fontSize: "14px", color: "#64748b" }}>{formatDate(u.premiumStartDate)}</td>
                        <td style={{ padding: "14px 16px", fontSize: "14px", color: "#64748b" }}>{formatDate(u.premiumEndDate)}</td>
                        <td style={{ padding: "14px 16px" }}>
                          {/* Rozet, sayaçlar ve butonlar AYNI getPremiumState kaynağını
                              kullanır; bayrak bayat olsa da tarih geçmişse "Süresi Doldu". */}
                          <span style={{
                            padding: "4px 10px",
                            borderRadius: "20px",
                            fontSize: "12px",
                            fontWeight: "500",
                            background: PREMIUM_STATE_LABELS[getPremiumState(u)].bg,
                            color: PREMIUM_STATE_LABELS[getPremiumState(u)].color,
                          }}>
                            {PREMIUM_STATE_LABELS[getPremiumState(u)].text}
                          </span>
                          {isGecersizOdeme(u) && (
                            <span
                              title="Premium, iOS satın alma eklentisinin ürettiği sanal işlemle yazılmış; para girmedi. Abone ve gelir sayılarına katılmaz. Uygulamadaki premium erişimi bu panelden değişmez."
                              style={{ marginLeft: "6px", padding: "4px 10px", borderRadius: "20px", fontSize: "12px", fontWeight: "500", background: "#e5e7eb", color: "#4b5563", whiteSpace: "nowrap" }}
                            >
                              Geçersiz (sanal işlem)
                            </span>
                          )}
                        </td>
                        <td style={{ padding: "14px 16px", textAlign: "center" }}>
                          <div style={{ display: "flex", gap: "8px", justifyContent: "center" }}>
                            {getPremiumState(u) === "active" && (
                              <>
                                <button
                                  onClick={() => { setSelectedUser(u); setModalAction("extend"); setShowModal(true); }}
                                  style={{ padding: "6px 12px", background: "#dbeafe", border: "none", borderRadius: "8px", fontSize: "12px", fontWeight: "500", color: "#2563eb", cursor: "pointer" }}
                                >
                                  Uzat
                                </button>
                                <button
                                  onClick={() => { setSelectedUser(u); setModalAction("deactivate"); setShowModal(true); }}
                                  style={{ padding: "6px 12px", background: "#fee2e2", border: "none", borderRadius: "8px", fontSize: "12px", fontWeight: "500", color: "#dc2626", cursor: "pointer" }}
                                >
                                  İptal Et
                                </button>
                              </>
                            )}
                            {getPremiumState(u) !== "active" && (
                              <button
                                onClick={() => { setSelectedUser(u); setModalAction("activate"); setShowModal(true); }}
                                style={{ padding: "6px 12px", background: "linear-gradient(135deg, #d4af37, #f4e4a6)", border: "none", borderRadius: "8px", fontSize: "12px", fontWeight: "600", color: "#1a0536", cursor: "pointer" }}
                              >
                                Aktifleştir
                              </button>
                            )}
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <PaginationBar currentPage={currentPage} totalPages={totalPages} goToPage={goToPage} totalItems={totalItems} startIndex={startIndex} endIndex={endIndex} />
            </>
          )}
        </div>
      )}

      {/* Action Modal */}
      {showModal && selectedUser && (
        <div style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000, padding: "20px" }}>
          <div style={{ background: "white", borderRadius: "20px", padding: "24px", maxWidth: "400px", width: "100%" }}>
            <div style={{ textAlign: "center", marginBottom: "20px" }}>
              <div style={{
                width: "60px",
                height: "60px",
                background: modalAction === "deactivate" ? "#fee2e2" : "linear-gradient(135deg, #fef3c7, #fde68a)",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 16px",
              }}>
                {modalAction === "deactivate" ? <XCircle size={30} color="#dc2626" /> : <Award size={30} color="#d97706" />}
              </div>
              <h3 style={{ fontSize: "18px", fontWeight: "700", color: "#1e293b", margin: "0 0 8px" }}>
                {modalAction === "activate" ? "Premium Aktifleştir" : modalAction === "extend" ? "Premium Uzat" : "Premium İptal Et"}
              </h3>
              <p style={{ fontSize: "14px", color: "#64748b", margin: 0 }}>
                <strong>{selectedUser.name || selectedUser.displayName}</strong> için işlem yapılacak
              </p>
            </div>

            {(modalAction === "activate" || modalAction === "extend") && (
              <div style={{ marginBottom: "20px" }}>
                <label style={{ display: "block", fontSize: "14px", fontWeight: "500", color: "#374151", marginBottom: "8px" }}>
                  Süre (Gün)
                </label>
                <input
                  type="number"
                  value={premiumDays}
                  onChange={(e) => setPremiumDays(parseInt(e.target.value) || 30)}
                  style={{ width: "100%", padding: "12px", border: "1px solid #e2e8f0", borderRadius: "10px", fontSize: "14px" }}
                  min="1"
                />
                <div style={{ display: "flex", gap: "8px", marginTop: "10px" }}>
                  {[7, 30, 90, 365].map(d => (
                    <button
                      key={d}
                      onClick={() => setPremiumDays(d)}
                      style={{
                        flex: 1,
                        padding: "8px",
                        background: premiumDays === d ? "#1e1b4b" : "#f1f5f9",
                        color: premiumDays === d ? "white" : "#64748b",
                        border: "none",
                        borderRadius: "8px",
                        fontSize: "12px",
                        fontWeight: "500",
                        cursor: "pointer",
                      }}
                    >
                      {d === 365 ? "1 Yıl" : d === 90 ? "3 Ay" : d === 30 ? "1 Ay" : "1 Hafta"}
                    </button>
                  ))}
                </div>
              </div>
            )}

            {modalAction === "deactivate" && (
              <div style={{ background: "#fef2f2", borderRadius: "10px", padding: "12px", marginBottom: "20px" }}>
                <p style={{ fontSize: "13px", color: "#991b1b", margin: 0 }}>
                  ⚠️ Bu işlem kullanıcının premium üyeliğini hemen sonlandıracaktır.
                </p>
              </div>
            )}

            <div style={{ display: "flex", gap: "12px" }}>
              <button
                onClick={() => { setShowModal(false); setSelectedUser(null); }}
                style={{ flex: 1, padding: "12px", background: "#f1f5f9", border: "none", borderRadius: "10px", fontSize: "14px", fontWeight: "600", color: "#64748b", cursor: "pointer" }}
              >
                İptal
              </button>
              <button
                onClick={() => handlePremiumToggle(selectedUser, modalAction)}
                style={{
                  flex: 1,
                  padding: "12px",
                  background: modalAction === "deactivate" ? "#dc2626" : "linear-gradient(135deg, #d4af37, #f4e4a6)",
                  border: "none",
                  borderRadius: "10px",
                  fontSize: "14px",
                  fontWeight: "600",
                  color: modalAction === "deactivate" ? "white" : "#1a0536",
                  cursor: "pointer",
                }}
              >
                {modalAction === "activate" ? "Aktifleştir" : modalAction === "extend" ? "Uzat" : "İptal Et"}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// ==================== ÖDEMELER (gerçek ödeme kayıtları: payments) ====================
// Önceki sürüm burada iş cirosu (devam eden / tamamlanan işlerin fiyatları) gösteriyordu; o liste
// İş İlanları > "Anlaşılan işler"e taşındı. Gerçek gelir: isTest !== true (odemeSinifla). Tarih: createdAt.
const ODEME_ARALIKLARI = [["bu_ay", "Bu ay"], ["gecen_ay", "Geçen ay"], ["son30", "Son 30 gün"], ["bu_yil", "Bu yıl"], ["tumu", "Tümü"], ["ozel", "Özel aralık"]];
// [bas, son) yerel saatle; Tümü için null. Özel: gün başı .. bitiş gününün sonu
const odemeAraligi = (id, ozelBas, ozelSon, simdi = new Date()) => {
  const y = simdi.getFullYear();
  const a = simdi.getMonth();
  if (id === "bu_ay") return { bas: new Date(y, a, 1).getTime(), son: new Date(y, a + 1, 1).getTime() };
  if (id === "gecen_ay") return { bas: new Date(y, a - 1, 1).getTime(), son: new Date(y, a, 1).getTime() };
  if (id === "son30") return { bas: simdi.getTime() - 30 * 24 * 60 * 60 * 1000, son: simdi.getTime() + 1 };
  if (id === "bu_yil") return { bas: new Date(y, 0, 1).getTime(), son: new Date(y + 1, 0, 1).getTime() };
  if (id === "ozel") {
    const gun = (s) => {
      const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(s || "");
      return m ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])) : null;
    };
    const b = gun(ozelBas);
    const s = gun(ozelSon);
    return {
      bas: b ? b.getTime() : -Infinity,
      son: s ? new Date(s.getFullYear(), s.getMonth(), s.getDate() + 1).getTime() : Infinity,
    };
  }
  return null;
};
const AY_ADLARI = ["Ocak", "Şubat", "Mart", "Nisan", "Mayıs", "Haziran", "Temmuz", "Ağustos", "Eylül", "Ekim", "Kasım", "Aralık"];
const ODEME_KAYNAK_AD = { google_play: "Google Play", apple_appstore: "App Store", apple_appstore_unverified: "App Store (doğrulanmamış geri yükleme)" };
const odemeSinifRozeti = (s) => {
  const renk = !s.test ? (s.hesapSilinmis ? ["#e0f2fe", "#0369a1"] : ["#dcfce7", "#16a34a"]) : s.gecersiz ? ["#e5e7eb", "#4b5563"] : ["#fef3c7", "#92400e"];
  return (
    <span style={{ display: "inline-flex", gap: "4px", alignItems: "center", flexWrap: "wrap" }}>
      <span title={s.test ? `Gelire katılmaz (testNedeni: ${s.sinif})` : "Gerçek gelir"}
        style={{ padding: "3px 9px", borderRadius: "20px", fontSize: "11px", fontWeight: "600", background: renk[0], color: renk[1], whiteSpace: "nowrap" }}>
        {s.test ? `${s.gecersiz ? "Geçersiz" : "Test"}: ${ODEME_SINIF_AD[s.sinif] || s.sinif}` : "Gerçek"}
      </span>
      {s.hesapSilinmis && s.sinif !== "silinmis_hesap" && s.sinif !== "silinmis_test_hesabi" && (
        <span style={{ padding: "3px 7px", borderRadius: "20px", fontSize: "10px", fontWeight: "600", background: "#e0f2fe", color: "#0369a1" }}>hesap silinmiş</span>
      )}
      {s.sinif === "silinmis_hesap" && (
        <span style={{ padding: "3px 7px", borderRadius: "20px", fontSize: "10px", fontWeight: "600", background: "#e0f2fe", color: "#0369a1" }}>hesap silinmiş</span>
      )}
      {!s.isaretli && (
        <span title="Sunucu bu kayda isTest yazmamış (markTestPayments henüz çalışmadı); panel aynı kurallarla değerlendirdi"
          style={{ padding: "3px 7px", borderRadius: "20px", fontSize: "10px", fontWeight: "600", background: "#f1f5f9", color: "#64748b", border: "1px dashed #cbd5e1" }}>işaretsiz</span>
      )}
    </span>
  );
};

const PaymentsPage = ({ resolveUser }) => {
  const { odemeDurum, tanimDurum } = usePanelVeri();
  const siniflanmis = useSiniflanmisOdemeler(resolveUser);
  const [aralik, setAralik] = useState("bu_ay");
  const [ozelBas, setOzelBas] = useState("");
  const [ozelSon, setOzelSon] = useState("");
  const [testDahil, setTestDahil] = useState(false);

  const sinir = odemeAraligi(aralik, ozelBas, ozelSon);
  const araliktaMi = (x) => !sinir || (x.s.t > 0 && x.s.t >= sinir.bas && x.s.t < sinir.son);
  const araliktaki = siniflanmis.filter(araliktaMi);
  const tarihsiz = sinir ? siniflanmis.filter((x) => !(x.s.t > 0)).length : 0;
  const ozet = odemeOzeti(araliktaki);
  const liste = testDahil ? araliktaki : araliktaki.filter((x) => !x.s.test);
  const isaretsizToplam = siniflanmis.filter((x) => !x.s.isaretli).length;

  // Aylık özet: aralıktaki kayıtlar, ay başına (yeni ay üstte)
  const aylar = useMemo(() => {
    const m = new Map();
    for (const x of araliktaki) {
      if (!(x.s.t > 0)) continue;
      const d = new Date(x.s.t);
      const k = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
      if (!m.has(k)) m.set(k, { k, ad: `${AY_ADLARI[d.getMonth()]} ${d.getFullYear()}`, liste: [] });
      m.get(k).liste.push(x);
    }
    return [...m.values()].sort((a, b) => (a.k < b.k ? 1 : -1)).map((a) => ({ ...a, o: odemeOzeti(a.liste) }));
  }, [araliktaki]);

  const { currentPage, totalPages, paginatedItems, goToPage, totalItems, startIndex, endIndex } = usePagination(liste, 20);
  const th = { padding: "12px 14px", textAlign: "left", fontSize: "12px", fontWeight: "600", color: "#64748b", whiteSpace: "nowrap" };
  const td = { padding: "12px 14px", fontSize: "13px", color: "#334155", verticalAlign: "top" };
  const kartlar = [
    {
      etiket: testDahil ? "Gelir (test dahil)" : "Gerçek gelir",
      deger: paraYaz(testDahil ? ozet.testDahilGelir : ozet.gelir),
      not: testDahil ? `test hariç: ${paraYaz(ozet.gelir)}` : "Test hariç",
      icon: DollarSign, renk: "#16a34a", bg: "#dcfce7",
    },
    {
      etiket: testDahil ? "İşlem (test dahil)" : "Gerçek işlem",
      deger: testDahil ? ozet.testDahilIslem : ozet.islem,
      not: testDahil ? `test hariç: ${ozet.islem}` : "Test hariç",
      icon: CreditCard, renk: "#4f46e5", bg: "#eef2ff",
    },
    { etiket: "Test kaydı", deger: ozet.test, not: ozet.testTutar ? `${paraYaz(ozet.testTutar)} gelire katılmadı` : "gelire katılmaz", icon: AlertTriangle, renk: "#d97706", bg: "#fef3c7" },
    { etiket: "Geçersiz kayıt", deger: ozet.gecersiz, not: "sanal işlem, elle verilen, tutar 0, eski kart formu", icon: XCircle, renk: "#6b7280", bg: "#f3f4f6" },
  ];

  return (
    <div>
      <div style={{ display: "flex", alignItems: "flex-end", justifyContent: "space-between", marginBottom: "20px", flexWrap: "wrap", gap: "12px" }}>
        <div>
          <h1 style={{ fontSize: "24px", fontWeight: "700", color: "#1e293b", margin: "0 0 4px 0" }}>Ödemeler</h1>
          <p style={{ fontSize: "14px", color: "#64748b", margin: 0 }}>
            Premium ödeme kayıtları (payments) · toplam {siniflanmis.length} kayıt. İş bedelleri İş İlanları &gt; "Anlaşılan işler"de.
          </p>
        </div>
        <label style={{ display: "flex", alignItems: "center", gap: "6px", fontSize: "13px", color: "#475569", cursor: "pointer" }}>
          <input type="checkbox" checked={testDahil} onChange={(e) => setTestDahil(e.target.checked)} />
          Test dahil göster
        </label>
      </div>

      {/* Tarih aralığı */}
      <div style={{ display: "flex", gap: "8px", flexWrap: "wrap", alignItems: "center", marginBottom: "16px" }}>
        {ODEME_ARALIKLARI.map(([id, etiket]) => (
          <button key={id} onClick={() => setAralik(id)}
            style={{ padding: "8px 14px", background: aralik === id ? "#1e1b4b" : "white", color: aralik === id ? "white" : "#64748b", border: "1px solid #e2e8f0", borderRadius: "10px", fontSize: "13px", fontWeight: "500", cursor: "pointer" }}>
            {etiket}
          </button>
        ))}
        {aralik === "ozel" && (
          <span style={{ display: "flex", gap: "6px", alignItems: "center", fontSize: "13px", color: "#475569" }}>
            <input type="date" value={ozelBas} onChange={(e) => setOzelBas(e.target.value)} style={{ padding: "6px 8px", border: "1px solid #e2e8f0", borderRadius: "8px" }} />
            –
            <input type="date" value={ozelSon} onChange={(e) => setOzelSon(e.target.value)} style={{ padding: "6px 8px", border: "1px solid #e2e8f0", borderRadius: "8px" }} />
          </span>
        )}
      </div>

      {odemeDurum === "hata" && (
        <div style={{ padding: "12px 16px", background: "#fef2f2", border: "1px solid #fecaca", borderRadius: "12px", marginBottom: "16px", fontSize: "13px", color: "#991b1b" }}>
          Ödeme kayıtları okunamadı; sayılar eksik. Sayfayı yenileyin.
        </div>
      )}

      {/* Kartlar: seçilen aralık */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: "16px", marginBottom: "12px" }}>
        {kartlar.map((s) => (
          <div key={s.etiket} style={{ background: "white", borderRadius: "16px", padding: "20px", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
            <div style={{ width: "44px", height: "44px", background: s.bg, borderRadius: "12px", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "12px" }}>
              <s.icon size={22} color={s.renk} />
            </div>
            <p style={{ fontSize: "24px", fontWeight: "700", color: "#1e293b", margin: "0 0 4px 0" }}>{odemeDurum === "bekliyor" ? "…" : s.deger}</p>
            <p style={{ fontSize: "13px", color: "#64748b", margin: 0 }}>{s.etiket}</p>
            <p style={{ fontSize: "11px", color: "#94a3b8", margin: "2px 0 0" }}>{s.not}</p>
          </div>
        ))}
      </div>
      <p style={{ fontSize: "12px", color: "#64748b", margin: "0 0 20px" }}>
        Test hariç: sunucunun isTest yazdığı kayıtlar (sanal işlem, elle verilen, tutar 0, eski kart formu, test hesabı, silinmiş test hesabı, olası test) gelire katılmaz.
        {isaretsizToplam > 0 && ` ${isaretsizToplam} kayıtta isTest yok (işaretsiz); panel aynı kurallarla değerlendirdi, markTestPayments çalıştırılınca kalkar.`}
        {tanimDurum !== "sunucu" && " Test hesabı listesi: panelin kopyası (getTestDefinition yayında değil)."}
        {tarihsiz > 0 && ` Tarihi olmayan ${tarihsiz} kayıt bu aralığa katılmadı ("Tümü"de görünür).`}
        {" "}Tutar: kayıttaki liste fiyatı (mağaza komisyonu ve iade kaydedilmiyor).
      </p>

      {/* Aylık özet */}
      {aylar.length > 0 && (
        <div style={{ background: "white", borderRadius: "16px", overflow: "hidden", boxShadow: "0 1px 3px rgba(0,0,0,0.05)", marginBottom: "20px" }}>
          <div style={{ padding: "14px 16px 6px", fontSize: "15px", fontWeight: "600", color: "#1e293b" }}>Aylık özet</div>
          <div style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead><tr style={{ background: "#f8fafc" }}>
                {["Ay", "Gerçek gelir", "Gerçek işlem", "Test", "Geçersiz", "İşaretsiz"].map((b) => <th key={b} style={th}>{b}</th>)}
              </tr></thead>
              <tbody>
                {aylar.map((a) => (
                  <tr key={a.k} style={{ borderTop: "1px solid #f1f5f9" }}>
                    <td style={{ ...td, fontWeight: "600" }}>{a.ad}</td>
                    <td style={{ ...td, fontWeight: "700", color: "#16a34a" }}>{paraYaz(a.o.gelir)}</td>
                    <td style={td}>{a.o.islem}</td>
                    <td style={{ ...td, color: a.o.test ? "#b45309" : "#94a3b8" }}>{a.o.test}{a.o.testTutar ? ` (${paraYaz(a.o.testTutar)})` : ""}</td>
                    <td style={{ ...td, color: a.o.gecersiz ? "#4b5563" : "#94a3b8" }}>{a.o.gecersiz}</td>
                    <td style={{ ...td, color: a.o.isaretsiz ? "#64748b" : "#cbd5e1" }}>{a.o.isaretsiz}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Liste */}
      {liste.length === 0 ? (
        <div style={{ background: "white", borderRadius: "16px", padding: "60px 20px", textAlign: "center", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
          <CreditCard size={48} color="#94a3b8" style={{ marginBottom: "16px" }} />
          <p style={{ fontSize: "16px", fontWeight: "600", color: "#1e293b", margin: "0 0 8px 0" }}>{odemeDurum === "bekliyor" ? "Yükleniyor…" : "Bu aralıkta ödeme kaydı yok"}</p>
          {!testDahil && ozet.test + ozet.gecersiz > 0 && <p style={{ fontSize: "13px", color: "#94a3b8", margin: 0 }}>{ozet.test + ozet.gecersiz} test / geçersiz kayıt gizli ("Test dahil göster").</p>}
        </div>
      ) : (
        <div style={{ background: "white", borderRadius: "16px", overflow: "hidden", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
          <div style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead><tr style={{ background: "#f8fafc" }}>
                {["Tarih ve saat", "Kullanıcı", "Plan", "Kaynak", "Tutar", "Sınıf", "Durum"].map((b) => <th key={b} style={{ ...th, textAlign: b === "Tutar" ? "right" : "left" }}>{b}</th>)}
              </tr></thead>
              <tbody>
                {paginatedItems.map(({ p, s }) => {
                  const r = p.userId ? resolveUser(p.userId) : null;
                  return (
                    <tr key={p.id} style={{ borderTop: "1px solid #f1f5f9", background: s.test ? "#f8fafc" : undefined, opacity: s.test ? 0.8 : 1 }}>
                      <td style={{ ...td, whiteSpace: "nowrap" }}>{s.t ? formatDateTime(new Date(s.t).toISOString()) : <span style={{ color: "#b45309" }}>tarih yok</span>}</td>
                      <td style={td}>
                        <div style={{ fontWeight: "600", color: r && r.missing ? "#94a3b8" : "#1e293b" }}>{p.userName || (r ? r.name : "—")}</div>
                        {p.userId && <div style={{ fontSize: "11px", color: "#cbd5e1", fontFamily: "monospace" }}>{p.userId.slice(0, 12)}…</div>}
                      </td>
                      <td style={td}>{p.plan === "yearly" ? "Yıllık" : p.plan === "monthly" ? "Aylık" : p.plan === "admin_granted" ? "Elle (admin)" : p.plan || "—"}</td>
                      <td style={td}>{ODEME_KAYNAK_AD[p.source] || p.source || (p.cardLast4 ? "eski kart formu" : "—")}</td>
                      <td style={{ ...td, textAlign: "right", fontWeight: "600", color: s.test ? "#94a3b8" : "#1e293b", textDecoration: s.test ? "line-through" : "none", whiteSpace: "nowrap" }}>
                        {s.tutar > 0 ? paraYaz(s.tutar) : "₺0"}
                      </td>
                      <td style={td}>{odemeSinifRozeti(s)}</td>
                      <td style={{ ...td, color: "#64748b" }}>{p.status === "completed" ? "Tamamlandı" : p.status || "—"}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <PaginationBar currentPage={currentPage} totalPages={totalPages} goToPage={goToPage} totalItems={totalItems} startIndex={startIndex} endIndex={endIndex} />
        </div>
      )}
    </div>
  );
};

// ==================== OLASI YANLIŞ ROL (teşhis) ====================
// Hizmet veren / iş arayan kişilerin müşteri olarak kaydolup kendi hizmetlerini
// ilan olarak yayınlamasının ne kadar yaygın olduğunu ÖLÇER. Hiçbir şeyi
// değiştirmez, gizlemez. Veri: bellekteki jobs + requests listesi. Tek ek okuma:
// test/yönetici hesaplarını ayıklamak için admins koleksiyonu bir kez okunur.
//
// ---- DÜZENLENEBİLİR AYARLAR ----
// Arz ifadeleri (hizmet sunma / iş arama): [ifade, puan].
// Eşleşme büyük/küçük harf ve Türkçe karakterden bağımsızdır; ifade kelime başında
// aranır ve sonuna ek gelebilir ("iletişime geçebilir" → "iletişime geçebilirsiniz").
// İki ifade metnin aynı yerine düşerse yüksek puanlı olan, eşitse uzun olan sayılır
// ("ders verilir" +3, içindeki "verilir" +2'yi ezer).
const YANLIS_ROL_IFADELERI = [
  // güçlü (+3): birinci tekil kişiden hizmet sunma / iş arama
  ["iş arıyorum", 3],
  ["iş bakıyorum", 3],
  ["çalışmak istiyorum", 3],
  ["ders veriyorum", 3],
  ["ders verilir", 3],
  ["hizmet veriyorum", 3],
  ["hizmetinizdeyiz", 3],
  ["deneyimliyim", 3],
  ["müşterilerime", 3],
  // orta (+2)
  ["iletişime geçebilir", 2],
  ["iletişime geçin", 2],
  ["teklifleriniz", 2],
  ["hizmetlerimiz", 2],
  ["verilir", 2],
  ["verilmektedir", 2],
  ["yapılır", 2],
  ["yapılmaktadır", 2],
  ["eğitimi veriyorum", 2],
  ["eğitimi", 2],
  ["yaparım", 2],
  ["öğrencilerine", 2],
  ["yıllık tecrübe", 2],
  ["firmamız", 2],
  ["ekibimiz", 2],
  ["whatsapp", 2],
  ["instagram", 2],
  // zayıf (+1): gerçek bir müşteri de yazabilir
  ["yapıyorum", 1],
  ["tecrübeli", 1],
  ["uygun fiyat", 1],
];
// Talep ifadeleri (hizmet isteme): puanı DÜŞÜRÜR.
const YANLIS_ROL_TALEP_IFADELERI = [
  ["istiyorum", -2],
  ["ihtiyacım var", -2],
  ["lazım", -2],
  ["gerekiyor", -2],
  ["yaptırmak", -2],
  ["aldırmak", -2],
  ["arıyorum", -2],
];
// İş arama beyanı. (1) Bu ifadelerin içindeki "arıyorum" talep sayılmaz — arz
// ifadesi aynı yere düştüğü ve daha yüksek puanlı olduğu için onu ezer.
// (2) Kişi iş aradığını söylüyorsa metindeki DİĞER talep ifadeleri de puan
// düşürmez: "iş arıyorum ama nakit para ihtiyacım var" cümlesindeki ihtiyaç
// bir hizmet talebi değil, kişinin kendi durumudur. Eşleşenlerde "0" görünür.
const YANLIS_ROL_IS_ARAMA = ["iş arıyorum", "iş bakıyorum"];
const YANLIS_ROL_PUAN = {
  telefon: 3, baglanti: 3, eposta: 3,
  cokluKategori2: 1, cokluKategori3: 2,
  talepYok: 1, // açıklama >= TALEP_YOK_MIN_KELIME kelime ve hiç talep ifadesi yok
};
const YANLIS_ROL_TALEP_YOK_MIN_KELIME = 3;
// Bu puan ve üstü "işaretlenir".
const YANLIS_ROL_ESIK = 3;

// Test ve yönetici hesapları (kesin ve olası) varsayılan olarak analizden HARİÇ tutulur: ortak tanım testHesabiMi
// (dosyanın başında); admins koleksiyonundaki hesaplar admin bağlamıyla otomatik eklenir.

// Türkçe katlama — her karakter TEK karaktere eşlenir, böylece katlanmış metindeki
// konumlar orijinal metindeki konumlarla aynı kalır (vurgulama için gerekli).
const TR_KATLAMA = { "ç": "c", "ğ": "g", "ı": "i", "ö": "o", "ş": "s", "ü": "u", "â": "a", "î": "i", "û": "u" };
const trKatla = (str) => {
  const s = String(str || "");
  let out = "";
  for (let i = 0; i < s.length; i++) {
    const c = s[i];
    let l = c.toLocaleLowerCase("tr-TR");
    if (l.length !== 1) l = c.toLowerCase();
    if (l.length !== 1) l = c;
    out += TR_KATLAMA[l] || l;
  }
  return out;
};
const HARF = /[a-z0-9]/;
const kelimeSayisi = (metin) => trKatla(metin).split(/\s+/).filter((w) => HARF.test(w)).length;

// Lookbehind KULLANILMADI (eski Safari'de sözdizimi hatası verip tüm paneli düşürür);
// rakam sınırı yakalanan ilk grupla sağlanır.
const TELEFON_RE = /(^|[^\d])((?:\+?90[\s.-]?)?\(?0?[2-5]\d{2}\)?[\s.-]?\d{3}[\s.-]?\d{2}[\s.-]?\d{2})(?!\d)/g;
const EPOSTA_RE = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}/g;
const BAGLANTI_RE = /(https?:\/\/\S+|www\.\S+|wa\.me\/?\S*|t\.me\/\S+|\b[a-z0-9-]+\.(?:com\.tr|com|net|org|info|biz|io|me|tr)\b(?:\/\S*)?)/g;
const KATLANMIS_IFADELER = [
  ...YANLIS_ROL_IFADELERI.map(([ifade, puan]) => ({ tur: "ifade", ifade, katli: trKatla(ifade), puan })),
  ...YANLIS_ROL_TALEP_IFADELERI.map(([ifade, puan]) => ({ tur: "talep", ifade, katli: trKatla(ifade), puan })),
];
const IS_ARAMA_SET = new Set(YANLIS_ROL_IS_ARAMA);

// Tek bir metindeki sinyaller: [{tur, ifade?, puan, start, end, metin}] — çakışmayan aralıklar
const yanlisRolSinyalleri = (metin) => {
  const k = trKatla(metin);
  const ham = [];
  for (const m of k.matchAll(EPOSTA_RE)) ham.push({ tur: "eposta", puan: YANLIS_ROL_PUAN.eposta, start: m.index, end: m.index + m[0].length });
  for (const m of k.matchAll(TELEFON_RE)) {
    const s = m.index + m[1].length;
    ham.push({ tur: "telefon", puan: YANLIS_ROL_PUAN.telefon, start: s, end: s + m[2].length });
  }
  for (const m of k.matchAll(BAGLANTI_RE)) ham.push({ tur: "baglanti", puan: YANLIS_ROL_PUAN.baglanti, start: m.index, end: m.index + m[0].length });
  for (const f of KATLANMIS_IFADELER) {
    let i = k.indexOf(f.katli);
    while (i !== -1) {
      if (i === 0 || !HARF.test(k[i - 1])) {
        ham.push({ tur: f.tur, ifade: f.ifade, puan: f.puan, start: i, end: i + f.katli.length });
      }
      i = k.indexOf(f.katli, i + 1);
    }
  }
  // Çakışma: yüksek puan kazanır, eşitse uzun olan. Böylece arz ifadesi her zaman
  // içindeki talep kelimesini ezer ("iş arıyorum" ⊃ "arıyorum"), e-posta kendi
  // alan adını ezer, "instagram.com/…" bağlantısı "instagram" kelimesini ezer.
  ham.sort((a, b) => b.puan - a.puan || (b.end - b.start) - (a.end - a.start) || a.start - b.start);
  const secilen = [];
  for (const h of ham) {
    if (secilen.some((s) => h.start < s.end && s.start < h.end)) continue;
    secilen.push(h);
  }
  const s = String(metin || "");
  return secilen
    .sort((a, b) => a.start - b.start)
    .map((h) => ({ ...h, metin: s.slice(h.start, h.end) }));
};

// Bir kaydın puanı ve eşleşen etiketleri
const yanlisRolPuanla = (baslikSinyal, aciklamaSinyal, aciklama, ayniKategori) => {
  const tum = [...baslikSinyal, ...aciklamaSinyal];
  const etiketler = [];
  let puan = 0;
  const isArama = tum.some((s) => s.tur === "ifade" && IS_ARAMA_SET.has(s.ifade));

  // Arz ifadeleri — aynı ifade birden çok kez geçse de bir kez sayılır
  const gorulen = new Set();
  for (const s of tum) {
    if (s.tur !== "ifade" || gorulen.has(s.ifade)) continue;
    gorulen.add(s.ifade);
    puan += s.puan;
    etiketler.push({ tur: "ifade", metin: s.metin, puan: s.puan });
  }
  // İletişim bilgileri — her tür bir kez
  for (const tur of ["telefon", "baglanti", "eposta"]) {
    const ilk = tum.find((s) => s.tur === tur);
    if (!ilk) continue;
    puan += YANLIS_ROL_PUAN[tur];
    etiketler.push({ tur, metin: ilk.metin, puan: YANLIS_ROL_PUAN[tur] });
  }
  // Talep ifadeleri — puan düşürür; iş arama beyanı varsa 0 sayılır
  const gorulenTalep = new Set();
  let talepVar = false;
  for (const s of tum) {
    if (s.tur !== "talep" || gorulenTalep.has(s.ifade)) continue;
    gorulenTalep.add(s.ifade);
    talepVar = true;
    const p = isArama ? 0 : s.puan;
    puan += p;
    etiketler.push({ tur: "talep", metin: s.metin, puan: p, notr: isArama });
  }
  // Talep ifadesi yok (zayıf arz sinyali)
  if (!talepVar && kelimeSayisi(aciklama) >= YANLIS_ROL_TALEP_YOK_MIN_KELIME) {
    puan += YANLIS_ROL_PUAN.talepYok;
    etiketler.push({ tur: "talepYok", metin: "talep ifadesi yok", puan: YANLIS_ROL_PUAN.talepYok });
  }
  // Aynı müşteri, aynı kategori
  if (ayniKategori >= 2) {
    const p = ayniKategori >= 3 ? YANLIS_ROL_PUAN.cokluKategori3 : YANLIS_ROL_PUAN.cokluKategori2;
    puan += p;
    etiketler.push({ tur: "coklu", metin: `aynı kategoride ${ayniKategori} kayıt`, puan: p });
  }
  return { puan, etiketler, isaretli: puan >= YANLIS_ROL_ESIK };
};

// Tüm kayıtları sınıflar ve puanlar.
//   rol: "musteri" | "test" | "bilinmeyen"   (uzman hesabının kayıtları yalnızca sayılır)
//   admin: { uids:Set, emails:Set }          testDahil: test kayıtları analize girsin mi
const yanlisRolAnalizi = (jobs, resolveUser, { admin = null, testDahil = false } = {}) => {
  const kayitlar = [];
  let uzmanHesabi = 0;

  for (const j of jobs || []) {
    if (!j) continue;
    if (j._source === "requests" && j.requestType === "support_ticket") continue;
    const uid = j.customerId || j.userId || j.createdBy || null;
    let r = null;
    let rol;
    let neden = null;
    if (!uid) {
      rol = "bilinmeyen";
      neden = "Oluşturan alanı boş (customerId / userId / createdBy yok)";
    } else if (admin && admin.uids.has(uid)) {
      r = resolveUser ? resolveUser(uid) : null;
      rol = "test";
    } else {
      r = resolveUser ? resolveUser(uid) : null;
      const tip = r ? r.userType : null;
      if (tip === "expert") { uzmanHesabi++; continue; }
      if (tip === "customer") {
        rol = testHesabiMi(uid, (r && (r.email || (r.raw && r.raw.email))) || "", admin, [r && r.raw && r.raw.name, r && r.raw && r.raw.displayName]) ? "test" : "musteri";
      } else {
        rol = "bilinmeyen";
        if (!r) neden = "Kullanıcı çözümlenemedi";
        else if (r.missing && r.deletedAt) neden = "Hesap silinmiş; silinme izinde hesap türü yok";
        else if (r.missing) neden = "Kullanıcı kaydı yok (users'ta yok, silinme izi de yok)";
        else if (r.raw && r.raw.userType) neden = `Hesap türü tanınmıyor: "${r.raw.userType}"`;
        else neden = "Kullanıcı kaydında userType alanı boş";
      }
    }

    const talepMi = j._source === "requests";
    const baslik = j.title || j.service || j.subCategory || "";
    const aciklama = j.description || "";
    kayitlar.push({
      j, uid, r, rol, neden, talepMi, baslik, aciklama,
      // jobs: başlık + açıklama taranır; requests: yalnızca açıklama
      baslikSinyal: talepMi ? [] : yanlisRolSinyalleri(baslik),
      aciklamaSinyal: yanlisRolSinyalleri(aciklama),
      kategoriAnahtari: trKatla(j.subCategory || j.service || j.category || "").trim(),
    });
  }

  const havuzdaMi = (x) => x.rol === "musteri" || (testDahil && x.rol === "test");

  // Aynı müşteri + aynı kategori — yalnızca analize giren kayıtlar arasında
  const grup = new Map();
  for (const x of kayitlar) {
    if (!havuzdaMi(x) || !x.kategoriAnahtari) continue;
    const key = x.uid + "|" + x.kategoriAnahtari;
    grup.set(key, (grup.get(key) || 0) + 1);
  }

  const sonuc = kayitlar.map((x) => {
    const tekrar = havuzdaMi(x) && x.kategoriAnahtari ? grup.get(x.uid + "|" + x.kategoriAnahtari) || 0 : 0;
    return { ...x, havuzda: havuzdaMi(x), ...yanlisRolPuanla(x.baslikSinyal, x.aciklamaSinyal, x.aciklama, tekrar) };
  });

  const havuz = sonuc.filter((x) => x.havuzda);
  const isaretli = havuz.filter((x) => x.isaretli);
  const say = (tur) => isaretli.filter((x) => x.etiketler.some((e) => e.tur === tur && e.puan !== 0)).length;
  return {
    sonuc,
    ozet: {
      incelenen: havuz.length,
      incelenenIlan: havuz.filter((x) => !x.talepMi).length,
      incelenenTalep: havuz.filter((x) => x.talepMi).length,
      isaretlenen: isaretli.length,
      oran: havuz.length ? Math.round((isaretli.length / havuz.length) * 1000) / 10 : 0,
      isaretlenenMusteri: new Set(isaretli.map((x) => x.uid)).size,
      uzmanHesabi,
      rolBilinmeyen: sonuc.filter((x) => x.rol === "bilinmeyen").length,
      testKayit: sonuc.filter((x) => x.rol === "test").length,
      testDahil,
      sinyal: {
        ifade: say("ifade"), telefon: say("telefon"), baglanti: say("baglanti"), eposta: say("eposta"),
        coklu: say("coklu"), talepYok: say("talepYok"), talep: say("talep"),
      },
    },
  };
};

// Metnin ilk `limit` karakterini, sinyal aralıklarını vurgulayarak çizer
const VURGU_RENK = {
  ifade: { bg: "#fef3c7", color: "#92400e" },
  talep: { bg: "#e0f2fe", color: "#075985" },
  telefon: { bg: "#fee2e2", color: "#991b1b" },
  baglanti: { bg: "#fee2e2", color: "#991b1b" },
  eposta: { bg: "#fee2e2", color: "#991b1b" },
};
const VurguluMetin = ({ metin, sinyaller, limit }) => {
  const s = String(metin || "");
  const kes = limit && s.length > limit ? limit : s.length;
  const parcalar = [];
  let i = 0;
  sinyaller.forEach((a, n) => {
    if (a.start >= kes || a.end <= i) return;
    if (a.start > i) parcalar.push(s.slice(i, a.start));
    const bitis = Math.min(a.end, kes);
    const renk = VURGU_RENK[a.tur] || VURGU_RENK.ifade;
    parcalar.push(
      <mark key={n} style={{ background: renk.bg, color: renk.color, padding: "0 2px", borderRadius: "3px", fontWeight: "600" }}>
        {s.slice(Math.max(a.start, i), bitis)}
      </mark>
    );
    i = bitis;
  });
  if (i < kes) parcalar.push(s.slice(i, kes));
  if (kes < s.length) parcalar.push("…");
  return <>{parcalar}</>;
};

// Yönetici hesapları (test hesabı sayılır): admins koleksiyonu BİR KEZ okunur (salt okunur,
// küçük). Oturumdaki yöneticinin uid'i okuma beklenmeden eklenir. Raporlar sayfası okur,
// "Olası yanlış rol" ve "Şehir × kategori" bölümleri aynı sonucu kullanır.
const useYoneticiListesi = () => {
  const [admin, setAdmin] = useState(() => ({
    uids: new Set(auth.currentUser ? [auth.currentUser.uid] : []),
    emails: new Set(auth.currentUser && auth.currentUser.email ? [auth.currentUser.email.toLowerCase()] : []),
  }));
  const [adminOkuma, setAdminOkuma] = useState("bekliyor"); // bekliyor | tamam | hata
  useEffect(() => {
    let iptal = false;
    getDocs(collection(db, "admins"))
      .then((snap) => {
        if (iptal) return;
        const uids = new Set(snap.docs.map((d) => d.id));
        const emails = new Set(
          snap.docs.map((d) => String((d.data() || {}).email || "").trim().toLowerCase()).filter(Boolean)
        );
        if (auth.currentUser) {
          uids.add(auth.currentUser.uid);
          if (auth.currentUser.email) emails.add(auth.currentUser.email.toLowerCase());
        }
        setAdmin({ uids, emails });
        setAdminOkuma("tamam");
      })
      .catch((e) => {
        console.error("admins okunamadı:", e);
        if (!iptal) setAdminOkuma("hata");
      });
    return () => { iptal = true; };
  }, []);
  return { admin, adminOkuma };
};

// Oturum açılınca bir kez: admins (yönetici listesi), getTestDefinition (test tanımı; yoksa panel kopyası) ve
// payments (ödemeler; tek okuma, elle premium verilince odemeleriYukle ile yeniden). Dashboard, Ödemeler, Premium,
// İş İlanları ve Raporlar aynı kaynağı kullanır.
const PanelVeriSaglayici = ({ children }) => {
  const { admin: yoneticiler, adminOkuma } = useYoneticiListesi();
  const [tanim, setTanim] = useState(PANEL_TEST_TANIMI);
  const [tanimDurum, setTanimDurum] = useState("bekliyor"); // bekliyor | sunucu | panel (fonksiyon yok / hata / geçersiz yanıt)
  useEffect(() => {
    let iptal = false;
    httpsCallable(getFunctions(auth.app, "us-central1"), "getTestDefinition", { timeout: 30000 })({})
      .then((r) => {
        if (iptal) return;
        const t = testTaniminiCoz(r && r.data);
        if (t) { setTanim(t); setTanimDurum("sunucu"); }
        else { console.warn("getTestDefinition yanıtı tanınmadı; panelin test listesi kullanılıyor."); setTanimDurum("panel"); }
      })
      .catch((e) => {
        if (iptal) return;
        console.warn(`getTestDefinition kullanılamadı (${(e && e.code) || e}); panelin test listesi kullanılıyor.`);
        setTanimDurum("panel");
      });
    return () => { iptal = true; };
  }, []);
  const admin = useMemo(() => ({
    uids: new Set([...yoneticiler.uids, ...(tanim.adminUidleri || [])]),
    emails: new Set([...yoneticiler.emails, ...(tanim.adminEpostalari || [])]),
    tanim,
  }), [yoneticiler, tanim]);

  const [odemeler, setOdemeler] = useState([]);
  const [odemeDurum, setOdemeDurum] = useState("bekliyor"); // bekliyor | tamam | hata
  const odemeleriYukle = useCallback(async () => {
    try {
      const s = await getDocs(collection(db, "payments"));
      setOdemeler(s.docs.map((d) => ({ id: d.id, ...d.data() })));
      setOdemeDurum("tamam");
    } catch (e) {
      console.error("Ödemeler yüklenemedi:", e);
      setOdemeDurum("hata");
    }
  }, []);
  useEffect(() => { odemeleriYukle(); }, [odemeleriYukle]);

  const deger = useMemo(
    () => ({ admin, adminOkuma, tanimDurum, odemeler, odemeDurum, odemeleriYukle }),
    [admin, adminOkuma, tanimDurum, odemeler, odemeDurum, odemeleriYukle]
  );
  return <PanelVeriBaglami.Provider value={deger}>{children}</PanelVeriBaglami.Provider>;
};

// Ödemeler sınıflanmış hâliyle (yeniden eskiye; tarihi olmayanlar sonda)
const useSiniflanmisOdemeler = (resolveUser) => {
  const { odemeler, admin } = usePanelVeri();
  return useMemo(
    () => odemeler
      .map((p) => ({ p, s: odemeSinifla(p, resolveUser, admin) }))
      .sort((a, b) => (b.s.t || 0) - (a.s.t || 0)),
    [odemeler, resolveUser, admin]
  );
};

const YanlisRolSection = ({ jobs, resolveUser, onToggleSuspend, admin, adminOkuma }) => {
  const [mod, setMod] = useState("isaretli");
  const [testDahil, setTestDahil] = useState(false);
  const [seciliMusteri, setSeciliMusteri] = useState(null);

  const { sonuc, ozet } = useMemo(
    () => yanlisRolAnalizi(jobs, resolveUser, { admin, testDahil }),
    [jobs, resolveUser, admin, testDahil]
  );
  const liste = useMemo(() => {
    let secim;
    if (mod === "bilinmeyen") secim = sonuc.filter((x) => x.rol === "bilinmeyen");
    else if (mod === "sinyalli") secim = sonuc.filter((x) => x.havuzda && x.puan > 0);
    else secim = sonuc.filter((x) => x.havuzda && x.isaretli);
    return [...secim].sort((a, b) =>
      mod === "bilinmeyen"
        ? toMillis(b.j.createdAt) - toMillis(a.j.createdAt)
        : b.puan - a.puan || toMillis(b.j.createdAt) - toMillis(a.j.createdAt)
    );
  }, [sonuc, mod]);
  const { currentPage, totalPages, paginatedItems, goToPage, totalItems, startIndex, endIndex } = usePagination(liste, 15);
  const bilinmeyenModu = mod === "bilinmeyen";

  const kart = { background: "white", borderRadius: "16px", padding: "24px", boxShadow: "0 1px 3px rgba(0,0,0,0.05)", marginBottom: "24px" };
  const th = { textAlign: "left", fontSize: "12px", fontWeight: "600", color: "#64748b", padding: "8px 10px", borderBottom: "1px solid #e2e8f0", whiteSpace: "nowrap" };
  const td = { padding: "10px", fontSize: "13px", color: "#334155", borderBottom: "1px solid #f1f5f9", verticalAlign: "top" };
  const kutu = (deger, etiket, renk) => (
    <div style={{ background: "#f8fafc", borderRadius: "12px", padding: "14px 16px" }}>
      <p style={{ fontSize: "22px", fontWeight: "700", color: renk || "#1e293b", margin: 0 }}>{deger}</p>
      <p style={{ fontSize: "12px", color: "#64748b", margin: "2px 0 0" }}>{etiket}</p>
    </div>
  );
  const ETIKET_RENK = {
    ifade: { bg: "#fef3c7", color: "#92400e" },
    talep: { bg: "#e0f2fe", color: "#075985" },
    talepNotr: { bg: "#f1f5f9", color: "#64748b" },
    talepYok: { bg: "#f1f5f9", color: "#475569" },
    telefon: { bg: "#fee2e2", color: "#991b1b" },
    baglanti: { bg: "#fee2e2", color: "#991b1b" },
    eposta: { bg: "#fee2e2", color: "#991b1b" },
    coklu: { bg: "#e0e7ff", color: "#3730a3" },
  };
  const TUR_AD = { telefon: "telefon", baglanti: "bağlantı", eposta: "e-posta" };
  const puanMetni = (p) => (p > 0 ? `+${p}` : `${p}`);

  return (
    <div style={kart}>
      {seciliMusteri && (
        <UserDetailModal user={seciliMusteri} onClose={() => setSeciliMusteri(null)}
          onToggleSuspend={onToggleSuspend || (() => {})} userType="customer" />
      )}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: "12px", flexWrap: "wrap", marginBottom: "16px" }}>
        <div>
          <h3 style={{ fontSize: "16px", fontWeight: "600", color: "#1e293b", margin: "0 0 4px 0" }}>Olası yanlış rol (teşhis)</h3>
          <p style={{ fontSize: "13px", color: "#64748b", margin: 0 }}>
            Müşteri hesaplarının açtığı ilan ve taleplerde hizmet tanıtımı / iş arama izleri. Yalnızca ölçer —
            hiçbir kaydı değiştirmez ya da gizlemez. Eşik: puan ≥ {YANLIS_ROL_ESIK}.
          </p>
        </div>
        <label style={{ display: "flex", alignItems: "center", gap: "8px", fontSize: "13px", color: "#334155", cursor: "pointer", whiteSpace: "nowrap", background: "#f8fafc", padding: "8px 12px", borderRadius: "10px", border: "1px solid #e2e8f0" }}>
          <input type="checkbox" checked={testDahil} onChange={(e) => setTestDahil(e.target.checked)} />
          Test hesaplarını dahil et
        </label>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))", gap: "12px", marginBottom: "12px" }}>
        {kutu(ozet.incelenen, `incelenen kayıt (${ozet.incelenenIlan} ilan · ${ozet.incelenenTalep} talep)`)}
        {kutu(ozet.isaretlenen, "işaretlenen", ozet.isaretlenen > 0 ? "#b45309" : undefined)}
        {kutu(`%${ozet.oran}`, "işaretlenme oranı", ozet.isaretlenen > 0 ? "#b45309" : undefined)}
        {kutu(ozet.isaretlenenMusteri, "işaretlenen müşteri")}
      </div>
      <p style={{ fontSize: "12px", color: "#64748b", margin: "0 0 4px 0" }}>
        İşaretlenenlerde sinyal: ifade {ozet.sinyal.ifade} · telefon {ozet.sinyal.telefon} · bağlantı {ozet.sinyal.baglanti} · e-posta {ozet.sinyal.eposta} · talep ifadesi yok {ozet.sinyal.talepYok} · aynı kategoride tekrar {ozet.sinyal.coklu} · puan düşüren talep ifadesi {ozet.sinyal.talep}
      </p>
      <p style={{ fontSize: "12px", color: "#94a3b8", margin: "0 0 4px 0" }}>
        Kapsam: tüm durumlar (açık, kapanmış, iptal). Destek talebi kayıtları hariç.
        İncelenmeyen: uzman hesabından {ozet.uzmanHesabi} · rolü belirlenemeyen {ozet.rolBilinmeyen}.
      </p>
      <p style={{ fontSize: "12px", color: ozet.testDahil ? "#b45309" : "#94a3b8", margin: "0 0 16px 0" }}>
        {ozet.testDahil ? `Dahil edilen test kaydı: ${ozet.testKayit}` : `Hariç tutulan test kaydı: ${ozet.testKayit}`}
        {adminOkuma === "hata" && <span style={{ color: "#dc2626", fontWeight: "600" }}> · admins koleksiyonu okunamadı — yalnızca liste ve oturumdaki yönetici hariç tutuldu</span>}
        {adminOkuma === "bekliyor" && <span> · yönetici listesi yükleniyor…</span>}
      </p>

      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px", flexWrap: "wrap", gap: "8px" }}>
        <p style={{ fontSize: "13px", color: "#475569", margin: 0 }}>{liste.length} kayıt</p>
        <select value={mod} onChange={(e) => setMod(e.target.value)}
          style={{ padding: "8px 12px", border: "1px solid #e2e8f0", borderRadius: "8px", fontSize: "13px", outline: "none" }}>
          <option value="isaretli">Yalnızca işaretlenenler (puan ≥ {YANLIS_ROL_ESIK})</option>
          <option value="sinyalli">Herhangi bir sinyali olanlar (puan ≥ 1)</option>
          <option value="bilinmeyen">Rolü belirlenemeyenler ({ozet.rolBilinmeyen})</option>
        </select>
      </div>

      {liste.length === 0 ? (
        <p style={{ padding: "24px", textAlign: "center", fontSize: "14px", color: "#16a34a", background: "#f0fdf4", borderRadius: "12px", margin: 0 }}>
          {bilinmeyenModu ? "Rolü belirlenemeyen kayıt yok ✓" : mod === "isaretli" ? "İşaretlenen kayıt yok ✓" : "Sinyal taşıyan kayıt yok ✓"}
        </p>
      ) : (
        <div style={{ border: "1px solid #e2e8f0", borderRadius: "12px", overflow: "hidden" }}>
          <div style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead><tr style={{ background: "#f8fafc" }}>
                <th style={th}>İlan</th>
                <th style={th}>Açıklama (ilk 100)</th>
                <th style={th}>{bilinmeyenModu ? "Oluşturan" : "Müşteri"}</th>
                {bilinmeyenModu && <th style={th}>Neden belirlenemedi</th>}
                <th style={th}>Eşleşenler</th>
                <th style={th}>Puan</th>
                <th style={th}>Tarih</th>
                <th style={th}>Durum</th>
              </tr></thead>
              <tbody>
                {paginatedItems.map((x) => {
                  const st = jobStatusInfo(x.j.status);
                  const tiklanir = x.r && !x.r.missing && !x.r.deleted && x.r.raw;
                  return (
                    <tr key={x.j.id}>
                      <td style={{ ...td, minWidth: "160px" }}>
                        <span style={{ display: "inline-block", fontSize: "10px", fontWeight: "700", padding: "1px 6px", borderRadius: "4px", marginBottom: "4px", background: x.talepMi ? "#ede9fe" : "#e0f2fe", color: x.talepMi ? "#6d28d9" : "#0369a1" }}>
                          {x.talepMi ? "TALEP" : "İLAN"}
                        </span>
                        {x.rol === "test" && (
                          <span style={{ display: "inline-block", fontSize: "10px", fontWeight: "700", padding: "1px 6px", borderRadius: "4px", marginLeft: "4px", background: "#fef3c7", color: "#92400e" }}>TEST</span>
                        )}
                        <div style={{ fontWeight: "600", color: "#1e293b" }}>
                          {x.baslik ? <VurguluMetin metin={x.baslik} sinyaller={x.baslikSinyal} /> : <span style={{ color: "#94a3b8", fontStyle: "italic" }}>(başlıksız)</span>}
                        </div>
                      </td>
                      <td style={{ ...td, minWidth: "240px", maxWidth: "340px" }} title={x.aciklama}>
                        {x.aciklama ? <VurguluMetin metin={x.aciklama} sinyaller={x.aciklamaSinyal} limit={100} /> : <span style={{ color: "#94a3b8", fontStyle: "italic" }}>açıklama yok</span>}
                      </td>
                      <td style={{ ...td, minWidth: "130px" }}>
                        {tiklanir ? (
                          <button onClick={() => setSeciliMusteri(x.r.raw)} title="Kullanıcı detayını aç"
                            style={{ background: "none", border: "none", padding: 0, cursor: "pointer", textAlign: "left", color: "#4f46e5", fontSize: "13px", fontWeight: "600", textDecoration: "underline" }}>
                            {x.r.name}
                          </button>
                        ) : (
                          <span style={{ color: "#94a3b8", fontStyle: "italic" }}>{x.r ? x.r.name : "—"}</span>
                        )}
                        {bilinmeyenModu && x.uid && (
                          <p style={{ margin: "2px 0 0", fontSize: "11px", color: "#cbd5e1", fontFamily: "monospace" }}>{String(x.uid).slice(0, 14)}…</p>
                        )}
                      </td>
                      {bilinmeyenModu && (
                        <td style={{ ...td, minWidth: "200px", color: "#b45309", fontWeight: "600" }}>{x.neden}</td>
                      )}
                      <td style={{ ...td, minWidth: "200px" }}>
                        <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
                          {x.etiketler.length === 0 && <span style={{ fontSize: "11px", color: "#cbd5e1" }}>—</span>}
                          {x.etiketler.map((e, n) => {
                            const renk = e.tur === "talep" && e.notr ? ETIKET_RENK.talepNotr : ETIKET_RENK[e.tur];
                            const metin =
                              e.tur === "ifade" || e.tur === "talep" ? `“${e.metin}”`
                              : e.tur === "coklu" || e.tur === "talepYok" ? e.metin
                              : `${TUR_AD[e.tur]}: ${e.metin}`;
                            return (
                              <span key={n}
                                title={e.tur === "talep" && e.notr ? "İş arama ifadesi olduğu için puan düşürmedi" : e.tur === "talep" ? "Talep ifadesi — puanı düşürür" : undefined}
                                style={{ fontSize: "11px", fontWeight: "600", padding: "2px 7px", borderRadius: "6px", whiteSpace: "nowrap", background: renk.bg, color: renk.color }}>
                                {metin} {puanMetni(e.puan)}{e.tur === "talep" && e.notr ? " (iş arama var)" : ""}
                              </span>
                            );
                          })}
                        </div>
                      </td>
                      <td style={{ ...td, fontWeight: "800", fontSize: "15px", color: x.isaretli ? "#b45309" : x.puan < 0 ? "#0369a1" : "#64748b" }}>{x.puan}</td>
                      <td style={{ ...td, whiteSpace: "nowrap", color: "#64748b" }}>{formatDateTime(x.j.createdAt)}</td>
                      <td style={td}>
                        <span style={{ fontSize: "11px", fontWeight: "600", padding: "3px 8px", borderRadius: "20px", background: st.bg, color: st.color, whiteSpace: "nowrap" }}>{st.text}</span>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          {totalPages > 1 && <PaginationBar currentPage={currentPage} totalPages={totalPages} goToPage={goToPage} totalItems={totalItems} startIndex={startIndex} endIndex={endIndex} />}
        </div>
      )}
    </div>
  );
};

// ==================== A3 SİMÜLASYONU (yeni ilan bildirimi) ====================
// Canlıdaki simulateNewJobNotify callable'ı (us-central1). Yalnızca admin oturumu
// çağırabilir, sunucu hiçbir şey yazmaz; panel de yazmaz. Düğmeye basılmadan çağrı yok.
// Girdi { days }, dönüş biçimi: isinebak2/functions/index.js → exports.simulateNewJobNotify
const A3_SIM_GUN = 30;
// sehirFiltresi/kimlikSarti varsayılanları (true/true) bugünkü gerçek gönderim kuralı
const A3_SENARYOLAR = [
  { anahtar: "sehirSiki_kimlikSartli", sehir: "Sıkı", kimlik: "Şartlı", canli: true },
  { anahtar: "sehirSiki_kimlikSartsiz", sehir: "Sıkı", kimlik: "Şartsız" },
  { anahtar: "sehirYok_kimlikSartli", sehir: "Yok", kimlik: "Şartlı" },
  { anahtar: "sehirYok_kimlikSartsiz", sehir: "Yok", kimlik: "Şartsız" },
];
const A3_ATLAMA_AD = {
  test_hesabi: "test hesabı",
  yanlis_rol: "yanlış rol (puan eşiği)",
  yanlis_rol_uzman_hesabi: "uzman hesabından açılmış",
  sahip_yok: "sahibi bulunamadı",
  sahip_rolu_belirsiz: "sahibinin rolü belirsiz",
};
// Sunucu her senaryoda alıcısız ilanların en çok bu kadarını döndürüyor
const A3_ALICISIZ_SINIR = 50;
// Sunucudaki NEWJOB_DAILY_LIMIT (uzman başına günlük bildirim); yalnızca açıklama metninde
const A3_GUNLUK_KOTA = 5;

const A3SimulasyonSection = ({ jobs }) => {
  const [durum, setDurum] = useState("bos"); // bos | calisiyor | tamam | hata
  const [sonuc, setSonuc] = useState(null);
  const [hata, setHata] = useState(null);
  const [sure, setSure] = useState(null);

  const calistir = async () => {
    setDurum("calisiyor");
    setHata(null);
    const bas = Date.now();
    try {
      // Fonksiyon zaman aşımı 120 sn; istemcinin varsayılan 70 sn'si yetmeyebilir
      const fn = httpsCallable(getFunctions(auth.app, "us-central1"), "simulateNewJobNotify", { timeout: 130000 });
      const r = await fn({ days: A3_SIM_GUN });
      setSonuc(r.data);
      setDurum("tamam");
    } catch (e) {
      console.error("simulateNewJobNotify:", e);
      setHata({ code: (e && e.code) || "bilinmiyor", message: (e && e.message) || String(e) });
      setDurum("hata");
    } finally {
      setSure(Date.now() - bas);
    }
  };

  // İlan başlıkları bellekteki jobs'tan (yeni okuma yok)
  const ilanBul = useMemo(() => {
    const m = new Map();
    (jobs || []).forEach((j) => { if (j._source !== "requests") m.set(j.id, j); });
    return (id) => m.get(id) || null;
  }, [jobs]);

  // Atlanan ilanlar: yanlış rol listesi + her senaryonun alıcısız ilanları, ilan başına tek satır
  const atlananlar = useMemo(() => {
    if (!sonuc) return [];
    const satirlar = new Map();
    (sonuc.yanlisRol || []).forEach((y) => {
      satirlar.set(y.jobId, { jobId: y.jobId, title: y.title, neden: "yanlış rol", puan: y.puan, etiketler: y.etiketler || [], alicisiz: {} });
    });
    A3_SENARYOLAR.forEach(({ anahtar }) => {
      ((sonuc.senaryolar && sonuc.senaryolar[anahtar] && sonuc.senaryolar[anahtar].alicisizIlanlar) || []).forEach((a) => {
        const s = satirlar.get(a.jobId) || { jobId: a.jobId, neden: "alıcı yok", alicisiz: {} };
        s.city = a.city; s.category = a.category; s.subCategory = a.subCategory;
        s.alicisiz[anahtar] = true;
        satirlar.set(a.jobId, s);
      });
    });
    return [...satirlar.values()].map((s) => {
      const j = ilanBul(s.jobId);
      return { ...s, title: s.title || (j && j.title) || "", city: s.city || (j && j.city) || "", category: s.category || (j && j.category) || "", subCategory: s.subCategory || (j && j.subCategory) || "" };
    });
  }, [sonuc, ilanBul]);
  const { currentPage, totalPages, paginatedItems, goToPage, totalItems, startIndex, endIndex } = usePagination(atlananlar, 15);

  const kart = { background: "white", borderRadius: "16px", padding: "24px", boxShadow: "0 1px 3px rgba(0,0,0,0.05)", marginBottom: "24px" };
  const th = { textAlign: "left", fontSize: "12px", fontWeight: "600", color: "#64748b", padding: "8px 10px", borderBottom: "1px solid #e2e8f0", whiteSpace: "nowrap" };
  const thSag = { ...th, textAlign: "right" };
  const td = { padding: "10px", fontSize: "13px", color: "#334155", borderBottom: "1px solid #f1f5f9", verticalAlign: "top" };
  const tdSag = { ...td, textAlign: "right", fontVariantNumeric: "tabular-nums" };
  const kutu = (deger, etiket) => (
    <div style={{ background: "#f8fafc", borderRadius: "12px", padding: "14px 16px" }}>
      <p style={{ fontSize: "22px", fontWeight: "700", color: "#1e293b", margin: 0 }}>{deger}</p>
      <p style={{ fontSize: "12px", color: "#64748b", margin: "2px 0 0" }}>{etiket}</p>
    </div>
  );

  const ozet = sonuc || {};
  const uzman = ozet.uzman || {};
  const ilan = ozet.ilan || {};
  const atlanan = ozet.atlanan || {};
  const aday = ilan.aday || 0;
  const alicisizKirpildi = A3_SENARYOLAR.some(({ anahtar }) => {
    const s = ozet.senaryolar && ozet.senaryolar[anahtar];
    return s && (s.alicisizIlan || 0) > (s.alicisizIlanlar || []).length;
  });

  return (
    <div style={kart}>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: "12px", flexWrap: "wrap", marginBottom: "16px" }}>
        <div>
          <h3 style={{ fontSize: "16px", fontWeight: "600", color: "#1e293b", margin: "0 0 4px 0" }}>Yeni ilan bildirimi (A3) simülasyonu</h3>
          <p style={{ fontSize: "13px", color: "#64748b", margin: 0 }}>
            Son {A3_SIM_GUN} günün ilanları, bugünkü uzman listesi ve kimlik durumlarıyla dört kural seçeneğinde
            kaç bildirim üretirdi. Sunucuda çalışır, hiçbir şey göndermez ve yazmaz.
          </p>
        </div>
        <button onClick={calistir} disabled={durum === "calisiyor"}
          style={{ display: "flex", alignItems: "center", gap: "8px", padding: "10px 16px", background: durum === "calisiyor" ? "#94a3b8" : "#1e1b4b", color: "white", border: "none", borderRadius: "10px", fontSize: "13px", fontWeight: "600", cursor: durum === "calisiyor" ? "default" : "pointer", whiteSpace: "nowrap" }}>
          <RefreshCw size={16} style={durum === "calisiyor" ? { animation: "spin 1s linear infinite" } : undefined} />
          {durum === "calisiyor" ? "Çalışıyor…" : `Simülasyonu çalıştır (son ${A3_SIM_GUN} gün)`}
        </button>
      </div>

      {durum === "bos" && (
        <p style={{ fontSize: "13px", color: "#94a3b8", margin: 0 }}>Henüz çalıştırılmadı. Düğmeye basılmadan sunucuya çağrı yapılmaz.</p>
      )}
      {durum === "calisiyor" && (
        <p style={{ fontSize: "13px", color: "#64748b", margin: 0 }}>Sunucu ilanları ve uzmanları tarıyor; bu bir dakikaya kadar sürebilir.</p>
      )}
      {durum === "hata" && hata && (
        <div style={{ background: "#fef2f2", border: "1px solid #fecaca", borderRadius: "10px", padding: "12px 14px", fontSize: "13px", color: "#991b1b" }}>
          <strong>Simülasyon çalışmadı.</strong> Kod: <code>{hata.code}</code> · {hata.message}
          {sure !== null && <span style={{ color: "#b91c1c" }}> ({(sure / 1000).toFixed(1)} sn)</span>}
        </div>
      )}

      {sonuc && (
        <>
          {durum === "hata" && <p style={{ fontSize: "12px", color: "#94a3b8", margin: "12px 0 0" }}>Aşağıda önceki başarılı çalıştırmanın sonucu gösteriliyor.</p>}
          <p style={{ fontSize: "12px", color: "#94a3b8", margin: "12px 0" }}>
            Dönem: {ozet.gun} gün ({ozet.since ? formatDateTime(ozet.since) : "-"} sonrası)
            {durum === "tamam" && sure !== null && ` · ${(sure / 1000).toFixed(1)} sn`}
            {ozet.rolKaynak && ` · yanlış rol puanlayıcısı: ${ozet.rolKaynak}`}
            {` · şehirden bağımsız kategoriler: ${(ozet.uzaktanKategoriler || []).length ? ozet.uzaktanKategoriler.join(", ") : "yok"}`}
          </p>

          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))", gap: "12px", marginBottom: "12px" }}>
            {kutu(ilan.toplam ?? 0, "dönemdeki ilan")}
            {kutu(aday, "bildirim adayı ilan")}
            {kutu(ilan.dogrudanIs ?? 0, "doğrudan uzmana açılan iş")}
            {kutu(uzman.uygun ?? 0, `bildirim alabilir uzman (toplam ${uzman.toplam ?? 0})`)}
            {kutu(uzman.kimlikOnayli ?? 0, "bunlardan kimliği onaylı")}
          </div>
          <p style={{ fontSize: "12px", color: "#64748b", margin: "0 0 16px 0" }}>
            Aday dışı kalan ilanlar: {Object.keys(A3_ATLAMA_AD).map((k) => `${A3_ATLAMA_AD[k]} ${atlanan[k] ?? 0}`).join(" · ")}
          </p>

          <div style={{ overflowX: "auto", marginBottom: "8px" }}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr>
                  <th style={th}>Şehir filtresi</th>
                  <th style={th}>Kimlik şartı</th>
                  <th style={thSag}>Bildirim üreten ilan</th>
                  <th style={thSag}>Alıcısız ilan</th>
                  <th style={thSag}>Toplam bildirim</th>
                  <th style={thSag}>Günlük kotaya takılan</th>
                  <th style={thSag} title="Sunucu senaryo başına farklı uzman sayısını döndürmüyor">Farklı uzman</th>
                </tr>
              </thead>
              <tbody>
                {A3_SENARYOLAR.map((s) => {
                  const v = (ozet.senaryolar && ozet.senaryolar[s.anahtar]) || {};
                  return (
                    <tr key={s.anahtar} style={s.canli ? { background: "#f8fafc" } : undefined}>
                      <td style={td}>{s.sehir}{s.canli && <span style={{ marginLeft: "6px", padding: "2px 8px", borderRadius: "10px", fontSize: "11px", fontWeight: "600", background: "#e0e7ff", color: "#3730a3" }}>bugünkü kural</span>}</td>
                      <td style={td}>{s.kimlik}</td>
                      <td style={tdSag}>{v.bildirimUretenIlan ?? 0} / {aday}</td>
                      <td style={tdSag}>{v.alicisizIlan ?? 0}</td>
                      <td style={{ ...tdSag, fontWeight: "600" }}>{v.bildirim ?? 0}</td>
                      <td style={tdSag}>{v.kotayaTakilan ?? 0}</td>
                      <td style={{ ...tdSag, color: "#94a3b8" }} title="Sunucu bu sayıyı döndürmüyor">—</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <p style={{ fontSize: "12px", color: "#94a3b8", margin: "0 0 20px 0" }}>
            Farklı uzman: fonksiyon senaryo başına bu sayıyı döndürmüyor. Üst sınır olarak havuz: kimlik şartlıda {uzman.kimlikOnayli ?? 0}, şartsızda {uzman.uygun ?? 0} uzman.
            Şehir "sıkı": ilanın şehri dışındaki uzmanlar alıcı değil (şehirden bağımsız kategoriler hariç). Günlük kota uzman başına {A3_GUNLUK_KOTA} bildirim.
          </p>

          <h4 style={{ fontSize: "14px", fontWeight: "600", color: "#1e293b", margin: "0 0 4px 0" }}>Atlanan ilanlar ({atlananlar.length})</h4>
          <p style={{ fontSize: "12px", color: "#94a3b8", margin: "0 0 10px 0" }}>
            Sunucu ilan bazında yalnızca yanlış rol yüzünden atlananları ve her senaryoda alıcısı çıkmayanları döndürüyor; eşleşen uzman sayısı ilan bazında dönmüyor.
            Diğer atlama nedenleri (test hesabı, sahibi yok…) yalnızca yukarıdaki toplamlarda.
            {alicisizKirpildi && ` Alıcısız ilanlar senaryo başına en çok ${A3_ALICISIZ_SINIR} tane dönüyor; liste eksik.`}
          </p>
          {atlananlar.length === 0 ? (
            <p style={{ fontSize: "13px", color: "#64748b", margin: "0 0 16px 0" }}>Atlanan ilan yok.</p>
          ) : (
            <>
              <div style={{ overflowX: "auto" }}>
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <thead>
                    <tr>
                      <th style={th}>İlan</th>
                      <th style={th}>Şehir</th>
                      <th style={th}>Kategori</th>
                      <th style={th}>Neden</th>
                      {A3_SENARYOLAR.map((s) => (
                        <th key={s.anahtar} style={{ ...th, textAlign: "center" }} title="Bu senaryoda alıcı çıkmadı mı?">Şehir {s.sehir.toLowerCase()} · kimlik {s.kimlik.toLowerCase()}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedItems.map((a) => (
                      <tr key={a.jobId}>
                        <td style={td}>
                          <div style={{ fontWeight: "600", color: "#1e293b" }}>{a.title || "(başlıksız)"}</div>
                          <div style={{ fontSize: "11px", color: "#94a3b8", fontFamily: "monospace" }}>{a.jobId}</div>
                        </td>
                        <td style={td}>{a.city || "-"}</td>
                        <td style={td}>{a.category || "-"}{a.subCategory ? ` / ${a.subCategory}` : ""}</td>
                        <td style={td}>
                          {a.neden}
                          {a.neden === "yanlış rol" && (
                            <div style={{ fontSize: "11px", color: "#92400e" }}>puan {a.puan}{a.etiketler.length ? ` · ${a.etiketler.join(", ")}` : ""}</div>
                          )}
                        </td>
                        {A3_SENARYOLAR.map((s) => (
                          <td key={s.anahtar} style={{ ...td, textAlign: "center", color: a.alicisiz[s.anahtar] ? "#b45309" : "#cbd5e1" }}>
                            {a.neden === "yanlış rol" ? "atlandı" : a.alicisiz[s.anahtar] ? "alıcı yok" : "—"}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <PaginationBar currentPage={currentPage} totalPages={totalPages} goToPage={goToPage} totalItems={totalItems} startIndex={startIndex} endIndex={endIndex} />
            </>
          )}

          <details style={{ marginTop: "16px" }}>
            <summary style={{ fontSize: "13px", color: "#475569", cursor: "pointer" }}>Ham JSON</summary>
            <pre style={{ background: "#0f172a", color: "#e2e8f0", fontSize: "12px", padding: "12px", borderRadius: "10px", overflow: "auto", maxHeight: "400px", marginTop: "8px" }}>
              {JSON.stringify(sonuc, null, 2)}
            </pre>
          </details>
        </>
      )}
    </div>
  );
};

// ==================== FOTOĞRAF GÖÇÜ (base64 → Storage) ====================
// Canlıdaki migrateInlinePhotos callable'ı (us-central1, yalnızca admin). Girdi, dönüş ve
// devam kuralları: isinebak2/docs/fotograf_storage_gocu_plani.md 2.2–2.3, functions/fotoGocu.js.
// Panel Firestore'a hiçbir şey yazmaz ve okumaz; yazan sunucu fonksiyonudur.
// Düğmeye basılmadan çağrı yapılmaz.
const FOTO_GOCU_ZAMAN_ASIMI_MS = 560 * 1000; // fonksiyonun zaman aşımı 540 sn
const FOTO_GOCU_MOD_AD = { dryRun: "Kuru çalıştırma", user: "Tek kullanıcı", all: "Hepsini taşı", rollback: "Geri al" };
const FOTO_GOCU_ONAY = "Bu işlem canlı veriyi değiştirir. Emin misin?";
const FOTO_GOCU_ONAY_KULLANICI = "Bu işlem bu kullanıcının canlı verisini değiştirir. Emin misin?";
// Sunucudaki sınırlar (fotoGocu.js): listelerin ilk 50'si; en büyük 10 belge + 900 KB üstü hepsi
const FOTO_GOCU_LISTE_SINIRI = 50;
const FOTO_GOCU_EN_BUYUK = 10;
const FOTO_GOCU_BUYUK_KB = 900;
// Yalnızca bu tarayıcıda: son yazan çalışmanın runId'si ve yarım kalan çalışmanın devam girdisi
const FOTO_GOCU_SON_RUN = "fotoGocu.sonRunId";
const FOTO_GOCU_YARIM = "fotoGocu.yarimKalan";

const fotoGocuDepoOku = (anahtar) => {
  try { return JSON.parse(localStorage.getItem(anahtar) || "null"); } catch (e) { return null; }
};
const fotoGocuDepoYaz = (anahtar, deger) => {
  try {
    if (deger === null) localStorage.removeItem(anahtar);
    else localStorage.setItem(anahtar, JSON.stringify(deger));
  } catch (e) { /* depolama kapalıysa yalnızca ekranda kalır */ }
};

// Kuru çalıştırmada her çağrı yalnızca KENDİ özetini döndürür; panel toplar.
// Sunucudaki ozetBirlestir'in MB biçimli karşılığı. user / all / rollback özeti zaten toplamdır.
const fotoGocuOzetTopla = (a, b) => {
  if (!a) return b;
  if (!b) return a;
  const say = (x, y) => (x || 0) + (y || 0);
  const mb3 = (x) => Math.round(x * 1000) / 1000;
  const byCollection = { ...((a.fields && a.fields.byCollection) || {}) };
  Object.entries((b.fields && b.fields.byCollection) || {}).forEach(([k, n]) => { byCollection[k] = say(byCollection[k], n); });
  const yollar = new Map();
  [...(a.largestDocs || []), ...(b.largestDocs || [])].forEach((x) => {
    const m = yollar.get(x.path);
    if (!m || x.kbBefore > m.kbBefore) yollar.set(x.path, x);
  });
  const sa = a.skipped || {};
  const sb = b.skipped || {};
  return {
    scannedDocs: say(a.scannedDocs, b.scannedDocs),
    changedDocs: say(a.changedDocs, b.changedDocs),
    fields: { total: say(a.fields && a.fields.total, b.fields && b.fields.total), byCollection },
    base64MB: mb3(say(a.base64MB, b.base64MB)),
    afterMB: mb3(say(a.afterMB, b.afterMB)),
    savedMB: mb3(say(a.savedMB, b.savedMB)),
    files: {
      uploaded: say(a.files && a.files.uploaded, b.files && b.files.uploaded),
      reused: say(a.files && a.files.reused, b.files && b.files.reused),
      storageMB: mb3(say(a.files && a.files.storageMB, b.files && b.files.storageMB)),
    },
    largestDocs: [...yollar.values()]
      .sort((x, y) => y.kbBefore - x.kbBefore)
      .filter((x, i) => i < FOTO_GOCU_EN_BUYUK || x.kbBefore >= FOTO_GOCU_BUYUK_KB),
    skipped: {
      unsupportedType: say(sa.unsupportedType, sb.unsupportedType),
      noOwner: say(sa.noOwner, sb.noOwner),
      ownerDeleted: say(sa.ownerDeleted, sb.ownerDeleted),
      ownerDeletedMB: mb3(say(sa.ownerDeletedMB, sb.ownerDeletedMB)),
      changedDuringRun: say(sa.changedDuringRun, sb.changedDuringRun),
    },
    unexpected: [...(a.unexpected || []), ...(b.unexpected || [])].slice(0, FOTO_GOCU_LISTE_SINIRI),
    unexpectedTotal: say(a.unexpectedTotal, b.unexpectedTotal),
    errors: [...(a.errors || []), ...(b.errors || [])].slice(0, FOTO_GOCU_LISTE_SINIRI),
    errorsTotal: say(a.errorsTotal, b.errorsTotal),
  };
};

// İmleçten okunur bir konum: { collection, stage } ya da geri almada { ownerIndex }
const fotoGocuImlecMetni = (next) => {
  if (!next || typeof next !== "object") return "";
  if (next.ownerIndex !== undefined) return `sahip #${next.ownerIndex}`;
  return [next.collection, next.stage].filter(Boolean).join(" · ");
};

const FotoGocuSection = () => {
  const [uid, setUid] = useState("");
  const [geriRunId, setGeriRunId] = useState("");
  const [calisma, setCalisma] = useState(null);
  const [sonRunId, setSonRunId] = useState(() => fotoGocuDepoOku(FOTO_GOCU_SON_RUN));
  const [yarim, setYarim] = useState(() => fotoGocuDepoOku(FOTO_GOCU_YARIM));
  const [kopyalandi, setKopyalandi] = useState(false);
  const durdurRef = useRef(false);
  const calisiyor = !!calisma && calisma.durum === "calisiyor";

  // Sayfadan çıkılırsa döngü o anki adımdan sonra durur; yazan çalışmanın devam
  // girdisi tarayıcıda saklı kalır ("Yarım kalan çalışma" ile sürdürülebilir).
  useEffect(() => () => { durdurRef.current = true; }, []);
  useEffect(() => {
    if (!calisiyor) return undefined;
    const uyar = (e) => { e.preventDefault(); e.returnValue = ""; };
    window.addEventListener("beforeunload", uyar);
    return () => window.removeEventListener("beforeunload", uyar);
  }, [calisiyor]);

  // mod: dryRun | user | all | rollback. temel: { mode, uid?, runId? (rollback) }.
  // devam: { girdi, onceki } — durdurulmuş / hatalı çalışmayı kaldığı yerden sürdürür.
  const calistir = async (mod, temel, devam = null) => {
    durdurRef.current = false;
    const fn = httpsCallable(getFunctions(auth.app, "us-central1"), "migrateInlinePhotos", { timeout: FOTO_GOCU_ZAMAN_ASIMI_MS });
    let durum = devam && devam.onceki
      ? { ...devam.onceki, durum: "calisiyor", hata: null, durdurIstendi: false }
      : { mod, temel, adimlar: [], yanitlar: [], ozet: null, son: null, runId: null, durum: "calisiyor", hata: null, sonrakiGirdi: null };
    setCalisma(durum);
    let girdi = devam ? devam.girdi : temel;
    try {
      for (;;) {
        const bas = Date.now();
        const r = (await fn(girdi)).data || {};
        const ozet = mod === "dryRun" ? fotoGocuOzetTopla(durum.ozet, r.summary) : r.summary;
        const adim = {
          no: durum.adimlar.length + 1,
          sureMs: r.durationMs ?? Date.now() - bas,
          done: r.done === true,
          taranan: (r.summary && r.summary.scannedDocs) || 0,
          alan: (r.summary && r.summary.fields && r.summary.fields.total) || 0,
          imlec: fotoGocuImlecMetni(r.next),
        };
        // Devam: aynı mode / uid; kuru çalıştırmada runId yok, diğerlerinde yanıttaki runId
        const sonraki = r.done ? null : { ...temel, ...(mod === "dryRun" ? {} : { runId: r.runId }), cursor: r.next };
        durum = { ...durum, adimlar: [...durum.adimlar, adim], yanitlar: [...durum.yanitlar, r], ozet, son: r, runId: r.runId || durum.runId, sonrakiGirdi: sonraki };
        if ((mod === "user" || mod === "all") && r.runId) {
          fotoGocuDepoYaz(FOTO_GOCU_SON_RUN, r.runId);
          setSonRunId(r.runId);
        }
        if (mod !== "dryRun") {
          const y = sonraki ? { mod, temel, girdi: sonraki, runId: r.runId, at: new Date().toISOString() } : null;
          fotoGocuDepoYaz(FOTO_GOCU_YARIM, y);
          setYarim(y);
        }
        if (r.done) { durum = { ...durum, durum: "tamam" }; break; }
        girdi = sonraki;
        if (durdurRef.current) { durum = { ...durum, durum: "durduruldu" }; break; }
        setCalisma(durum);
      }
    } catch (e) {
      console.error("migrateInlinePhotos:", e);
      durum = { ...durum, durum: "hata", hata: { code: (e && e.code) || "bilinmiyor", message: (e && e.message) || String(e) }, sonrakiGirdi: durum.sonrakiGirdi || (devam ? devam.girdi : null) };
    }
    setCalisma(durum);
  };

  // Kuru çalıştırma dışında her mod canlı veriyi değiştirir → onay
  const onayla = (mod) =>
    mod === "dryRun" || window.confirm(mod === "user" ? FOTO_GOCU_ONAY_KULLANICI : FOTO_GOCU_ONAY);
  const baslat = (mod) => {
    if (calisiyor) return;
    let temel;
    if (mod === "dryRun") temel = { mode: "dryRun" };
    else if (mod === "all") temel = { mode: "all" };
    else if (mod === "user") {
      const u = uid.trim();
      if (!u) { alert("Tek kullanıcı için uid girin."); return; }
      temel = { mode: "user", uid: u };
    } else {
      const r = geriRunId.trim();
      if (!r) { alert("Geri almak için runId girin."); return; }
      temel = { mode: "rollback", runId: r };
    }
    if (!onayla(mod)) return;
    calistir(mod, temel);
  };
  const devamEt = () => {
    if (calisiyor || !calisma || !calisma.sonrakiGirdi) return;
    calistir(calisma.mod, calisma.temel, { girdi: calisma.sonrakiGirdi, onceki: calisma });
  };
  // Sayfa yenilendikten / değiştirildikten sonra: tarayıcıda saklı devam girdisiyle sürdür
  const yarimiSurdur = () => {
    if (calisiyor || !yarim) return;
    calistir(yarim.mod, yarim.temel, { girdi: yarim.girdi, onceki: null });
  };
  const yarimiUnut = () => { fotoGocuDepoYaz(FOTO_GOCU_YARIM, null); setYarim(null); };

  const kopyala = async (metin) => {
    try {
      await navigator.clipboard.writeText(metin);
      setKopyalandi(true);
      setTimeout(() => setKopyalandi(false), 1500);
    } catch (e) {
      alert(`Kopyalanamadı; elle seçip kopyalayın:\n${metin}`);
    }
  };

  const kart = { background: "white", borderRadius: "16px", padding: "24px", boxShadow: "0 1px 3px rgba(0,0,0,0.05)", marginBottom: "24px" };
  const th = { textAlign: "left", fontSize: "12px", fontWeight: "600", color: "#64748b", padding: "8px 10px", borderBottom: "1px solid #e2e8f0", whiteSpace: "nowrap" };
  const thSag = { ...th, textAlign: "right" };
  const td = { padding: "8px 10px", fontSize: "13px", color: "#334155", borderBottom: "1px solid #f1f5f9", verticalAlign: "top" };
  const tdSag = { ...td, textAlign: "right", fontVariantNumeric: "tabular-nums" };
  const girdiStil = { padding: "8px 10px", border: "1px solid #e2e8f0", borderRadius: "8px", fontSize: "13px", fontFamily: "monospace", minWidth: "220px", outline: "none" };
  const dugme = (renk, pasif) => ({ display: "flex", alignItems: "center", gap: "6px", padding: "9px 14px", background: pasif ? "#cbd5e1" : renk, color: "white", border: "none", borderRadius: "10px", fontSize: "13px", fontWeight: "600", cursor: pasif ? "default" : "pointer", whiteSpace: "nowrap" });
  const kucukDugme = { padding: "4px 10px", background: "#f1f5f9", color: "#334155", border: "1px solid #e2e8f0", borderRadius: "8px", fontSize: "12px", cursor: "pointer" };
  const kutu = (deger, etiket) => (
    <div style={{ background: "#f8fafc", borderRadius: "12px", padding: "14px 16px" }}>
      <p style={{ fontSize: "20px", fontWeight: "700", color: "#1e293b", margin: 0 }}>{deger}</p>
      <p style={{ fontSize: "12px", color: "#64748b", margin: "2px 0 0" }}>{etiket}</p>
    </div>
  );
  const altBaslik = (metin) => <h4 style={{ fontSize: "14px", fontWeight: "600", color: "#1e293b", margin: "20px 0 8px" }}>{metin}</h4>;

  const ozet = calisma && calisma.ozet;
  const son = calisma && calisma.son;
  const kuru = calisma && calisma.mod === "dryRun";
  const toplamSureSn = calisma ? calisma.adimlar.reduce((t, a) => t + (a.sureMs || 0), 0) / 1000 : 0;

  return (
    <div style={kart}>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      <h3 style={{ fontSize: "16px", fontWeight: "600", color: "#1e293b", margin: "0 0 4px 0" }}>Fotoğraf göçü (base64 → Storage)</h3>
      <p style={{ fontSize: "13px", color: "#64748b", margin: "0 0 16px 0" }}>
        Firestore belgelerindeki base64 fotoğrafları Storage'a taşır ve yerlerine adres yazar (sunucudaki migrateInlinePhotos).
        Her alan önce yedeklenir; yedekler 30 gün tutulur. Aynı anda yalnızca bir yazan çalışma olabilir.
      </p>

      <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", alignItems: "center", marginBottom: "10px" }}>
        <button onClick={() => baslat("dryRun")} disabled={calisiyor} style={dugme("#1e1b4b", calisiyor)}>Kuru çalıştırma</button>
        <span style={{ fontSize: "12px", color: "#94a3b8" }}>hiçbir şey yazmaz</span>
      </div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", alignItems: "center", marginBottom: "10px" }}>
        <input value={uid} onChange={(e) => setUid(e.target.value)} placeholder="uid" style={girdiStil} disabled={calisiyor} />
        <button onClick={() => baslat("user")} disabled={calisiyor} style={dugme("#b45309", calisiyor)}>Tek kullanıcı</button>
        <span style={{ fontSize: "12px", color: "#b45309" }}>canlı veriyi değiştirir: bu kullanıcının fotoğrafları ve bütün kopyaları</span>
      </div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", alignItems: "center", marginBottom: "10px" }}>
        <button onClick={() => baslat("all")} disabled={calisiyor} style={dugme("#dc2626", calisiyor)}>Hepsini taşı</button>
        <span style={{ fontSize: "12px", color: "#dc2626" }}>canlı veriyi değiştirir</span>
      </div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", alignItems: "center", marginBottom: "16px" }}>
        <input value={geriRunId} onChange={(e) => setGeriRunId(e.target.value)} placeholder="runId" style={girdiStil} disabled={calisiyor} />
        <button onClick={() => baslat("rollback")} disabled={calisiyor} style={dugme("#475569", calisiyor)}>Geri al</button>
        <span style={{ fontSize: "12px", color: "#64748b" }}>bir "Tek kullanıcı" ya da "Hepsini taşı" çalışmasını geri yazar</span>
      </div>

      {/* Son yazan çalışmanın runId'si — geri alma için */}
      <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", alignItems: "center", background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: "10px", padding: "10px 12px", marginBottom: "16px", fontSize: "13px", color: "#334155" }}>
        <span>Son çalışmanın runId'si:</span>
        {sonRunId ? (
          <>
            <code style={{ fontFamily: "monospace", userSelect: "all", background: "white", padding: "2px 8px", borderRadius: "6px", border: "1px solid #e2e8f0" }}>{sonRunId}</code>
            <button onClick={() => kopyala(sonRunId)} style={kucukDugme}>{kopyalandi ? "Kopyalandı" : "Kopyala"}</button>
            <button onClick={() => setGeriRunId(sonRunId)} disabled={calisiyor} style={kucukDugme}>Geri alma kutusuna yaz</button>
          </>
        ) : (
          <span style={{ color: "#94a3b8" }}>bu tarayıcıda henüz yazan çalışma yok</span>
        )}
      </div>

      {yarim && !calisiyor && !(calisma && calisma.sonrakiGirdi) && (
        <div style={{ background: "#fffbeb", border: "1px solid #fde68a", borderRadius: "10px", padding: "10px 12px", marginBottom: "16px", fontSize: "13px", color: "#92400e", display: "flex", flexWrap: "wrap", gap: "8px", alignItems: "center" }}>
          <span>
            Yarım kalan çalışma: <strong>{FOTO_GOCU_MOD_AD[yarim.mod]}</strong>
            {yarim.runId ? <> · <code style={{ userSelect: "all" }}>{yarim.runId}</code></> : null}
            {yarim.at ? ` · son adım ${formatDateTime(yarim.at)}` : ""}
          </span>
          <button onClick={yarimiSurdur} style={kucukDugme}>Kaldığı yerden devam et</button>
          <button onClick={yarimiUnut} style={kucukDugme}>Unut</button>
        </div>
      )}

      {!calisma && <p style={{ fontSize: "13px", color: "#94a3b8", margin: 0 }}>Henüz çalıştırılmadı. Düğmeye basılmadan sunucuya çağrı yapılmaz.</p>}

      {calisma && (
        <>
          {/* İlerleme */}
          <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", alignItems: "center", marginBottom: "10px" }}>
            <strong style={{ fontSize: "14px", color: "#1e293b" }}>{FOTO_GOCU_MOD_AD[calisma.mod]}</strong>
            {calisma.temel.uid && <code style={{ fontSize: "12px" }}>uid {calisma.temel.uid}</code>}
            {calisma.mod === "rollback" && <code style={{ fontSize: "12px" }}>hedef {calisma.temel.runId}</code>}
            {calisiyor && (
              <>
                <span style={{ display: "flex", alignItems: "center", gap: "6px", fontSize: "13px", color: "#64748b" }}>
                  <RefreshCw size={14} style={{ animation: "spin 1s linear infinite" }} />
                  {calisma.adimlar.length + 1}. adım çalışıyor{calisma.adimlar.length ? ` (${fotoGocuImlecMetni(calisma.sonrakiGirdi && calisma.sonrakiGirdi.cursor)})` : ""}…
                </span>
                <button onClick={() => { durdurRef.current = true; setCalisma((c) => (c ? { ...c, durdurIstendi: true } : c)); }} disabled={calisma.durdurIstendi}
                  style={dugme("#64748b", calisma.durdurIstendi)}>
                  {calisma.durdurIstendi ? "Bu adımdan sonra duracak" : "Durdur"}
                </button>
              </>
            )}
            {calisma.durum === "tamam" && <span style={{ fontSize: "13px", color: "#16a34a", fontWeight: "600" }}>Tamamlandı ({calisma.adimlar.length} adım, {toplamSureSn.toFixed(1)} sn)</span>}
            {calisma.durum === "durduruldu" && <span style={{ fontSize: "13px", color: "#b45309", fontWeight: "600" }}>Durduruldu ({calisma.adimlar.length} adım). Çalışma bitmedi.</span>}
            {!calisiyor && calisma.sonrakiGirdi && calisma.sonrakiGirdi.cursor && (
              <button onClick={devamEt} style={dugme("#1e1b4b", false)}>Kaldığı yerden devam et</button>
            )}
          </div>
          {calisma.durum === "durduruldu" && calisma.mod !== "dryRun" && (
            <p style={{ fontSize: "12px", color: "#b45309", margin: "0 0 10px" }}>
              Yazan çalışmanın kilidi 10 dakika bu çalışmada kalır; bu sürede başka bir yazan çalışma başlatılamaz. Devam etmek için yukarıdaki düğmeyi kullanın.
            </p>
          )}
          {calisma.durum === "hata" && calisma.hata && (
            <div style={{ background: "#fef2f2", border: "1px solid #fecaca", borderRadius: "10px", padding: "12px 14px", fontSize: "13px", color: "#991b1b", marginBottom: "10px" }}>
              <strong>{calisma.adimlar.length + 1}. adımda hata.</strong> Kod: <code>{calisma.hata.code}</code> · {calisma.hata.message}
              {calisma.adimlar.length > 0 && <div style={{ marginTop: "4px", color: "#b91c1c" }}>Önceki {calisma.adimlar.length} adımın sonucu aşağıda.</div>}
            </div>
          )}

          {calisma.adimlar.length > 0 && (
            <div style={{ overflowX: "auto", marginBottom: "8px" }}>
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr>
                    <th style={th}>Adım</th>
                    <th style={thSag}>Süre</th>
                    <th style={thSag}>{kuru ? "Taranan (bu adım)" : "Taranan (toplam)"}</th>
                    <th style={thSag}>{kuru ? "Alan (bu adım)" : "Alan (toplam)"}</th>
                    <th style={th}>Durum</th>
                  </tr>
                </thead>
                <tbody>
                  {calisma.adimlar.map((a) => (
                    <tr key={a.no}>
                      <td style={td}>{a.no}</td>
                      <td style={tdSag}>{(a.sureMs / 1000).toFixed(1)} sn</td>
                      <td style={tdSag}>{a.taranan}</td>
                      <td style={tdSag}>{a.alan}</td>
                      <td style={td}>{a.done ? "bitti" : `devam: ${a.imlec || "—"}`}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {calisma.runId && (
            <p style={{ fontSize: "13px", color: "#334155", margin: "12px 0 0" }}>
              runId: <code style={{ fontFamily: "monospace", userSelect: "all" }}>{calisma.runId}</code>{" "}
              <button onClick={() => kopyala(calisma.runId)} style={kucukDugme}>{kopyalandi ? "Kopyalandı" : "Kopyala"}</button>
            </p>
          )}

          {ozet && (
            <>
              {altBaslik(kuru ? "Özet (bütün adımların toplamı; kuru çalıştırma — yazılmadı)" : calisma.mod === "rollback" ? "Özet (geri yazılan alanlar)" : "Özet (çalışmanın toplamı)")}
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))", gap: "12px", marginBottom: "12px" }}>
                {kutu(ozet.scannedDocs ?? 0, "taranan belge")}
                {kutu(ozet.changedDocs ?? 0, kuru ? "değişecek belge" : "değişen belge")}
                {kutu((ozet.fields && ozet.fields.total) ?? 0, kuru ? "taşınacak alan" : "değişen alan")}
                {kutu(`${ozet.base64MB ?? 0} → ${ozet.afterMB ?? 0} MB`, "base64 → adres")}
                {kutu(`${ozet.savedMB ?? 0} MB`, kuru ? "kazanılacak" : "kazanılan")}
                {kutu(`${(ozet.files && ozet.files.uploaded) ?? 0} / ${(ozet.files && ozet.files.reused) ?? 0}`, `${kuru ? "yüklenecek" : "yüklenen"} / yeniden kullanılan dosya (${(ozet.files && ozet.files.storageMB) ?? 0} MB)`)}
              </div>

              <div style={{ display: "flex", flexWrap: "wrap", gap: "24px" }}>
                <div style={{ minWidth: "220px" }}>
                  {altBaslik("Koleksiyona göre alan")}
                  {Object.keys((ozet.fields && ozet.fields.byCollection) || {}).length === 0 ? (
                    <p style={{ fontSize: "13px", color: "#94a3b8", margin: 0 }}>Alan yok.</p>
                  ) : (
                    <table style={{ borderCollapse: "collapse" }}>
                      <tbody>
                        {Object.entries(ozet.fields.byCollection).map(([k, n]) => (
                          <tr key={k}><td style={td}>{k}</td><td style={tdSag}>{n}</td></tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </div>
                <div style={{ minWidth: "260px" }}>
                  {altBaslik("Atlananlar")}
                  <table style={{ borderCollapse: "collapse" }}>
                    <tbody>
                      {[
                        ["desteklenmeyen tür", ozet.skipped && ozet.skipped.unsupportedType],
                        ["sahibi belirlenemedi", ozet.skipped && ozet.skipped.noOwner],
                        [`sahibi silinmiş (${(ozet.skipped && ozet.skipped.ownerDeletedMB) ?? 0} MB)`, ozet.skipped && ozet.skipped.ownerDeleted],
                        ["çalışma sırasında değişti", ozet.skipped && ozet.skipped.changedDuringRun],
                      ].map(([ad, n]) => (
                        <tr key={ad}><td style={td}>{ad}</td><td style={tdSag}>{n ?? 0}</td></tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                {son && (son.backup || son.rollback) && (
                  <div style={{ minWidth: "260px" }}>
                    {son.backup && (
                      <>
                        {altBaslik("Yedek")}
                        <table style={{ borderCollapse: "collapse" }}>
                          <tbody>
                            <tr><td style={td}>önek</td><td style={{ ...td, fontFamily: "monospace", fontSize: "12px" }}>{son.backup.prefix}</td></tr>
                            <tr><td style={td}>kayıt</td><td style={tdSag}>{son.backup.entries}</td></tr>
                            <tr><td style={td}>silineceği gün</td><td style={tdSag}>{son.backup.expiresAt}</td></tr>
                          </tbody>
                        </table>
                      </>
                    )}
                    {son.rollback && (
                      <>
                        {altBaslik("Geri alma")}
                        <table style={{ borderCollapse: "collapse" }}>
                          <tbody>
                            {[
                              ["geri yazılan / zaten eski değerinde", son.rollback.restored],
                              ["göçten sonra değişmiş, dokunulmadı", son.rollback.skippedChanged],
                              ["yedeği yok", son.rollback.missingBackup],
                              ["hesap silinmiş, geri getirilmedi", son.rollback.ownerDeleted],
                            ].map(([ad, n]) => (
                              <tr key={ad}><td style={td}>{ad}</td><td style={tdSag}>{n ?? 0}</td></tr>
                            ))}
                          </tbody>
                        </table>
                      </>
                    )}
                  </div>
                )}
              </div>

              {(ozet.largestDocs || []).length > 0 && (
                <>
                  {altBaslik(`En büyük belgeler (${FOTO_GOCU_EN_BUYUK} en büyük + ${FOTO_GOCU_BUYUK_KB} KB üstü hepsi)`)}
                  <div style={{ overflowX: "auto" }}>
                    <table style={{ width: "100%", borderCollapse: "collapse" }}>
                      <thead><tr><th style={th}>Belge</th><th style={thSag}>Önce</th><th style={thSag}>Sonra (tahmin)</th></tr></thead>
                      <tbody>
                        {ozet.largestDocs.map((d) => (
                          <tr key={d.path}>
                            <td style={{ ...td, fontFamily: "monospace", fontSize: "12px" }}>{d.path}</td>
                            <td style={{ ...tdSag, color: d.kbBefore >= FOTO_GOCU_BUYUK_KB ? "#dc2626" : "#334155" }}>{d.kbBefore} KB</td>
                            <td style={tdSag}>{d.kbAfter} KB</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </>
              )}

              {[["unexpected", "Beklenmeyenler", "unexpectedTotal"], ["errors", "Hatalar", "errorsTotal"]].map(([anahtar, baslik, toplamAnahtar]) => (
                <div key={anahtar}>
                  {altBaslik(`${baslik} (${ozet[toplamAnahtar] ?? 0})`)}
                  {(ozet[anahtar] || []).length === 0 ? (
                    <p style={{ fontSize: "13px", color: "#94a3b8", margin: 0 }}>Yok.</p>
                  ) : (
                    <>
                      <div style={{ overflowX: "auto" }}>
                        <table style={{ width: "100%", borderCollapse: "collapse" }}>
                          <thead><tr><th style={th}>Belge</th><th style={th}>Alan</th><th style={anahtar === "errors" ? th : thSag}>{anahtar === "errors" ? "Mesaj" : "Boyut"}</th></tr></thead>
                          <tbody>
                            {ozet[anahtar].map((x, i) => (
                              <tr key={`${x.path}-${x.field}-${i}`}>
                                <td style={{ ...td, fontFamily: "monospace", fontSize: "12px" }}>{x.path}</td>
                                <td style={td}>{x.field}</td>
                                {anahtar === "errors" ? <td style={{ ...td, color: "#991b1b" }}>{x.message}</td> : <td style={tdSag}>{x.kb} KB</td>}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                      {(ozet[toplamAnahtar] || 0) > ozet[anahtar].length && (
                        <p style={{ fontSize: "12px", color: "#94a3b8", margin: "4px 0 0" }}>İlk {ozet[anahtar].length} kayıt gösteriliyor.</p>
                      )}
                    </>
                  )}
                </div>
              ))}
            </>
          )}

          {calisma.yanitlar.length > 0 && (
            <details style={{ marginTop: "16px" }}>
              <summary style={{ fontSize: "13px", color: "#475569", cursor: "pointer" }}>Ham JSON ({calisma.yanitlar.length} yanıt)</summary>
              <pre style={{ background: "#0f172a", color: "#e2e8f0", fontSize: "12px", padding: "12px", borderRadius: "10px", overflow: "auto", maxHeight: "400px", marginTop: "8px" }}>
                {JSON.stringify(calisma.yanitlar.length === 1 ? calisma.yanitlar[0] : calisma.yanitlar, null, 2)}
              </pre>
            </details>
          )}
        </>
      )}
    </div>
  );
};

// ==================== YETİM BELGE DOSYALARI (cleanupOrphanDocumentFiles, 1.0.31 Grup 2 madde 6) ====================
// Kaynak: isinebak2/docs/admin_paneli_131_grup2.md §2 ve functions/belgeTemizligi.js.
// expert-documents/{uid}/ altında olup users/{uid} belgesindeki hiçbir storagePath'in göstermediği
// dosyalar (kullanıcı belgesi yoksa da yetim); yalnızca minYasSaat'ten eskiler. Sunucu varsayılan
// olarak kuru çalışır; yalnızca dryRun:false ile siler. Silme çağrısı dosyaları YENİDEN tarar ve
// en çok `limit` kadarını siler. Panel Firestore'a ve Storage'a hiçbir şey yazmaz.
const YETIM_ZAMAN_ASIMI_MS = 560 * 1000; // fonksiyonun zaman aşımı 540 sn
const YETIM_VARSAYILAN = { minYasSaat: 48, limit: 500 };
const yetimSayi = (v, alt, ust, vars) => (Number.isFinite(Number(v)) && String(v).trim() !== "" ? Math.min(ust, Math.max(alt, Number(v))) : vars);

const YetimBelgeSection = () => {
  const [minYasSaat, setMinYasSaat] = useState(String(YETIM_VARSAYILAN.minYasSaat));
  const [limit, setLimit] = useState(String(YETIM_VARSAYILAN.limit));
  const [son, setSon] = useState(null); // son yanıt (kuru ya da silme)
  const [kuruGirdi, setKuruGirdi] = useState(null); // son başarılı kuru çalıştırmanın girdisi
  const [calisiyor, setCalisiyor] = useState(null); // "kuru" | "sil" | null
  const [hata, setHata] = useState(null);

  const girdi = { minYasSaat: yetimSayi(minYasSaat, 0, 720, YETIM_VARSAYILAN.minYasSaat), limit: Math.floor(yetimSayi(limit, 1, 2000, YETIM_VARSAYILAN.limit)) };
  const ayniGirdi = kuruGirdi && kuruGirdi.minYasSaat === girdi.minYasSaat && kuruGirdi.limit === girdi.limit;
  // Sil: yalnızca aynı ayarlarla yapılmış bir kuru çalıştırmadan sonra; silmeden sonra kalan varsa yeniden
  const silinecek = son ? Math.min(son.dryRun ? son.yetim : son.kalan, girdi.limit) : 0;
  const silinebilir = !!(ayniGirdi && son && silinecek > 0);

  const cagir = async (dryRun) => {
    setHata(null);
    setCalisiyor(dryRun ? "kuru" : "sil");
    try {
      const fn = httpsCallable(getFunctions(auth.app, "us-central1"), "cleanupOrphanDocumentFiles", { timeout: YETIM_ZAMAN_ASIMI_MS });
      const r = (await fn({ dryRun, ...girdi })).data || {};
      setSon(r);
      if (dryRun) setKuruGirdi({ minYasSaat: r.minYasSaat, limit: r.limit });
    } catch (e) {
      console.error("cleanupOrphanDocumentFiles:", e);
      setHata({ code: (e && e.code) || "bilinmiyor", message: (e && e.message) || String(e) });
    } finally {
      setCalisiyor(null);
    }
  };

  const sil = () => {
    if (!silinebilir || calisiyor) return;
    if (!window.confirm(`${silinecek} dosya kalıcı olarak silinecek (KVKK temizliği). Geri alınamaz.`)) return;
    cagir(false);
  };

  const kart = { background: "white", borderRadius: "16px", padding: "24px", boxShadow: "0 1px 3px rgba(0,0,0,0.05)", marginBottom: "24px" };
  const th = { textAlign: "left", fontSize: "12px", fontWeight: "600", color: "#64748b", padding: "8px 10px", borderBottom: "1px solid #e2e8f0", whiteSpace: "nowrap" };
  const td = { padding: "8px 10px", fontSize: "13px", color: "#334155", borderBottom: "1px solid #f1f5f9", verticalAlign: "top" };
  const girdiStil = { padding: "8px 10px", border: "1px solid #e2e8f0", borderRadius: "8px", fontSize: "13px", width: "90px", outline: "none" };
  const dugme = (renk, pasif) => ({ display: "flex", alignItems: "center", gap: "6px", padding: "9px 14px", background: pasif ? "#cbd5e1" : renk, color: "white", border: "none", borderRadius: "10px", fontSize: "13px", fontWeight: "600", cursor: pasif ? "default" : "pointer", whiteSpace: "nowrap" });
  const kutu = (deger, etiket, renk) => (
    <div style={{ background: "#f8fafc", borderRadius: "12px", padding: "14px 16px" }}>
      <p style={{ fontSize: "20px", fontWeight: "700", color: renk || "#1e293b", margin: 0 }}>{deger}</p>
      <p style={{ fontSize: "12px", color: "#64748b", margin: "2px 0 0" }}>{etiket}</p>
    </div>
  );
  const donen = (spin) => spin && <RefreshCw size={14} style={{ animation: "spin 1s linear infinite" }} />;

  return (
    <div style={kart}>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      <h3 style={{ fontSize: "16px", fontWeight: "600", color: "#1e293b", margin: "0 0 4px 0" }}>Yetim belge dosyaları (KVKK temizliği)</h3>
      <p style={{ fontSize: "13px", color: "#64748b", margin: "0 0 16px 0" }}>
        Storage'da <code>expert-documents/{"{uid}"}/</code> altında kalmış, kullanıcı belgesindeki hiçbir belgenin göstermediği dosyalar
        (kullanıcı belgesi yoksa da yetim). Yüklemesi süren dosyalara dokunmamak için yalnızca belirtilen yaştan eski dosyalar.
      </p>

      <div style={{ display: "flex", flexWrap: "wrap", gap: "12px", alignItems: "center", marginBottom: "12px", fontSize: "13px", color: "#334155" }}>
        <label style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          En az yaş (saat, 0–720)
          <input type="number" min="0" max="720" value={minYasSaat} onChange={(e) => setMinYasSaat(e.target.value)} disabled={!!calisiyor} style={girdiStil} />
        </label>
        <label style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          Silme sınırı (1–2000)
          <input type="number" min="1" max="2000" value={limit} onChange={(e) => setLimit(e.target.value)} disabled={!!calisiyor} style={girdiStil} />
        </label>
      </div>

      <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", alignItems: "center" }}>
        <button onClick={() => cagir(true)} disabled={!!calisiyor} style={dugme("#1e1b4b", !!calisiyor)}>
          {donen(calisiyor === "kuru")}Yetim belge dosyalarını bul (kuru)
        </button>
        <button onClick={sil} disabled={!silinebilir || !!calisiyor} title={silinebilir ? "" : "Önce aynı ayarlarla kuru çalıştırma yapın"}
          style={dugme("#dc2626", !silinebilir || !!calisiyor)}>
          {donen(calisiyor === "sil")}Sil{silinebilir ? ` (${silinecek})` : ""}
        </button>
        {kuruGirdi && !ayniGirdi && <span style={{ fontSize: "12px", color: "#b45309" }}>Ayarlar değişti; silmeden önce yeniden kuru çalıştırın.</span>}
      </div>

      {hata && (
        <div style={{ marginTop: "12px", background: "#fef2f2", border: "1px solid #fecaca", borderRadius: "10px", padding: "12px 14px", fontSize: "13px", color: "#991b1b" }}>
          <strong>Çağrı başarısız.</strong> Kod: <code>{hata.code}</code> · {hata.message}
        </div>
      )}

      {son && (
        <>
          <p style={{ fontSize: "13px", fontWeight: "600", color: son.dryRun ? "#1e293b" : "#b91c1c", margin: "16px 0 8px" }}>
            {son.dryRun ? "Kuru çalıştırma — hiçbir dosya silinmedi" : "Silme sonucu"} · en az yaş {son.minYasSaat} saat · sınır {son.limit}
          </p>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(140px, 1fr))", gap: "12px", marginBottom: "8px" }}>
            {kutu(son.taranan ?? 0, "taranan dosya")}
            {kutu(son.yetim ?? 0, "yetim", son.yetim ? "#b45309" : undefined)}
            {kutu(son.korunan ?? 0, "korunan (belgede var)")}
            {kutu(son.atlananYeni ?? 0, "yeni, atlandı")}
            {kutu(son.gecersizYol ?? 0, "geçersiz yol")}
            {kutu(son.kullaniciBelgesiYok ?? 0, "yetimlerden kullanıcısı olmayan")}
            {!son.dryRun && kutu(son.silinen ?? 0, "silinen", "#b91c1c")}
            {!son.dryRun && kutu(son.hata ?? 0, "silinemeyen", son.hata ? "#b91c1c" : undefined)}
            {kutu(son.kalan ?? 0, son.dryRun ? "silinmeyi bekleyen" : "kalan")}
          </div>
          {!son.dryRun && son.kalan > 0 && (
            <p style={{ fontSize: "12px", color: "#b45309", margin: "0 0 8px" }}>Sınır nedeniyle {son.kalan} yetim dosya kaldı; "Sil" yeniden çalıştırılabilir.</p>
          )}
          {(son.ornekler || []).length > 0 && (
            <>
              <p style={{ fontSize: "12px", color: "#94a3b8", margin: "8px 0 4px" }}>
                {son.dryRun ? "Yetim dosyalar" : "Silmeden önce bulunan yetimler"} (ilk {son.ornekler.length}{son.yetim > son.ornekler.length ? ` / ${son.yetim}` : ""})
              </p>
              <div style={{ overflowX: "auto", maxHeight: "360px", overflowY: "auto" }}>
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <thead><tr><th style={th}>Dosya yolu</th><th style={th}>uid</th><th style={th}>Neden</th><th style={{ ...th, textAlign: "right" }}>Yaş (gün)</th></tr></thead>
                  <tbody>
                    {son.ornekler.map((o) => (
                      <tr key={o.yol}>
                        <td style={{ ...td, fontFamily: "monospace", fontSize: "12px", wordBreak: "break-all" }}>{o.yol}</td>
                        <td style={{ ...td, fontFamily: "monospace", fontSize: "12px" }}>{o.uid}</td>
                        <td style={td}>{o.neden}</td>
                        <td style={{ ...td, textAlign: "right" }}>{o.yasGun}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </>
          )}
          <details style={{ marginTop: "12px" }}>
            <summary style={{ fontSize: "13px", color: "#475569", cursor: "pointer" }}>Ham JSON</summary>
            <pre style={{ background: "#0f172a", color: "#e2e8f0", fontSize: "12px", padding: "12px", borderRadius: "10px", overflow: "auto", maxHeight: "300px", marginTop: "8px" }}>{JSON.stringify(son, null, 2)}</pre>
          </details>
        </>
      )}
    </div>
  );
};

// ==================== 1.0.31 GRUP 3: TAŞIMA VE DOLDURMA ====================
// Kaynak: isinebak2/docs/admin_paneli_131_grup3.md ve functions/index.js (auditUsersPrivateData,
// migrateAppleTokens, backfillContactInfo, backfillPublicProfiles; 29 Ekim ekleri fixBlockedDates,
// purgeDeletedAccountContacts, countAuthlessUsers) + yardımcı dosyaları (izinGunleri.js, silinmisHesapTemizligi.js,
// authsuzKullanicilar.js); 30 Ekim: countContactExposure, moveSupportTicketsFromRequests, stripProposalEmails
// (sizintiTemizligi.js), cleanupDeletedAccountTraces (hesapSilmeTemizligi.js), setRetentionExpiry (saklamaSuresi.js);
// 31 Ekim: classifyPayments, markTestPayments (odemeSiniflandirma.js), countPushTokenStatus (pushAnahtarDurumu.js);
// 3 Kasım: countPremiumAnomalies (premiumDenetimi.js; bekçi ayarı settings/automation yalnızca okunur), countRoleConfusion (rolKarisikligi.js).
// Hepsi us-central1 callable, yalnızca admin. Yazanlar KURU başlar; yalnızca dryRun:false ile yazar.
// Panel Firestore'a hiçbir şey yazmaz; düğmeye basılmadan çağrı yapılmaz.
const GRUP3_ZAMAN_ASIMI_MS = 320 * 1000; // fonksiyonların zaman aşımı 300 sn
const GRUP3_UZUN_ZAMAN_ASIMI_MS = 560 * 1000; // purgeDeletedAccountContacts, countAuthlessUsers, stripProposalEmails, cleanupDeletedAccountTraces: 540 sn
const FIRESTORE_KONSOL = "https://console.firebase.google.com/project/uygulama-e5dd5/firestore/databases/-default-/data";

const grup3Cagir = async (ad, girdi, zamanAsimi = GRUP3_ZAMAN_ASIMI_MS) => {
  const fn = httpsCallable(getFunctions(auth.app, "us-central1"), ad, { timeout: zamanAsimi });
  return (await fn(girdi)).data || {};
};
const grup3Hata = (e) => ({ code: (e && e.code) || "bilinmiyor", message: (e && e.message) || String(e) });

const grup3Stil = {
  kart: { border: "1px solid #e2e8f0", borderRadius: "14px", padding: "18px", marginBottom: "16px" },
  baslik: { fontSize: "15px", fontWeight: "600", color: "#1e293b", margin: "0 0 4px 0" },
  aciklama: { fontSize: "12px", color: "#64748b", margin: "0 0 12px 0" },
  dugme: (renk, pasif) => ({ display: "flex", alignItems: "center", gap: "6px", padding: "8px 14px", background: pasif ? "#cbd5e1" : renk, color: "white", border: "none", borderRadius: "10px", fontSize: "13px", fontWeight: "600", cursor: pasif ? "default" : "pointer", whiteSpace: "nowrap" }),
  girdi: { padding: "7px 10px", border: "1px solid #e2e8f0", borderRadius: "8px", fontSize: "13px", width: "90px", outline: "none" },
  secim: { padding: "7px 10px", border: "1px solid #e2e8f0", borderRadius: "8px", fontSize: "13px", outline: "none", background: "white" },
};
const Grup3Hata = ({ hata }) => hata ? (
  <div style={{ marginTop: "10px", background: "#fef2f2", border: "1px solid #fecaca", borderRadius: "10px", padding: "10px 12px", fontSize: "13px", color: "#991b1b" }}>
    <strong>Çağrı başarısız.</strong> Kod: <code>{hata.code}</code> · {hata.message}
  </div>
) : null;
const Grup3Sayilar = ({ satirlar }) => (
  <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(120px, 1fr))", gap: "10px", marginTop: "12px" }}>
    {satirlar.map(([etiket, deger, renk]) => (
      <div key={etiket} style={{ background: "#f8fafc", borderRadius: "10px", padding: "10px 12px" }}>
        <p style={{ fontSize: "18px", fontWeight: "700", color: renk || "#1e293b", margin: 0 }}>{deger ?? 0}</p>
        <p style={{ fontSize: "11px", color: "#64748b", margin: "2px 0 0" }}>{etiket}</p>
      </div>
    ))}
  </div>
);
const Grup3Ham = ({ veri }) => (
  <details style={{ marginTop: "10px" }}>
    <summary style={{ fontSize: "12px", color: "#475569", cursor: "pointer" }}>Ham JSON</summary>
    <pre style={{ background: "#0f172a", color: "#e2e8f0", fontSize: "12px", padding: "10px", borderRadius: "8px", overflow: "auto", maxHeight: "260px" }}>{JSON.stringify(veri, null, 2)}</pre>
  </details>
);
const Grup3Donen = ({ acik }) => (acik ? <RefreshCw size={14} style={{ animation: "spin 1s linear infinite" }} /> : null);

// 3.0 auditUsersPrivateData — salt okunur; yalnızca sayı ve kullanıcı kimliği döner
const OzelVeriDenetimi = ({ resolveUser, onAc }) => {
  const [sonuc, setSonuc] = useState(null);
  const [calisiyor, setCalisiyor] = useState(false);
  const [hata, setHata] = useState(null);
  const calistir = async () => {
    setCalisiyor(true);
    setHata(null);
    try { setSonuc(await grup3Cagir("auditUsersPrivateData", {})); } catch (e) { setHata(grup3Hata(e)); } finally { setCalisiyor(false); }
  };
  const ornekler = (liste) => (liste || []).length === 0 ? <span style={{ color: "#cbd5e1" }}>—</span> : (
    <span style={{ display: "inline-flex", flexWrap: "wrap", gap: "4px" }}>
      {liste.map((uid) => {
        const r = resolveUser ? resolveUser(uid) : null;
        const acilabilir = r && r.raw && !r.missing;
        return (
          <button key={uid} onClick={() => acilabilir && onAc(r)} disabled={!acilabilir} title={uid}
            style={{ padding: "2px 8px", borderRadius: "6px", border: "1px solid #e2e8f0", background: acilabilir ? "#eef2ff" : "#f8fafc", color: acilabilir ? "#3730a3" : "#94a3b8", fontSize: "11px", cursor: acilabilir ? "pointer" : "default" }}>
            {(r && !r.missing && r.name) || uid.slice(0, 10) + "…"}
          </button>
        );
      })}
    </span>
  );
  const td = { padding: "8px 10px", fontSize: "13px", color: "#334155", borderBottom: "1px solid #f1f5f9", verticalAlign: "top" };
  return (
    <div style={grup3Stil.kart}>
      <h4 style={grup3Stil.baslik}>3.0 users özel veri denetimi</h4>
      <p style={grup3Stil.aciklama}>Bütün users belgelerini okur, hiçbir şey yazmaz; alan değeri göstermez. Apple taşımasından önce ve sonra çalıştırın.</p>
      <button onClick={calistir} disabled={calisiyor} style={grup3Stil.dugme("#1e1b4b", calisiyor)}><Grup3Donen acik={calisiyor} />Denetle</button>
      <Grup3Hata hata={hata} />
      {sonuc && (
        <>
          <p style={{ fontSize: "12px", color: "#64748b", margin: "12px 0 6px" }}>Taranan kullanıcı: <strong>{sonuc.taranan}</strong></p>
          <div style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <tbody>
                <tr><td style={td}>Eski base64 belge (fileData)</td><td style={{ ...td, textAlign: "right" }}>{sonuc.base64Belge?.kullanici ?? 0} kullanıcı · {sonuc.base64Belge?.kayit ?? 0} kayıt</td><td style={td}>{ornekler(sonuc.base64Belge?.ornek)}</td></tr>
                <tr><td style={td}>Base64 fotoğraf</td><td style={{ ...td, textAlign: "right" }}>{sonuc.base64Foto?.kullanici ?? 0} kullanıcı · {sonuc.base64Foto?.kayit ?? 0} kayıt</td><td style={td}>{ornekler(sonuc.base64Foto?.ornek)}</td></tr>
                <tr><td style={td}>TC kimlik alanı{(sonuc.tcAlani?.alanlar || []).length ? ` (${sonuc.tcAlani.alanlar.join(", ")})` : ""}</td><td style={{ ...td, textAlign: "right" }}>{sonuc.tcAlani?.kullanici ?? 0} kullanıcı</td><td style={td}>{ornekler(sonuc.tcAlani?.ornek)}</td></tr>
                <tr><td style={td}>Apple belirteci users'ta (appleRefreshToken)</td><td style={{ ...td, textAlign: "right", fontWeight: "600", color: sonuc.appleBelirteci?.kullanici ? "#b45309" : "#15803d" }}>{sonuc.appleBelirteci?.kullanici ?? 0} kullanıcı</td><td style={td}><span style={{ color: "#94a3b8", fontSize: "12px" }}>taşımadan sonra 0 olmalı</span></td></tr>
              </tbody>
            </table>
          </div>
          <p style={{ fontSize: "11px", color: "#94a3b8", margin: "6px 0 0" }}>Örnekler en çok 20 kimlik; ada tıklayınca kullanıcı detayı açılır.</p>
          <Grup3Ham veri={sonuc} />
        </>
      )}
    </div>
  );
};

// 3.1-d migrateAppleTokens — users.appleRefreshToken → appleTokens/{uid}
const AppleBelirtecTasima = () => {
  const [limit, setLimit] = useState("500");
  const [sonuc, setSonuc] = useState(null);
  const [calisiyor, setCalisiyor] = useState(null);
  const [hata, setHata] = useState(null);
  const sinir = Math.min(2000, Math.max(1, Math.floor(Number(limit)) || 500));
  const calistir = async (dryRun) => {
    if (!dryRun && !window.confirm(`Apple belirteçleri appleTokens'a taşınacak ve users'tan silinecek (bir çağrıda en çok ${sinir} hesap).\n\nBu işlem canlı veriyi değiştirir. Emin misin?`)) return;
    setCalisiyor(dryRun ? "kuru" : "gercek");
    setHata(null);
    try { setSonuc(await grup3Cagir("migrateAppleTokens", { dryRun, limit: sinir })); } catch (e) { setHata(grup3Hata(e)); } finally { setCalisiyor(null); }
  };
  const kalanOlabilir = sonuc && !sonuc.dryRun && sonuc.bulunan >= sinir;
  return (
    <div style={grup3Stil.kart}>
      <h4 style={grup3Stil.baslik}>3.1-d Apple belirteçlerini appleTokens'a taşı</h4>
      <p style={grup3Stil.aciklama}>
        users'ta appleRefreshToken'ı olan hesaplar: belirteç appleTokens/{"{uid}"}'e kopyalanır, users'taki alan silinir. appleTokens'ta daha yeni belirteç varsa üzerine yazılmaz.
        Sıra: denetim (Apple sayısı N) → kuru (bulunan N) → taşı (silinen N, hata 0) → denetim (0). Gerçek taşımayı canlı doğrulamanın 2. ve 3. adımlarından sonra yapın.
      </p>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", alignItems: "center" }}>
        <label style={{ fontSize: "13px", color: "#334155", display: "flex", alignItems: "center", gap: "6px" }}>
          Çağrı başına en çok <input type="number" min="1" max="2000" value={limit} onChange={(e) => setLimit(e.target.value)} disabled={!!calisiyor} style={grup3Stil.girdi} /> hesap
        </label>
        <button onClick={() => calistir(true)} disabled={!!calisiyor} style={grup3Stil.dugme("#1e1b4b", !!calisiyor)}><Grup3Donen acik={calisiyor === "kuru"} />Kuru çalıştır</button>
        <button onClick={() => calistir(false)} disabled={!!calisiyor} style={grup3Stil.dugme("#dc2626", !!calisiyor)}><Grup3Donen acik={calisiyor === "gercek"} />Taşı</button>
      </div>
      <Grup3Hata hata={hata} />
      {sonuc && (
        <>
          <p style={{ fontSize: "12px", fontWeight: "600", color: sonuc.dryRun ? "#1e293b" : "#b91c1c", margin: "12px 0 0" }}>{sonuc.dryRun ? "Kuru çalıştırma — hiçbir şey yazılmadı" : "Gerçek çalıştırma sonucu"}</p>
          <Grup3Sayilar satirlar={[
            ["bulunan", sonuc.bulunan],
            ["taşınan", sonuc.tasinan],
            ["appleTokens'ta zaten vardı", sonuc.zatenVardi],
            ["users'tan silinen", sonuc.silinen],
            ["hata", sonuc.hata, sonuc.hata ? "#b91c1c" : undefined],
            ["kuru mu", sonuc.dryRun ? "evet" : "hayır"],
          ]} />
          {kalanOlabilir && <p style={{ fontSize: "12px", color: "#b45309", margin: "8px 0 0" }}>Bulunan sayısı sınıra eşit: kalan hesaplar olabilir, "Taşı"yı yeniden çalıştırın (taşınanlar artık sorguya girmez).</p>}
          <Grup3Ham veri={sonuc} />
        </>
      )}
    </div>
  );
};

// Sayfalı doldurma (backfillContactInfo / backfillPublicProfiles): kuru ya da gerçek; "Devam" aynı
// ayarla baslangic: sonraki gönderir. Sayılar sayfa sayfa toplanır.
const SayfaliDoldurma = ({ baslik, aciklama, fnAdi, koleksiyonlar = null, sayiAlanlari, ekBilgi = null }) => {
  const [koleksiyon, setKoleksiyon] = useState(koleksiyonlar ? koleksiyonlar[0].id : null);
  const [limit, setLimit] = useState("300");
  const [calisma, setCalisma] = useState(null); // { dryRun, koleksiyon, limit, sayfalar, toplam, sonraki, son }
  const [calisiyor, setCalisiyor] = useState(false);
  const [hata, setHata] = useState(null);
  const sinir = Math.min(1000, Math.max(1, Math.floor(Number(limit)) || 300));
  const kolAd = (id) => (koleksiyonlar ? (koleksiyonlar.find((k) => k.id === id) || {}).ad || id : "");

  const sayfa = async (dryRun, devam) => {
    const ayar = devam ? { dryRun: calisma.dryRun, koleksiyon: calisma.koleksiyon, limit: calisma.limit } : { dryRun, koleksiyon, limit: sinir };
    if (!devam && !ayar.dryRun) {
      const ne = koleksiyonlar ? `${kolAd(ayar.koleksiyon)} için ` : "";
      if (!window.confirm(`${ne}${baslik} yazılacak (sayfa başına ${ayar.limit} belge; sonraki sayfalar "Devam" ile).\n\nBu işlem canlı veriyi değiştirir. Emin misin?`)) return;
    }
    setCalisiyor(true);
    setHata(null);
    try {
      const girdi = { dryRun: ayar.dryRun, limit: ayar.limit };
      if (koleksiyonlar) girdi.koleksiyon = ayar.koleksiyon;
      if (devam && calisma.sonraki) girdi.baslangic = calisma.sonraki;
      const r = await grup3Cagir(fnAdi, girdi);
      const onceki = devam ? calisma.toplam : {};
      const toplam = {};
      ["taranan", ...sayiAlanlari.map(([k]) => k)].forEach((k) => { toplam[k] = (onceki[k] || 0) + (Number(r[k]) || 0); });
      setCalisma({ ...ayar, sayfalar: (devam ? calisma.sayfalar : 0) + 1, toplam, sonraki: r.sonraki || null, son: r });
    } catch (e) {
      setHata(grup3Hata(e));
    } finally {
      setCalisiyor(false);
    }
  };

  const bitti = calisma && !calisma.sonraki;
  return (
    <div style={grup3Stil.kart}>
      <h4 style={grup3Stil.baslik}>{baslik}</h4>
      <p style={grup3Stil.aciklama}>{aciklama}</p>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", alignItems: "center" }}>
        {koleksiyonlar && (
          <select value={koleksiyon} onChange={(e) => setKoleksiyon(e.target.value)} disabled={calisiyor} style={grup3Stil.secim}>
            {koleksiyonlar.map((k) => <option key={k.id} value={k.id}>{k.ad}</option>)}
          </select>
        )}
        <label style={{ fontSize: "13px", color: "#334155", display: "flex", alignItems: "center", gap: "6px" }}>
          Sayfa başına <input type="number" min="1" max="1000" value={limit} onChange={(e) => setLimit(e.target.value)} disabled={calisiyor} style={grup3Stil.girdi} /> belge
        </label>
        <button onClick={() => sayfa(true, false)} disabled={calisiyor} style={grup3Stil.dugme("#1e1b4b", calisiyor)}><Grup3Donen acik={calisiyor && !calisma} />Kuru çalıştır</button>
        <button onClick={() => sayfa(false, false)} disabled={calisiyor} style={grup3Stil.dugme("#dc2626", calisiyor)}>Doldur</button>
        {calisma && calisma.sonraki && (
          <button onClick={() => sayfa(null, true)} disabled={calisiyor} style={grup3Stil.dugme(calisma.dryRun ? "#475569" : "#b45309", calisiyor)}>
            <Grup3Donen acik={calisiyor} />Devam ({calisma.dryRun ? "kuru" : "gerçek"}, {calisma.sayfalar + 1}. sayfa)
          </button>
        )}
        {ekBilgi}
      </div>
      <Grup3Hata hata={hata} />
      {calisma && (
        <>
          <p style={{ fontSize: "12px", fontWeight: "600", color: calisma.dryRun ? "#1e293b" : "#b91c1c", margin: "12px 0 0" }}>
            {calisma.dryRun ? "Kuru çalıştırma — hiçbir şey yazılmadı" : "Gerçek çalıştırma"}
            {koleksiyonlar ? ` · ${kolAd(calisma.koleksiyon)}` : ""} · {calisma.sayfalar} sayfa (sayfa başına {calisma.limit})
            {bitti ? " · son sayfaya ulaşıldı" : " · devam eden sayfalar var"}
          </p>
          <Grup3Sayilar satirlar={[["taranan", calisma.toplam.taranan], ...sayiAlanlari.map(([k, etiket, vurgu]) => [etiket, calisma.toplam[k], vurgu && calisma.toplam[k] ? vurgu : undefined])]} />
          {bitti && calisma.dryRun && calisma.toplam.yazilacak === 0 && <p style={{ fontSize: "12px", color: "#15803d", margin: "8px 0 0" }}>Yazılacak belge kalmadı.</p>}
          <Grup3Ham veri={calisma.son} />
        </>
      )}
    </div>
  );
};

// 29 Ekim eki: örnek sayısı girdisi (sunucu: varsayılan 20, 0–500)
const grup3OrnekSayisi = (v) => {
  const n = Math.floor(Number(v));
  return Number.isFinite(n) ? Math.min(500, Math.max(0, n)) : 20;
};

// fixBlockedDates — 1.0.30 ve öncesinin bir gün geride yazdığı users.blockedDates'i takvimdeki güne çevirir.
// Gerçek çalıştırma zorunlu güncellemeden (Z1) sonra: o zamana kadar eski sürümdeki uzman kendi takviminde
// izin günlerini bir gün kaymış görür. Açmak için IZIN_GUNU_DUZELTME_ACIK = true.
const IZIN_GUNU_DUZELTME_ACIK = false;
const IzinGunuDuzeltme = ({ resolveUser }) => {
  const [ornek, setOrnek] = useState("20");
  const [sonuc, setSonuc] = useState(null);
  const [calisiyor, setCalisiyor] = useState(null);
  const [hata, setHata] = useState(null);
  const calistir = async (dryRun) => {
    if (!dryRun) {
      if (!IZIN_GUNU_DUZELTME_ACIK) return;
      if (!window.confirm("Eski biçimdeki bütün izin günleri bir gün ileri kaydırılacak (users.blockedDates; eski liste blockedDatesEski'ye yazılır).\n\nZorunlu güncellemeden önce çalıştırılırsa eski sürümdeki uzmanlar kendi takvimlerinde izin günlerini bir gün sonra görür.\n\nBu işlem canlı veriyi değiştirir. Emin misin?")) return;
    }
    setCalisiyor(dryRun ? "kuru" : "gercek");
    setHata(null);
    try { setSonuc(await grup3Cagir("fixBlockedDates", { dryRun, ornek: grup3OrnekSayisi(ornek) })); } catch (e) { setHata(grup3Hata(e)); } finally { setCalisiyor(null); }
  };
  const td = { padding: "6px 8px", fontSize: "12px", color: "#334155", borderBottom: "1px solid #f1f5f9", verticalAlign: "top" };
  const gunler = (l) => (Array.isArray(l) && l.length ? l.map(String).join(", ") : "—");
  return (
    <div style={grup3Stil.kart}>
      <h4 style={grup3Stil.baslik}>29 Ekim: izin günü kayması (fixBlockedDates)</h4>
      <p style={grup3Stil.aciklama}>
        1.0.30 ve öncesi, takvimde işaretlenen izin gününü bir gün önce yazıyordu (5 Kasım → "2026-11-04"). Bütün users taranır; blockedDates'i dolu ve blockedDatesBicim 2 olmayanlar düzeltilir:
        düz günler bir gün ileri, tam zaman damgaları İstanbul gününe, bozuk değerler atılır. Gerçekte blockedDatesBicim: 2 ve eski liste (blockedDatesEski) yazılır; ikinci çalıştırma bir şey değiştirmez.
        Sıra: kuru → sayıları ve örnekleri kontrol et → düzelt → kuru yeniden: düzeltilecek uzman 0.
      </p>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", alignItems: "center" }}>
        <label style={{ fontSize: "13px", color: "#334155", display: "flex", alignItems: "center", gap: "6px" }}>
          Örnek <input type="number" min="0" max="500" value={ornek} onChange={(e) => setOrnek(e.target.value)} disabled={!!calisiyor} style={grup3Stil.girdi} />
        </label>
        <button onClick={() => calistir(true)} disabled={!!calisiyor} style={grup3Stil.dugme("#1e1b4b", !!calisiyor)}><Grup3Donen acik={calisiyor === "kuru"} />Kuru çalıştır</button>
        <button onClick={() => calistir(false)} disabled={!IZIN_GUNU_DUZELTME_ACIK || !!calisiyor} style={grup3Stil.dugme("#dc2626", !IZIN_GUNU_DUZELTME_ACIK || !!calisiyor)}
          title={IZIN_GUNU_DUZELTME_ACIK ? "" : "Zorunlu güncellemeden sonra çalıştırılacak"}>
          <Grup3Donen acik={calisiyor === "gercek"} />Düzelt
        </button>
        {!IZIN_GUNU_DUZELTME_ACIK && <span style={{ fontSize: "12px", fontWeight: "600", color: "#b45309" }}>Zorunlu güncellemeden sonra çalıştırılacak</span>}
      </div>
      <Grup3Hata hata={hata} />
      {sonuc && (
        <>
          <p style={{ fontSize: "12px", fontWeight: "600", color: sonuc.dryRun ? "#1e293b" : "#b91c1c", margin: "12px 0 0" }}>{sonuc.dryRun ? "Kuru çalıştırma — hiçbir şey yazılmadı" : "Gerçek çalıştırma sonucu"}</p>
          <Grup3Sayilar satirlar={[
            ["taranan kullanıcı", sonuc.taranan],
            ["izin günü olan", sonuc.izinGunuOlan],
            ["zaten yeni biçim (1.0.31)", sonuc.zatenYeniBicim],
            ["düzeltilecek uzman", sonuc.duzeltilecekUzman, sonuc.duzeltilecekUzman ? "#b45309" : "#15803d"],
            ["kaydırılan gün", sonuc.kaydirilanGun],
            ["zaman damgalı", sonuc.zamanDamgali],
            ["atılan geçersiz", sonuc.atilanGecersiz, sonuc.atilanGecersiz ? "#b91c1c" : undefined],
            ...(sonuc.dryRun ? [] : [["yazılan", sonuc.yazilan], ["değiştiği için atlanan", sonuc.degistigiIcinAtlanan, sonuc.degistigiIcinAtlanan ? "#b45309" : undefined]]),
          ]} />
          {(sonuc.ornekler || []).length > 0 && (
            <div style={{ overflowX: "auto", marginTop: "12px" }}>
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead><tr>{["Kullanıcı", "Tür", "Önce (ilk 5)", "Sonra (ilk 5)"].map((b) => <th key={b} style={{ ...td, textAlign: "left", fontWeight: "600", color: "#475569", background: "#f8fafc" }}>{b}</th>)}</tr></thead>
                <tbody>
                  {sonuc.ornekler.map((o) => {
                    const r = resolveUser ? resolveUser(o.uid) : null;
                    return (
                      <tr key={o.uid}>
                        <td style={td}>
                          <div>{(r && !r.missing && r.name) || "—"}</div>
                          <div style={{ fontSize: "11px", color: "#94a3b8", fontFamily: "monospace" }}>{o.uid}</div>
                        </td>
                        <td style={td}>{o.userType || "—"}</td>
                        <td style={{ ...td, fontFamily: "monospace" }}>{gunler(o.once)}</td>
                        <td style={{ ...td, fontFamily: "monospace", color: "#15803d" }}>{gunler(o.sonra)}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              {sonuc.duzeltilecekUzman > sonuc.ornekler.length && <p style={{ fontSize: "11px", color: "#94a3b8", margin: "6px 0 0" }}>{sonuc.duzeltilecekUzman} hesaptan ilk {sonuc.ornekler.length} örnek.</p>}
            </div>
          )}
          <Grup3Ham veri={sonuc} />
        </>
      )}
    </div>
  );
};

// purgeDeletedAccountContacts — silinmiş hesapların (deletedAccounts kaydı olan ya da Auth'ta olmayan customerId)
// jobs / requests belgelerinden address, customerPhone, phone, customerEmail ve private/contact silinir; il, ilçe
// ve ad kalır. Değer dönmez, yalnızca sayılar ve yollar. "Temizle" ancak bir kuru çalıştırmadan sonra açılır.
const SILINMIS_HESAP_ALANLARI = ["address", "customerPhone", "phone", "customerEmail"];
const SilinmisHesapIletisimTemizligi = () => {
  const [ornek, setOrnek] = useState("20");
  const [sonuc, setSonuc] = useState(null);
  const [sonKuru, setSonKuru] = useState(null);
  const [calisiyor, setCalisiyor] = useState(null);
  const [hata, setHata] = useState(null);
  const calistir = async (dryRun) => {
    if (!dryRun) {
      if (!sonKuru) return;
      const b = sonKuru.belge || {};
      const uyarilar = [
        sonKuru.adiAnonimDegil ? `• ${sonKuru.adiAnonimDegil} belgede ad "Silinmiş Kullanıcı" değil.` : null,
        sonKuru.kaydiVarAmaAuthtaVar ? `• ${sonKuru.kaydiVarAmaAuthtaVar} hesabın deletedAccounts kaydı var ama Auth'ta hâlâ duruyor.` : null,
      ].filter(Boolean);
      if (!window.confirm(
        `Son kuru çalıştırmaya göre ${b.jobs || 0} ilan ve ${b.requests || 0} talepten adres, telefon ve e-posta, ${sonKuru.altBelge || 0} private/contact alt belgesi silinecek.\n\n` +
        (uyarilar.length ? `Kontrol et:\n${uyarilar.join("\n")}\n\n` : "") +
        "Silinen değerler hiçbir yerde saklanmaz; GERİ ALINAMAZ. Emin misin?"
      )) return;
    }
    setCalisiyor(dryRun ? "kuru" : "gercek");
    setHata(null);
    try {
      const r = await grup3Cagir("purgeDeletedAccountContacts", { dryRun, ornek: grup3OrnekSayisi(ornek) }, GRUP3_UZUN_ZAMAN_ASIMI_MS);
      setSonuc(r);
      setSonKuru(r.dryRun ? r : null);
    } catch (e) { setHata(grup3Hata(e)); } finally { setCalisiyor(null); }
  };
  const td = { padding: "6px 8px", fontSize: "12px", color: "#334155", borderBottom: "1px solid #f1f5f9", verticalAlign: "top" };
  const temizlePasif = !sonKuru || !!calisiyor;
  return (
    <div style={grup3Stil.kart}>
      <h4 style={grup3Stil.baslik}>29 Ekim: silinmiş hesapların ilan ve taleplerinde iletişim bilgisi (purgeDeletedAccountContacts)</h4>
      <p style={grup3Stil.aciklama}>
        1.0.31'den önce silinen hesapların ilan ve taleplerinde adres, telefon ve e-posta kaldı. jobs ve requests'in tamamı taranır; customerId'si için deletedAccounts kaydı olan ya da Auth'ta bulunmayan belgelerden
        address, customerPhone, phone, customerEmail ve private/contact silinir; il, ilçe, ad ve durum kalır. Değer dönmez. Sıra: kuru → kontrol → temizle → kuru yeniden: belge 0 / 0.
      </p>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", alignItems: "center" }}>
        <label style={{ fontSize: "13px", color: "#334155", display: "flex", alignItems: "center", gap: "6px" }}>
          Örnek <input type="number" min="0" max="500" value={ornek} onChange={(e) => setOrnek(e.target.value)} disabled={!!calisiyor} style={grup3Stil.girdi} />
        </label>
        <button onClick={() => calistir(true)} disabled={!!calisiyor} style={grup3Stil.dugme("#1e1b4b", !!calisiyor)}><Grup3Donen acik={calisiyor === "kuru"} />Kuru çalıştır</button>
        <button onClick={() => calistir(false)} disabled={temizlePasif} style={grup3Stil.dugme("#dc2626", temizlePasif)} title={sonKuru ? "" : "Önce kuru çalıştırın"}>
          <Grup3Donen acik={calisiyor === "gercek"} />Temizle
        </button>
        {calisiyor && <span style={{ fontSize: "12px", color: "#64748b" }}>Bütün ilan ve talepler okunuyor; birkaç dakika sürebilir.</span>}
      </div>
      <Grup3Hata hata={hata} />
      {sonuc && (
        <>
          <p style={{ fontSize: "12px", fontWeight: "600", color: sonuc.dryRun ? "#1e293b" : "#b91c1c", margin: "12px 0 0" }}>{sonuc.dryRun ? "Kuru çalıştırma — hiçbir şey yazılmadı" : "Gerçek çalıştırma sonucu"}</p>
          <Grup3Sayilar satirlar={[
            ["taranan ilan", sonuc.taranan?.jobs],
            ["taranan talep", sonuc.taranan?.requests],
            ["farklı müşteri", sonuc.musteri],
            ["silinmiş hesap", sonuc.silinmisHesap],
            ["deletedAccounts kaydı", sonuc.deletedAccountsKaydi],
            ["Auth'ta yok", sonuc.authtaYok],
            ["kaydı var ama Auth'ta var", sonuc.kaydiVarAmaAuthtaVar, sonuc.kaydiVarAmaAuthtaVar ? "#b45309" : undefined],
            ["temizlenecek ilan", sonuc.belge?.jobs, sonuc.belge?.jobs ? "#b45309" : "#15803d"],
            ["temizlenecek talep", sonuc.belge?.requests, sonuc.belge?.requests ? "#b45309" : "#15803d"],
            ["private/contact", sonuc.altBelge],
            ["adı anonim", sonuc.adiAnonim],
            ["adı anonim değil", sonuc.adiAnonimDegil, sonuc.adiAnonimDegil ? "#b45309" : undefined],
            ...(sonuc.dryRun ? [] : [["yazılan belge", sonuc.yazilanBelge], ["silinen alt belge", sonuc.silinenAltBelge]]),
          ]} />
          <p style={{ fontSize: "12px", color: "#475569", margin: "10px 0 0" }}>
            Alan başına belge: {SILINMIS_HESAP_ALANLARI.map((a) => `${a} ${(sonuc.alan || {})[a] ?? 0}`).join(" · ")}
          </p>
          {sonuc.dryRun && (sonuc.adiAnonimDegil > 0 || sonuc.kaydiVarAmaAuthtaVar > 0) && (
            <div style={{ marginTop: "10px", background: "#fffbeb", border: "1px solid #fde68a", borderRadius: "10px", padding: "10px 12px", fontSize: "12px", color: "#92400e" }}>
              Gerçek çalıştırmadan önce kontrol et: adı anonim olmayan belgeler ve deletedAccounts kaydı olup Auth'ta duran hesaplar. Auth'ta hiç olmamış bir customerId ile elle ya da tohum verisiyle açılmış ilanlar da "Auth'ta yok" sayılır; temizlenmesin isteniyorsa önce ayıklanmalı.
            </div>
          )}
          {(sonuc.ornekler || []).length > 0 && (
            <div style={{ overflowX: "auto", marginTop: "12px" }}>
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead><tr>{["Belge", "Silinecek alanlar", "private/contact", "Neden"].map((b) => <th key={b} style={{ ...td, textAlign: "left", fontWeight: "600", color: "#475569", background: "#f8fafc" }}>{b}</th>)}</tr></thead>
                <tbody>
                  {sonuc.ornekler.map((o) => (
                    <tr key={o.yol}>
                      <td style={td}><button onClick={() => konsoluAc(o.yol)} style={{ ...konsolDugmesi, fontFamily: "monospace", fontSize: "11px" }}>{o.yol}</button></td>
                      <td style={td}>{(o.alanlar || []).length ? o.alanlar.join(", ") : "—"}</td>
                      <td style={td}>{o.altBelge ? "var" : "—"}</td>
                      <td style={td}>{o.neden === "deletedAccounts" ? "deletedAccounts kaydı" : o.neden === "auth_yok" ? "Auth'ta yok" : o.neden || "—"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          <Grup3Ham veri={sonuc} />
        </>
      )}
    </div>
  );
};

// countAuthlessUsers — SALT OKUNUR: Console'dan Auth'u silinmiş ama users belgesi duran hesaplar
// (functions/authsuzKullanicilar.js). Hiçbir şey yazmaz; ad, e-posta, telefon dönmez. Onay penceresi yok.
const AUTHSUZ_ROL_AD = { uzman: "uzman", musteri: "müşteri", diger: "diğer", rolYok: "rol yok" };
const AuthsuzKullaniciSayimi = ({ resolveUser, onAc }) => {
  const [ornek, setOrnek] = useState("50");
  const [yeniDakika, setYeniDakika] = useState("10");
  const [sonuc, setSonuc] = useState(null);
  const [calisiyor, setCalisiyor] = useState(false);
  const [hata, setHata] = useState(null);
  const calistir = async () => {
    const n = Math.floor(Number(ornek));
    const dk = Number(yeniDakika);
    setCalisiyor(true);
    setHata(null);
    try {
      setSonuc(await grup3Cagir("countAuthlessUsers", {
        ornek: Number.isFinite(n) ? Math.min(500, Math.max(0, n)) : 50,
        yeniDakika: Number.isFinite(dk) ? Math.min(60, Math.max(0, dk)) : 10,
      }, GRUP3_UZUN_ZAMAN_ASIMI_MS));
    } catch (e) { setHata(grup3Hata(e)); } finally { setCalisiyor(false); }
  };
  const td = { padding: "6px 8px", fontSize: "12px", color: "#334155", borderBottom: "1px solid #f1f5f9", verticalAlign: "top", whiteSpace: "nowrap" };
  const sayi = (v) => (v === undefined || v === null ? <span style={{ color: "#cbd5e1" }}>—</span> : v || <span style={{ color: "#cbd5e1" }}>0</span>);
  const evet = (v, renk = "#b91c1c") => (v ? <span style={{ fontWeight: "600", color: renk }}>evet</span> : <span style={{ color: "#cbd5e1" }}>—</span>);
  const rol = (sonuc && sonuc.rol) || {};
  const etki = (sonuc && sonuc.etki) || {};
  return (
    <div style={grup3Stil.kart}>
      <h4 style={grup3Stil.baslik}>29 Ekim: Auth kaydı olmayan users belgeleri (countAuthlessUsers, salt okunur)</h4>
      <p style={grup3Stil.aciklama}>
        Firebase Console'dan elle silinen hesapların yalnızca Auth kaydı gider; users belgesi, ilanları, talepleri ve hizmetleri kalır. Böyle bir uzman listelerde görünür, talep ve A3 bildirimi alır.
        Auth'taki bütün uid'ler ve users'ın tamamı okunur; admin ve test hesapları aday sayılmaz. Hiçbir şey yazmaz; ad, e-posta, telefon dönmez. Sık çalıştırılacak bir iş değil. Temizlik ayrı karar.
      </p>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", alignItems: "center" }}>
        <label style={{ fontSize: "13px", color: "#334155", display: "flex", alignItems: "center", gap: "6px" }}>
          Örnek <input type="number" min="0" max="500" value={ornek} onChange={(e) => setOrnek(e.target.value)} disabled={calisiyor} style={grup3Stil.girdi} />
        </label>
        <label style={{ fontSize: "13px", color: "#334155", display: "flex", alignItems: "center", gap: "6px" }}>
          Son <input type="number" min="0" max="60" value={yeniDakika} onChange={(e) => setYeniDakika(e.target.value)} disabled={calisiyor} style={grup3Stil.girdi} /> dakikada oluşanları sayma
        </label>
        <button onClick={calistir} disabled={calisiyor} style={grup3Stil.dugme("#1e1b4b", calisiyor)}><Grup3Donen acik={calisiyor} />Say</button>
        {calisiyor && <span style={{ fontSize: "12px", color: "#64748b" }}>Auth ve bütün users okunuyor; birkaç dakika sürebilir.</span>}
      </div>
      <Grup3Hata hata={hata} />
      {sonuc && (
        <>
          {sonuc.listelerdeGorunenUzman > 0 && (
            <div style={{ marginTop: "12px", background: "#fef2f2", border: "1px solid #fecaca", borderRadius: "10px", padding: "10px 12px", fontSize: "13px", color: "#991b1b" }}>
              <strong>Auth kaydı olmayan {sonuc.listelerdeGorunenUzman} uzman listelerde görünüyor.</strong> Tüm Uzmanlar, arama, harita, Hizmetler ve ana sayfa sayılarında çıkıyor; doğrudan talep ve yeni ilan bildirimi (A3) alabiliyor. Bu hesaplarla iletişim kurulamaz.
            </div>
          )}
          <Grup3Sayilar satirlar={[
            ["taranan users", sonuc.taranan],
            ["Auth'taki kullanıcı", sonuc.authKullanici],
            ["Auth'ta yok", sonuc.authsuz, sonuc.authsuz ? "#b45309" : "#15803d"],
            ["yeni oluşturulan (sayılmadı)", sonuc.yeniOlusturulan],
            ["admin (sayılmadı)", sonuc.admin],
            ["test hesabı (sayılmadı)", sonuc.testHesabi],
            ["aday", sonuc.aday, sonuc.aday ? "#b91c1c" : "#15803d"],
            ["uzman", rol.uzman],
            ["müşteri", rol.musteri],
            ["diğer rol", rol.diger],
            ["rol yok", rol.rolYok],
            ["listelerde görünen uzman", sonuc.listelerdeGorunenUzman, sonuc.listelerdeGorunenUzman ? "#b91c1c" : "#15803d"],
            ["kimlik onaylı uzman", sonuc.kimlikOnayliUzman],
            ["bildirim anahtarı olan", sonuc.bildirimAnahtariOlan],
            ["deleted işaretli", sonuc.deletedIsaretli],
            ["deletedAccounts kaydı olan", sonuc.deletedAccountsKaydiOlan],
            ["herkese açık profili olan", sonuc.herkeseAcikProfiliOlan],
          ]} />
          <p style={{ fontSize: "12px", fontWeight: "600", color: "#334155", margin: "14px 0 0" }}>
            Etki ({sonuc.etkiHesaplanan ?? 0} aday{sonuc.aday > (sonuc.etkiHesaplanan ?? 0) ? `; ilk ${sonuc.etkiHesaplanan} aday için hesaplandı` : ""})
          </p>
          <Grup3Sayilar satirlar={[
            ["açık ilan", etki.acikIlan, etki.acikIlan ? "#b45309" : undefined],
            ["açık talep (müşteri)", etki.acikTalepMusteri, etki.acikTalepMusteri ? "#b45309" : undefined],
            ["açık talep (uzmana)", etki.acikTalepUzman, etki.acikTalepUzman ? "#b45309" : undefined],
            ["aktif hizmet", etki.aktifHizmet, etki.aktifHizmet ? "#b45309" : undefined],
            ["konuşma", etki.konusma],
            ["açık ilan/talebi olan aday", etki.adayIleIlan],
            ["aktif hizmeti olan aday", etki.adayIleHizmet],
          ]} />
          {(sonuc.ornekler || []).length > 0 && (
            <div style={{ overflowX: "auto", marginTop: "12px" }}>
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead>
                  <tr>{["Kullanıcı", "Rol", "Oluşturma", "Listelerde", "Kimlik", "Bildirim", "deleted", "deletedAccounts", "Açık profil", "Açık ilan", "Talep (müşteri)", "Talep (uzmana)", "Aktif hizmet", "Konuşma"].map((b) => (
                    <th key={b} style={{ ...td, textAlign: "left", fontWeight: "600", color: "#475569", background: "#f8fafc" }}>{b}</th>
                  ))}</tr>
                </thead>
                <tbody>
                  {sonuc.ornekler.map((o) => {
                    const r = resolveUser ? resolveUser(o.uid) : null;
                    const acilabilir = !!(r && r.raw && !r.missing);
                    return (
                      <tr key={o.uid} style={{ background: o.listelerdeGorunur ? "#fef2f2" : "white" }}>
                        <td style={td}>
                          <button onClick={() => (acilabilir ? onAc(r) : konsoluAc(`users/${o.uid}`))}
                            title={acilabilir ? "Kullanıcı detayını aç" : "Panelde yok: Firestore konsolunda aç"}
                            style={{ ...konsolDugmesi, fontFamily: "monospace", fontSize: "11px", textAlign: "left" }}>
                            {o.uid}
                          </button>
                          <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
                            {acilabilir && <span style={{ fontSize: "11px", color: "#475569" }}>{r.name}</span>}
                            {acilabilir && <button onClick={() => konsoluAc(`users/${o.uid}`)} style={{ ...konsolDugmesi, fontSize: "11px", color: "#94a3b8" }}>konsol</button>}
                          </div>
                        </td>
                        <td style={td}>{AUTHSUZ_ROL_AD[o.rol] || o.rol || "—"}</td>
                        <td style={td}>{o.olusturmaGunu || "—"}</td>
                        <td style={td}>{evet(o.listelerdeGorunur)}</td>
                        <td style={td}>{evet(o.kimlikOnayli, "#334155")}</td>
                        <td style={td}>{evet(o.bildirimAnahtari, "#334155")}</td>
                        <td style={td}>{evet(o.deletedIsaretli, "#334155")}</td>
                        <td style={td}>{evet(o.deletedAccountsKaydi, "#334155")}</td>
                        <td style={td}>{evet(o.herkeseAcikProfil, "#334155")}</td>
                        <td style={td}>{sayi(o.acikIlan)}</td>
                        <td style={td}>{sayi(o.acikTalepMusteri)}</td>
                        <td style={td}>{sayi(o.acikTalepUzman)}</td>
                        <td style={td}>{sayi(o.aktifHizmet)}</td>
                        <td style={td}>{sayi(o.konusma)}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              <p style={{ fontSize: "11px", color: "#94a3b8", margin: "6px 0 0" }}>
                {sonuc.ornekler.length}{sonuc.aday > sonuc.ornekler.length ? ` / ${sonuc.aday}` : ""} örnek; listelerde görünenler önce (kırmızı satır), sonra açık iş ve hizmet sayısına göre.
                uid panelde varsa kullanıcı detayını, yoksa Firestore konsolunu açar. "—": etki hesaplanmadı.
              </p>
            </div>
          )}
          <Grup3Ham veri={sonuc} />
        </>
      )}
    </div>
  );
};

// ---- 30 Ekim: açık iletişim bilgisi (functions/sizintiTemizligi.js). Değer dönmez; yalnızca sayılar ve yollar ----
const grup3Td = { padding: "6px 8px", fontSize: "12px", color: "#334155", borderBottom: "1px solid #f1f5f9", verticalAlign: "top" };
const grup3Th = { ...grup3Td, textAlign: "left", fontWeight: "600", color: "#475569", background: "#f8fafc", whiteSpace: "nowrap" };
const Grup3Ornekler = ({ basliklar, satirlar }) => (
  <div style={{ overflowX: "auto", marginTop: "12px" }}>
    <table style={{ width: "100%", borderCollapse: "collapse" }}>
      <thead><tr>{basliklar.map((b) => <th key={b} style={grup3Th}>{b}</th>)}</tr></thead>
      <tbody>{satirlar}</tbody>
    </table>
  </div>
);
const Grup3OrnekGirdisi = ({ deger, setDeger, pasif }) => (
  <label style={{ fontSize: "13px", color: "#334155", display: "flex", alignItems: "center", gap: "6px" }}>
    Örnek <input type="number" min="0" max="500" value={deger} onChange={(e) => setDeger(e.target.value)} disabled={pasif} style={grup3Stil.girdi} />
  </label>
);
const yolDugmesi = (yol) => <button onClick={() => konsoluAc(yol)} style={{ ...konsolDugmesi, fontFamily: "monospace", fontSize: "11px", textAlign: "left" }}>{yol}</button>;

// countContactExposure — SALT OKUNUR: requests'teki destek kayıtları ve tekliflerdeki expertEmail
const IletisimSizintisiSayimi = () => {
  const [sonuc, setSonuc] = useState(null);
  const [calisiyor, setCalisiyor] = useState(false);
  const [hata, setHata] = useState(null);
  const calistir = async () => {
    setCalisiyor(true);
    setHata(null);
    try { setSonuc(await grup3Cagir("countContactExposure", {})); } catch (e) { setHata(grup3Hata(e)); } finally { setCalisiyor(false); }
  };
  const destek = (sonuc && sonuc.destek) || {};
  const teklif = (sonuc && sonuc.teklif) || {};
  const epostaliTeklif = ["jobs", "requests"].reduce((t, k) => t + ((teklif[k] && teklif[k].epostaliTeklif) || 0), 0);
  return (
    <div style={grup3Stil.kart}>
      <h4 style={grup3Stil.baslik}>30 Ekim: açık iletişim bilgisi sayımı (countContactExposure, salt okunur)</h4>
      <p style={grup3Stil.aciklama}>
        requests'te requestType "support_ticket" olan destek kayıtları (e-posta, telefon, mesaj; requests giriş yapan herkese açık) ve ilan / taleplerin proposals dizisindeki expertEmail.
        Hiçbir şey yazmaz; değer dönmez. Sıra: say → kural paketi 3.3 → destek kayıtlarını taşı → teklif e-postalarını sil → yeniden say.
      </p>
      <button onClick={calistir} disabled={calisiyor} style={grup3Stil.dugme("#1e1b4b", calisiyor)}><Grup3Donen acik={calisiyor} />Say</button>
      <Grup3Hata hata={hata} />
      {sonuc && (
        <>
          {(destek.kayit > 0 || epostaliTeklif > 0) && (
            <div style={{ marginTop: "12px", background: "#fef2f2", border: "1px solid #fecaca", borderRadius: "10px", padding: "10px 12px", fontSize: "13px", color: "#991b1b" }}>
              <strong>Açık iletişim bilgisi var:</strong>
              {destek.kayit > 0 ? ` requests'te ${destek.kayit} destek kaydı (${destek.iletisimli || 0} tanesinde e-posta ya da telefon dolu).` : ""}
              {epostaliTeklif > 0 ? ` ${epostaliTeklif} teklifte expertEmail.` : ""}
            </div>
          )}
          <p style={{ fontSize: "12px", fontWeight: "600", color: "#334155", margin: "14px 0 0" }}>Destek kayıtları (requests)</p>
          <Grup3Sayilar satirlar={[
            ["kayıt", destek.kayit, destek.kayit ? "#b91c1c" : "#15803d"],
            ["iletişim alanı dolu", destek.iletisimli, destek.iletisimli ? "#b91c1c" : undefined],
            ["userEmail", destek.alan?.userEmail],
            ["contactEmail", destek.alan?.contactEmail],
            ["contactPhone", destek.alan?.contactPhone],
            ["supportTickets'ta da var", destek.supportTicketsteVar],
            ["private/contact", destek.altBelge],
          ]} />
          {Object.keys(destek.durum || {}).length > 0 && (
            <p style={{ fontSize: "12px", color: "#475569", margin: "8px 0 0" }}>
              Durum: {Object.entries(destek.durum).sort((a, b) => b[1] - a[1]).map(([d, n]) => `${d} ${n}`).join(" · ")}
            </p>
          )}
          <p style={{ fontSize: "12px", fontWeight: "600", color: "#334155", margin: "14px 0 0" }}>Teklif e-postaları (proposals[].expertEmail)</p>
          <Grup3Ornekler
            basliklar={["Koleksiyon", "Taranan", "Teklifli belge", "Teklif", "E-postalı belge", "E-postalı teklif", "Dolu e-posta"]}
            satirlar={["jobs", "requests"].map((k) => {
              const r = teklif[k] || {};
              return (
                <tr key={k}>
                  <td style={grup3Td}>{k === "jobs" ? "İlanlar (jobs)" : "Talepler (requests)"}</td>
                  <td style={grup3Td}>{r.taranan ?? 0}</td>
                  <td style={grup3Td}>{r.teklifliBelge ?? 0}</td>
                  <td style={grup3Td}>{r.teklif ?? 0}</td>
                  <td style={{ ...grup3Td, fontWeight: r.epostaliBelge ? "700" : "400", color: r.epostaliBelge ? "#b91c1c" : "#334155" }}>{r.epostaliBelge ?? 0}</td>
                  <td style={{ ...grup3Td, fontWeight: r.epostaliTeklif ? "700" : "400", color: r.epostaliTeklif ? "#b91c1c" : "#334155" }}>{r.epostaliTeklif ?? 0}</td>
                  <td style={grup3Td}>{r.doluEposta ?? 0}</td>
                </tr>
              );
            })}
          />
          <Grup3Ham veri={sonuc} />
        </>
      )}
    </div>
  );
};

// moveSupportTicketsFromRequests — destek kayıtlarını supportTickets'a (aynı kimlik) taşır ve requests'ten siler.
// Kuru başlar; "Taşı" ancak bir önizlemeden sonra açılır ve onay ister.
const DESTEK_TASIMA_DURUM_AD = { tasinacak: "taşınacak", zaten_tasinmis: "zaten taşınmış (yalnızca kaynak silinir)", cakisma: "çakışma (dokunulmaz)" };
const DestekKayitTasima = () => {
  const [ornek, setOrnek] = useState("20");
  const [sonuc, setSonuc] = useState(null);
  const [sonKuru, setSonKuru] = useState(null);
  const [calisiyor, setCalisiyor] = useState(null);
  const [hata, setHata] = useState(null);
  const calistir = async (dryRun) => {
    if (!dryRun) {
      if (!sonKuru) return;
      if (!window.confirm(
        `Son önizlemeye göre ${sonKuru.tasinacak || 0} destek kaydı supportTickets'a kopyalanıp requests'ten silinecek` +
        `${sonKuru.zatenTasinmis ? `; ${sonKuru.zatenTasinmis} kaydın kopyası zaten var, yalnızca requests'teki kaynağı silinecek` : ""}` +
        `${sonKuru.altBelge ? `; ${sonKuru.altBelge} private/contact alt belgesi silinecek` : ""}.\n` +
        `${sonKuru.cakisma ? `${sonKuru.cakisma} çakışan kayda dokunulmayacak.\n` : ""}` +
        "\nKural paketi 3.3 yayında olmalı. Bu işlem canlı veriyi değiştirir. Emin misin?"
      )) return;
    }
    setCalisiyor(dryRun ? "kuru" : "gercek");
    setHata(null);
    try {
      const r = await grup3Cagir("moveSupportTicketsFromRequests", { dryRun, ornek: grup3OrnekSayisi(ornek) });
      setSonuc(r);
      setSonKuru(r.dryRun ? r : null);
    } catch (e) { setHata(grup3Hata(e)); } finally { setCalisiyor(null); }
  };
  const tasiPasif = !sonKuru || !!calisiyor;
  return (
    <div style={grup3Stil.kart}>
      <h4 style={grup3Stil.baslik}>30 Ekim: requests'teki destek kayıtlarını supportTickets'a taşı (moveSupportTicketsFromRequests)</h4>
      <p style={grup3Stil.aciklama}>
        Her destek kaydı supportTickets/{"{aynı kimlik}"}'e kopyalanır (requestType düşer, tasinma işareti eklenir; mesajlar, durum, admin notları aynen) ve requests'ten (varsa private/contact ile) silinir.
        Hedefte aynı içerik varsa yalnızca kaynak silinir; farklı içerik varsa ikisine de dokunulmaz (çakışma). Taşınanlar Destek Talepleri sayfasında görünür.
        Sıra: kural paketi 3.3 → önizle → taşı → önizle yeniden: taşınacak 0.
      </p>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", alignItems: "center" }}>
        <Grup3OrnekGirdisi deger={ornek} setDeger={setOrnek} pasif={!!calisiyor} />
        <button onClick={() => calistir(true)} disabled={!!calisiyor} style={grup3Stil.dugme("#1e1b4b", !!calisiyor)}><Grup3Donen acik={calisiyor === "kuru"} />Önizle</button>
        <button onClick={() => calistir(false)} disabled={tasiPasif} style={grup3Stil.dugme("#dc2626", tasiPasif)} title={sonKuru ? "" : "Önce önizleyin"}>
          <Grup3Donen acik={calisiyor === "gercek"} />Taşı
        </button>
      </div>
      <Grup3Hata hata={hata} />
      {sonuc && (
        <>
          <p style={{ fontSize: "12px", fontWeight: "600", color: sonuc.dryRun ? "#1e293b" : "#b91c1c", margin: "12px 0 0" }}>{sonuc.dryRun ? "Önizleme (kuru) — hiçbir şey yazılmadı" : "Gerçek çalıştırma sonucu"}</p>
          <Grup3Sayilar satirlar={[
            ["bulunan", sonuc.bulunan],
            ["taşınacak", sonuc.tasinacak, sonuc.tasinacak ? "#b45309" : "#15803d"],
            ["zaten taşınmış", sonuc.zatenTasinmis],
            ["çakışma", sonuc.cakisma, sonuc.cakisma ? "#b91c1c" : undefined],
            ["private/contact", sonuc.altBelge],
            ...(sonuc.dryRun ? [] : [["taşınan", sonuc.tasinan], ["requests'ten silinen", sonuc.silinen]]),
          ]} />
          {sonuc.cakisma > 0 && (
            <p style={{ fontSize: "12px", color: "#b91c1c", margin: "8px 0 0" }}>Çakışan kayıtlarda supportTickets'ta aynı kimlikle farklı bir kayıt var; ikisine de dokunulmadı. Elle incelenmeli.</p>
          )}
          {(sonuc.ornekler || []).length > 0 && (
            <Grup3Ornekler
              basliklar={["Kaynak", "Hedef", "Durum", "private/contact"]}
              satirlar={sonuc.ornekler.map((o) => (
                <tr key={o.yol}>
                  <td style={grup3Td}>{yolDugmesi(o.yol)}</td>
                  <td style={grup3Td}>{yolDugmesi(o.hedef)}</td>
                  <td style={{ ...grup3Td, color: o.durum === "cakisma" ? "#b91c1c" : "#334155" }}>{DESTEK_TASIMA_DURUM_AD[o.durum] || o.durum}</td>
                  <td style={grup3Td}>{o.altBelge ? "var" : "—"}</td>
                </tr>
              ))}
            />
          )}
          <Grup3Ham veri={sonuc} />
        </>
      )}
    </div>
  );
};

// stripProposalEmails — ilan ve taleplerin proposals dizisinden yalnızca expertEmail silinir (belge başına transaction).
// Kuru başlar; "Sil" ancak bir önizlemeden sonra açılır ve onay ister.
const TeklifEpostasiSilme = () => {
  const [ornek, setOrnek] = useState("20");
  const [sonuc, setSonuc] = useState(null);
  const [sonKuru, setSonKuru] = useState(null);
  const [calisiyor, setCalisiyor] = useState(null);
  const [hata, setHata] = useState(null);
  const calistir = async (dryRun) => {
    if (!dryRun) {
      if (!sonKuru) return;
      const b = sonKuru.belge || {};
      const t = sonKuru.teklif || {};
      if (!window.confirm(
        `Son önizlemeye göre ${b.jobs || 0} ilan ve ${b.requests || 0} talepte ${(t.jobs || 0) + (t.requests || 0)} tekliften expertEmail silinecek. ` +
        "Teklifin öteki alanları, sırası ve proposalCount aynı kalır.\n\nSilinen e-postalar saklanmaz; GERİ ALINAMAZ. Emin misin?"
      )) return;
    }
    setCalisiyor(dryRun ? "kuru" : "gercek");
    setHata(null);
    try {
      const r = await grup3Cagir("stripProposalEmails", { dryRun, ornek: grup3OrnekSayisi(ornek) }, GRUP3_UZUN_ZAMAN_ASIMI_MS);
      setSonuc(r);
      setSonKuru(r.dryRun ? r : null);
    } catch (e) { setHata(grup3Hata(e)); } finally { setCalisiyor(null); }
  };
  const silPasif = !sonKuru || !!calisiyor;
  return (
    <div style={grup3Stil.kart}>
      <h4 style={grup3Stil.baslik}>30 Ekim: tekliflerdeki uzman e-postalarını sil (stripProposalEmails)</h4>
      <p style={grup3Stil.aciklama}>
        jobs ve requests'in hepsi taranır; proposals dizisinden yalnızca expertEmail silinir. Belge başına transaction (aynı anda eklenen teklif kaybolmaz); yalnızca proposals yazılır, updatedAt değişmez.
        1.0.29–1.0.31 yeni tekliflere hâlâ expertEmail yazıyor: sonraki sürüme kadar arada yeniden çalıştırılabilir. Sıra: önizle → sil → önizle yeniden: belge 0.
      </p>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", alignItems: "center" }}>
        <Grup3OrnekGirdisi deger={ornek} setDeger={setOrnek} pasif={!!calisiyor} />
        <button onClick={() => calistir(true)} disabled={!!calisiyor} style={grup3Stil.dugme("#1e1b4b", !!calisiyor)}><Grup3Donen acik={calisiyor === "kuru"} />Önizle</button>
        <button onClick={() => calistir(false)} disabled={silPasif} style={grup3Stil.dugme("#dc2626", silPasif)} title={sonKuru ? "" : "Önce önizleyin"}>
          <Grup3Donen acik={calisiyor === "gercek"} />Sil
        </button>
        {calisiyor && <span style={{ fontSize: "12px", color: "#64748b" }}>Bütün ilan ve talepler okunuyor; birkaç dakika sürebilir.</span>}
      </div>
      <Grup3Hata hata={hata} />
      {sonuc && (
        <>
          <p style={{ fontSize: "12px", fontWeight: "600", color: sonuc.dryRun ? "#1e293b" : "#b91c1c", margin: "12px 0 0" }}>{sonuc.dryRun ? "Önizleme (kuru) — hiçbir şey yazılmadı" : "Gerçek çalıştırma sonucu"}</p>
          <Grup3Sayilar satirlar={[
            ["taranan ilan", sonuc.taranan?.jobs],
            ["taranan talep", sonuc.taranan?.requests],
            ["e-postalı ilan", sonuc.belge?.jobs, sonuc.belge?.jobs ? "#b45309" : "#15803d"],
            ["e-postalı talep", sonuc.belge?.requests, sonuc.belge?.requests ? "#b45309" : "#15803d"],
            ["e-postalı teklif (ilan)", sonuc.teklif?.jobs],
            ["e-postalı teklif (talep)", sonuc.teklif?.requests],
            ...(sonuc.dryRun ? [] : [["yazılan belge", sonuc.yazilanBelge], ["silinen e-posta", sonuc.silinenEposta]]),
          ]} />
          {(sonuc.ornekler || []).length > 0 && (
            <Grup3Ornekler
              basliklar={["Belge", "Teklif", "E-postalı teklif"]}
              satirlar={sonuc.ornekler.map((o) => (
                <tr key={o.yol}>
                  <td style={grup3Td}>{yolDugmesi(o.yol)}</td>
                  <td style={grup3Td}>{o.teklif}</td>
                  <td style={grup3Td}>{o.epostali}</td>
                </tr>
              ))}
            />
          )}
          <Grup3Ham veri={sonuc} />
        </>
      )}
    </div>
  );
};

// cleanupDeletedAccountTraces — geçmiş silmelerin izleri (functions/hesapSilmeTemizligi.js). Kuru başlar; "Temizle"
// ancak bir önizlemeden sonra açılır ve onay ister. Değer dönmez: sayılar, belge yolları ve uid.
const SILME_IZI_ORNEK_AD = { sikayet: "şikayet kaydı", destek: "destek kaydı", destekEposta: "e-postayla açılmış itiraz", destekTalebi: "requests'teki destek kaydı", teklif: "teklif", bildirim: "bildirim" };
const SILME_IZI_ESKI_AD = { jobs: "iş", requests: "talep", appointments: "randevu", conversations: "konuşma", reviews: "yorum" };
const SilinmisHesapIzTemizligi = () => {
  const [ornek, setOrnek] = useState("20");
  const [sonuc, setSonuc] = useState(null);
  const [sonKuru, setSonKuru] = useState(null);
  const [calisiyor, setCalisiyor] = useState(null);
  const [hata, setHata] = useState(null);
  const calistir = async (dryRun) => {
    if (!dryRun) {
      if (!sonKuru) return;
      const s = sonKuru.sayac || {};
      if (!window.confirm(
        `Son önizlemeye göre ${sonKuru.kullanici || 0} silinmiş hesabın izleri temizlenecek: ` +
        `${s.sikayet || 0} şikayet, ${s.destek || 0} destek kaydı, ${s.teklif || 0} teklif, ${s.mesaj || 0} mesaj ve ${s.bildirim || 0} bildirim temizlenecek; ${s.kendiBildirimi || 0} kendi bildirimi silinecek.\n\n` +
        (sonKuru.adiBilinmeyen ? `${sonKuru.adiBilinmeyen} hesabın adı hiçbir yerde kalmamış: bunlara ait bildirimlerdeki ad değişmeyecek.\n\n` : "") +
        "Silinen ve maskelenen değerler saklanmaz; GERİ ALINAMAZ. Emin misin?"
      )) return;
    }
    setCalisiyor(dryRun ? "kuru" : "gercek");
    setHata(null);
    try {
      const r = await grup3Cagir("cleanupDeletedAccountTraces", { dryRun, ornek: grup3OrnekSayisi(ornek) }, GRUP3_UZUN_ZAMAN_ASIMI_MS);
      setSonuc(r);
      setSonKuru(r.dryRun ? r : null);
    } catch (e) { setHata(grup3Hata(e)); } finally { setCalisiyor(null); }
  };
  const temizlePasif = !sonKuru || !!calisiyor;
  const s = (sonuc && sonuc.sayac) || {};
  const eskiAd = s.eskiAd || {};
  const renk = (v) => (v ? "#b45309" : undefined);
  return (
    <div style={grup3Stil.kart}>
      <h4 style={grup3Stil.baslik}>30 Ekim: geçmiş silmelerin izleri (cleanupDeletedAccountTraces)</h4>
      <p style={grup3Stil.aciklama}>
        deletedAccounts kaydı olan ve kayıtlarda geçip Auth'ta bulunmayan (Console'dan silinmiş) hesaplar; admin hesapları hariç. Her hesap için deleteMyAccount'un 30 Ekim adımları: şikayet ve destek kayıtları,
        e-postayla açılmış itirazlar, requests'teki destek kayıtları, teklifler, mesajlardaki ad, başkalarına giden bildirimler. Console'dan silinmişlerde ayrıca iş, talep, randevu, konuşma ve yorumdaki ad ve kendi bildirimleri.
        Şikayet, destek, yorum, iş, talep, randevu ve konuşmaların hepsi okunur; tek seferlik. Sıra: önizle → temizle → önizle yeniden: sayaçlar 0.
      </p>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", alignItems: "center" }}>
        <Grup3OrnekGirdisi deger={ornek} setDeger={setOrnek} pasif={!!calisiyor} />
        <button onClick={() => calistir(true)} disabled={!!calisiyor} style={grup3Stil.dugme("#1e1b4b", !!calisiyor)}><Grup3Donen acik={calisiyor === "kuru"} />Önizle</button>
        <button onClick={() => calistir(false)} disabled={temizlePasif} style={grup3Stil.dugme("#dc2626", temizlePasif)} title={sonKuru ? "" : "Önce önizleyin"}>
          <Grup3Donen acik={calisiyor === "gercek"} />Temizle
        </button>
        {calisiyor && <span style={{ fontSize: "12px", color: "#64748b" }}>Birkaç dakika sürebilir.</span>}
      </div>
      <Grup3Hata hata={hata} />
      {sonuc && (
        <>
          <p style={{ fontSize: "12px", fontWeight: "600", color: sonuc.dryRun ? "#1e293b" : "#b91c1c", margin: "12px 0 0" }}>{sonuc.dryRun ? "Önizleme (kuru) — hiçbir şey yazılmadı" : "Gerçek çalıştırma sonucu"}</p>
          {sonuc.adiBilinmeyen > 0 && (
            <div style={{ marginTop: "10px", background: "#fffbeb", border: "1px solid #fde68a", borderRadius: "10px", padding: "10px 12px", fontSize: "13px", color: "#92400e" }}>
              <strong>{sonuc.adiBilinmeyen} hesabın adı bilinmiyor.</strong> Ad hiçbir yerde (mesaj, teklif) kalmamış; bu hesaplara ait başkalarına giden bildirimlerdeki ad değişmeyecek. Öteki adımlar çalışır.
            </div>
          )}
          <Grup3Sayilar satirlar={[
            ["silinmiş hesap", sonuc.kullanici, sonuc.kullanici ? "#b45309" : "#15803d"],
            ["deletedAccounts kaydı", sonuc.deletedAccountsKaydi],
            ["Auth'ta yok (Console'dan silinmiş)", sonuc.authtaYok],
            ["adı bilinmeyen", sonuc.adiBilinmeyen, sonuc.adiBilinmeyen ? "#b91c1c" : undefined],
          ]} />
          <p style={{ fontSize: "12px", fontWeight: "600", color: "#334155", margin: "14px 0 0" }}>Kayıtlar</p>
          <Grup3Sayilar satirlar={[
            ["şikayet", s.sikayet, renk(s.sikayet)],
            ["destek", s.destek, renk(s.destek)],
            ["destek (e-postayla)", s.destekEposta, renk(s.destekEposta)],
            ["requests'teki destek", s.destekTalebi, renk(s.destekTalebi)],
            ["teklifli belge", s.teklifBelge, renk(s.teklifBelge)],
            ["teklif", s.teklif, renk(s.teklif)],
            ["mesaj (gönderen adı)", s.mesaj, renk(s.mesaj)],
          ]} />
          <p style={{ fontSize: "12px", fontWeight: "600", color: "#334155", margin: "14px 0 0" }}>Bildirimler</p>
          <Grup3Sayilar satirlar={[
            ["ilgili bildirim", s.ilgiliBildirim],
            ["değişecek bildirim", s.bildirim, renk(s.bildirim)],
            ["ad değişecek", s.bildirimAd],
            ["mesaj bildirimi", s.bildirimMesajParcasi],
            ["maskelenecek (admin)", s.bildirimMaske],
            ["kendi bildirimi (silinir)", s.kendiBildirimi, renk(s.kendiBildirimi)],
          ]} />
          <p style={{ fontSize: "12px", fontWeight: "600", color: "#334155", margin: "14px 0 0" }}>Console'dan silinmişlerde eski ad</p>
          <Grup3Sayilar satirlar={Object.entries(SILME_IZI_ESKI_AD).map(([k, ad]) => [ad, eskiAd[k], renk(eskiAd[k])])} />
          {(sonuc.ornekler || []).length > 0 && (
            <Grup3Ornekler
              basliklar={["Belge", "Ne", "Silinmiş hesap (uid)"]}
              satirlar={sonuc.ornekler.map((o, i) => (
                <tr key={`${o.yol}|${o.ne}|${i}`}>
                  <td style={grup3Td}>{yolDugmesi(o.yol)}</td>
                  <td style={grup3Td}>{SILME_IZI_ORNEK_AD[o.ne] || o.ne}</td>
                  <td style={{ ...grup3Td, fontFamily: "monospace", fontSize: "11px" }}>{o.uid}</td>
                </tr>
              ))}
            />
          )}
          <Grup3Ham veri={sonuc} />
        </>
      )}
    </div>
  );
};

// setRetentionExpiry — reports ve moderationLog'da expireAt'i olmayan kayda başlangıçtan 1 yıl sonrası (functions/saklamaSuresi.js).
// Silmeyi Firestore TTL politikası yapar. Kuru başlar; "Yaz" ancak bir önizlemeden sonra açılır ve onay ister.
const SAKLAMA_KOLEKSIYONLARI = [["reports", "İçerik şikayetleri (reports)"], ["moderationLog", "İçerik denetimi kayıtları (moderationLog)"]];
const SaklamaSuresiYazma = () => {
  const [ornek, setOrnek] = useState("20");
  const [sonuc, setSonuc] = useState(null);
  const [sonKuru, setSonKuru] = useState(null);
  const [calisiyor, setCalisiyor] = useState(null);
  const [hata, setHata] = useState(null);
  const topla = (r, alan) => SAKLAMA_KOLEKSIYONLARI.reduce((t, [k]) => t + ((r && r.koleksiyon && r.koleksiyon[k] && r.koleksiyon[k][alan]) || 0), 0);
  const calistir = async (dryRun) => {
    if (!dryRun) {
      if (!sonKuru) return;
      const gecmis = topla(sonKuru, "gecmisTarihli");
      if (!window.confirm(
        `Son önizlemeye göre ${topla(sonKuru, "eksik")} kayda expireAt yazılacak (başlangıçtan ${sonKuru.saklamaGun || 365} gün sonra; tarihi olmayana bugünden).\n\n` +
        (gecmis ? `DİKKAT: ${gecmis} kaydın süresi zaten dolmuş. TTL politikası açılınca bu kayıtlar birkaç saat içinde silinecek; 1 yıldan eski içerik denetimi kayıtları artık geri alınamaz. Saklanmaları gerekiyorsa vazgeç.\n\n` : "") +
        "Yalnızca expireAt yazılır. Emin misin?"
      )) return;
    }
    setCalisiyor(dryRun ? "kuru" : "gercek");
    setHata(null);
    try {
      const r = await grup3Cagir("setRetentionExpiry", { dryRun, ornek: grup3OrnekSayisi(ornek) });
      setSonuc(r);
      setSonKuru(r.dryRun ? r : null);
    } catch (e) { setHata(grup3Hata(e)); } finally { setCalisiyor(null); }
  };
  const yazPasif = !sonKuru || !!calisiyor;
  const gecmisTarihli = topla(sonuc, "gecmisTarihli");
  const simdi = Date.now();
  return (
    <div style={grup3Stil.kart}>
      <h4 style={grup3Stil.baslik}>30 Ekim: reports ve moderationLog saklama süresi (setRetentionExpiry)</h4>
      <p style={grup3Stil.aciklama}>
        expireAt'i olmayan eski kayda başlangıç tarihinden (reports.createdAt, moderationLog.at; yoksa bugün) 1 yıl sonrası yazılır; yalnızca expireAt. Yeni kayıtlar bunu kendileri yazıyor.
        Silmeyi Firestore TTL politikası yapar (Google Cloud Console'dan açılır, alan expireAt). Sıra: önizle (geçmiş tarihli sayısına bak) → yaz → önizle yeniden: eksik 0 → TTL'i aç.
      </p>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", alignItems: "center" }}>
        <Grup3OrnekGirdisi deger={ornek} setDeger={setOrnek} pasif={!!calisiyor} />
        <button onClick={() => calistir(true)} disabled={!!calisiyor} style={grup3Stil.dugme("#1e1b4b", !!calisiyor)}><Grup3Donen acik={calisiyor === "kuru"} />Önizle</button>
        <button onClick={() => calistir(false)} disabled={yazPasif} style={grup3Stil.dugme("#dc2626", yazPasif)} title={sonKuru ? "" : "Önce önizleyin"}>
          <Grup3Donen acik={calisiyor === "gercek"} />Yaz
        </button>
      </div>
      <Grup3Hata hata={hata} />
      {sonuc && (
        <>
          <p style={{ fontSize: "12px", fontWeight: "600", color: sonuc.dryRun ? "#1e293b" : "#b91c1c", margin: "12px 0 0" }}>
            {sonuc.dryRun ? "Önizleme (kuru) — hiçbir şey yazılmadı" : "Gerçek çalıştırma sonucu"} · saklama {sonuc.saklamaGun ?? 365} gün
          </p>
          {gecmisTarihli > 0 && (
            <div style={{ marginTop: "10px", background: "#fef2f2", border: "1px solid #fecaca", borderRadius: "10px", padding: "10px 12px", fontSize: "13px", color: "#991b1b" }}>
              <strong>TTL açılınca bu kayıtlar silinecek: {gecmisTarihli} kayıt</strong> ({SAKLAMA_KOLEKSIYONLARI.map(([k]) => `${k} ${(sonuc.koleksiyon && sonuc.koleksiyon[k] && sonuc.koleksiyon[k].gecmisTarihli) || 0}`).join(", ")}).
              {" "}Başlangıç tarihleri 1 yıldan eski; TTL politikası açıldıktan sonra birkaç saat içinde silinirler ve içerik denetimi kayıtları artık geri alınamaz. Saklanmaları gerekiyorsa TTL'i açmadan önce karar ver.
            </div>
          )}
          <Grup3Ornekler
            basliklar={["Koleksiyon", "Taranan", "expireAt eksik", "Tarihsiz", "Geçmiş tarihli", ...(sonuc.dryRun ? [] : ["Yazılan"])]}
            satirlar={SAKLAMA_KOLEKSIYONLARI.map(([k, ad]) => {
              const r = (sonuc.koleksiyon && sonuc.koleksiyon[k]) || {};
              return (
                <tr key={k}>
                  <td style={grup3Td}>{ad}</td>
                  <td style={grup3Td}>{r.taranan ?? 0}</td>
                  <td style={{ ...grup3Td, fontWeight: r.eksik ? "700" : "400", color: r.eksik ? "#b45309" : "#15803d" }}>{r.eksik ?? 0}</td>
                  <td style={{ ...grup3Td, color: r.tarihsiz ? "#b45309" : "#334155" }}>{r.tarihsiz ?? 0}</td>
                  <td style={{ ...grup3Td, fontWeight: r.gecmisTarihli ? "700" : "400", color: r.gecmisTarihli ? "#b91c1c" : "#334155" }}>{r.gecmisTarihli ?? 0}</td>
                  {!sonuc.dryRun && <td style={grup3Td}>{r.yazilan ?? 0}</td>}
                </tr>
              );
            })}
          />
          <p style={{ fontSize: "11px", color: "#94a3b8", margin: "6px 0 0" }}>Tarihsiz: başlangıç tarihi yok, bugünden 1 yıl yazılır. Geçmiş tarihli: hesaplanan bitiş bugünden önce.</p>
          {(sonuc.ornekler || []).length > 0 && (
            <Grup3Ornekler
              basliklar={["Belge", "expireAt"]}
              satirlar={sonuc.ornekler.map((o) => {
                const gecmis = toMillis(o.expireAt) <= simdi;
                return (
                  <tr key={o.yol}>
                    <td style={grup3Td}>{yolDugmesi(o.yol)}</td>
                    <td style={{ ...grup3Td, color: gecmis ? "#b91c1c" : "#334155", fontWeight: gecmis ? "600" : "400" }}>{formatDateTime(o.expireAt)}{gecmis ? " (geçmiş)" : ""}</td>
                  </tr>
                );
              })}
            />
          )}
          <Grup3Ham veri={sonuc} />
        </>
      )}
    </div>
  );
};

// ---- 31 Ekim: ödeme kayıtlarında test / gerçek ayrımı (functions/odemeSiniflandirma.js) ----
// classifyPayments salt okunur; markTestPayments kuru başlar, "Yaz" ancak önizlemeden sonra açılır ve onay ister.
// classifyNewPayment tetikleyicidir (yeni kayıt), düğmesi yok. Değer dönmez: sayılar, tutar toplamları ve yollar.
const ODEME_ISARET_AD = { tarihi_eksik: "tarihi eksik", silinmis_hesap: "hesabı silinmiş", kullanicisiz: "userId yok", hesap_bilinmiyor: "hesap bilinmiyor (Auth okunamadı)" };
const OdemeSinifRaporu = ({ sonuc }) => {
  const sinif = sonuc.sinif || {};
  const isaret = sonuc.isaret || {};
  const isaretli = sonuc.isaretli || {};
  const siniflar = Object.keys(ODEME_SINIF_AD).filter((k) => sinif[k]);
  const gercekTutar = ["gercek", "silinmis_hesap"].reduce((t, k) => t + ((sinif[k] && sinif[k].tutar) || 0), 0);
  const testTutar = siniflar.filter((k) => !["gercek", "silinmis_hesap"].includes(k)).reduce((t, k) => t + (sinif[k].tutar || 0), 0);
  return (
    <>
      <Grup3Sayilar satirlar={[
        ["taranan ödeme", sonuc.taranan],
        ["gerçek gelir (test hariç)", paraYaz(gercekTutar), "#16a34a"],
        ["test / geçersiz tutar", paraYaz(testTutar), testTutar ? "#b45309" : undefined],
        ["kural sürümü", sonuc.kuralSurumu],
        ["daha önce işaretli", isaretli.var],
        ["işaretli ama kural farklı", isaretli.farkli, isaretli.farkli ? "#b91c1c" : undefined],
      ]} />
      <Grup3Ornekler
        basliklar={["Sınıf", "Kayıt", "Tutar", "Gelire"]}
        satirlar={Object.keys(ODEME_SINIF_AD).map((k) => {
          const x = sinif[k] || { sayi: 0, tutar: 0 };
          const gelir = k === "gercek" || k === "silinmis_hesap";
          return (
            <tr key={k} style={{ opacity: x.sayi ? 1 : 0.5 }}>
              <td style={grup3Td}>{ODEME_SINIF_AD[k]} <span style={{ color: "#94a3b8", fontFamily: "monospace", fontSize: "11px" }}>{k}</span></td>
              <td style={{ ...grup3Td, fontWeight: x.sayi ? "700" : "400" }}>{x.sayi}</td>
              <td style={grup3Td}>{paraYaz(x.tutar)}</td>
              <td style={{ ...grup3Td, color: gelir ? "#16a34a" : "#b45309" }}>{gelir ? "katılır" : "katılmaz (isTest)"}</td>
            </tr>
          );
        })}
      />
      <p style={{ fontSize: "12px", color: "#475569", margin: "10px 0 0" }}>
        İşaretler: {Object.entries(ODEME_ISARET_AD).map(([k, ad]) => `${ad} ${isaret[k] ?? 0}`).join(" · ")}
      </p>
      {isaret.hesap_bilinmiyor > 0 && (
        <p style={{ fontSize: "12px", color: "#b91c1c", margin: "6px 0 0" }}>Auth okunamadığı için {isaret.hesap_bilinmiyor} kaydın hesabı bilinmiyor; sınıflar eksik olabilir, yeniden çalıştırın.</p>
      )}
      {(sonuc.ornekler || []).length > 0 && (
        <Grup3Ornekler
          basliklar={["Belge", "Sınıf"]}
          satirlar={sonuc.ornekler.map((o) => (
            <tr key={o.yol}>
              <td style={grup3Td}>{yolDugmesi(o.yol)}</td>
              <td style={grup3Td}>{ODEME_SINIF_AD[o.sinif] || o.sinif}</td>
            </tr>
          ))}
        />
      )}
      <Grup3Ham veri={sonuc} />
    </>
  );
};

const OdemeSiniflandirmaSayimi = () => {
  const [ornek, setOrnek] = useState("20");
  const [sonuc, setSonuc] = useState(null);
  const [calisiyor, setCalisiyor] = useState(false);
  const [hata, setHata] = useState(null);
  const calistir = async () => {
    setCalisiyor(true);
    setHata(null);
    try { setSonuc(await grup3Cagir("classifyPayments", { ornek: grup3OrnekSayisi(ornek) })); } catch (e) { setHata(grup3Hata(e)); } finally { setCalisiyor(false); }
  };
  return (
    <div style={grup3Stil.kart}>
      <h4 style={grup3Stil.baslik}>31 Ekim: ödeme kayıtlarının sınıflandırılması (classifyPayments, salt okunur)</h4>
      <p style={grup3Stil.aciklama}>
        payments'ın tamamı sunucunun kurallarıyla sınıflandırılır (ilk uyan): sanal işlem, elle verilen, tutar 0, eski kart formu, test hesabı, silinmiş test hesabı, olası test → isTest; silinmiş hesap ve gerçek → gelire katılır.
        Hiçbir şey yazmaz; e-posta, ad, işlem kimliği dönmez. Yeni kayıtları classifyNewPayment tetikleyicisi kendisi işaretler.
      </p>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", alignItems: "center" }}>
        <Grup3OrnekGirdisi deger={ornek} setDeger={setOrnek} pasif={calisiyor} />
        <button onClick={calistir} disabled={calisiyor} style={grup3Stil.dugme("#1e1b4b", calisiyor)}><Grup3Donen acik={calisiyor} />Say</button>
      </div>
      <Grup3Hata hata={hata} />
      {sonuc && <OdemeSinifRaporu sonuc={sonuc} />}
    </div>
  );
};

const TestOdemeIsaretleme = () => {
  const { odemeleriYukle } = usePanelVeri();
  const [ornek, setOrnek] = useState("20");
  const [sonuc, setSonuc] = useState(null);
  const [sonKuru, setSonKuru] = useState(null);
  const [calisiyor, setCalisiyor] = useState(null);
  const [hata, setHata] = useState(null);
  const calistir = async (dryRun) => {
    if (!dryRun) {
      if (!sonKuru) return;
      if (!window.confirm(
        `Son önizlemeye göre ${sonKuru.yazilacak || 0} ödeme kaydına isTest, testNedeni, hesapSilinmis ve testKuraliSurumu yazılacak (yalnızca farklı olanlar; ödemenin öteki alanlarına dokunulmaz).\n\n` +
        "Bundan sonra gelir kartları bu işaretlere göre hesaplanır. Bu işlem canlı veriyi değiştirir. Emin misin?"
      )) return;
    }
    setCalisiyor(dryRun ? "kuru" : "gercek");
    setHata(null);
    try {
      const r = await grup3Cagir("markTestPayments", { dryRun, ornek: grup3OrnekSayisi(ornek) });
      setSonuc(r);
      setSonKuru(r.dryRun ? r : null);
      if (!r.dryRun) odemeleriYukle(); // gelir kartları yeni işaretleri görsün
    } catch (e) { setHata(grup3Hata(e)); } finally { setCalisiyor(null); }
  };
  const yazPasif = !sonKuru || !!calisiyor;
  return (
    <div style={grup3Stil.kart}>
      <h4 style={grup3Stil.baslik}>31 Ekim: test ödemelerini işaretle (markTestPayments)</h4>
      <p style={grup3Stil.aciklama}>
        Her ödeme kaydına isTest, testNedeni (test değilse null), hesapSilinmis ve testKuraliSurumu yazılır; yalnızca alanları farklı olanlara. Kural sürümü değişince yeniden çalıştırılır.
        Sıra: önizle → yaz → önizle yeniden: yazılacak 0.
      </p>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", alignItems: "center" }}>
        <Grup3OrnekGirdisi deger={ornek} setDeger={setOrnek} pasif={!!calisiyor} />
        <button onClick={() => calistir(true)} disabled={!!calisiyor} style={grup3Stil.dugme("#1e1b4b", !!calisiyor)}><Grup3Donen acik={calisiyor === "kuru"} />Önizle</button>
        <button onClick={() => calistir(false)} disabled={yazPasif} style={grup3Stil.dugme("#dc2626", yazPasif)} title={sonKuru ? "" : "Önce önizleyin"}>
          <Grup3Donen acik={calisiyor === "gercek"} />Yaz
        </button>
      </div>
      <Grup3Hata hata={hata} />
      {sonuc && (
        <>
          <p style={{ fontSize: "12px", fontWeight: "600", color: sonuc.dryRun ? "#1e293b" : "#b91c1c", margin: "12px 0 0" }}>{sonuc.dryRun ? "Önizleme (kuru) — hiçbir şey yazılmadı" : "Gerçek çalıştırma sonucu"}</p>
          <Grup3Sayilar satirlar={[
            ["yazılacak", sonuc.yazilacak, sonuc.yazilacak ? "#b45309" : "#15803d"],
            ...(sonuc.dryRun ? [] : [["yazılan", sonuc.yazilan]]),
          ]} />
          <OdemeSinifRaporu sonuc={sonuc} />
        </>
      )}
    </div>
  );
};

// ---- 31 Ekim: push anahtarı (users.fcmToken) olmayan kullanıcılar (functions/pushAnahtarDurumu.js) ----
// countPushTokenStatus SALT OKUNUR; yalnızca sayı döner (uid, e-posta, ad, anahtar yok). Onay penceresi yok.
// Silinmiş ve askıdakiler hariç, admin / test hesapları ayrı; sayilan = anahtarli + anahtarsiz.
const PUSH_NEDENLERI = [
  ["cikis_onceden_anahtarli", "Çıkışta silinmiş (önceden anahtarlı)", "Çıkış yapınca silinmiş; önceden çalışan bir anahtarı vardı."],
  ["cikis_anahtar_belirsiz", "Çıkışta silinmiş (anahtar belirsiz)", "Çıkışta silinmiş; 9 Temmuz 2026 öncesi hatada anahtar hiç yazılmamış olabilir (devicePlatform yok)."],
  ["gecersiz", "Geçersiz", "Push gönderilirken anahtar geçersiz çıktı, sunucu sildi (uygulama silinmiş, telefon değişmiş, izin kapatılmış)."],
  ["hic_olmamis", "Hiç olmamış", "fcmToken alanı hiç yok: izin reddedilmiş, soru yanıtsız bırakılmış ya da 9 Temmuz öncesi hata (birbirinden ayrılamaz)."],
  ["bos_metin", "Boş", "fcmToken boş metin (beklenmeyen kayıt)."],
];
const PUSH_KIRILIMLAR = [
  ["platform", "Platform", [["ios", "iOS"], ["android", "Android"], ["tahmini_ios", "iOS", true], ["tahmini_android", "Android", true], ["bilinmiyor", "bilinmiyor"]]],
  ["rol", "Rol", [["uzman", "uzman"], ["musteri", "müşteri"], ["diger", "diğer"]]],
  ["kayitDonemi", "Kayıt dönemi", [["hata_oncesi", "9 Tem öncesi"], ["ara", "9 Tem – 27 Eki"], ["surum_1029_sonrasi", "27 Eki sonrası"], ["bilinmiyor", "bilinmiyor"]]],
  ["sonAktif", "Son aktiflik", [["gun7", "≤7 gün"], ["gun30", "≤30 gün"], ["gun90", "≤90 gün"], ["eski", "90 günden eski"], ["hic", "hiç"]]],
];
const yuzde = (pay, payda) => (payda > 0 ? `%${Math.round((pay / payda) * 1000) / 10}` : "—");
const PushKirilimi = ({ k }) => (
  <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: "8px", padding: "8px 0" }}>
    {PUSH_KIRILIMLAR.map(([alan, baslik, degerler]) => (
      <div key={alan} style={{ background: "#f8fafc", borderRadius: "8px", padding: "8px 10px" }}>
        <p style={{ fontSize: "11px", fontWeight: "600", color: "#64748b", margin: "0 0 4px" }}>{baslik}</p>
        <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
          {degerler.map(([d, ad, tahmini]) => {
            const n = (k && k[alan] && k[alan][d]) || 0;
            return (
              <span key={d} title={tahmini ? "Tahmini: Apple girişi, ödeme kaynağı, hata kayıtları ya da eski devicePlatform'dan; kesin değil" : undefined}
                style={{ padding: "2px 7px", borderRadius: "10px", fontSize: "11px", background: tahmini ? "#fff7ed" : "white", border: `1px ${tahmini ? "dashed #fdba74" : "solid #e2e8f0"}`, color: n ? "#1e293b" : "#cbd5e1" }}>
                {ad}{tahmini && <em style={{ color: "#c2410c", fontStyle: "normal", fontWeight: "600" }}> (tahmini)</em>}: <strong>{n}</strong>
              </span>
            );
          })}
        </div>
      </div>
    ))}
  </div>
);

const PushAnahtarDurumu = () => {
  const [sonuc, setSonuc] = useState(null);
  const [calisiyor, setCalisiyor] = useState(false);
  const [hata, setHata] = useState(null);
  const [acik, setAcik] = useState({}); // neden → kırılım açık mı
  const calistir = async () => {
    setCalisiyor(true);
    setHata(null);
    try { setSonuc(await grup3Cagir("countPushTokenStatus", {})); } catch (e) { setHata(grup3Hata(e)); } finally { setCalisiyor(false); }
  };
  const s = sonuc || {};
  const neden = s.neden || {};
  const kirilim = s.kirilim || {};
  // Rol bazında anahtarlı / toplam (anahtarlı kırılımı + nedenlerin kırılımları)
  const rolOrani = (rol) => {
    const anahtarli = (s.anahtarliKirilim && s.anahtarliKirilim.rol && s.anahtarliKirilim.rol[rol]) || 0;
    const anahtarsiz = PUSH_NEDENLERI.reduce((t, [n]) => t + ((kirilim[n] && kirilim[n].rol && kirilim[n].rol[rol]) || 0), 0);
    return { anahtarli, toplam: anahtarli + anahtarsiz };
  };
  const uzman = rolOrani("uzman");
  const musteri = rolOrani("musteri");
  const uzmanOran = uzman.toplam ? uzman.anahtarli / uzman.toplam : 0;
  const uzmanRenk = !uzman.toplam ? ["#f8fafc", "#475569"] : uzmanOran < 0.5 ? ["#fef2f2", "#b91c1c"] : uzmanOran < 0.8 ? ["#fffbeb", "#b45309"] : ["#f0fdf4", "#15803d"];
  const satir = (anahtar, ad, aciklama, sayi, k, vurgu) => (
    <React.Fragment key={anahtar}>
      <tr onClick={() => setAcik((a) => ({ ...a, [anahtar]: !a[anahtar] }))} style={{ cursor: "pointer", background: vurgu ? "#f0fdf4" : undefined }}>
        <td style={grup3Td}>
          <span style={{ color: "#94a3b8", marginRight: "6px" }}>{acik[anahtar] ? "▾" : "▸"}</span>
          <strong>{ad}</strong>
          <div style={{ fontSize: "11px", color: "#64748b", marginLeft: "16px" }}>{aciklama}</div>
        </td>
        <td style={{ ...grup3Td, fontWeight: "700", whiteSpace: "nowrap" }}>{sayi}</td>
        <td style={{ ...grup3Td, whiteSpace: "nowrap", color: "#64748b" }}>{vurgu ? yuzde(sayi, s.sayilan) : yuzde(sayi, s.anahtarsiz)}</td>
        <td style={{ ...grup3Td, whiteSpace: "nowrap", color: "#64748b" }}>{yuzde(sayi, s.sayilan)}</td>
      </tr>
      {acik[anahtar] && (
        <tr><td colSpan={4} style={{ padding: "0 8px 8px", borderBottom: "1px solid #f1f5f9" }}><PushKirilimi k={k} /></td></tr>
      )}
    </React.Fragment>
  );
  return (
    <div style={grup3Stil.kart}>
      <h4 style={grup3Stil.baslik}>31 Ekim: push anahtarı olmayan kullanıcılar (countPushTokenStatus, salt okunur)</h4>
      <p style={grup3Stil.aciklama}>
        users'ta push anahtarı (fcmToken) olmayan hesaplar nedene göre sayılır. Silinmiş ve askıdakiler hariç; yönetici ve test hesapları ayrı. Hiçbir şey yazmaz; yalnızca sayı döner.
        users ve clientErrors'ın tamamı okunur: günde bir kezden sık çalıştırmaya gerek yok.
      </p>
      <button onClick={calistir} disabled={calisiyor} style={grup3Stil.dugme("#1e1b4b", calisiyor)}><Grup3Donen acik={calisiyor} />{sonuc ? "Yeniden say" : "Say"}</button>
      <Grup3Hata hata={hata} />
      {sonuc && (
        <>
          <Grup3Sayilar satirlar={[
            ["sayılan kullanıcı", s.sayilan],
            ["anahtarlı (push ulaşır)", `${s.anahtarli ?? 0} · ${yuzde(s.anahtarli, s.sayilan)}`, "#15803d"],
            ["anahtarsız", `${s.anahtarsiz ?? 0} · ${yuzde(s.anahtarsiz, s.sayilan)}`, s.anahtarsiz ? "#b91c1c" : undefined],
          ]} />
          <div style={{ marginTop: "12px", display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))", gap: "10px" }}>
            <div style={{ background: uzmanRenk[0], border: `1px solid ${uzmanRenk[1]}33`, borderRadius: "12px", padding: "12px 14px" }}>
              <p style={{ fontSize: "12px", fontWeight: "600", color: uzmanRenk[1], margin: 0 }}>Uzmanlarda push ulaşabilen</p>
              <p style={{ fontSize: "26px", fontWeight: "800", color: uzmanRenk[1], margin: "2px 0" }}>{yuzde(uzman.anahtarli, uzman.toplam)}</p>
              <p style={{ fontSize: "12px", color: "#475569", margin: 0 }}>{uzman.anahtarli} / {uzman.toplam} uzman. Yeni iş bildirimleri (A3) ve doğrudan talep push'ları buna bağlı.</p>
            </div>
            <div style={{ background: "#f8fafc", borderRadius: "12px", padding: "12px 14px" }}>
              <p style={{ fontSize: "12px", fontWeight: "600", color: "#475569", margin: 0 }}>Müşterilerde push ulaşabilen</p>
              <p style={{ fontSize: "20px", fontWeight: "700", color: "#334155", margin: "2px 0" }}>{yuzde(musteri.anahtarli, musteri.toplam)}</p>
              <p style={{ fontSize: "12px", color: "#475569", margin: 0 }}>{musteri.anahtarli} / {musteri.toplam} müşteri</p>
            </div>
          </div>
          <p style={{ fontSize: "12px", color: "#64748b", margin: "10px 0 0" }}>
            Toplam users {s.toplamKullanici ?? 0} · hariç: {(s.haric && s.haric.silinmis) || 0} silinmiş, {(s.haric && s.haric.askida) || 0} askıda ·
            {" "}yönetici / test hesabı {(s.test && s.test.toplam) || 0} ({(s.test && s.test.anahtarli) || 0} anahtarlı, {(s.test && s.test.anahtarsiz) || 0} anahtarsız; sayılmadı)
          </p>
          {s.authOkunamadi > 0 && (
            <p style={{ fontSize: "12px", color: "#b45309", margin: "6px 0 0" }}>{s.authOkunamadi} hesabın Auth kaydı okunamadı; bunlarda platform ve son aktiflik tahmini zayıf.</p>
          )}
          <Grup3Ornekler
            basliklar={["Neden (kırılım için tıklayın)", "Hesap", "Anahtarsızların", "Sayılanların"]}
            satirlar={[
              ...PUSH_NEDENLERI.map(([n, ad, aciklama]) => satir(n, ad, aciklama, neden[n] || 0, kirilim[n])),
              satir("_anahtarli", "Karşılaştırma: anahtarlılar", "Push ulaşan hesapların aynı kırılımları", s.anahtarli || 0, s.anahtarliKirilim, true),
            ]}
          />
          <p style={{ fontSize: "11px", color: "#94a3b8", margin: "8px 0 0" }}>
            Platform: iOS / Android yalnızca 9 Temmuz 2026'dan sonra yazılmış devicePlatform'dan; <span style={{ color: "#c2410c" }}>(tahmini)</span> olanlar Apple girişi, ödeme kaynağı, hata kayıtları ya da eski devicePlatform'dan, kesin değil.
            Asıl hedef: "Hiç olmamış" içinde son 30 günde aktif ve 9 Temmuz sonrası kayıtlı olanlar (düzeltilmiş sürümle girip izin vermemiş). İzin "reddedildi" ile "hiç sorulmadı" bu sayımla ayrılamaz.
          </p>
          <Grup3Ham veri={sonuc} />
        </>
      )}
    </div>
  );
};

// ---- 3 Kasım: Premium ve deneme denetimi (functions/premiumDenetimi.js, premiumKurallari.js, premiumBekcisi.js) ----
// countPremiumAnomalies SALT OKUNUR; sayı, bekçi (premiumGuard) özeti ve istenirse { yol, sinif } döner. Onay penceresi yok.
// Bekçinin ayarı settings/automation'dan YALNIZCA OKUNUR (herkese açık okuma); panel değiştirmez.
const PREMIUM_DENETIM_SINIFLARI = [
  ["admin_verdi", "Panelden verilmiş", "normal"],
  ["urun_bizim_degil", "Ürün bizim değil (sanal işlem dahil) ya da yok", "supheli"],
  ["suresiz", "Bitiş tarihi yok", "supheli"],
  ["baslangic_yok", "Başlangıç tarihi yok", "supheli"],
  ["sure_fazla", "Süre planı aşıyor (aylık 33, yıllık 368 gün) ya da bitiş çok ileride", "supheli"],
  ["gelecek_baslangic", "Başlangıç 2 günden fazla ileride", "supheli"],
  ["musteri_premium", "Müşteri hesabında Premium", "supheli"],
  ["islem_kimligi_yok", "İşlem kimliği yok (Android senkronu ya da elle yazılmış)", "kontrol"],
  ["odeme_kaydi_gercek", "Ödeme kaydı var: gerçek", "normal"],
  ["odeme_kaydi_test", "Ödeme kaydı var: test", "kontrol"],
  ["odeme_kaydi_isaretsiz", "Ödeme kaydı var: işaretsiz", "kontrol"],
  ["odeme_kaydi_yok", "İşlem kimliği var, ödeme kaydı yok (geri yüklemede kayıt yazılmaz; tek başına kanıt değil)", "kontrol"],
];
const DENEME_DENETIM_SINIFLARI = [
  ["deneme_suresiz", "Aktif ama bitiş yok", "supheli"],
  ["deneme_uzun", "31 günden uzun", "supheli"],
  ["deneme_kayittan_kopuk", "Başlangıç hesap açılışından 2 günden fazla sonra", "supheli"],
  ["musteri_deneme", "Müşteri hesabında aktif deneme", "supheli"],
  ["deneme_kaynak_tuhaf", "trialSource bilinen değerlerden değil", "kontrol"],
  ["deneme_normal", "Kayıttaki biçim", "normal"],
];
const BEKCI_KOD_AD = {
  olusturmada_premium: "hesap Premium'la açılmış", urun_bizim_degil: "ürün bizim değil", bitis_yok: "bitiş yok", bitis_okunamadi: "bitiş okunamadı",
  baslangic_yok: "başlangıç yok", baslangic_okunamadi: "başlangıç okunamadı", sure_fazla: "süre planı aşıyor", ileri_fazla: "bitiş çok ileride",
  deneme_kayittan_sonra: "deneme hesap açıldıktan sonra açılmış", musteri_deneme: "müşteride deneme", deneme_bitis_yok: "deneme bitişi yok",
  deneme_bitis_okunamadi: "deneme bitişi okunamadı", deneme_baslangic_yok: "deneme başlangıcı yok", deneme_uzun: "deneme 31 günden uzun",
  deneme_ileri_fazla: "deneme bitişi çok ileride", deneme_kaynak_tuhaf: "deneme kaynağı tuhaf",
};
const DENETIM_DURUM_STIL = { supheli: ["#fef2f2", "#b91c1c", "şüpheli"], kontrol: ["#fffbeb", "#b45309", "kontrol"], normal: ["#f0fdf4", "#15803d", "normal"] };
const PREMIUM_SINIF_AD = Object.fromEntries([...PREMIUM_DENETIM_SINIFLARI, ...DENEME_DENETIM_SINIFLARI].map(([k, ad]) => [k, ad]));

const PremiumDenetimi = () => {
  const [ornek, setOrnek] = useState("0");
  const [sonuc, setSonuc] = useState(null);
  const [calisiyor, setCalisiyor] = useState(false);
  const [hata, setHata] = useState(null);
  const [ayar, setAyar] = useState({ durum: "yukleniyor" }); // settings/automation: yalnızca okunur
  const ayarOku = useCallback(async () => {
    try {
      const s = await getDoc(doc(db, "settings", "automation"));
      const v = s.exists() ? s.data() || {} : {};
      setAyar({ durum: "tamam", var: s.exists(), geriAl: v.premiumGuardRevertEnabled, kapali: v.premiumGuardDisabled });
    } catch (e) {
      setAyar({ durum: "hata", hata: grup3Hata(e) });
    }
  }, []);
  useEffect(() => { ayarOku(); }, [ayarOku]);
  const calistir = async () => {
    const n = Math.floor(Number(ornek));
    setCalisiyor(true);
    setHata(null);
    try {
      setSonuc(await grup3Cagir("countPremiumAnomalies", { ornek: Number.isFinite(n) ? Math.min(200, Math.max(0, n)) : 0 }));
      ayarOku();
    } catch (e) { setHata(grup3Hata(e)); } finally { setCalisiyor(false); }
  };
  const s = sonuc || {};
  const toplamSupheli = (tanimlar, sinif) => tanimlar.filter(([, , d]) => d === "supheli").reduce((t, [k]) => t + ((sinif && sinif[k]) || 0), 0);
  const premiumSupheli = toplamSupheli(PREMIUM_DENETIM_SINIFLARI, s.premium && s.premium.sinif);
  const denemeSupheli = toplamSupheli(DENEME_DENETIM_SINIFLARI, s.deneme && s.deneme.sinif);
  const bekci = s.bekci || null;
  const kodlar = bekci ? Object.entries(bekci.kod || {}).sort((a, b) => b[1] - a[1]) : [];
  const sinifTablosu = (baslik, tanimlar, bolum) => (
    <>
      <p style={{ fontSize: "13px", fontWeight: "600", color: "#1e293b", margin: "16px 0 0" }}>{baslik}: {(bolum && bolum.toplam) || 0} hesap</p>
      <Grup3Ornekler
        basliklar={["Sınıf", "Hesap", "Değerlendirme"]}
        satirlar={tanimlar.map(([k, ad, d]) => {
          const n = (bolum && bolum.sinif && bolum.sinif[k]) || 0;
          const [zemin, renk, etiket] = DENETIM_DURUM_STIL[d];
          return (
            <tr key={k} style={{ opacity: n ? 1 : 0.5 }}>
              <td style={grup3Td}>{ad} <span style={{ color: "#94a3b8", fontFamily: "monospace", fontSize: "11px" }}>{k}</span></td>
              <td style={{ ...grup3Td, fontWeight: n ? "700" : "400", color: n && d === "supheli" ? "#b91c1c" : "#334155" }}>{n}</td>
              <td style={grup3Td}><span style={{ padding: "2px 8px", borderRadius: "10px", fontSize: "11px", fontWeight: "600", background: zemin, color: renk }}>{etiket}</span></td>
            </tr>
          );
        })}
      />
    </>
  );
  const ayarMetni = ayar.durum === "yukleniyor" ? "okunuyor…"
    : ayar.durum === "hata" ? `okunamadı (${ayar.hata.code})`
    : ayar.kapali === true ? "BEKÇİ KAPALI (premiumGuardDisabled: true; hiçbir şey yapmıyor)"
    : ayar.geriAl === true ? "GERİ ALMA AÇIK (premiumGuardRevertEnabled: true; ihlali kaydeder ve geri alır)"
    : `Yalnızca işaretleme (premiumGuardRevertEnabled: ${ayar.geriAl === undefined ? "yok" : JSON.stringify(ayar.geriAl)}; varsayılan)`;
  const ayarRenk = ayar.kapali === true ? ["#fef2f2", "#b91c1c"] : ayar.geriAl === true ? ["#fffbeb", "#b45309"] : ["#f1f5f9", "#334155"];
  return (
    <div style={grup3Stil.kart}>
      <h4 style={grup3Stil.baslik}>3 Kasım: Premium ve deneme denetimi (countPremiumAnomalies, salt okunur)</h4>
      <p style={grup3Stil.aciklama}>
        users kuralı Premium ve deneme alanlarını kullanıcıya açık bıraktığı için kendine Premium ya da uzun deneme vermiş olabilecek hesaplar sayılır. Silinmiş ve askıdakiler hariç; yönetici ve test hesapları ayrı.
        Hiçbir şey yazmaz; ad, e-posta, işlem kimliği dönmez. Şüphe, kanıt değil: kesin sonuç mağaza doğrulamasıyla çıkar.
      </p>
      <div style={{ padding: "10px 12px", borderRadius: "10px", background: ayarRenk[0], color: ayarRenk[1], fontSize: "13px", marginBottom: "12px" }}>
        <strong>Premium bekçisi (premiumGuard):</strong> {ayarMetni}
        <div style={{ fontSize: "11px", color: "#64748b", marginTop: "2px" }}>
          settings/automation'dan okunuyor; panelden değiştirilmez. Açılış sırası: 2–3 gün yalnızca işaretleme → bekçi kod dağılımında yanlış alarm yoksa geri alma açılır.
        </div>
      </div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", alignItems: "center" }}>
        <label style={{ fontSize: "13px", color: "#334155", display: "flex", alignItems: "center", gap: "6px" }}>
          Örnek belge yolu <input type="number" min="0" max="200" value={ornek} onChange={(e) => setOrnek(e.target.value)} disabled={calisiyor} style={grup3Stil.girdi} />
          <span style={{ fontSize: "11px", color: "#94a3b8" }}>(0: yalnızca sayı)</span>
        </label>
        <button onClick={calistir} disabled={calisiyor} style={grup3Stil.dugme("#1e1b4b", calisiyor)}><Grup3Donen acik={calisiyor} />Say</button>
      </div>
      <Grup3Hata hata={hata} />
      {sonuc && (
        <>
          <Grup3Sayilar satirlar={[
            ["taranan users", s.taranan],
            ["Premium açık", s.premium && s.premium.toplam],
            ["şüpheli Premium", premiumSupheli, premiumSupheli ? "#b91c1c" : "#15803d"],
            ["aktif deneme", s.deneme && s.deneme.toplam],
            ["şüpheli deneme", denemeSupheli, denemeSupheli ? "#b91c1c" : "#15803d"],
            ["kapanmış ama 31 günden uzun deneme", s.deneme && s.deneme.kapaliUzun, s.deneme && s.deneme.kapaliUzun ? "#b45309" : undefined],
          ]} />
          <p style={{ fontSize: "12px", color: "#64748b", margin: "10px 0 0" }}>
            Hariç: {(s.haric && s.haric.silinmis) || 0} silinmiş, {(s.haric && s.haric.askida) || 0} askıda · yönetici / test hesabı: {(s.test && s.test.premium) || 0} Premium, {(s.test && s.test.deneme) || 0} deneme (sayılmadı)
            {s.authOkunamadi > 0 && <span style={{ color: "#b45309" }}> · {s.authOkunamadi} hesabın Auth kaydı okunamadı</span>}
          </p>
          {sinifTablosu("Premium sınıfları (ilk uyan)", PREMIUM_DENETIM_SINIFLARI, s.premium)}
          {sinifTablosu("Deneme sınıfları (ilk uyan)", DENEME_DENETIM_SINIFLARI, s.deneme)}

          <p style={{ fontSize: "13px", fontWeight: "600", color: "#1e293b", margin: "16px 0 0" }}>Bekçi kayıtları (premiumAudit)</p>
          {!bekci ? (
            <p style={{ fontSize: "12px", color: "#94a3b8", margin: "4px 0 0" }}>Yanıtta bekçi özeti yok (countPremiumAnomalies bekçiyle birlikte yeniden deploy edilmemiş olabilir).</p>
          ) : (
            <>
              <p style={{ fontSize: "13px", color: "#334155", margin: "6px 0 0" }}>
                Son 7 günde <strong>{bekci.son7gun || 0}</strong> kayıt, toplam {bekci.kayit || 0} kayıt / {bekci.hesap || 0} hesap; <strong>{bekci.geriAlindi || 0}</strong> geri alındı.
              </p>
              <Grup3Sayilar satirlar={[
                ["yalnızca işaretlendi", bekci.isaretle],
                ["geri alma modunda", bekci.geriAl],
                ["geri alındı", bekci.geriAlindi, bekci.geriAlindi ? "#b45309" : undefined],
                ["test hesabı (muaf)", bekci.muafTest],
                ["hesap açılışında", bekci.olusturma],
              ]} />
              {kodlar.length > 0 ? (
                <Grup3Ornekler
                  basliklar={["Kod", "Kayıt"]}
                  satirlar={kodlar.map(([k, n]) => (
                    <tr key={k}>
                      <td style={grup3Td}>{BEKCI_KOD_AD[k] || k} <span style={{ color: "#94a3b8", fontFamily: "monospace", fontSize: "11px" }}>{k}</span></td>
                      <td style={{ ...grup3Td, fontWeight: "700" }}>{n}</td>
                    </tr>
                  ))}
                />
              ) : (
                <p style={{ fontSize: "12px", color: "#15803d", margin: "6px 0 0" }}>Bekçi henüz hiçbir şey işaretlemedi.</p>
              )}
              <p style={{ fontSize: "11px", color: "#94a3b8", margin: "6px 0 0" }}>Gerçek alıcılar ya da kayıtlar yanlışlıkla işaretleniyorsa geri alma açılmamalı. Bir kayıtta birden çok kod olabilir.</p>
            </>
          )}

          {(s.ornekler || []).length > 0 && (
            <>
              <p style={{ fontSize: "13px", fontWeight: "600", color: "#1e293b", margin: "16px 0 0" }}>Örnek belge yolları ({s.ornekler.length})</p>
              <Grup3Ornekler
                basliklar={["Belge", "Sınıf"]}
                satirlar={s.ornekler.map((o, i) => (
                  <tr key={`${o.yol}|${i}`}>
                    <td style={grup3Td}>{yolDugmesi(o.yol)}</td>
                    <td style={grup3Td}>{PREMIUM_SINIF_AD[o.sinif] || o.sinif} <span style={{ color: "#94a3b8", fontFamily: "monospace", fontSize: "11px" }}>{o.sinif}</span></td>
                  </tr>
                ))}
              />
              <p style={{ fontSize: "11px", color: "#94a3b8", margin: "6px 0 0" }}>Panelden verilmiş ve gerçek ödeme kaydıyla eşleşen Premium'lar örneğe girmez.</p>
            </>
          )}
          <Grup3Ham veri={sonuc} />
        </>
      )}
    </div>
  );
};

// ---- 3 Kasım (1.0.33): rol karışıklığı (functions/rolKarisikligi.js, rolIsareti.js; docs/rol_karisikligi_plani.md) ----
// countRoleConfusion SALT OKUNUR; onay yok. Profil hatırlatması ayarları settings/automation'dan YALNIZCA OKUNUR.
// "hizmet_tanitimi" kayıtları moderationLog'da (istemciye kapalı): son 7 gün sayısı listModerationLog sayfalarıyla, yalnızca
// "Say"a basılınca sayılır. Örnek ilanlar bellekteki listeden İş İlanları ayrıntı penceresinde (IlanDetayModal) açılır.
const ROL_SAHIP_AD = [["musteri", "Müşteri"], ["uzman", "Uzman (açarken de uzman)"], ["sonradanUzman", "Sonradan uzmana dönmüş"], ["silinmis", "Silinmiş hesap"]];
const ROL_ETIKET_AD = { telefon: "telefon", baglanti: "bağlantı", eposta: "e-posta", talepYok: "talep ifadesi yok", coklu: "çoklu işaret" };
const ROL_ORNEK_SAYFA = 200;
const ROL_ORNEK_EN_COK_SAYFA = 10;
// moderationLog'da son 7 günün "hizmet_tanitimi" kayıtları (yeniden eskiye; pencerenin dışına çıkınca durur)
const hizmetTanitimiSay = async () => {
  const sinir = new Date(Date.now() - 7 * 24 * 60 * 60 * 1000).toISOString();
  let sonraki = null;
  let sayi = 0;
  let taranan = 0;
  for (let i = 0; i < ROL_ORNEK_EN_COK_SAYFA; i++) {
    const r = await grup3Cagir("listModerationLog", sonraki ? { limit: ROL_ORNEK_SAYFA, sonraki } : { limit: ROL_ORNEK_SAYFA });
    const liste = Array.isArray(r.kayitlar) ? r.kayitlar : [];
    let pencereDisi = false;
    for (const k of liste) {
      if (String(k.at || "") < sinir) { pencereDisi = true; break; }
      taranan++;
      if (k.neden === "hizmet_tanitimi") sayi++;
    }
    if (pencereDisi || !r.sonraki) return { sayi, taranan, eksik: false };
    sonraki = r.sonraki;
  }
  return { sayi, taranan, eksik: true };
};

const RolKarisikligi = ({ jobs = [], resolveUser, updateJobStatus, onToggleSuspend }) => {
  const [gun, setGun] = useState(30);
  const [ornek, setOrnek] = useState("0");
  const [sonuc, setSonuc] = useState(null);
  const [calisiyor, setCalisiyor] = useState(false);
  const [hata, setHata] = useState(null);
  const [kayit, setKayit] = useState(null); // { sayi, taranan, eksik } | { hata }
  const [ayar, setAyar] = useState({ durum: "yukleniyor" });
  const [seciliIlan, setSeciliIlan] = useState(null); // ilan id
  const ayarOku = useCallback(async () => {
    try {
      const s = await getDoc(doc(db, "settings", "automation"));
      const v = s.exists() ? s.data() || {} : {};
      setAyar({ durum: "tamam", acik: v.profilNudgeEnabled, kuru: v.profilNudgeDryRun });
    } catch (e) {
      setAyar({ durum: "hata", hata: grup3Hata(e) });
    }
  }, []);
  useEffect(() => { ayarOku(); }, [ayarOku]);
  const calistir = async () => {
    const n = Math.floor(Number(ornek));
    setCalisiyor(true);
    setHata(null);
    setKayit(null);
    try {
      setSonuc(await grup3Cagir("countRoleConfusion", { gun, ornek: Number.isFinite(n) ? Math.min(50, Math.max(0, n)) : 0 }));
    } catch (e) { setHata(grup3Hata(e)); }
    try { setKayit(await hizmetTanitimiSay()); } catch (e) { setKayit({ hata: grup3Hata(e) }); }
    ayarOku();
    setCalisiyor(false);
  };
  const s = sonuc || {};
  const ilan = s.ilan || {};
  const tanitim = s.tanitim || {};
  const teklif = s.teklif || {};
  const uzman = s.uzman || {};
  const acikIlan = seciliIlan ? jobs.find((j) => j.id === seciliIlan && j._source === "jobs") || null : null;
  const nudge = ayar.durum !== "tamam" ? (ayar.durum === "hata" ? `okunamadı (${ayar.hata.code})` : "okunuyor…")
    : ayar.acik !== true ? `KAPALI (profilNudgeEnabled: ${ayar.acik === undefined ? "yok" : JSON.stringify(ayar.acik)}; çalışmıyor)`
    : ayar.kuru !== false ? "AÇIK, KURU (profilNudgeDryRun false değil; yalnızca günlüğe yazıyor, bildirim gitmiyor)"
    : "AÇIK, GERÇEK (profilNudgeDryRun: false; uzmanlara profile_nudge bildirimi gidiyor)";
  const nudgeRenk = ayar.acik === true && ayar.kuru === false ? ["#fffbeb", "#b45309"] : ayar.acik === true ? ["#eef2ff", "#3730a3"] : ["#f1f5f9", "#334155"];
  const sayiSatiri = (etiket, deger, renk) => [etiket, deger ?? 0, renk];
  const sozluk = (o, adlar = {}) => Object.entries(o || {}).sort((a, b) => b[1] - a[1]).map(([k, n]) => `${adlar[k] || k} ${n}`).join(" · ") || "—";
  return (
    <div style={grup3Stil.kart}>
      {acikIlan && (
        <IlanDetayModal ilan={acikIlan} resolveUser={resolveUser} onClose={() => setSeciliIlan(null)}
          updateJobStatus={updateJobStatus || (() => {})} onToggleSuspend={onToggleSuspend} />
      )}
      <h4 style={grup3Stil.baslik}>3 Kasım (1.0.33): rol karışıklığı (countRoleConfusion, salt okunur)</h4>
      <p style={grup3Stil.aciklama}>
        Son N günde açılan ilanlardan hizmet tanıtımı gibi olanlar (A3 ile aynı puan) ve uzmanların hizmet kayıtları sayılır. Test hesapları ayrı. Hiçbir şey yazmaz.
        Örnek ilanlar elle iptal için (eski tanıtım ilanlarına otomatik işlem yok).
      </p>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))", gap: "10px", marginBottom: "12px" }}>
        <div style={{ padding: "10px 12px", borderRadius: "10px", background: nudgeRenk[0], color: nudgeRenk[1], fontSize: "13px" }}>
          <strong>Profil hatırlatması (profileNudgeDaily):</strong> {nudge}
          <div style={{ fontSize: "11px", color: "#64748b", marginTop: "2px" }}>settings/automation'dan okunuyor; panelden değiştirilmez.</div>
        </div>
        <div style={{ padding: "10px 12px", borderRadius: "10px", background: "#f8fafc", color: "#334155", fontSize: "13px" }}>
          <strong>Kuru işaret (moderationLog, "hizmet_tanitimi"):</strong>{" "}
          {!kayit ? <span style={{ color: "#94a3b8" }}>"Say"a basınca sayılır</span>
            : kayit.hata ? <span style={{ color: "#b91c1c" }}>okunamadı ({kayit.hata.code})</span>
            : <>son 7 günde <strong>{kayit.sayi}</strong> kayıt <span style={{ color: "#94a3b8" }}>({kayit.taranan} kayıt tarandı{kayit.eksik ? `; ilk ${ROL_ORNEK_SAYFA * ROL_ORNEK_EN_COK_SAYFA} kayıtta durdu, eksik olabilir` : ""})</span></>}
          <div style={{ fontSize: "11px", color: "#64748b", marginTop: "2px" }}>İlana dokunulmaz, admin bildirimi gitmez. Kayıtlar İçerik Şikayetleri &gt; Otomatik Denetim'de.</div>
        </div>
      </div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "10px", alignItems: "center" }}>
        <span style={{ fontSize: "13px", color: "#334155" }}>Son</span>
        {[7, 30, 90].map((g) => (
          <button key={g} onClick={() => setGun(g)} disabled={calisiyor}
            style={{ padding: "6px 12px", borderRadius: "8px", border: "1px solid #e2e8f0", background: gun === g ? "#1e1b4b" : "white", color: gun === g ? "white" : "#475569", fontSize: "13px", cursor: "pointer" }}>
            {g} gün
          </button>
        ))}
        <label style={{ fontSize: "13px", color: "#334155", display: "flex", alignItems: "center", gap: "6px" }}>
          Örnek ilan <input type="number" min="0" max="50" value={ornek} onChange={(e) => setOrnek(e.target.value)} disabled={calisiyor} style={grup3Stil.girdi} />
          <span style={{ fontSize: "11px", color: "#94a3b8" }}>(0–50)</span>
        </label>
        <button onClick={calistir} disabled={calisiyor} style={grup3Stil.dugme("#1e1b4b", calisiyor)}><Grup3Donen acik={calisiyor} />Say</button>
      </div>
      <Grup3Hata hata={hata} />
      {sonuc && (
        <>
          <p style={{ fontSize: "12px", color: "#64748b", margin: "12px 0 0" }}>
            Son {s.gun} gün ({s.sinir ? formatDateTime(s.sinir) : "—"} sonrası) · eşik {s.esik ?? "—"} · ifade listesi {s.listeSurumu ?? "—"} ({s.listeKaynagi || "—"})
            {s.authOkunamadi > 0 && <span style={{ color: "#b45309" }}> · {s.authOkunamadi} hesabın Auth kaydı okunamadı</span>}
          </p>

          <p style={{ fontSize: "13px", fontWeight: "600", color: "#1e293b", margin: "14px 0 0" }}>İlanlar</p>
          <Grup3Sayilar satirlar={[
            sayiSatiri("ilan (toplam)", ilan.toplam),
            sayiSatiri("sayılan", ilan.sayilan),
            sayiSatiri("test hesabının", ilan.test),
            sayiSatiri("sahibi yok", ilan.sahipYok),
            sayiSatiri("tanıtım gibi", tanitim.isaretli, tanitim.isaretli ? "#b91c1c" : "#15803d"),
            sayiSatiri("sınırda (puan 1–2)", tanitim.sinirda, tanitim.sinirda ? "#b45309" : undefined),
            sayiSatiri("temiz", tanitim.temiz),
            sayiSatiri("\"yine de yayınla\" seçilen", tanitim.yineDeYayinla),
          ]} />
          <p style={{ fontSize: "12px", color: "#475569", margin: "8px 0 0" }}>
            Durum: {sozluk(ilan.durum)}{ilan.gizli ? ` · gizli ${ilan.gizli}` : ""}<br />
            Tanıtım etiketleri: {sozluk(tanitim.etiket, ROL_ETIKET_AD)}<br />
            Eşleşen ifadeler: {sozluk(tanitim.ifade)}
          </p>
          <Grup3Ornekler
            basliklar={["Teklif", "Tanıtım gibi", "Öteki ilanlar"]}
            satirlar={[["alan", "Teklif alan"], ["almayan", "Teklif almayan"]].map(([k, ad]) => (
              <tr key={k}>
                <td style={grup3Td}>{ad}</td>
                <td style={{ ...grup3Td, fontWeight: "600" }}>{(teklif.tanitim && teklif.tanitim[k]) || 0}</td>
                <td style={grup3Td}>{(teklif.oteki && teklif.oteki[k]) || 0}</td>
              </tr>
            ))}
          />
          <Grup3Ornekler
            basliklar={["İlan sahibi", "Bütün ilanlar", "Tanıtım gibi olanlar"]}
            satirlar={ROL_SAHIP_AD.map(([k, ad]) => (
              <tr key={k}>
                <td style={grup3Td}>{ad}</td>
                <td style={grup3Td}>{(s.sahip && s.sahip[k]) || 0}</td>
                <td style={{ ...grup3Td, fontWeight: "600", color: s.kesisim && s.kesisim[k] ? "#b91c1c" : "#334155" }}>{(s.kesisim && s.kesisim[k]) || 0}</td>
              </tr>
            ))}
          />
          <p style={{ fontSize: "11px", color: "#94a3b8", margin: "4px 0 0" }}>"Sonradan uzmana dönmüş": ilanı açan hesap ilandan sonra uzmana çevrilmiş. "Uzman": açarken de uzmandı ya da dönüşüm tarihi bilinmiyor.</p>

          <p style={{ fontSize: "13px", fontWeight: "600", color: "#1e293b", margin: "16px 0 0" }}>Uzmanlar</p>
          <Grup3Sayilar satirlar={[
            sayiSatiri("sayılan uzman", uzman.sayilan),
            sayiSatiri("hizmeti olan", uzman.hizmetli),
            sayiSatiri("hizmeti olmayan", uzman.hizmetsiz, uzman.hizmetsiz ? "#b45309" : undefined),
            sayiSatiri("yalnızca genel kaydı olan", uzman.yalnizcaGenel, uzman.yalnizcaGenel ? "#b45309" : undefined),
            sayiSatiri("fiyatlı", uzman.fiyatli, "#15803d"),
            sayiSatiri("yalnızca \"teklifle\"", uzman.yalnizcaTeklifle),
            sayiSatiri("fiyatsız", uzman.fiyatsiz, uzman.fiyatsiz ? "#b45309" : undefined),
          ]} />
          <p style={{ fontSize: "12px", color: "#475569", margin: "8px 0 0" }}>Kayıt yolu: {sozluk(uzman.kayitYolu)}</p>

          {(s.ornekler || []).length > 0 && (
            <>
              <p style={{ fontSize: "13px", fontWeight: "600", color: "#1e293b", margin: "16px 0 0" }}>Tanıtım gibi işaretlenen ilanlar ({s.ornekler.length})</p>
              <Grup3Ornekler
                basliklar={["İlan", "Puan", "Sahip", "Durum", "Teklif"]}
                satirlar={s.ornekler.map((o) => {
                  const id = String(o.yol || "").split("/")[1] || "";
                  const j = jobs.find((x) => x.id === id && x._source === "jobs");
                  return (
                    <tr key={o.yol}>
                      <td style={grup3Td}>
                        {j ? (
                          <button onClick={() => setSeciliIlan(id)} style={{ ...konsolDugmesi, textAlign: "left" }} title="İş İlanları ayrıntı penceresinde aç">
                            {j.title || j.subCategory || j.category || id}
                          </button>
                        ) : yolDugmesi(o.yol)}
                        <div style={{ fontSize: "11px", color: "#94a3b8", fontFamily: "monospace" }}>{o.yol}{!j && " · panelde yok, konsolda açılır"}</div>
                      </td>
                      <td style={{ ...grup3Td, fontWeight: "700" }}>{o.puan}</td>
                      <td style={grup3Td}>{(ROL_SAHIP_AD.find(([k]) => k === o.sahip) || [null, o.sahip])[1]}</td>
                      <td style={grup3Td}>{jobStatusInfo(o.durum).text}</td>
                      <td style={grup3Td}>{o.teklif ? "var" : "yok"}</td>
                    </tr>
                  );
                })}
              />
            </>
          )}
          <Grup3Ham veri={sonuc} />
        </>
      )}
    </div>
  );
};

const Grup3Section = ({ experts, jobs = [], resolveUser, onToggleSuspend, updateJobStatus = null }) => {
  const [seciliKullanici, setSeciliKullanici] = useState(null);
  // "Örnek göster": rastgele bir (silinmemiş) uzmanın publicProfiles belgesi Firestore konsolunda
  const ornekUzman = () => {
    const adaylar = (experts || []).filter((e) => e && e.id && e.deleted !== true);
    if (!adaylar.length) { alert("Uzman yok."); return; }
    const e = adaylar[Math.floor(Math.random() * adaylar.length)];
    window.open(`${FIRESTORE_KONSOL}/~2FpublicProfiles~2F${encodeURIComponent(e.id)}`, "_blank", "noopener,noreferrer");
  };
  return (
    <div style={{ background: "white", borderRadius: "16px", padding: "24px", boxShadow: "0 1px 3px rgba(0,0,0,0.05)", marginBottom: "24px" }}>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      {seciliKullanici && (
        <UserDetailModal user={seciliKullanici} onClose={() => setSeciliKullanici(null)} onToggleSuspend={onToggleSuspend || (() => {})} userType={seciliKullanici.userType} />
      )}
      <h3 style={{ fontSize: "16px", fontWeight: "600", color: "#1e293b", margin: "0 0 4px 0" }}>1.0.31 Grup 3: taşıma ve doldurma</h3>
      <p style={{ fontSize: "13px", color: "#64748b", margin: "0 0 16px 0" }}>
        Sunucu fonksiyonlarını çağırır (yalnızca admin). Yazan işler kuru başlar; "Taşı", "Doldur", "Düzelt", "Temizle", "Sil" ve "Yaz" onay ister. Fonksiyonlar deploy edilmeden düğmeler hata koduyla döner.
      </p>
      <OzelVeriDenetimi resolveUser={resolveUser} onAc={(r) => setSeciliKullanici({ ...r.raw, id: r.raw.id || r.id })} />
      <AppleBelirtecTasima />
      <SayfaliDoldurma
        baslik="3.1 (c) İlan ve talep iletişim bilgisi → private/contact"
        aciklama="Adres ve müşteri telefonu {jobs,requests}/{id}/private/contact'a da yazılır; ana belgeden silinmez. Sıra: kuru (iki koleksiyon, son sayfaya kadar) → doldur → kuru yeniden: yazılacak 0."
        fnAdi="backfillContactInfo"
        koleksiyonlar={[{ id: "jobs", ad: "İlanlar (jobs)" }, { id: "requests", ad: "Talepler (requests)" }]}
        sayiAlanlari={[["iletisimli", "iletişim alanı olan"], ["ayni", "alt belgesi zaten aynı"], ["yazilacak", "yazılacak", "#b45309"], ["yazilan", "yazılan"], ["hata", "hata", "#b91c1c"]]}
      />
      <SayfaliDoldurma
        baslik="3.1 (a, b) Herkese açık profiller → publicProfiles"
        aciklama="Her kullanıcı için publicProfiles/{uid}: beyaz listedeki alanlar ve hesaplanan alanlar (aktif, listelenebilir, kimlik, premium, sonAktifGun). Sıra: kuru → doldur (son sayfaya kadar) → kuru yeniden: yazılacak 0."
        fnAdi="backfillPublicProfiles"
        sayiAlanlari={[["uzman", "uzman"], ["musteri", "müşteri"], ["ayni", "zaten aynı"], ["yazilacak", "yazılacak", "#b45309"], ["yazilan", "yazılan"], ["hata", "hata", "#b91c1c"]]}
        ekBilgi={<button onClick={ornekUzman} style={{ background: "none", border: "none", color: "#4f46e5", fontSize: "13px", cursor: "pointer", textDecoration: "underline", padding: 0 }}>Örnek göster (rastgele uzman, Firestore konsolu)</button>}
      />
      <IzinGunuDuzeltme resolveUser={resolveUser} />
      <SilinmisHesapIletisimTemizligi />
      <AuthsuzKullaniciSayimi resolveUser={resolveUser} onAc={(r) => setSeciliKullanici({ ...r.raw, id: r.raw.id || r.id })} />
      <IletisimSizintisiSayimi />
      <DestekKayitTasima />
      <TeklifEpostasiSilme />
      <SilinmisHesapIzTemizligi />
      <SaklamaSuresiYazma />
      <OdemeSiniflandirmaSayimi />
      <TestOdemeIsaretleme />
      <PushAnahtarDurumu />
      <PremiumDenetimi />
      <RolKarisikligi jobs={jobs} resolveUser={resolveUser} updateJobStatus={updateJobStatus} onToggleSuspend={onToggleSuspend} />
    </div>
  );
};

// ==================== İÇERİK DENETİMİ (29 Ekim olayı) ====================
// Kaynak: isinebak2/docs/admin_paneli_icerik_denetimi.md ve functions/icerikDenetimi.js, hizmetSayimi.js,
// index.js (listModerationLog, undoModeration, scanModeration, countDuplicateServices). Hepsi us-central1
// callable, yalnızca admin. moderationLog istemciye kapalı: panel kayıtları yalnızca listModerationLog ile okur.
// Panelin kendi yazdığı tek şey settings/moderation.sunucuModu (merge; kuruya dönüşte alan silinir).
// Çağrılar yalnızca düğmeyle yapılır; sekme açılınca yalnızca settings/moderation bir kez okunur.
const DENETIM_NEDEN_AD = { icerik: "Uygunsuz içerik", hiz: "Hız sınırı", hizmet_tanitimi: "Hizmet tanıtımı" };
const DENETIM_TUR_AD = { requests: "Talep", jobs: "İlan", messages: "Mesaj", users: "Profil" };
const DENETIM_ISLEM_AD = { yalnizca_kayit: "Yalnızca kayıt", gizlendi: "Gizlendi", metin_degisti: "Metin değişti" };
const HIZ_KURAL_AD = {
  yeni_hesap_saatlik_talep: "Yeni hesap, saatlik talep",
  yeni_hesap_gunluk_talep: "Yeni hesap, günlük talep",
  herkes_saatlik_talep: "Herkes, saatlik talep",
  yeni_hesap_gunluk_ilan: "Yeni hesap, günlük ilan",
};
// icerikDenetimi.js VARSAYILAN.hizSiniri
const HIZ_SINIRI_ALANLARI = [
  ["yeniHesapGun", "Yeni hesap sayılma süresi (gün)", 7],
  ["yeniHesapSaatlikTalep", "Yeni hesap: saatte en çok talep", 5],
  ["yeniHesapGunlukTalep", "Yeni hesap: günde en çok talep", 10],
  ["herkesSaatlikTalep", "Herkes: saatte en çok talep", 20],
  ["yeniHesapGunlukIlan", "Yeni hesap: günde en çok ilan", 3],
];
const GERI_AL_RED = {
  kayit_yok: "Kayıt bulunamadı.",
  zaten_geri_alindi: "Bu kayıt zaten geri alınmış.",
  belge_yok: "Belge artık yok (silinmiş).",
  islem_yok: "Bu kayıtta geri alınacak işlem yok (kuru modda belge değişmedi).",
};
const DENETIM_SAYFA = 50;
const denetimKonsolu = (yol) => `${FIRESTORE_KONSOL}/${String(yol || "").split("/").filter(Boolean).map((p) => `~2F${encodeURIComponent(p)}`).join("")}`;
const geriAlinabilirMi = (k) => !k.geriAlindi && (k.islem === "gizlendi" || k.islem === "metin_degisti");
const denetimRozet = (metin, renk, zemin) => (
  <span style={{ display: "inline-block", padding: "2px 8px", borderRadius: "6px", fontSize: "11px", fontWeight: "600", color: renk, background: zemin, whiteSpace: "nowrap" }}>{metin}</span>
);
const KelimeCipleri = ({ kelimeler }) => (
  <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
    {kelimeler.map((k) => <span key={k} style={{ padding: "1px 7px", background: "#fee2e2", color: "#b91c1c", borderRadius: "10px", fontSize: "11px", fontWeight: "600" }}>{k}</span>)}
  </div>
);
const denetimTablo = { width: "100%", borderCollapse: "collapse", fontSize: "12px" };
const denetimTh = { textAlign: "left", padding: "8px", background: "#f8fafc", color: "#475569", fontWeight: "600", borderBottom: "1px solid #e2e8f0", whiteSpace: "nowrap" };
const denetimTd = { padding: "8px", borderBottom: "1px solid #f1f5f9", verticalAlign: "top", color: "#1e293b" };
const konsolDugmesi = { background: "none", border: "none", color: "#4f46e5", fontSize: "12px", cursor: "pointer", textDecoration: "underline", padding: 0 };
const konsoluAc = (yol) => window.open(denetimKonsolu(yol), "_blank", "noopener,noreferrer");

// Sunucu modu (settings/moderation.sunucuModu) ve sunucunun kullandığı ek listeler / hız sınırları
const DenetimModu = () => {
  const [ayar, setAyar] = useState(null); // { var, veri }
  const [hata, setHata] = useState(null);
  const [yaziliyor, setYaziliyor] = useState(false);
  const oku = useCallback(async () => {
    setHata(null);
    try {
      const s = await getDoc(doc(db, "settings", "moderation"));
      setAyar({ var: s.exists(), veri: s.exists() ? s.data() || {} : {} });
    } catch (e) {
      setHata(grup3Hata(e));
    }
  }, []);
  useEffect(() => { oku(); }, [oku]);

  const v = (ayar && ayar.veri) || {};
  const uygula = v.sunucuModu === "uygula";
  const liste = (a) => (Array.isArray(v[a]) ? v[a] : []);
  const canliBanned = new Set(liste("bannedWords").map(normalizeBannedWord));
  const eksikBanned = TEMEL_BANNED_WORDS.filter((w) => !canliBanned.has(w));

  const moduYaz = async (yeni) => {
    const metin = yeni === "uygula"
      ? "Sunucu UYGULA moduna geçecek.\n\n" +
        "• Uygunsuz içerikli ya da hız sınırını aşan YENİ talep ve ilanlar iptal edilip gizlenir.\n" +
        "• Uygunsuz mesajın metni \"Bu mesaj uygunsuz içerik nedeniyle kaldırıldı\" olur.\n" +
        "• Bunlara ait push gönderilmez, bildirim silinir.\n" +
        "• Profiller değiştirilmez (yalnızca kayıt).\n\n" +
        "Etkisi en geç 1 dakikada görülür. Önce tarama ve kayıtlarda yanlış pozitif aradın mı? Emin misin?"
      : "Sunucu KURU moda dönecek (sunucuModu alanı silinir).\n\nYeni kayıtlarda yalnızca kayıt ve admin bildirimi yapılır; " +
        "daha önce gizlenenler kendiliğinden geri gelmez (kayıtlardan \"Geri al\"). Etkisi en geç 1 dakikada görülür. Emin misin?";
    if (!window.confirm(metin)) return;
    setYaziliyor(true);
    setHata(null);
    try {
      await setDoc(
        doc(db, "settings", "moderation"),
        { sunucuModu: yeni === "uygula" ? "uygula" : deleteField(), updatedAt: new Date().toISOString() },
        { merge: true }
      );
      await oku();
    } catch (e) {
      setHata(grup3Hata(e));
    } finally {
      setYaziliyor(false);
    }
  };

  return (
    <div style={grup3Stil.kart}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: "12px", flexWrap: "wrap" }}>
        <div>
          <p style={grup3Stil.baslik}>Sunucu modu</p>
          <p style={grup3Stil.aciklama}>settings/moderation.sunucuModu. Talep, ilan, mesaj ve profil denetimi sunucuda; her iki modda da kayıt ve admin bildirimi yapılır.</p>
        </div>
        <button onClick={oku} disabled={yaziliyor} style={grup3Stil.dugme("#475569", yaziliyor)}><RefreshCw size={14} /> Yeniden oku</button>
      </div>
      {!ayar && !hata && <p style={{ fontSize: "13px", color: "#64748b" }}>Okunuyor…</p>}
      {ayar && (
        <>
          <div style={{ display: "flex", alignItems: "center", gap: "12px", flexWrap: "wrap", padding: "12px 14px", borderRadius: "10px", background: uygula ? "#fef2f2" : "#f1f5f9", border: `1px solid ${uygula ? "#fecaca" : "#e2e8f0"}` }}>
            <span style={{ fontSize: "14px", fontWeight: "700", color: uygula ? "#b91c1c" : "#334155" }}>
              {uygula ? "UYGULA" : "KURU"}
            </span>
            <span style={{ fontSize: "12px", color: "#475569", flex: "1 1 260px" }}>
              {uygula
                ? "Uygunsuz ya da hız sınırını aşan yeni talep ve ilanlar iptal edilip gizleniyor, mesaj metni değiştiriliyor, push gönderilmiyor."
                : `Hiçbir kayıt değiştirilmiyor; yalnızca moderationLog kaydı ve admin bildirimi.${v.sunucuModu ? ` (Alan değeri "${String(v.sunucuModu)}": "uygula" olmadığı için kuru.)` : " (Alan yok: varsayılan.)"}`}
            </span>
            {uygula ? (
              <button onClick={() => moduYaz("kuru")} disabled={yaziliyor} style={grup3Stil.dugme("#334155", yaziliyor)}><Grup3Donen acik={yaziliyor} /> Kuru moda dön</button>
            ) : (
              <button onClick={() => moduYaz("uygula")} disabled={yaziliyor} style={grup3Stil.dugme("#dc2626", yaziliyor)}><Grup3Donen acik={yaziliyor} /> Uygula moduna geç</button>
            )}
          </div>
          {eksikBanned.length > 0 && (
            <div style={{ marginTop: "10px", background: "#fffbeb", border: "1px solid #fde68a", borderRadius: "10px", padding: "10px 12px", fontSize: "12px", color: "#92400e" }}>
              <strong>bannedWords'te {eksikBanned.length} kelime eksik:</strong> {eksikBanned.join(", ")}.
              {" "}1.0.30 ve öncesinde bu liste koddakinin yerine geçtiği için eski sürümler bu kelimeleri engellemez (sunucu yine de denetler).
              Ayarlar &gt; İçerik Filtresi'nden eklenebilir.
            </div>
          )}
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))", gap: "12px", marginTop: "12px" }}>
            <div style={{ background: "#f8fafc", borderRadius: "10px", padding: "10px 12px" }}>
              <p style={{ fontSize: "12px", fontWeight: "600", color: "#334155", margin: "0 0 6px" }}>Hız sınırı (hizSiniri)</p>
              {HIZ_SINIRI_ALANLARI.map(([k, ad, varsayilan]) => {
                const d = v.hizSiniri && Number(v.hizSiniri[k]);
                const ozel = Number.isFinite(d) && d > 0;
                return (
                  <div key={k} style={{ display: "flex", justifyContent: "space-between", gap: "8px", fontSize: "12px", color: "#475569", padding: "2px 0" }}>
                    <span>{ad}</span>
                    <strong style={{ color: ozel ? "#4f46e5" : "#1e293b" }} title={ozel ? `Ayardan (varsayılan ${varsayilan})` : "Koddaki varsayılan"}>{ozel ? d : varsayilan}{ozel ? " *" : ""}</strong>
                  </div>
                );
              })}
              <p style={{ fontSize: "11px", color: "#94a3b8", margin: "6px 0 0" }}>* ayardan gelen değer; diğerleri koddaki varsayılan.</p>
            </div>
            <div style={{ background: "#f8fafc", borderRadius: "10px", padding: "10px 12px", fontSize: "12px", color: "#475569" }}>
              <p style={{ fontSize: "12px", fontWeight: "600", color: "#334155", margin: "0 0 6px" }}>Sunucuya ek listeler (koddaki yedeğe eklenir)</p>
              {[["tamKelimeler", "Tam kelimeler"], ["kokler", "Kökler"], ["istisnalar", "İstisnalar"]].map(([k, ad]) => (
                <div key={k} style={{ marginBottom: "6px" }}>
                  <span>{ad}: </span>
                  {liste(k).length ? <span style={{ color: "#1e293b" }}>{liste(k).join(", ")}</span> : <span style={{ color: "#94a3b8" }}>yok</span>}
                </div>
              ))}
              <p style={{ fontSize: "11px", color: "#94a3b8", margin: "6px 0 0" }}>
                Yanlış pozitifte ilgili başlangıç istisnalar'a yazılır.{" "}
                <button onClick={() => konsoluAc("settings/moderation")} style={konsolDugmesi}>Firestore konsolunda aç</button>
              </p>
            </div>
          </div>
        </>
      )}
      <Grup3Hata hata={hata} />
    </div>
  );
};

// listModerationLog (yeniden eskiye, sayfalı) + undoModeration
const DenetimKayitlari = ({ resolveUser }) => {
  const [kayitlar, setKayitlar] = useState(null);
  const [sonraki, setSonraki] = useState(null);
  const [calisiyor, setCalisiyor] = useState(false);
  const [hata, setHata] = useState(null);
  const [filtre, setFiltre] = useState("hepsi");
  const [geriAlinan, setGeriAlinan] = useState(null);

  const getir = async (devam) => {
    setCalisiyor(true);
    setHata(null);
    try {
      const r = await grup3Cagir("listModerationLog", devam && sonraki ? { limit: DENETIM_SAYFA, sonraki } : { limit: DENETIM_SAYFA });
      const yeni = Array.isArray(r.kayitlar) ? r.kayitlar : [];
      setKayitlar((onceki) => (devam && onceki ? [...onceki, ...yeni.filter((k) => !onceki.some((o) => o.id === k.id))] : yeni));
      setSonraki(r.sonraki || null);
    } catch (e) {
      setHata(grup3Hata(e));
    } finally {
      setCalisiyor(false);
    }
  };

  const geriAl = async (k) => {
    const tur = DENETIM_TUR_AD[k.koleksiyon] || k.koleksiyon;
    const metin = k.islem === "gizlendi"
      ? `${tur} geri alınacak: gizleme kaldırılır${k.oncekiDurum ? `, iptal edildiyse durumu "${k.oncekiDurum}" olur` : ""}.\n\n${k.yol}\n\nEmin misin?`
      : `Mesaj asıl metnine döndürülecek (konuşmanın son mesajı da).\n\n${k.yol}\n\nEmin misin?`;
    if (!window.confirm(metin)) return;
    setGeriAlinan(k.id);
    try {
      const r = await grup3Cagir("undoModeration", { logId: k.id });
      if (r.ok) {
        setKayitlar((l) => l.map((x) => (x.id === k.id ? { ...x, geriAlindi: true, geriAlinmaAt: new Date().toISOString() } : x)));
      } else {
        alert(`Geri alınamadı: ${GERI_AL_RED[r.neden] || r.neden || "bilinmeyen neden"}`);
        if (r.neden === "zaten_geri_alindi") setKayitlar((l) => l.map((x) => (x.id === k.id ? { ...x, geriAlindi: true } : x)));
      }
    } catch (e) {
      const h = grup3Hata(e);
      alert(`Geri alma başarısız. Kod: ${h.code} · ${h.message}`);
    } finally {
      setGeriAlinan(null);
    }
  };

  const liste = kayitlar || [];
  const gorunen = liste.filter((k) => {
    if (filtre === "hepsi") return true;
    if (filtre === "geri_alinabilir") return geriAlinabilirMi(k);
    if (filtre === "icerik" || filtre === "hiz" || filtre === "hizmet_tanitimi") return k.neden === filtre;
    return k.koleksiyon === filtre;
  });

  return (
    <div style={grup3Stil.kart}>
      <p style={grup3Stil.baslik}>Denetim kayıtları (moderationLog)</p>
      <p style={grup3Stil.aciklama}>
        Yeniden eskiye, {DENETIM_SAYFA}'şer. "Geri al" yalnızca uygula modunda gizlenen talep / ilan ve değiştirilen mesajda; bir kayıt yalnızca bir kez geri alınır.
      </p>
      <div style={{ display: "flex", gap: "8px", alignItems: "center", flexWrap: "wrap" }}>
        <button onClick={() => getir(false)} disabled={calisiyor} style={grup3Stil.dugme("#4f46e5", calisiyor)}><Grup3Donen acik={calisiyor} /> {kayitlar ? "Baştan getir" : "Kayıtları getir"}</button>
        {kayitlar && (
          <button onClick={() => getir(true)} disabled={calisiyor || !sonraki} style={grup3Stil.dugme("#475569", calisiyor || !sonraki)} title={sonraki ? "" : "Başka kayıt yok"}>Daha fazla</button>
        )}
        {kayitlar && (
          <select value={filtre} onChange={(e) => setFiltre(e.target.value)} style={grup3Stil.secim}>
            <option value="hepsi">Hepsi ({liste.length})</option>
            <option value="geri_alinabilir">Geri alınabilir ({liste.filter(geriAlinabilirMi).length})</option>
            <option value="icerik">Uygunsuz içerik ({liste.filter((k) => k.neden === "icerik").length})</option>
            <option value="hiz">Hız sınırı ({liste.filter((k) => k.neden === "hiz").length})</option>
            <option value="hizmet_tanitimi">Hizmet tanıtımı ({liste.filter((k) => k.neden === "hizmet_tanitimi").length})</option>
            {Object.entries(DENETIM_TUR_AD).map(([k, ad]) => <option key={k} value={k}>{ad} ({liste.filter((x) => x.koleksiyon === k).length})</option>)}
          </select>
        )}
      </div>
      <Grup3Hata hata={hata} />
      {kayitlar && (
        gorunen.length === 0 ? (
          <p style={{ fontSize: "13px", color: "#94a3b8", margin: "12px 0 0" }}>{liste.length ? "Bu filtrede kayıt yok." : "Kayıt yok."}</p>
        ) : (
          <div style={{ overflowX: "auto", marginTop: "12px" }}>
            <table style={denetimTablo}>
              <thead>
                <tr>{["Zaman", "Tür / neden", "Kullanıcı", "Alanlar ve kelimeler", "Özet", "Mod / işlem", ""].map((b) => <th key={b} style={denetimTh}>{b}</th>)}</tr>
              </thead>
              <tbody>
                {gorunen.map((k) => {
                  const u = resolveUser ? resolveUser(k.uid) : { name: k.uid || "—", missing: !k.uid };
                  return (
                    <tr key={k.id} style={{ background: k.geriAlindi ? "#f8fafc" : "white" }}>
                      <td style={{ ...denetimTd, whiteSpace: "nowrap" }}>{formatDateTime(k.at)}</td>
                      <td style={denetimTd}>
                        <div style={{ fontWeight: "600" }}>{DENETIM_TUR_AD[k.koleksiyon] || k.koleksiyon || "?"}</div>
                        {denetimRozet(DENETIM_NEDEN_AD[k.neden] || k.neden || "?", k.neden === "hiz" ? "#9a3412" : "#b91c1c", k.neden === "hiz" ? "#ffedd5" : "#fee2e2")}
                      </td>
                      <td style={denetimTd}>
                        <div style={{ color: u.missing ? "#94a3b8" : "#1e293b", fontStyle: u.missing ? "italic" : "normal" }}>{u.name}</div>
                        {k.uid && <div style={{ fontSize: "11px", color: "#94a3b8", fontFamily: "monospace" }}>{k.uid.slice(0, 12)}…</div>}
                      </td>
                      <td style={denetimTd}>
                        {(k.alanlar || []).length > 0 && <div style={{ color: "#64748b", marginBottom: "4px" }}>{k.alanlar.join(", ")}</div>}
                        {(k.kelimeler || []).length > 0 && <KelimeCipleri kelimeler={k.kelimeler} />}
                        {k.hiz && (
                          <div style={{ color: "#9a3412" }}>{HIZ_KURAL_AD[k.hiz.kural] || k.hiz.kural}: {k.hiz.sayi} / {k.hiz.sinir}</div>
                        )}
                        {k.neden === "hizmet_tanitimi" && (
                          <div style={{ color: "#475569" }}>
                            puan {k.puan ?? "?"} / eşik {k.esik ?? "?"}
                            {(k.etiketler || []).length > 0 && <div style={{ fontSize: "11px", color: "#64748b" }}>{k.etiketler.map((e) => (e.ifade ? `"${e.ifade}"` : e.tur)).join(", ")}</div>}
                            {k.kullaniciSecimi === "yine_de_yayinla" && <div style={{ fontSize: "11px", color: "#b45309" }}>kullanıcı "Yine de yayınla" dedi</div>}
                          </div>
                        )}
                      </td>
                      <td style={{ ...denetimTd, maxWidth: "320px" }}>
                        {k.ozet ? (
                          <div title={k.ozet} style={{ display: "-webkit-box", WebkitLineClamp: 3, WebkitBoxOrient: "vertical", overflow: "hidden", wordBreak: "break-word" }}>{k.ozet}</div>
                        ) : <span style={{ color: "#94a3b8" }}>—</span>}
                      </td>
                      <td style={denetimTd}>
                        <div style={{ display: "flex", flexDirection: "column", gap: "4px", alignItems: "flex-start" }}>
                          {k.mod === "uygula" ? denetimRozet("uygula", "#b91c1c", "#fee2e2") : denetimRozet(k.mod || "kuru", "#475569", "#f1f5f9")}
                          {denetimRozet(DENETIM_ISLEM_AD[k.islem] || k.islem || "?", "#334155", "#e2e8f0")}
                          {k.geriAlindi && denetimRozet(`Geri alındı${k.geriAlinmaAt ? ` · ${formatDateTime(k.geriAlinmaAt)}` : ""}`, "#166534", "#dcfce7")}
                        </div>
                      </td>
                      <td style={{ ...denetimTd, whiteSpace: "nowrap" }}>
                        <div style={{ display: "flex", flexDirection: "column", gap: "6px", alignItems: "flex-start" }}>
                          {k.yol && <button onClick={() => konsoluAc(k.yol)} style={konsolDugmesi} title={k.yol}>Belgeyi aç</button>}
                          {geriAlinabilirMi(k) && (
                            <button onClick={() => geriAl(k)} disabled={geriAlinan !== null} style={grup3Stil.dugme("#16a34a", geriAlinan !== null)}>
                              <Grup3Donen acik={geriAlinan === k.id} /> Geri al
                            </button>
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )
      )}
    </div>
  );
};

// scanModeration — salt okunur; örnek yollar ve kelime sayıları döner, metin dönmez
const DenetimTaramasi = () => {
  const [gun, setGun] = useState(7);
  const [sonuc, setSonuc] = useState(null);
  const [calisiyor, setCalisiyor] = useState(false);
  const [hata, setHata] = useState(null);
  const calistir = async () => {
    const g = Math.min(90, Math.max(1, Math.floor(Number(gun) || 7)));
    setGun(g);
    setCalisiyor(true);
    setHata(null);
    try { setSonuc(await grup3Cagir("scanModeration", { gun: g })); } catch (e) { setHata(grup3Hata(e)); } finally { setCalisiyor(false); }
  };
  return (
    <div style={grup3Stil.kart}>
      <p style={grup3Stil.baslik}>Tarama (yanlış pozitif ölçümü, salt okunur)</p>
      <p style={grup3Stil.aciklama}>
        Son N günün talep, ilan ve mesajlarında ve bütün profillerde bugünkü listeyle kaç eşleşme olurdu. Hiçbir şey yazmaz; metin dönmez. Uygula moduna geçmeden önce.
      </p>
      <div style={{ display: "flex", gap: "8px", alignItems: "center", flexWrap: "wrap" }}>
        <label style={{ fontSize: "13px", color: "#475569" }}>Gün (1–90)</label>
        <input type="number" min={1} max={90} value={gun} onChange={(e) => setGun(e.target.value)} style={grup3Stil.girdi} />
        <button onClick={calistir} disabled={calisiyor} style={grup3Stil.dugme("#4f46e5", calisiyor)}><Grup3Donen acik={calisiyor} /> Tara</button>
        {calisiyor && <span style={{ fontSize: "12px", color: "#64748b" }}>Bütün profiller okunuyor; birkaç dakika sürebilir.</span>}
      </div>
      <Grup3Hata hata={hata} />
      {sonuc && (
        <>
          <p style={{ fontSize: "12px", color: "#64748b", margin: "12px 0 0" }}>Son {sonuc.gun} gün · o anki sunucu modu: <strong>{sonuc.mod}</strong></p>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))", gap: "12px", marginTop: "8px" }}>
            {["requests", "jobs", "messages", "users"].map((kol) => {
              const r = sonuc[kol] || { taranan: 0, eslesen: 0, ornek: [], kelimeler: {} };
              const kelimeler = Object.entries(r.kelimeler || {}).sort((a, b) => b[1] - a[1]);
              return (
                <div key={kol} style={{ background: "#f8fafc", borderRadius: "10px", padding: "10px 12px" }}>
                  <p style={{ fontSize: "13px", fontWeight: "600", color: "#1e293b", margin: "0 0 4px" }}>
                    {DENETIM_TUR_AD[kol]}{kol === "users" ? " (bütün profiller)" : ""}
                  </p>
                  <p style={{ fontSize: "12px", color: "#475569", margin: "0 0 6px" }}>
                    Taranan <strong>{r.taranan}</strong> · eşleşen <strong style={{ color: r.eslesen ? "#b91c1c" : "#1e293b" }}>{r.eslesen}</strong>
                  </p>
                  {kelimeler.length > 0 && (
                    <div style={{ display: "flex", flexWrap: "wrap", gap: "4px", marginBottom: "6px" }}>
                      {kelimeler.map(([k, n]) => <span key={k} style={{ padding: "1px 7px", background: "#fee2e2", color: "#b91c1c", borderRadius: "10px", fontSize: "11px", fontWeight: "600" }}>{k} ×{n}</span>)}
                    </div>
                  )}
                  {(r.ornek || []).length > 0 && (
                    <details>
                      <summary style={{ fontSize: "12px", color: "#475569", cursor: "pointer" }}>Örnek yollar ({r.ornek.length}{r.eslesen > r.ornek.length ? ` / ${r.eslesen}` : ""})</summary>
                      <div style={{ display: "flex", flexDirection: "column", gap: "2px", marginTop: "4px" }}>
                        {r.ornek.map((y) => <button key={y} onClick={() => konsoluAc(y)} style={{ ...konsolDugmesi, textAlign: "left", fontFamily: "monospace", fontSize: "11px" }}>{y}</button>)}
                      </div>
                    </details>
                  )}
                </div>
              );
            })}
          </div>
          <Grup3Ham veri={sonuc} />
        </>
      )}
    </div>
  );
};

// countDuplicateServices — salt okunur; aynı uzmanın aynı kategori + alt kategorideki birden fazla hizmet kaydı
const MukerrerHizmetSayimi = ({ resolveUser }) => {
  const [ornek, setOrnek] = useState(50);
  const [sonuc, setSonuc] = useState(null);
  const [calisiyor, setCalisiyor] = useState(false);
  const [hata, setHata] = useState(null);
  const [yalnizcaMukerrerTur, setYalnizcaMukerrerTur] = useState(true);
  const calistir = async () => {
    const n = Math.min(200, Math.max(1, Math.floor(Number(ornek) || 50)));
    setOrnek(n);
    setCalisiyor(true);
    setHata(null);
    try { setSonuc(await grup3Cagir("countDuplicateServices", { ornek: n })); } catch (e) { setHata(grup3Hata(e)); } finally { setCalisiyor(false); }
  };
  const turler = sonuc ? (sonuc.turler || []).filter((t) => !yalnizcaMukerrerTur || t.kayit > t.uzman) : [];
  return (
    <div style={grup3Stil.kart}>
      <p style={grup3Stil.baslik}>Hizmet kayıtlarında mükerrer (salt okunur)</p>
      <p style={grup3Stil.aciklama}>
        services: aynı uzmanın aynı kategori + alt kategorideki birden fazla kaydı (Mantolama çifti). Alt kategorisi boş eski kayıtta başlık sayılır; harf farkı yok sayılır; pasif kayıtlar da sayılır. Hiçbir şey yazmaz ya da silmez; temizlik kararı admin'in.
      </p>
      <div style={{ display: "flex", gap: "8px", alignItems: "center", flexWrap: "wrap" }}>
        <label style={{ fontSize: "13px", color: "#475569" }}>Örnek grup (1–200)</label>
        <input type="number" min={1} max={200} value={ornek} onChange={(e) => setOrnek(e.target.value)} style={grup3Stil.girdi} />
        <button onClick={calistir} disabled={calisiyor} style={grup3Stil.dugme("#4f46e5", calisiyor)}><Grup3Donen acik={calisiyor} /> Say</button>
      </div>
      <Grup3Hata hata={hata} />
      {sonuc && (
        <>
          <Grup3Sayilar satirlar={[
            ["toplam kayıt", sonuc.toplamKayit],
            ["aktif kayıt", sonuc.aktifKayit],
            ["uzman", sonuc.uzmanSayisi],
            ["uzmansız kayıt", sonuc.uzmansizKayit, sonuc.uzmansizKayit ? "#b45309" : undefined],
            ["mükerrer grup", sonuc.mukerrerGrup, sonuc.mukerrerGrup ? "#b91c1c" : undefined],
            ["fazla kayıt", sonuc.fazlaKayit, sonuc.fazlaKayit ? "#b91c1c" : undefined],
          ]} />
          {(sonuc.ornekler || []).length > 0 && (
            <>
              <p style={{ fontSize: "13px", fontWeight: "600", color: "#1e293b", margin: "16px 0 6px" }}>
                Mükerrer gruplar ({sonuc.ornekler.length}{sonuc.mukerrerGrup > sonuc.ornekler.length ? ` / ${sonuc.mukerrerGrup}` : ""})
              </p>
              <div style={{ overflowX: "auto" }}>
                <table style={denetimTablo}>
                  <thead><tr>{["Uzman", "Kategori", "Alt kategori", "Adet", "Kayıtlar"].map((b) => <th key={b} style={denetimTh}>{b}</th>)}</tr></thead>
                  <tbody>
                    {sonuc.ornekler.map((g, i) => {
                      const u = resolveUser && g.expertId ? resolveUser(g.expertId) : { name: g.expertId ? `${g.expertId.slice(0, 8)}…` : "(uzman yok)", missing: !g.expertId };
                      return (
                        <tr key={`${g.expertId}|${g.kategori}|${g.altKategori}|${i}`}>
                          <td style={denetimTd}>
                            <div style={{ color: u.missing ? "#94a3b8" : "#1e293b", fontStyle: u.missing ? "italic" : "normal" }}>{u.name}</div>
                            {g.expertId && <div style={{ fontSize: "11px", color: "#94a3b8", fontFamily: "monospace" }}>{g.expertId.slice(0, 12)}…</div>}
                          </td>
                          <td style={denetimTd}>{g.kategori || <span style={{ color: "#94a3b8" }}>—</span>}</td>
                          <td style={denetimTd}>{g.altKategori || <span style={{ color: "#94a3b8" }}>—</span>}</td>
                          <td style={{ ...denetimTd, fontWeight: "700", color: "#b91c1c" }}>{g.adet}</td>
                          <td style={denetimTd}>
                            {(g.kayitlar || []).map((h) => (
                              <div key={h.id} style={{ display: "flex", gap: "8px", alignItems: "center", flexWrap: "wrap", padding: "1px 0" }}>
                                <button onClick={() => konsoluAc(`services/${h.id}`)} style={{ ...konsolDugmesi, fontFamily: "monospace", fontSize: "11px" }}>{h.id}</button>
                                {h.aktif ? denetimRozet("aktif", "#166534", "#dcfce7") : denetimRozet("pasif", "#475569", "#f1f5f9")}
                                <span style={{ color: "#64748b" }}>{h.createdAt ? formatDateTime(h.createdAt) : "tarih yok"}</span>
                                <span style={{ color: "#64748b" }}>{h.fiyat ? `₺${Number(h.fiyat).toLocaleString("tr-TR")}` : "fiyat yok"}</span>
                              </div>
                            ))}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </>
          )}
          <div style={{ display: "flex", alignItems: "center", gap: "12px", margin: "16px 0 6px", flexWrap: "wrap" }}>
            <p style={{ fontSize: "13px", fontWeight: "600", color: "#1e293b", margin: 0 }}>Tür başına kayıt ve uzman (ilk 100)</p>
            <label style={{ fontSize: "12px", color: "#475569", display: "flex", alignItems: "center", gap: "4px" }}>
              <input type="checkbox" checked={yalnizcaMukerrerTur} onChange={(e) => setYalnizcaMukerrerTur(e.target.checked)} />
              yalnızca kayıt &gt; uzman olanlar
            </label>
          </div>
          {turler.length === 0 ? (
            <p style={{ fontSize: "12px", color: "#94a3b8", margin: 0 }}>{yalnizcaMukerrerTur ? "Kayıt sayısı uzman sayısını aşan tür yok." : "Tür yok."}</p>
          ) : (
            <div style={{ overflowX: "auto", maxHeight: "360px", overflowY: "auto" }}>
              <table style={denetimTablo}>
                <thead><tr>{["Kategori", "Alt kategori", "Kayıt", "Uzman"].map((b) => <th key={b} style={denetimTh}>{b}</th>)}</tr></thead>
                <tbody>
                  {turler.map((t, i) => (
                    <tr key={`${t.kategori}|${t.altKategori}|${i}`} style={{ background: t.kayit > t.uzman ? "#fff7ed" : "white" }}>
                      <td style={denetimTd}>{t.kategori || <span style={{ color: "#94a3b8" }}>—</span>}</td>
                      <td style={denetimTd}>{t.altKategori || <span style={{ color: "#94a3b8" }}>—</span>}</td>
                      <td style={{ ...denetimTd, fontWeight: t.kayit > t.uzman ? "700" : "400" }}>{t.kayit}</td>
                      <td style={denetimTd}>{t.uzman}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
          <Grup3Ham veri={sonuc} />
        </>
      )}
    </div>
  );
};

const IcerikDenetimiPanel = ({ resolveUser }) => (
  <div style={{ background: "white", borderRadius: "16px", padding: "24px", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
    <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    <h3 style={{ fontSize: "16px", fontWeight: "600", color: "#1e293b", margin: "0 0 4px 0" }}>Otomatik içerik denetimi (sunucu)</h3>
    <p style={{ fontSize: "13px", color: "#64748b", margin: "0 0 16px 0" }}>
      Talep, ilan, mesaj ve profil metinleri sunucuda denetlenir; yeni hesaplara hız sınırı uygulanır. Düğmeler sunucu fonksiyonlarını çağırır (yalnızca admin); fonksiyonlar deploy edilmeden hata koduyla döner.
    </p>
    <DenetimModu />
    <DenetimKayitlari resolveUser={resolveUser} />
    <DenetimTaramasi />
    <MukerrerHizmetSayimi resolveUser={resolveUser} />
  </div>
);

// ==================== ŞEHİR × KATEGORİ ARZ / TALEP ====================
// Bellekteki users / jobs / requests'ten hesaplanır; Firestore'a yazmaz, yeni okuma yapmaz
// (yönetici listesi Raporlar sayfasının tek admins okumasından gelir).
//   Arz:   uzmanlar — silinmiş ve askıdakiler hariç. İl: serviceArea.city || serviceArea || city
//          (A3 bildirimiyle aynı kaynak). Kategori: categories[] (ana kategori adları;
//          eski kayıtlarda { name }). Çok kategorili uzman her kategorisinde sayılır.
//   Talep: son 60 günde müşteri hesaplarının açtığı ilan + talepler. Test hesapları ve
//          "Olası yanlış rol" işaretlileri hariç — o bölümle AYNI analiz (yanlisRolAnalizi).
//          Bütün durumlar sayılır (iptal edilen de talep oluşturmuştur).
const ARZ_TALEP_GUN = 60;
const ARZ_TALEP_IL_YOK = "(il yok)";
const ARZ_TALEP_KATEGORI_YOK = "(kategorisiz)";
const ARZ_TALEP_DURUM = {
  uzmanYok: { text: "uzman yok", bg: "#fee2e2", color: "#b91c1c" },
  talepYok: { text: "talep yok", bg: "#f1f5f9", color: "#64748b" },
  dengeli: { text: "dengeli", bg: "#dcfce7", color: "#15803d" },
};

// Karşılaştırma anahtarı: Türkçe katlama + boşluk sadeleştirme ("İstanbul" = "istanbul ")
const arzTalepAnahtar = (v) => trKatla(String(v == null ? "" : v)).replace(/\s+/g, " ").trim();
const arzTalepAdListesi = (v) =>
  (Array.isArray(v) ? v : [])
    .map((x) => (x && typeof x === "object" ? x.name : x))
    .filter((x) => typeof x === "string" && x.trim());
const arzTalepUzmanIli = (e) => {
  const sa = e && e.serviceArea;
  const s = sa && typeof sa === "object" ? sa.city : typeof sa === "string" ? sa : null;
  return s || (e && e.city) || "";
};
// Talebin ili: city → location ("İlçe, İl" biçiminde yazılıyor) → müşterinin profil ili
const arzTalepTalepIli = (j, r) => {
  if (j.city && String(j.city).trim()) return { il: j.city, kaynak: "city" };
  if (typeof j.location === "string" && j.location.trim()) {
    const parca = j.location.split(",").map((x) => x.trim()).filter(Boolean);
    if (parca.length) return { il: parca[parca.length - 1], kaynak: "location" };
  }
  const profil = r && r.raw && r.raw.city;
  if (profil && String(profil).trim()) return { il: profil, kaynak: "profil" };
  return { il: "", kaynak: "yok" };
};

const arzTalepAnalizi = (experts, jobs, resolveUser, admin, now = Date.now()) => {
  // anahtar -> { ad sayaçları } ; görünen ad en sık yazılış
  const adlar = new Map();
  const adKaydet = (anahtar, ham) => {
    if (!adlar.has(anahtar)) adlar.set(anahtar, new Map());
    const m = adlar.get(anahtar);
    const t = String(ham).trim();
    m.set(t, (m.get(t) || 0) + 1);
  };
  const ad = (anahtar, bos) => {
    const m = adlar.get(anahtar);
    if (!m || !anahtar) return bos;
    return [...m.entries()].sort((a, b) => b[1] - a[1] || a[0].localeCompare(b[0], "tr"))[0][0];
  };
  const hucreler = new Map(); // "il|kat" -> hücre
  const hucre = (ilA, katA) => {
    const k = ilA + "|" + katA;
    if (!hucreler.has(k)) hucreler.set(k, { ilA, katA, talep: 0, uzman: 0, kimlikOnayli: 0 });
    return hucreler.get(k);
  };

  // --- Arz
  const ozet = { uzman: 0, uzmanHaric: 0, uzmanIlsiz: 0, uzmanKategorisiz: 0, talep: 0, talepIlsiz: 0, talepKategorisiz: 0, ilKaynak: { city: 0, location: 0, profil: 0, yok: 0 }, haricTest: 0, haricYanlisRol: 0, haricBilinmeyen: 0 };
  for (const e of experts || []) {
    if (!e || e.deleted === true) continue;
    if (isSuspended(e)) { ozet.uzmanHaric++; continue; }
    ozet.uzman++;
    const ilHam = arzTalepUzmanIli(e);
    const ilA = arzTalepAnahtar(ilHam);
    if (ilA) adKaydet("il:" + ilA, ilHam); else ozet.uzmanIlsiz++;
    const kats = [...new Map(arzTalepAdListesi(e.categories).map((k) => [arzTalepAnahtar(k), k])).entries()].filter(([a]) => a);
    if (!kats.length) { ozet.uzmanKategorisiz++; kats.push(["", ""]); }
    const kimlik = !!(e._teklifKimlik && e._teklifKimlik.kimlikOnayli);
    for (const [katA, katHam] of kats) {
      if (katA) adKaydet("kat:" + katA, katHam);
      const h = hucre(ilA, katA);
      h.uzman++;
      if (kimlik) h.kimlikOnayli++;
    }
  }

  // --- Talep: "Olası yanlış rol" ile aynı analiz; yalnızca havuzdaki (gerçek müşteri) ve işaretsizler
  const baslangic = now - ARZ_TALEP_GUN * 24 * 60 * 60 * 1000;
  const { sonuc } = yanlisRolAnalizi(jobs, resolveUser, { admin, testDahil: false });
  for (const x of sonuc) {
    const t = toMillis(x.j.createdAt);
    if (!t || t < baslangic || t > now) continue;
    if (x.rol === "test") { ozet.haricTest++; continue; }
    if (x.rol !== "musteri") { ozet.haricBilinmeyen++; continue; }
    if (x.isaretli) { ozet.haricYanlisRol++; continue; }
    ozet.talep++;
    const { il: ilHam, kaynak } = arzTalepTalepIli(x.j, x.r);
    ozet.ilKaynak[kaynak]++;
    const ilA = arzTalepAnahtar(ilHam);
    if (ilA) adKaydet("il:" + ilA, ilHam); else ozet.talepIlsiz++;
    const katHam = x.j.category || "";
    const katA = arzTalepAnahtar(katHam);
    if (katA) adKaydet("kat:" + katA, katHam); else ozet.talepKategorisiz++;
    hucre(ilA, katA).talep++;
  }

  const satirlar = [...hucreler.values()].map((h) => ({
    ...h,
    il: ad("il:" + h.ilA, ARZ_TALEP_IL_YOK),
    kategori: ad("kat:" + h.katA, ARZ_TALEP_KATEGORI_YOK),
    durum: h.talep > 0 && h.uzman === 0 ? "uzmanYok" : h.talep === 0 ? "talepYok" : "dengeli",
  }));
  satirlar.sort((a, b) => b.talep - a.talep || b.uzman - a.uzman || a.il.localeCompare(b.il, "tr") || a.kategori.localeCompare(b.kategori, "tr"));

  // En çok talep gelen 10 il ve her birinde en çok talep gelen 3 kategori
  const ilTalep = new Map();
  for (const s of satirlar) {
    if (!s.talep) continue;
    if (!ilTalep.has(s.ilA)) ilTalep.set(s.ilA, { il: s.il, ilA: s.ilA, talep: 0, uzman: 0, kategoriler: [] });
    const g = ilTalep.get(s.ilA);
    g.talep += s.talep;
    g.kategoriler.push(s);
  }
  // İldeki uzman sayısı: kategoriden bağımsız, tekil uzman (çok kategorili uzman bir kez)
  const ilUzman = new Map();
  for (const e of experts || []) {
    if (!e || e.deleted === true || isSuspended(e)) continue;
    const ilA = arzTalepAnahtar(arzTalepUzmanIli(e));
    ilUzman.set(ilA, (ilUzman.get(ilA) || 0) + 1);
  }
  const ilkOnIl = [...ilTalep.values()]
    .map((g) => ({ ...g, uzman: ilUzman.get(g.ilA) || 0, kategoriler: g.kategoriler.slice(0, 3) }))
    .sort((a, b) => b.talep - a.talep || a.il.localeCompare(b.il, "tr"))
    .slice(0, 10);

  return { satirlar, ilkOnIl, uzmanYok: satirlar.filter((s) => s.durum === "uzmanYok"), ozet };
};

const csvHucre = (v) => {
  const s = String(v == null ? "" : v);
  return /[",\n\r]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};
const csvMetni = (basliklar, satirlar) => [basliklar, ...satirlar].map((r) => r.map(csvHucre).join(",")).join("\r\n");
const panoyaKopyala = async (metin) => {
  try {
    await navigator.clipboard.writeText(metin);
    return true;
  } catch (e) {
    // Pano izni yoksa: geçici textarea ile eski yöntem
    try {
      const ta = document.createElement("textarea");
      ta.value = metin;
      ta.style.position = "fixed";
      ta.style.opacity = "0";
      document.body.appendChild(ta);
      ta.select();
      const ok = document.execCommand("copy");
      document.body.removeChild(ta);
      return ok;
    } catch (e2) {
      return false;
    }
  }
};

const ArzTalepSection = ({ experts, jobs, resolveUser, admin, adminOkuma }) => {
  const [gorunum, setGorunum] = useState("eslesme"); // eslesme | arz | talep
  const [durumFiltre, setDurumFiltre] = useState("hepsi");
  const [ara, setAra] = useState("");
  const [kopyalanan, setKopyalanan] = useState(null);

  const { satirlar, ilkOnIl, uzmanYok, ozet } = useMemo(
    () => arzTalepAnalizi(experts, jobs, resolveUser, admin),
    [experts, jobs, resolveUser, admin]
  );

  const liste = useMemo(() => {
    const q = arzTalepAnahtar(ara);
    return satirlar.filter((s) => {
      if (gorunum === "arz" && s.uzman === 0) return false;
      if (gorunum === "talep" && s.talep === 0) return false;
      if (durumFiltre !== "hepsi" && s.durum !== durumFiltre) return false;
      if (q && !arzTalepAnahtar(s.il).includes(q) && !arzTalepAnahtar(s.kategori).includes(q)) return false;
      return true;
    });
  }, [satirlar, gorunum, durumFiltre, ara]);
  const { currentPage, totalPages, paginatedItems, goToPage, totalItems, startIndex, endIndex } = usePagination(liste, 20);

  const kopyala = async (ad, metin) => {
    const ok = await panoyaKopyala(metin);
    setKopyalanan(ok ? ad : "hata");
    setTimeout(() => setKopyalanan(null), 1800);
  };
  const durumAd = (d) => ARZ_TALEP_DURUM[d].text;
  const tabloCsv = () => csvMetni(
    ["İl", "Kategori", `Talep (son ${ARZ_TALEP_GUN} gün)`, "Uzman", "Kimliği onaylı uzman", "Durum"],
    liste.map((s) => [s.il, s.kategori, s.talep, s.uzman, s.kimlikOnayli, durumAd(s.durum)])
  );
  const ilkOnCsv = () => csvMetni(
    ["Sıra", "İl", "Talep", "İldeki uzman", "1. kategori", "Talep", "2. kategori", "Talep", "3. kategori", "Talep"],
    ilkOnIl.map((g, i) => [i + 1, g.il, g.talep, g.uzman, ...[0, 1, 2].flatMap((k) => (g.kategoriler[k] ? [g.kategoriler[k].kategori, g.kategoriler[k].talep] : ["", ""]))])
  );
  const uzmanYokCsv = () => csvMetni(
    ["İl", "Kategori", "Talep"],
    uzmanYok.map((s) => [s.il, s.kategori, s.talep])
  );

  const kart = { background: "white", borderRadius: "16px", padding: "24px", boxShadow: "0 1px 3px rgba(0,0,0,0.05)", marginBottom: "24px" };
  const th = { textAlign: "left", fontSize: "12px", fontWeight: "600", color: "#64748b", padding: "8px 10px", borderBottom: "1px solid #e2e8f0", whiteSpace: "nowrap" };
  const thSag = { ...th, textAlign: "right" };
  const td = { padding: "8px 10px", fontSize: "13px", color: "#334155", borderBottom: "1px solid #f1f5f9", verticalAlign: "top" };
  const tdSag = { ...td, textAlign: "right", fontVariantNumeric: "tabular-nums" };
  const secim = { padding: "8px 12px", border: "1px solid #e2e8f0", borderRadius: "8px", fontSize: "13px", outline: "none", background: "white" };
  const kopyaDugmesi = (ad, uret) => (
    <button onClick={() => kopyala(ad, uret())}
      style={{ padding: "6px 12px", background: "#f1f5f9", color: "#334155", border: "1px solid #e2e8f0", borderRadius: "8px", fontSize: "12px", cursor: "pointer", whiteSpace: "nowrap" }}>
      {kopyalanan === ad ? "Kopyalandı" : kopyalanan === "hata" ? "Kopyalanamadı" : "CSV kopyala"}
    </button>
  );
  const durumRozeti = (d) => (
    <span style={{ padding: "2px 8px", borderRadius: "10px", fontSize: "11px", fontWeight: "600", background: ARZ_TALEP_DURUM[d].bg, color: ARZ_TALEP_DURUM[d].color, whiteSpace: "nowrap" }}>
      {ARZ_TALEP_DURUM[d].text}
    </span>
  );
  const kutu = (deger, etiket, renk) => (
    <div style={{ background: "#f8fafc", borderRadius: "12px", padding: "14px 16px" }}>
      <p style={{ fontSize: "22px", fontWeight: "700", color: renk || "#1e293b", margin: 0 }}>{deger}</p>
      <p style={{ fontSize: "12px", color: "#64748b", margin: "2px 0 0" }}>{etiket}</p>
    </div>
  );
  const baslikSatiri = (metin, aciklama, dugme) => (
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end", gap: "12px", flexWrap: "wrap", margin: "24px 0 8px" }}>
      <div>
        <h4 style={{ fontSize: "14px", fontWeight: "600", color: "#1e293b", margin: 0 }}>{metin}</h4>
        {aciklama && <p style={{ fontSize: "12px", color: "#94a3b8", margin: "2px 0 0" }}>{aciklama}</p>}
      </div>
      {dugme}
    </div>
  );

  return (
    <div style={kart}>
      <h3 style={{ fontSize: "16px", fontWeight: "600", color: "#1e293b", margin: "0 0 4px 0" }}>Şehir × kategori arz/talep</h3>
      <p style={{ fontSize: "13px", color: "#64748b", margin: "0 0 16px 0" }}>
        Arz: silinmiş ve askıdakiler hariç uzmanlar (il ve ana kategori; çok kategorili uzman her kategorisinde sayılır).
        Talep: son {ARZ_TALEP_GUN} günde müşteri hesaplarından açılan ilan ve talepler; test hesapları ve "Olası yanlış rol" işaretlileri hariç.
      </p>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(150px, 1fr))", gap: "12px", marginBottom: "12px" }}>
        {kutu(ozet.uzman, `uzman (askıda ${ozet.uzmanHaric} hariç)`)}
        {kutu(ozet.talep, `talep (son ${ARZ_TALEP_GUN} gün)`)}
        {kutu(satirlar.filter((s) => s.talep > 0).length, "talep gelen il × kategori")}
        {kutu(uzmanYok.length, "uzmanı olmayan il × kategori", uzmanYok.length ? "#b91c1c" : undefined)}
      </div>
      <p style={{ fontSize: "12px", color: "#64748b", margin: "0 0 4px 0" }}>
        Hariç tutulan talep: test hesabı {ozet.haricTest} · olası yanlış rol {ozet.haricYanlisRol} · rolü belirlenemeyen {ozet.haricBilinmeyen}. Uzman hesaplarının açtıkları talep sayılmaz.
      </p>
      <p style={{ fontSize: "12px", color: "#94a3b8", margin: "0 0 4px 0" }}>
        Talebin ili: city alanından {ozet.ilKaynak.city} · konum metninden {ozet.ilKaynak.location} · müşteri profilinden {ozet.ilKaynak.profil} · belirlenemeyen {ozet.ilKaynak.yok}.
        İli olmayan uzman {ozet.uzmanIlsiz} · kategorisi olmayan uzman {ozet.uzmanKategorisiz} · kategorisi olmayan talep {ozet.talepKategorisiz}.
      </p>
      <p style={{ fontSize: "12px", color: "#94a3b8", margin: "0 0 4px 0" }}>
        Şehirden bağımsız (uzaktan) hizmet veren kategoriler de il bazında sayılır; o kategorilerde "uzman yok" başka ildeki uzmanlarca karşılanabilir.
        {adminOkuma === "bekliyor" && " · yönetici listesi yükleniyor…"}
        {adminOkuma === "hata" && <span style={{ color: "#dc2626", fontWeight: "600" }}> · admins okunamadı — yalnızca liste ve oturumdaki yönetici test sayıldı</span>}
      </p>

      {baslikSatiri(
        "İl × kategori tablosu",
        `${liste.length} satır`,
        <div style={{ display: "flex", gap: "8px", flexWrap: "wrap", alignItems: "center" }}>
          <select value={gorunum} onChange={(e) => setGorunum(e.target.value)} style={secim}>
            <option value="eslesme">Eşleşme (arz + talep)</option>
            <option value="arz">Uzman arzı (uzmanı olanlar)</option>
            <option value="talep">Talep (talep gelenler)</option>
          </select>
          <select value={durumFiltre} onChange={(e) => setDurumFiltre(e.target.value)} style={secim}>
            <option value="hepsi">Bütün durumlar</option>
            <option value="uzmanYok">Uzman yok</option>
            <option value="talepYok">Talep yok</option>
            <option value="dengeli">Dengeli</option>
          </select>
          <input value={ara} onChange={(e) => setAra(e.target.value)} placeholder="İl ya da kategori ara" style={{ ...secim, minWidth: "180px" }} />
          {kopyaDugmesi("tablo", tabloCsv)}
        </div>
      )}
      {liste.length === 0 ? (
        <p style={{ fontSize: "13px", color: "#64748b", margin: 0 }}>Bu seçimde satır yok.</p>
      ) : (
        <>
          <div style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr>
                  <th style={th}>İl</th>
                  <th style={th}>Kategori</th>
                  <th style={thSag}>Talep</th>
                  <th style={thSag}>Uzman</th>
                  <th style={thSag}>Kimliği onaylı</th>
                  <th style={th}>Durum</th>
                </tr>
              </thead>
              <tbody>
                {paginatedItems.map((s) => (
                  <tr key={s.ilA + "|" + s.katA}>
                    <td style={td}>{s.il}</td>
                    <td style={td}>{s.kategori}</td>
                    <td style={{ ...tdSag, fontWeight: s.talep ? "600" : "400" }}>{s.talep}</td>
                    <td style={tdSag}>{s.uzman}</td>
                    <td style={tdSag}>{s.kimlikOnayli}</td>
                    <td style={td}>{durumRozeti(s.durum)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <PaginationBar currentPage={currentPage} totalPages={totalPages} goToPage={goToPage} totalItems={totalItems} startIndex={startIndex} endIndex={endIndex} />
        </>
      )}

      {baslikSatiri(
        "En çok talep gelen 10 il",
        "Her ilde en çok talep gelen 3 kategori; parantez içinde o kategorideki uzman sayısı",
        ilkOnIl.length > 0 && kopyaDugmesi("ilkOn", ilkOnCsv)
      )}
      {ilkOnIl.length === 0 ? (
        <p style={{ fontSize: "13px", color: "#64748b", margin: 0 }}>Son {ARZ_TALEP_GUN} günde talep yok.</p>
      ) : (
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th style={th}>#</th>
                <th style={th}>İl</th>
                <th style={thSag}>Talep</th>
                <th style={thSag}>İldeki uzman</th>
                <th style={th}>1. kategori</th>
                <th style={th}>2. kategori</th>
                <th style={th}>3. kategori</th>
              </tr>
            </thead>
            <tbody>
              {ilkOnIl.map((g, i) => (
                <tr key={g.ilA}>
                  <td style={td}>{i + 1}</td>
                  <td style={{ ...td, fontWeight: "600" }}>{g.il}</td>
                  <td style={tdSag}>{g.talep}</td>
                  <td style={tdSag}>{g.uzman}</td>
                  {[0, 1, 2].map((k) => {
                    const s = g.kategoriler[k];
                    return (
                      <td key={k} style={td}>
                        {s ? (
                          <>
                            {s.kategori} <strong>{s.talep}</strong>{" "}
                            <span style={{ color: s.uzman === 0 ? "#b91c1c" : "#94a3b8", fontWeight: s.uzman === 0 ? "600" : "400" }}>({s.uzman} uzman)</span>
                          </>
                        ) : <span style={{ color: "#cbd5e1" }}>—</span>}
                      </td>
                    );
                  })}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {baslikSatiri(
        `Uzmanı olmayan ama talep gelen il × kategori (${uzmanYok.length})`,
        "Talep sayısına göre sıralı",
        uzmanYok.length > 0 && kopyaDugmesi("uzmanYok", uzmanYokCsv)
      )}
      {uzmanYok.length === 0 ? (
        <p style={{ fontSize: "13px", color: "#64748b", margin: 0 }}>Talep gelen her il × kategoride en az bir uzman var.</p>
      ) : (
        <div style={{ overflowX: "auto", maxHeight: "420px", overflowY: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr><th style={th}>İl</th><th style={th}>Kategori</th><th style={thSag}>Talep</th></tr>
            </thead>
            <tbody>
              {uzmanYok.map((s) => (
                <tr key={s.ilA + "|" + s.katA}>
                  <td style={td}>{s.il}</td>
                  <td style={td}>{s.kategori}</td>
                  <td style={{ ...tdSag, fontWeight: "600" }}>{s.talep}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

// ==================== REPORTS PAGE (with Charts) ====================
// ==================== TEKLİF HAZIRLIĞI (teşhis) ====================
// Uzmanların ana uygulamada teklif verip veremeyeceğini, uygulamanın KENDİ kapılarıyla
// hesaplar. Veri: bellekteki users/jobs dinleyicileri. Ek Firestore okuması YOK.
const TEKLIF_KAPI_SATIRLARI = [
  { id: "toplam", label: "Toplam uzman (silinmemiş, askıda olmayan)", sec: () => true },
  { id: "abone", label: "Abonelik ya da deneme geçerli", sec: (r) => r.abone },
  { id: "kimlik", label: "Kimlik yüklenmiş", sec: (r) => r.k.kimlikYuklendi },
  { id: "onay", label: "Kimlik onaylı ve reddedilmiş belge yok", sec: (r) => r.k.kimlikOnayli && !r.k.reddedilmisBelgeVar },
  { id: "hepsi", label: "Üç kapıyı birden geçen — teklif verebilir", sec: (r) => r.teklifVerebilir },
];

const teklifTarihMetni = (d) => {
  const t = teklifTarih(d);
  return t ? t.toLocaleDateString("tr-TR") : "—";
};

// Uygulamanın `new Date(x)` ile okuyamadığı ama panelin okuyabildiği tarih (ör. Timestamp)
const teklifUygulamaOkuyamaz = (d) => !!d && isNaN(new Date(d).getTime()) && !!teklifTarih(d);

const teklifAbonelikMetni = (u) => {
  const parcalar = ["Abonelik/deneme yok"];
  if (u.trialEndDate) {
    parcalar.push(
      `deneme bitişi ${teklifTarihMetni(u.trialEndDate)}` +
        (u.trialActive === true ? "" : " (trialActive kapalı)") +
        (teklifUygulamaOkuyamaz(u.trialEndDate) ? " — uygulama bu tarihi okuyamıyor" : "")
    );
  } else {
    parcalar.push("deneme kaydı yok");
  }
  if (u.premiumEndDate) {
    parcalar.push(
      `premium bitişi ${teklifTarihMetni(u.premiumEndDate)}` +
        (teklifUygulamaOkuyamaz(u.premiumEndDate) ? " — uygulama bu tarihi okuyamıyor" : "")
    );
  }
  return parcalar.join(" · ");
};

// Kategori yazım karşılaştırması için anahtar ve fark sebepleri
const teklifKatBosluk = (v) => v.normalize("NFC").replace(/ /g, " ").trim().replace(/\s+/g, " ");
const teklifKatVe = (v) => v.replace(/\s*&\s*/g, " ve ").replace(/\s+/g, " ").trim();
const teklifKatAnahtar = (v) =>
  typeof v === "string" ? teklifKatVe(teklifKatBosluk(v).toLocaleLowerCase("tr-TR")) : `__${JSON.stringify(v)}`;
const teklifKatSebepler = (a, b) => {
  if (typeof a !== "string" || typeof b !== "string") return ["tür farkı"];
  const sebep = [];
  const a1 = teklifKatBosluk(a);
  const b1 = teklifKatBosluk(b);
  if (a1 !== a || b1 !== b) sebep.push("boşluk/Unicode");
  if (/&/.test(a1) !== /&/.test(b1)) sebep.push("& / ve");
  if (teklifKatVe(a1) !== teklifKatVe(b1)) sebep.push("büyük/küçük harf");
  return sebep;
};
const teklifKatGoster = (v) =>
  v === undefined || v === null || v === "" ? "(boş)" : typeof v === "string" ? `"${v}"` : JSON.stringify(v);

const TeklifHazirligiSection = ({ experts, jobs }) => {
  const [acikSatir, setAcikSatir] = useState(null);

  const analiz = useMemo(() => {
    const now = new Date();
    const havuz = experts.filter((e) => e.suspended !== true);

    const uzmanlar = havuz
      .map((e) => {
        const k = e._teklifKimlik || {
          kimlikYuklendi: false,
          kimlikDurumu: null,
          kimlikOnayli: false,
          reddedilmisBelgeVar: false,
        };
        const abone = teklifAbonelikGecerli(e, now);
        const kapilar = [];
        if (!abone) kapilar.push(teklifAbonelikMetni(e));
        if (!k.kimlikYuklendi) kapilar.push("Kimlik yüklenmemiş");
        else if (!k.kimlikOnayli)
          kapilar.push(`Kimlik onaysız (durum: ${k.kimlikDurumu === null ? "yok" : `"${k.kimlikDurumu}"`})`);
        if (k.reddedilmisBelgeVar) kapilar.push("Reddedilmiş belge var");
        const teklifVerebilir = abone && k.kimlikYuklendi && !k.reddedilmisBelgeVar && k.kimlikOnayli;
        return { e, k, abone, kapilar, teklifVerebilir };
      })
      .sort((a, b) => (teklifTarih(b.e.createdAt)?.getTime() || 0) - (teklifTarih(a.e.createdAt)?.getTime() || 0));

    const satirlar = TEKLIF_KAPI_SATIRLARI.map((s) => ({ ...s, liste: uzmanlar.filter(s.sec) }));
    const verebilenler = uzmanlar.filter((r) => r.teklifVerebilir);

    // Ana uygulamanın getPendingJobs'u yalnızca `jobs` koleksiyonunu, status "pending" ile okur
    const sadeceJobs = jobs.filter((j) => j._source === "jobs");
    const acikIlanlar = sadeceJobs
      .filter((j) => j.status === "pending")
      .sort((a, b) => (teklifTarih(b.createdAt)?.getTime() || 0) - (teklifTarih(a.createdAt)?.getTime() || 0))
      .map((j) => ({
        j,
        eslesen: verebilenler.filter((r) => Array.isArray(r.e.categories) && r.e.categories.includes(j.category)).length,
      }));
    const kategorisiBosVerebilen = verebilenler.filter(
      (r) => !Array.isArray(r.e.categories) || r.e.categories.length === 0
    ).length;

    // Kategori değerleri: jobs koleksiyonundaki tüm ilanlar × havuzdaki tüm uzmanlar
    const ilanKat = new Map();
    sadeceJobs.forEach((j) => {
      const v = j.category === undefined || j.category === null ? "" : j.category;
      ilanKat.set(v, (ilanKat.get(v) || 0) + 1);
    });
    const uzmanKat = new Map();
    havuz.forEach((e) => {
      (Array.isArray(e.categories) ? e.categories : []).forEach((v) => uzmanKat.set(v, (uzmanKat.get(v) || 0) + 1));
    });
    const tumDegerler = Array.from(new Set([...ilanKat.keys(), ...uzmanKat.keys()]));
    const katSatirlari = tumDegerler
      .map((v) => {
        const ilan = ilanKat.get(v) || 0;
        const uzman = uzmanKat.get(v) || 0;
        let durum = "birebir";
        let varyantlar = [];
        if (!(ilan > 0 && uzman > 0)) {
          const karsiTaraf = ilan > 0 ? Array.from(uzmanKat.keys()) : Array.from(ilanKat.keys());
          const anahtar = teklifKatAnahtar(v);
          varyantlar = v === "" ? [] : karsiTaraf.filter((x) => x !== v && x !== "" && teklifKatAnahtar(x) === anahtar);
          durum = v === "" ? "bos" : varyantlar.length > 0 ? "yazim" : "karsiliksiz";
        }
        return { v, ilan, uzman, durum, varyantlar };
      })
      .sort((a, b) => {
        const sira = { yazim: 0, bos: 1, karsiliksiz: 2, birebir: 3 };
        return sira[a.durum] - sira[b.durum] || b.ilan + b.uzman - (a.ilan + a.uzman);
      });

    return { satirlar, acikIlanlar, katSatirlari, kategorisiBosVerebilen, toplam: uzmanlar.length };
  }, [experts, jobs]);

  const kart = { background: "white", borderRadius: "16px", padding: "24px", boxShadow: "0 1px 3px rgba(0,0,0,0.05)", marginBottom: "24px" };
  const th = { textAlign: "left", fontSize: "12px", fontWeight: "600", color: "#64748b", padding: "8px 10px", borderBottom: "1px solid #e2e8f0", whiteSpace: "nowrap" };
  const td = { fontSize: "13px", color: "#1e293b", padding: "8px 10px", borderBottom: "1px solid #f1f5f9", verticalAlign: "top" };
  const mono = { fontFamily: "ui-monospace, SFMono-Regular, Menlo, Consolas, monospace", whiteSpace: "pre", fontSize: "12px" };
  const altBaslik = { fontSize: "14px", fontWeight: "600", color: "#1e293b", margin: "24px 0 10px 0" };
  const durumRozeti = {
    birebir: { text: "✓ birebir eşleşiyor", bg: "#dcfce7", color: "#166534" },
    yazim: { text: "⚠ yazım farkı", bg: "#fef3c7", color: "#92400e" },
    karsiliksiz: { text: "karşılığı yok", bg: "#f1f5f9", color: "#475569" },
    bos: { text: "⚠ kategori boş", bg: "#fee2e2", color: "#991b1b" },
  };

  return (
    <div style={kart}>
      <h3 style={{ fontSize: "16px", fontWeight: "600", color: "#1e293b", margin: "0 0 4px 0" }}>Teklif Hazırlığı (teşhis)</h3>
      <p style={{ fontSize: "13px", color: "#64748b", margin: "0 0 16px 0" }}>
        Ana uygulamanın teklif kapılarının birebir kopyası. Veri: bellekteki kullanıcı ve ilan listeleri, ek okuma yok.
      </p>

      {/* 1) Uzman kapı tablosu */}
      <h4 style={{ ...altBaslik, marginTop: 0 }}>1. Uzman kapıları</h4>
      <div style={{ border: "1px solid #e2e8f0", borderRadius: "12px", overflow: "hidden" }}>
        {analiz.satirlar.map((s, i) => {
          const acik = acikSatir === s.id;
          const oran = analiz.toplam > 0 ? Math.round((s.liste.length / analiz.toplam) * 100) : 0;
          return (
            <div key={s.id} style={{ borderTop: i === 0 ? "none" : "1px solid #f1f5f9" }}>
              <button
                onClick={() => setAcikSatir(acik ? null : s.id)}
                style={{
                  width: "100%", display: "flex", alignItems: "center", gap: "10px", padding: "12px 14px",
                  background: s.id === "hepsi" ? "#f5f3ff" : acik ? "#f8fafc" : "white",
                  border: "none", cursor: "pointer", textAlign: "left",
                }}
              >
                <ChevronRight size={16} color="#94a3b8" style={{ transform: acik ? "rotate(90deg)" : "none", transition: "transform 0.15s", flexShrink: 0 }} />
                <span style={{ flex: 1, fontSize: "14px", fontWeight: s.id === "hepsi" ? "700" : "500", color: "#1e293b" }}>{s.label}</span>
                <span style={{ fontSize: "16px", fontWeight: "700", color: s.id === "hepsi" ? "#6d28d9" : "#1e293b", minWidth: "40px", textAlign: "right" }}>{s.liste.length}</span>
                <span style={{ fontSize: "12px", color: "#94a3b8", minWidth: "44px", textAlign: "right" }}>{s.id === "toplam" ? "" : `%${oran}`}</span>
              </button>
              {acik && (
                <div style={{ padding: "0 14px 14px 40px", background: "#f8fafc" }}>
                  {s.liste.length === 0 ? (
                    <p style={{ fontSize: "13px", color: "#94a3b8", margin: 0, padding: "8px 0" }}>Bu satırda uzman yok.</p>
                  ) : (
                    <div style={{ maxHeight: "360px", overflow: "auto", background: "white", border: "1px solid #e2e8f0", borderRadius: "8px" }}>
                      <table style={{ width: "100%", borderCollapse: "collapse" }}>
                        <thead>
                          <tr>
                            <th style={th}>İsim</th>
                            <th style={th}>Kayıt tarihi</th>
                            <th style={th}>Takıldığı kapı</th>
                          </tr>
                        </thead>
                        <tbody>
                          {s.liste.map((r) => (
                            <tr key={r.e.id}>
                              <td style={td}>{r.e.name || r.e.displayName || r.e.email || r.e.id}</td>
                              <td style={{ ...td, whiteSpace: "nowrap" }}>{teklifTarihMetni(r.e.createdAt)}</td>
                              <td style={td}>
                                {r.kapilar.length === 0 ? (
                                  <span style={{ color: "#16a34a", fontWeight: "600" }}>— (teklif verebilir)</span>
                                ) : (
                                  <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
                                    {r.kapilar.map((k, ki) => (
                                      <span key={ki} style={{ background: "#fee2e2", color: "#991b1b", borderRadius: "6px", padding: "2px 8px", fontSize: "12px" }}>{k}</span>
                                    ))}
                                  </div>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>

      {/* 2) Açık ilan × kategori */}
      <h4 style={altBaslik}>2. Açık ilanlar × kategori ({analiz.acikIlanlar.length} ilan, jobs koleksiyonu, status "pending")</h4>
      {analiz.acikIlanlar.length === 0 ? (
        <p style={{ fontSize: "13px", color: "#94a3b8", margin: 0 }}>Açık ilan yok.</p>
      ) : (
        <div style={{ overflowX: "auto", border: "1px solid #e2e8f0", borderRadius: "12px" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th style={th}>Başlık</th>
                <th style={th}>category (birebir)</th>
                <th style={th}>Şehir</th>
                <th style={th}>Tarih</th>
                <th style={{ ...th, textAlign: "right" }}>Birebir eşleşen “teklif verebilir” uzman</th>
              </tr>
            </thead>
            <tbody>
              {analiz.acikIlanlar.map(({ j, eslesen }) => (
                <tr key={j.id}>
                  <td style={td}>{j.title || j.subCategory || j.service || "(başlıksız)"}</td>
                  <td style={{ ...td, ...mono }}>{teklifKatGoster(j.category)}</td>
                  <td style={td}>{[j.city, j.district].filter(Boolean).join(" / ") || "—"}</td>
                  <td style={{ ...td, whiteSpace: "nowrap" }}>{teklifTarihMetni(j.createdAt)}</td>
                  <td style={{ ...td, textAlign: "right", fontWeight: "700", color: eslesen === 0 ? "#dc2626" : "#16a34a" }}>{eslesen}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <p style={{ fontSize: "12px", color: "#64748b", margin: "8px 0 0 0", lineHeight: "1.5" }}>
        Not (ana uygulama kodundan): İlan listesi kategori filtresini <code>expertCategories</code> ile uygular (App.js:32388).
        Bu değer yalnızca kayıt oturumunda doldurulur (App.js:64696); uygulama yeniden açıldığında boştur (App.js:69575)
        ve bu durumda uzman tüm açık ilanları görür. Kategorisi boş “teklif verebilir” uzman: {analiz.kategorisiBosVerebilen}.
      </p>

      {/* 3) Kategori yazım farkı */}
      <h4 style={altBaslik}>3. Kategori değerleri: ilanlar ↔ uzmanlar</h4>
      {analiz.katSatirlari.length === 0 ? (
        <p style={{ fontSize: "13px", color: "#94a3b8", margin: 0 }}>Kategori değeri yok.</p>
      ) : (
        <div style={{ overflowX: "auto", border: "1px solid #e2e8f0", borderRadius: "12px" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th style={th}>Değer (birebir)</th>
                <th style={{ ...th, textAlign: "right" }}>İlanlarda</th>
                <th style={{ ...th, textAlign: "right" }}>Uzmanlarda</th>
                <th style={th}>Durum</th>
              </tr>
            </thead>
            <tbody>
              {analiz.katSatirlari.map((r, i) => {
                const rozet = durumRozeti[r.durum];
                return (
                  <tr key={i}>
                    <td style={{ ...td, ...mono }}>{teklifKatGoster(r.v)}</td>
                    <td style={{ ...td, textAlign: "right" }}>{r.ilan}</td>
                    <td style={{ ...td, textAlign: "right" }}>{r.uzman}</td>
                    <td style={td}>
                      <span style={{ background: rozet.bg, color: rozet.color, borderRadius: "6px", padding: "2px 8px", fontSize: "12px", fontWeight: "600", whiteSpace: "nowrap" }}>{rozet.text}</span>
                      {r.durum === "yazim" &&
                        r.varyantlar.map((x, xi) => (
                          <div key={xi} style={{ fontSize: "12px", color: "#475569", marginTop: "4px" }}>
                            {r.ilan > 0 ? "uzmanlarda" : "ilanlarda"}: <span style={mono}>{teklifKatGoster(x)}</span> — {teklifKatSebepler(r.v, x).join(", ")}
                          </div>
                        ))}
                      {r.durum === "karsiliksiz" && (
                        <div style={{ fontSize: "12px", color: "#64748b", marginTop: "4px" }}>
                          {r.ilan > 0 ? "Bu kategoride uzman yok" : "Bu kategoride ilan yok"}
                        </div>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

const ReportsPage = ({ stats, customers, experts, jobs, deletedCount = 0, resolveUser = null, onToggleSuspend = null, updateJobStatus = null }) => {
  const { admin, adminOkuma } = usePanelVeri();

  // Aylık kayıt verileri hesapla (son 6 ay)
  const monthlyData = useMemo(() => {
    const months = [];
    const now = new Date();
    for (let i = 5; i >= 0; i--) {
      const date = new Date(now.getFullYear(), now.getMonth() - i, 1);
      const monthEnd = new Date(now.getFullYear(), now.getMonth() - i + 1, 0);
      const monthLabel = date.toLocaleDateString("tr-TR", { month: "short", year: "2-digit" });

      const getDate = (d) => {
        if (!d) return null;
        if (typeof d === "object" && d.seconds) return new Date(d.seconds * 1000);
        if (typeof d === "object" && d.toDate) return d.toDate();
        const parsed = new Date(d);
        return isNaN(parsed.getTime()) ? null : parsed;
      };

      const countInMonth = (arr) => arr.filter((item) => {
        const d = getDate(item.createdAt);
        return d && d >= date && d <= monthEnd;
      }).length;

      months.push({
        label: monthLabel,
        customers: countInMonth(customers),
        experts: countInMonth(experts),
        jobs: countInMonth(jobs),
      });
    }
    return months;
  }, [customers, experts, jobs]);

  // İş durumu dağılımı
  const jobStatusData = useMemo(() => {
    const statuses = { pending: 0, in_progress: 0, completed: 0, cancelled: 0 };
    jobs.forEach((j) => { if (statuses[j.status] !== undefined) statuses[j.status]++; });
    return statuses;
  }, [jobs]);

  // Şehir dağılımı
  const cityData = useMemo(() => {
    const cities = {};
    [...customers, ...experts].forEach((u) => {
      const city = u.city || "Belirtilmemiş";
      cities[city] = (cities[city] || 0) + 1;
    });
    return Object.entries(cities).sort((a, b) => b[1] - a[1]).slice(0, 8);
  }, [customers, experts]);

  const maxMonthly = Math.max(...monthlyData.map((m) => Math.max(m.customers, m.experts, m.jobs)), 1);
  const totalJobs = Object.values(jobStatusData).reduce((a, b) => a + b, 0);
  const maxCity = cityData.length > 0 ? cityData[0][1] : 1;

  const statusLabels = { pending: "Bekliyor", in_progress: "Devam Ediyor", completed: "Tamamlandı", cancelled: "İptal" };
  const statusColors = { pending: "#f59e0b", in_progress: "#3b82f6", completed: "#16a34a", cancelled: "#dc2626" };

  return (
    <div>
      <div style={{ marginBottom: "24px" }}>
        <h1 style={{ fontSize: "24px", fontWeight: "700", color: "#1e293b", margin: "0 0 4px 0" }}>Raporlar</h1>
        <p style={{ fontSize: "14px", color: "#64748b", margin: 0 }}>Detaylı istatistikler ve grafikler</p>
      </div>

      {/* Genel Özet Kartları */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))", gap: "16px", marginBottom: "24px" }}>
        {[
          { icon: Users, color: "#3b82f6", value: customers.length, label: "Toplam Müşteri" },
          { icon: UserCheck, color: "#10b981", value: experts.length, label: "Toplam Uzman" },
          { icon: Briefcase, color: "#f59e0b", value: jobs.length, label: "Toplam İş İlanı" },
          { icon: CheckCircle, color: "#8b5cf6", value: jobs.filter((j) => j.status === "completed").length, label: "Tamamlanan İş" },
          // Dashboard'dan taşındı. Kaynak: allDeletedUsers.length (eski soft-delete + deletedAccounts tombstone'ları)
          { icon: Trash2, color: "#ef4444", value: deletedCount, label: "Silinmiş Hesap" },
        ].map((s, i) => (
          <div key={i} style={{ background: "white", borderRadius: "16px", padding: "20px", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
            <s.icon size={24} color={s.color} style={{ marginBottom: "12px" }} />
            <p style={{ fontSize: "28px", fontWeight: "700", color: "#1e293b", margin: "0 0 4px 0" }}>{s.value}</p>
            <p style={{ fontSize: "14px", color: "#64748b", margin: 0 }}>{s.label}</p>
          </div>
        ))}
      </div>

      {/* Teklif Hazırlığı — teşhis (ana uygulamanın teklif kapıları) */}
      <TeklifHazirligiSection experts={experts} jobs={jobs} />

      {/* Olası yanlış rol — teşhis (müşteri hesabından hizmet tanıtımı / iş arama) */}
      <YanlisRolSection jobs={jobs} resolveUser={resolveUser} onToggleSuspend={onToggleSuspend} admin={admin} adminOkuma={adminOkuma} />

      {/* Şehir × kategori arz/talep — bellekteki veriden, yeni Firestore okuması yok */}
      <ArzTalepSection experts={experts} jobs={jobs} resolveUser={resolveUser} admin={admin} adminOkuma={adminOkuma} />

      {/* A3 simülasyonu — yalnızca düğmeyle sunucu çağrısı, hiçbir şey yazmaz */}
      <A3SimulasyonSection jobs={jobs} />

      {/* Fotoğraf göçü — yalnızca düğmeyle sunucu çağrısı; panel Firestore'a yazmaz */}
      <FotoGocuSection />

      {/* Yetim belge dosyaları — yalnızca düğmeyle sunucu çağrısı; varsayılan kuru çalıştırma */}
      <YetimBelgeSection />

      {/* 1.0.31 Grup 3 — taşıma ve doldurma; yalnızca düğmeyle sunucu çağrısı, kuru başlar */}
      <Grup3Section experts={experts} jobs={jobs} resolveUser={resolveUser} onToggleSuspend={onToggleSuspend} updateJobStatus={updateJobStatus} />

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(350px, 1fr))", gap: "20px", marginBottom: "24px" }}>
        {/* Aylık Kayıt Grafiği */}
        <div style={{ background: "white", borderRadius: "16px", padding: "24px", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
          <h3 style={{ fontSize: "16px", fontWeight: "600", color: "#1e293b", margin: "0 0 8px 0" }}>Aylık Kayıtlar (Son 6 Ay)</h3>
          <div style={{ display: "flex", gap: "12px", marginBottom: "16px", fontSize: "12px" }}>
            <span style={{ display: "flex", alignItems: "center", gap: "4px" }}><span style={{ width: "10px", height: "10px", borderRadius: "50%", background: "#3b82f6" }} />Müşteri</span>
            <span style={{ display: "flex", alignItems: "center", gap: "4px" }}><span style={{ width: "10px", height: "10px", borderRadius: "50%", background: "#10b981" }} />Uzman</span>
            <span style={{ display: "flex", alignItems: "center", gap: "4px" }}><span style={{ width: "10px", height: "10px", borderRadius: "50%", background: "#f59e0b" }} />İş İlanı</span>
          </div>
          <div style={{ display: "flex", alignItems: "flex-end", gap: "8px", height: "180px" }}>
            {monthlyData.map((m, i) => (
              <div key={i} style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center", gap: "4px" }}>
                <div style={{ display: "flex", gap: "2px", alignItems: "flex-end", height: "150px", width: "100%" }}>
                  <div style={{ flex: 1, background: "#3b82f6", borderRadius: "4px 4px 0 0", height: `${Math.max((m.customers / maxMonthly) * 100, 4)}%`, transition: "height 0.3s" }} title={`Müşteri: ${m.customers}`} />
                  <div style={{ flex: 1, background: "#10b981", borderRadius: "4px 4px 0 0", height: `${Math.max((m.experts / maxMonthly) * 100, 4)}%`, transition: "height 0.3s" }} title={`Uzman: ${m.experts}`} />
                  <div style={{ flex: 1, background: "#f59e0b", borderRadius: "4px 4px 0 0", height: `${Math.max((m.jobs / maxMonthly) * 100, 4)}%`, transition: "height 0.3s" }} title={`İş: ${m.jobs}`} />
                </div>
                <span style={{ fontSize: "11px", color: "#94a3b8", whiteSpace: "nowrap" }}>{m.label}</span>
              </div>
            ))}
          </div>
        </div>

        {/* İş Durumu Dağılımı */}
        <div style={{ background: "white", borderRadius: "16px", padding: "24px", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
          <h3 style={{ fontSize: "16px", fontWeight: "600", color: "#1e293b", margin: "0 0 20px 0" }}>İş Durumu Dağılımı</h3>
          {totalJobs === 0 ? (
            <p style={{ fontSize: "14px", color: "#94a3b8", textAlign: "center", padding: "40px 0" }}>Veri yok</p>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
              {Object.entries(jobStatusData).map(([status, count]) => (
                <div key={status}>
                  <div style={{ display: "flex", justifyContent: "space-between", marginBottom: "6px" }}>
                    <span style={{ fontSize: "13px", fontWeight: "500", color: "#1e293b" }}>{statusLabels[status]}</span>
                    <span style={{ fontSize: "13px", fontWeight: "600", color: "#64748b" }}>{count} ({totalJobs > 0 ? Math.round((count / totalJobs) * 100) : 0}%)</span>
                  </div>
                  <div style={{ height: "10px", background: "#f1f5f9", borderRadius: "5px", overflow: "hidden" }}>
                    <div style={{ height: "100%", width: `${totalJobs > 0 ? (count / totalJobs) * 100 : 0}%`, background: statusColors[status], borderRadius: "5px", transition: "width 0.5s" }} />
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Şehir Dağılımı */}
      <div style={{ background: "white", borderRadius: "16px", padding: "24px", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
        <h3 style={{ fontSize: "16px", fontWeight: "600", color: "#1e293b", margin: "0 0 20px 0" }}>Kullanıcı Şehir Dağılımı (İlk 8)</h3>
        {cityData.length === 0 ? (
          <p style={{ fontSize: "14px", color: "#94a3b8", textAlign: "center", padding: "20px" }}>Veri yok</p>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
            {cityData.map(([city, count], i) => (
              <div key={city} style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                <span style={{ width: "24px", fontSize: "13px", fontWeight: "600", color: "#94a3b8", textAlign: "right" }}>{i + 1}.</span>
                <span style={{ width: "120px", fontSize: "14px", fontWeight: "500", color: "#1e293b" }}>{city}</span>
                <div style={{ flex: 1, height: "28px", background: "#f1f5f9", borderRadius: "6px", overflow: "hidden" }}>
                  <div style={{ height: "100%", width: `${(count / maxCity) * 100}%`, background: `hsl(${220 + i * 20}, 70%, 55%)`, borderRadius: "6px", display: "flex", alignItems: "center", paddingLeft: "8px", transition: "width 0.5s" }}>
                    <span style={{ fontSize: "12px", fontWeight: "600", color: "white" }}>{count}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

// ==================== NOTIFICATIONS PAGE ====================
// Bireysel gönderimler listesi. Kural kök notifications'ı panele kapattığı için liste her
// kullanıcının users/{uid}/notifications kopyasından toplanır: kullanıcı başına bir sorgu
// (sonuç boş olsa da en az 1 okuma). Bu yüzden sayfa açılınca değil, düğmeyle yüklenir.
const BIREYSEL_PARCA = 25;
const BireyselGonderimler = ({ users = [], resolveUser = null }) => {
  const [durum, setDurum] = useState("bos"); // bos | yukleniyor | tamam | hata
  const [ilerleme, setIlerleme] = useState(0);
  const [liste, setListe] = useState([]);
  const [hataSayisi, setHataSayisi] = useState(0);
  const { currentPage, totalPages, paginatedItems, goToPage, totalItems, startIndex, endIndex } = usePagination(liste, 20);
  const hedefler = useMemo(() => (users || []).filter((u) => u && u.id && !u._tombstone), [users]);

  const yukle = async () => {
    setDurum("yukleniyor");
    setIlerleme(0);
    setHataSayisi(0);
    const toplanan = [];
    let hata = 0;
    for (let i = 0; i < hedefler.length; i += BIREYSEL_PARCA) {
      const parca = hedefler.slice(i, i + BIREYSEL_PARCA);
      const sonuclar = await Promise.allSettled(parca.map((u) => bireyselBildirimleriOku(u.id)));
      for (const s of sonuclar) {
        if (s.status === "fulfilled") toplanan.push(...s.value);
        else hata++;
      }
      setIlerleme(Math.min(hedefler.length, i + BIREYSEL_PARCA));
    }
    toplanan.sort((a, b) => toMillis(b.createdAt) - toMillis(a.createdAt));
    setListe(toplanan);
    setHataSayisi(hata);
    setDurum(hata && !toplanan.length ? "hata" : "tamam");
  };

  const th = { textAlign: "left", fontSize: "12px", fontWeight: "600", color: "#64748b", padding: "8px 10px", borderBottom: "1px solid #e2e8f0", whiteSpace: "nowrap" };
  const td = { padding: "8px 10px", fontSize: "13px", color: "#334155", borderBottom: "1px solid #f1f5f9", verticalAlign: "top" };

  return (
    <div style={{ background: "white", borderRadius: "16px", padding: "24px", marginTop: "24px", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: "12px", flexWrap: "wrap", marginBottom: "12px" }}>
        <div>
          <h3 style={{ fontSize: "16px", fontWeight: "600", color: "#1e293b", margin: "0 0 4px 0" }}>Bireysel gönderimler</h3>
          <p style={{ fontSize: "12px", color: "#94a3b8", margin: 0, maxWidth: "640px" }}>
            Müşteriler ve Uzmanlar sayfasındaki "Bildirim gönder" ile tek kullanıcıya gönderilenler. Liste panelin kopyasından gelir;
            okunma ve push durumu burada görünmez (kural kök bildirimi panele kapalı tutuyor).
          </p>
        </div>
        <button onClick={yukle} disabled={durum === "yukleniyor" || hedefler.length === 0}
          style={{ display: "flex", alignItems: "center", gap: "6px", padding: "9px 14px", background: durum === "yukleniyor" ? "#cbd5e1" : "#1e1b4b", color: "white", border: "none", borderRadius: "10px", fontSize: "13px", fontWeight: "600", cursor: durum === "yukleniyor" ? "default" : "pointer", whiteSpace: "nowrap" }}>
          <RefreshCw size={14} style={durum === "yukleniyor" ? { animation: "spin 1s linear infinite" } : undefined} />
          {durum === "bos" ? `Listeyi yükle (${hedefler.length} kullanıcı taranır)` : durum === "yukleniyor" ? `${ilerleme}/${hedefler.length} kullanıcı…` : "Yenile"}
        </button>
      </div>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      {durum === "bos" && <p style={{ fontSize: "13px", color: "#94a3b8", margin: 0 }}>Okuma maliyeti nedeniyle liste düğmeyle yüklenir (kullanıcı başına en az bir okuma).</p>}
      {hataSayisi > 0 && <p style={{ fontSize: "12px", color: "#dc2626", margin: "0 0 8px" }}>{hataSayisi} kullanıcının kaydı okunamadı.</p>}
      {durum === "tamam" && liste.length === 0 && <p style={{ fontSize: "13px", color: "#64748b", margin: 0 }}>Henüz bireysel gönderim yok.</p>}
      {liste.length > 0 && (
        <>
          <div style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead><tr><th style={th}>Tarih</th><th style={th}>Kullanıcı</th><th style={th}>Başlık</th><th style={th}>Metin</th></tr></thead>
              <tbody>
                {paginatedItems.map((n) => {
                  const u = resolveUser ? resolveUser(n.uid) : null;
                  return (
                    <tr key={n.uid + "/" + n.id}>
                      <td style={{ ...td, whiteSpace: "nowrap" }}>{formatDateTime(n.createdAt)}</td>
                      <td style={td}>
                        <div style={{ fontWeight: "600", color: "#1e293b" }}>{(u && u.name) || n.uid}</div>
                        <div style={{ fontSize: "11px", color: "#94a3b8" }}>{u && u.userType === "expert" ? "Uzman" : u && u.userType === "customer" ? "Müşteri" : ""}</div>
                      </td>
                      <td style={{ ...td, fontWeight: "600" }}>{n.title}</td>
                      <td style={{ ...td, whiteSpace: "pre-wrap", maxWidth: "420px" }}>{n.message}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <PaginationBar currentPage={currentPage} totalPages={totalPages} goToPage={goToPage} totalItems={totalItems} startIndex={startIndex} endIndex={endIndex} />
        </>
      )}
    </div>
  );
};

const TOPLU_HEDEF_AD = { all: "Tüm kullanıcılar", customers: "Müşteriler", experts: "Uzmanlar", experts_category: "Belirli kategorideki uzmanlar" };
const NotificationsPage = ({ sendBulkNotification, users = [], customers = [], experts = [], resolveUser = null }) => {
  const { admin } = usePanelVeri();
  const [targetType, setTargetType] = useState("all");
  const [anaKategori, setAnaKategori] = useState("");
  const [altKategori, setAltKategori] = useState("");
  const [testHaric, setTestHaric] = useState(true);
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);
  const [ilerleme, setIlerleme] = useState(null); // { n, toplam }
  const [sonuc, setSonuc] = useState(null);

  // Hedef: seçilen kitle → (kategori) → test hesapları hariç (kesin ve olası; ortak test tanımı)
  const hedef = useMemo(() => {
    const kitle = targetType === "customers" ? customers
      : targetType === "experts" ? experts
      : targetType === "experts_category" ? (anaKategori ? experts.filter((e) => uzmanKategorideMi(e, anaKategori, altKategori)) : [])
      : [...customers, ...experts];
    const testler = new Set(kitle.filter((u) => testDurumu({ uid: u.id, email: u.email, ad: [u.name, u.displayName] }, admin) !== null));
    const liste = testHaric ? kitle.filter((u) => !testler.has(u)) : kitle;
    return {
      kitle, liste, test: testler.size,
      pushsuz: liste.filter((u) => !u.fcmToken).length,
      askida: liste.filter((u) => isSuspended(u)).length,
    };
  }, [targetType, customers, experts, anaKategori, altKategori, testHaric, admin]);

  const b = title.trim();
  const m = message.trim();
  const metinGecerli = b.length > 0 && m.length > 0 && b.length <= BILDIRIM_BASLIK_SINIRI && m.length <= BILDIRIM_METIN_SINIRI;
  const kategoriEksik = targetType === "experts_category" && !anaKategori;
  const gonderilebilir = metinGecerli && !kategoriEksik && hedef.liste.length > 0 && !sending;
  const kitleAdi = () => {
    if (targetType !== "experts_category") return TOPLU_HEDEF_AD[targetType];
    const ad = (k, adlar) => { for (const e of experts) { const x = adlar(e).find((y) => arzTalepAnahtar(y) === k); if (x) return x; } return k; };
    return `"${ad(anaKategori, uzmanAnaKategorileri)}"${altKategori ? ` / "${ad(altKategori, uzmanAltKategorileri)}"` : ""} kategorisindeki uzmanlar`;
  };

  const handleSend = async () => {
    if (!gonderilebilir) return;
    if (!window.confirm(
      `${hedef.liste.length} kişiye bildirim gönderilecek: ${kitleAdi()}${testHaric ? ` (${hedef.test} test hesabı hariç)` : " (test hesapları DAHİL)"}.\n\n` +
      `${b}\n${m}\n\n${hedef.pushsuz ? `${hedef.pushsuz} kişinin push anahtarı yok: onlara yalnızca uygulama içinde görünür.\n` : ""}Push hemen gider; geri alınamaz. Emin misin?`
    )) return;
    setSending(true);
    setSonuc(null);
    setIlerleme({ n: 0, toplam: hedef.liste.length });
    const r = await sendBulkNotification(hedef.liste, b, m, (n, toplam) => setIlerleme({ n, toplam }));
    setSonuc(r);
    setIlerleme(null);
    if (r.hata === 0) { setTitle(""); setMessage(""); }
    setSending(false);
  };
  const etiket = { display: "block", fontSize: "14px", fontWeight: "600", color: "#1e293b", marginBottom: "8px" };
  const sayac = (n, sinir) => <span style={{ fontSize: "11px", fontWeight: "400", color: n > sinir ? "#dc2626" : "#94a3b8" }}>{n}/{sinir}</span>;

  return (
    <div>
      <div style={{ marginBottom: "24px" }}><h1 style={{ fontSize: "24px", fontWeight: "700", color: "#1e293b", margin: "0 0 4px 0" }}>Bildirim Gönder</h1><p style={{ fontSize: "14px", color: "#64748b", margin: 0 }}>Toplu bildirim gönder</p></div>
      <div style={{ background: "white", borderRadius: "16px", padding: "24px", maxWidth: "560px", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
        <div style={{ marginBottom: "16px" }}>
          <label style={etiket}>Hedef Kitle</label>
          <select value={targetType} onChange={(e) => setTargetType(e.target.value)} disabled={sending} style={{ width: "100%", padding: "12px", border: "1px solid #e2e8f0", borderRadius: "10px", fontSize: "14px", outline: "none" }}>
            <option value="all">Tüm Kullanıcılar</option><option value="customers">Sadece Müşteriler</option><option value="experts">Sadece Uzmanlar</option>
            <option value="experts_category">Belirli kategorideki uzmanlar</option>
          </select>
          {targetType === "experts_category" && (
            <div style={{ display: "flex", gap: "8px", flexWrap: "wrap", marginTop: "8px" }}>
              <KategoriSecici uzmanlar={experts} ana={anaKategori} alt={altKategori} setAna={setAnaKategori} setAlt={setAltKategori} stil={{ flex: "1 1 200px" }} />
            </div>
          )}
          <label style={{ display: "flex", alignItems: "center", gap: "6px", fontSize: "13px", color: "#475569", marginTop: "10px", cursor: "pointer" }}>
            <input type="checkbox" checked={testHaric} onChange={(e) => setTestHaric(e.target.checked)} disabled={sending} />
            Test hesaplarını hariç tut (yönetici, test listesi ve olası test hesapları)
          </label>
          <div style={{ marginTop: "10px", padding: "10px 12px", borderRadius: "10px", background: kategoriEksik || hedef.liste.length === 0 ? "#fef2f2" : "#eef2ff", fontSize: "13px", color: kategoriEksik || hedef.liste.length === 0 ? "#991b1b" : "#3730a3" }}>
            {kategoriEksik ? "Ana kategori seçin." : (
              <>
                <strong>{hedef.liste.length} kişiye gidecek</strong>
                {testHaric ? ` · ${hedef.test} test hesabı hariç` : hedef.test ? ` · ${hedef.test} test hesabı DAHİL` : ""}
                {hedef.pushsuz > 0 && ` · ${hedef.pushsuz} kişinin push anahtarı yok (yalnızca uygulama içi)`}
                {hedef.askida > 0 && ` · ${hedef.askida} askıda hesap`}
              </>
            )}
          </div>
        </div>
        <div style={{ marginBottom: "16px" }}>
          <label style={{ ...etiket, display: "flex", justifyContent: "space-between" }}>Başlık {sayac(b.length, BILDIRIM_BASLIK_SINIRI)}</label>
          <input type="text" value={title} onChange={(e) => setTitle(e.target.value)} disabled={sending} placeholder="Bildirim başlığı" style={{ width: "100%", padding: "12px", border: "1px solid #e2e8f0", borderRadius: "10px", fontSize: "14px", outline: "none", boxSizing: "border-box" }} />
        </div>
        <div style={{ marginBottom: "16px" }}>
          <label style={{ ...etiket, display: "flex", justifyContent: "space-between" }}>Mesaj {sayac(m.length, BILDIRIM_METIN_SINIRI)}</label>
          <textarea value={message} onChange={(e) => setMessage(e.target.value)} disabled={sending} placeholder="Bildirim mesajı" rows={4} style={{ width: "100%", padding: "12px", border: "1px solid #e2e8f0", borderRadius: "10px", fontSize: "14px", outline: "none", resize: "vertical", boxSizing: "border-box" }} />
        </div>
        <div style={{ marginBottom: "16px" }}>
          <PushOnizlemeKutusu baslik={b} metin={m} />
        </div>
        {sonuc && (
          <p style={{ fontSize: "13px", color: sonuc.hata ? "#991b1b" : "#15803d", background: sonuc.hata ? "#fef2f2" : "#f0fdf4", border: `1px solid ${sonuc.hata ? "#fecaca" : "#bbf7d0"}`, borderRadius: "8px", padding: "8px 10px", margin: "0 0 12px" }}>
            {sonuc.gonderilen} kişiye gönderildi.{sonuc.hata ? ` ${sonuc.hata} kişide hata oldu (konsola yazıldı); metin silinmedi.` : ""}
          </p>
        )}
        <button onClick={handleSend} disabled={!gonderilebilir} style={{ width: "100%", padding: "14px", background: !gonderilebilir ? "#94a3b8" : "linear-gradient(135deg, #6366f1, #8b5cf6)", color: "white", border: "none", borderRadius: "10px", fontSize: "15px", fontWeight: "600", cursor: !gonderilebilir ? "not-allowed" : "pointer", display: "flex", alignItems: "center", justifyContent: "center", gap: "8px" }}>
          <Send size={18} />{sending ? `Gönderiliyor… ${ilerleme ? `${ilerleme.n}/${ilerleme.toplam}` : ""}` : `Bildirim Gönder (${hedef.liste.length} kişi)`}
        </button>
      </div>

      <BireyselGonderimler users={users} resolveUser={resolveUser} />
    </div>
  );
};

// ==================== SETTINGS PAGE ====================
// ==================== ADMIN ŞİFRE DEĞİŞTİRME ====================
const AdminPasswordChange = () => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [changing, setChanging] = useState(false);
  const [showPasswords, setShowPasswords] = useState(false);
  const [message, setMessage] = useState({ type: "", text: "" });

  const isPasswordStrong = (pwd) => {
    if (!pwd || pwd.length < 8) return false;
    if (!/[A-ZÇĞİÖŞÜ]/.test(pwd)) return false;
    if (!/[a-zçğıöşü]/.test(pwd)) return false;
    if (!/[0-9]/.test(pwd)) return false;
    return true;
  };

  const handleChangePassword = async () => {
    setMessage({ type: "", text: "" });

    if (!currentPassword) { setMessage({ type: "error", text: "Mevcut şifrenizi girin" }); return; }
    if (!newPassword) { setMessage({ type: "error", text: "Yeni şifrenizi girin" }); return; }
    if (!isPasswordStrong(newPassword)) { setMessage({ type: "error", text: "Yeni şifre en az 8 karakter, 1 büyük harf, 1 küçük harf ve 1 rakam içermeli" }); return; }
    if (newPassword !== confirmPassword) { setMessage({ type: "error", text: "Yeni şifreler eşleşmiyor" }); return; }
    if (currentPassword === newPassword) { setMessage({ type: "error", text: "Yeni şifre mevcut şifreden farklı olmalı" }); return; }

    setChanging(true);
    try {
      const user = auth.currentUser;
      const credential = EmailAuthProvider.credential(user.email, currentPassword);
      await reauthenticateWithCredential(user, credential);
      await updatePassword(user, newPassword);
      setMessage({ type: "success", text: "Şifreniz başarıyla değiştirildi!" });
      setCurrentPassword("");
      setNewPassword("");
      setConfirmPassword("");
    } catch (error) {
      console.error("Şifre değiştirme hatası:", error);
      if (error.code === "auth/wrong-password" || error.code === "auth/invalid-credential") {
        setMessage({ type: "error", text: "Mevcut şifre hatalı" });
      } else if (error.code === "auth/too-many-requests") {
        setMessage({ type: "error", text: "Çok fazla deneme. Lütfen daha sonra tekrar deneyin" });
      } else {
        setMessage({ type: "error", text: "Şifre değiştirilemedi. Lütfen tekrar deneyin." });
      }
    } finally {
      setChanging(false);
    }
  };

  const inputStyle = { width: "100%", padding: "12px 16px", border: "1px solid #e2e8f0", borderRadius: "10px", fontSize: "14px", outline: "none", boxSizing: "border-box" };
  const labelStyle = { display: "block", fontSize: "14px", fontWeight: "600", color: "#1e293b", marginBottom: "8px" };

  return (
    <div style={{ padding: "20px", background: "#f8fafc", borderRadius: "12px" }}>
      <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "20px" }}>
        <div style={{ width: "40px", height: "40px", background: "linear-gradient(135deg, #512da8, #7c4dff)", borderRadius: "10px", display: "flex", alignItems: "center", justifyContent: "center" }}>
          <Shield size={20} color="white" />
        </div>
        <div>
          <p style={{ fontSize: "15px", fontWeight: "700", color: "#1e293b", margin: 0 }}>Admin Şifre Değiştir</p>
          <p style={{ fontSize: "12px", color: "#64748b", margin: 0 }}>{auth.currentUser?.email}</p>
        </div>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
        <div>
          <label style={labelStyle}>Mevcut Şifre</label>
          <input type={showPasswords ? "text" : "password"} value={currentPassword} onChange={(e) => setCurrentPassword(e.target.value)} placeholder="Mevcut şifrenizi girin" style={inputStyle} />
        </div>
        <div>
          <label style={labelStyle}>Yeni Şifre</label>
          <input type={showPasswords ? "text" : "password"} value={newPassword} onChange={(e) => setNewPassword(e.target.value)} placeholder="En az 8 karakter (büyük harf, küçük harf, rakam)" style={inputStyle} />
          {newPassword && newPassword.length > 0 && (
            <div style={{ marginTop: "8px", fontSize: "12px", display: "flex", gap: "12px", flexWrap: "wrap" }}>
              <span style={{ color: newPassword.length >= 8 ? "#16a34a" : "#dc2626" }}>{newPassword.length >= 8 ? "✓" : "✗"} 8+ karakter</span>
              <span style={{ color: /[A-ZÇĞİÖŞÜ]/.test(newPassword) ? "#16a34a" : "#dc2626" }}>{/[A-ZÇĞİÖŞÜ]/.test(newPassword) ? "✓" : "✗"} Büyük harf</span>
              <span style={{ color: /[a-zçğıöşü]/.test(newPassword) ? "#16a34a" : "#dc2626" }}>{/[a-zçğıöşü]/.test(newPassword) ? "✓" : "✗"} Küçük harf</span>
              <span style={{ color: /[0-9]/.test(newPassword) ? "#16a34a" : "#dc2626" }}>{/[0-9]/.test(newPassword) ? "✓" : "✗"} Rakam</span>
            </div>
          )}
        </div>
        <div>
          <label style={labelStyle}>Yeni Şifre Tekrar</label>
          <input type={showPasswords ? "text" : "password"} value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} placeholder="Yeni şifrenizi tekrar girin" style={{ ...inputStyle, borderColor: confirmPassword && newPassword !== confirmPassword ? "#dc2626" : "#e2e8f0" }} />
          {confirmPassword && newPassword !== confirmPassword && (
            <p style={{ fontSize: "12px", color: "#dc2626", margin: "6px 0 0 0" }}>Şifreler eşleşmiyor</p>
          )}
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <button onClick={() => setShowPasswords(!showPasswords)} style={{ background: "none", border: "none", fontSize: "13px", color: "#512da8", cursor: "pointer", fontWeight: "600", padding: 0 }}>
            {showPasswords ? "🙈 Şifreleri Gizle" : "👁️ Şifreleri Göster"}
          </button>
        </div>

        {message.text && (
          <div style={{ padding: "12px 16px", background: message.type === "success" ? "#f0fdf4" : "#fef2f2", borderRadius: "10px", border: `1px solid ${message.type === "success" ? "#bbf7d0" : "#fecaca"}` }}>
            <p style={{ fontSize: "13px", color: message.type === "success" ? "#166534" : "#991b1b", margin: 0, fontWeight: "500" }}>
              {message.type === "success" ? "✓ " : "✗ "}{message.text}
            </p>
          </div>
        )}

        <button onClick={handleChangePassword} disabled={changing || !currentPassword || !newPassword || !confirmPassword}
          style={{ padding: "14px", background: changing || !currentPassword || !newPassword || !confirmPassword ? "#94a3b8" : "linear-gradient(135deg, #512da8, #7c4dff)", color: "white", border: "none", borderRadius: "10px", fontSize: "14px", fontWeight: "700", cursor: changing ? "not-allowed" : "pointer", transition: "all 0.3s" }}>
          {changing ? "Değiştiriliyor..." : "Şifreyi Değiştir"}
        </button>
      </div>
    </div>
  );
};

// ==================== İL / İLÇE LİSTESİ YAYINI (publishLocations, 1.0.31 Grup 2 madde 17) ====================
// Kaynak: isinebak2/docs/admin_paneli_131_grup2.md §1 ve functions/ilListesi.js.
// Yazan sunucudaki publishLocations callable'ıdır (yalnızca admin; dryRun:false olmadan yazmaz).
// Panel yalnızca settings/locations'ı OKUR. Belge yoksa başlangıç listesi, isinebak2'deki
// docs/settings_locations.json'ın kopyası (src/data/) — uygulamanın içindeki listeyle aynı.
const IL_LISTESI_KURALI = "Listeye yalnızca ekleme yapılır; ad değiştirme ve silme yok.";

// Metin alanı: [{ name, districts }] ya da { cities: [...] } kabul edilir
const ilListesiCoz = (metin) => {
  try {
    const v = JSON.parse(metin);
    const cities = Array.isArray(v) ? v : v && Array.isArray(v.cities) ? v.cities : null;
    if (!cities) return { hata: "JSON bir dizi ya da { cities: [...] } olmalı" };
    return { cities };
  } catch (e) {
    return { hata: `JSON okunamadı: ${e.message}` };
  }
};

const IlIlceYayinPanel = () => {
  const [metin, setMetin] = useState("");
  const [kaynak, setKaynak] = useState({ durum: "yukleniyor" }); // yukleniyor | yayinda | yerel | hata
  const [denetim, setDenetim] = useState(null); // { metin, sonuc } — son "Denetle"
  const [yayin, setYayin] = useState(null); // son "Yayınla" sonucu
  const [calisiyor, setCalisiyor] = useState(null); // "denetle" | "yayinla" | null
  const [hata, setHata] = useState(null);

  const yerelListeyiYukle = useCallback(async (neden) => {
    const m = await import("./data/settings_locations.json");
    const veri = m.default || m;
    setMetin(JSON.stringify(veri.cities || veri, null, 2));
    setKaynak({ durum: "yerel", neden });
  }, []);

  const yayindakiniOku = useCallback(async () => {
    setKaynak({ durum: "yukleniyor" });
    try {
      const snap = await getDoc(doc(db, "settings", "locations"));
      if (snap.exists() && Array.isArray((snap.data() || {}).cities)) {
        const d = snap.data();
        setMetin(JSON.stringify(d.cities, null, 2));
        setKaynak({ durum: "yayinda", updatedAt: d.updatedAt || null, updatedBy: d.updatedBy || null });
      } else {
        await yerelListeyiYukle("settings/locations henüz yok");
      }
    } catch (e) {
      console.error("settings/locations okunamadı:", e);
      setKaynak({ durum: "hata", mesaj: (e && e.message) || String(e) });
    }
  }, [yerelListeyiYukle]);

  useEffect(() => { yayindakiniOku(); }, [yayindakiniOku]);

  const cozum = useMemo(() => (metin ? ilListesiCoz(metin) : null), [metin]);
  const ozet = cozum && cozum.cities
    ? { il: cozum.cities.length, ilce: cozum.cities.reduce((t, il) => t + (Array.isArray(il && il.districts) ? il.districts.length : 0), 0) }
    : null;
  // "Yayınla" yalnızca son denetim geçtiyse VE metin o denetimden beri değişmediyse
  const yayinlanabilir = !!(denetim && denetim.metin === metin && denetim.sonuc && denetim.sonuc.ok === true);

  const cagir = async (dryRun) => {
    setHata(null);
    setCalisiyor(dryRun ? "denetle" : "yayinla");
    try {
      const fn = httpsCallable(getFunctions(auth.app, "us-central1"), "publishLocations");
      const r = (await fn({ cities: cozum.cities, dryRun })).data || {};
      return r;
    } catch (e) {
      console.error("publishLocations:", e);
      setHata({ code: (e && e.code) || "bilinmiyor", message: (e && e.message) || String(e) });
      return null;
    } finally {
      setCalisiyor(null);
    }
  };

  const denetle = async () => {
    if (!cozum || !cozum.cities || calisiyor) return;
    const gonderilen = metin;
    setYayin(null);
    const r = await cagir(true);
    setDenetim(r ? { metin: gonderilen, sonuc: r } : null);
  };

  const yayinla = async () => {
    if (!yayinlanabilir || calisiyor) return;
    const s = denetim.sonuc;
    const ilceler = s.eklenenIlceler || [];
    const ornek = ilceler.slice(0, 20).map((x) => `${x.il}/${x.ilce}`).join(", ");
    const iller = (s.eklenenIller || []).length ? `\nYeni il: ${s.eklenenIller.join(", ")}` : "";
    const onay =
      `${ilceler.length} ilçe eklenecek${ilceler.length ? `: ${ornek}${ilceler.length > 20 ? ` … ve ${ilceler.length - 20} ilçe daha` : ""}` : ""}.${iller}\n\n` +
      "Uygulama bu listeyi bir sonraki açılışta kullanır.";
    if (!window.confirm(onay)) return;
    const r = await cagir(false);
    if (r) {
      setYayin(r);
      setDenetim(null);
      if (r.ok && r.yazildi) yayindakiniOku();
    }
  };

  const dugme = (renk, pasif) => ({ display: "flex", alignItems: "center", gap: "6px", padding: "10px 16px", background: pasif ? "#cbd5e1" : renk, color: "white", border: "none", borderRadius: "10px", fontSize: "13px", fontWeight: "600", cursor: pasif ? "default" : "pointer" });
  const sonucKutusu = (r, baslik) => (
    <div style={{ marginTop: "16px", padding: "14px 16px", borderRadius: "10px", border: `1px solid ${r.ok ? "#bbf7d0" : "#fecaca"}`, background: r.ok ? "#f0fdf4" : "#fef2f2", fontSize: "13px", color: "#334155" }}>
      <p style={{ margin: "0 0 6px", fontWeight: "600", color: r.ok ? "#15803d" : "#b91c1c" }}>
        {baslik}: {r.ok ? (r.yazildi ? "yayınlandı" : "geçti") : "geçmedi"}
        {r.ok && r.ilkYayin ? " · ilk yayın (settings/locations henüz yok)" : ""}
      </p>
      {!r.ok && <p style={{ margin: 0 }}>Sorun: <strong>{r.sorun}</strong></p>}
      {r.ok && (
        <>
          <p style={{ margin: "0 0 6px" }}>{r.ilSayisi} il · {r.ilceSayisi} ilçe · eklenen il {(r.eklenenIller || []).length} · eklenen ilçe {(r.eklenenIlceler || []).length}</p>
          {(r.eklenenIller || []).length > 0 && <p style={{ margin: "0 0 6px" }}>Yeni iller: {r.eklenenIller.join(", ")}</p>}
          {(r.eklenenIlceler || []).length > 0 && (
            <div style={{ maxHeight: "200px", overflowY: "auto", background: "white", border: "1px solid #e2e8f0", borderRadius: "8px", padding: "8px 10px" }}>
              {r.eklenenIlceler.map((x, i) => <div key={i}>{x.il} / {x.ilce}</div>)}
            </div>
          )}
        </>
      )}
      <details style={{ marginTop: "8px" }}>
        <summary style={{ cursor: "pointer", color: "#475569" }}>Ham JSON</summary>
        <pre style={{ background: "#0f172a", color: "#e2e8f0", fontSize: "12px", padding: "10px", borderRadius: "8px", overflow: "auto", maxHeight: "260px" }}>{JSON.stringify(r, null, 2)}</pre>
      </details>
    </div>
  );

  return (
    <div>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
      <h2 style={{ fontSize: "18px", fontWeight: "600", color: "#1e293b", margin: "0 0 4px 0" }}>İl / İlçe Listesi</h2>
      <p style={{ fontSize: "13px", color: "#64748b", margin: "0 0 4px 0" }}>
        Uygulama il ve ilçe listesini <code>settings/locations</code> belgesinden alır; denetimi geçmeyen listeyi kullanmaz.
      </p>
      <p style={{ fontSize: "13px", fontWeight: "600", color: "#b45309", margin: "0 0 16px 0" }}>{IL_LISTESI_KURALI}</p>

      <div style={{ fontSize: "12px", color: "#64748b", marginBottom: "8px", display: "flex", flexWrap: "wrap", gap: "8px", alignItems: "center" }}>
        {kaynak.durum === "yukleniyor" && <span>Yayındaki liste okunuyor…</span>}
        {kaynak.durum === "yayinda" && (
          <span>Başlangıç: yayındaki liste{kaynak.updatedAt ? ` · güncelleme ${formatDateTime(kaynak.updatedAt)}` : ""}{kaynak.updatedBy ? ` · ${kaynak.updatedBy}` : ""}</span>
        )}
        {kaynak.durum === "yerel" && <span>Başlangıç: uygulamanın içindeki liste ({kaynak.neden}). Değiştirmeden yayınlanabilir; eklenen 0 olur.</span>}
        {kaynak.durum === "hata" && (
          <>
            <span style={{ color: "#b91c1c" }}>settings/locations okunamadı: {kaynak.mesaj}</span>
            <button onClick={yayindakiniOku} style={{ padding: "4px 10px", fontSize: "12px", borderRadius: "8px", border: "1px solid #e2e8f0", background: "#f8fafc", cursor: "pointer" }}>Tekrar dene</button>
          </>
        )}
        {ozet && <span>· metindeki liste: {ozet.il} il, {ozet.ilce} ilçe</span>}
      </div>

      <textarea value={metin} onChange={(e) => setMetin(e.target.value)} spellCheck={false} disabled={kaynak.durum === "yukleniyor"}
        style={{ width: "100%", height: "380px", padding: "12px", border: "1px solid #e2e8f0", borderRadius: "10px", fontFamily: "monospace", fontSize: "12px", boxSizing: "border-box", outline: "none", resize: "vertical" }} />
      {cozum && cozum.hata && <p style={{ fontSize: "12px", color: "#b91c1c", margin: "6px 0 0" }}>{cozum.hata}</p>}
      {denetim && denetim.metin !== metin && (
        <p style={{ fontSize: "12px", color: "#b45309", margin: "6px 0 0" }}>Metin son denetimden sonra değişti; yayınlamadan önce yeniden denetleyin.</p>
      )}

      <div style={{ display: "flex", gap: "10px", marginTop: "12px", flexWrap: "wrap" }}>
        <button onClick={denetle} disabled={!cozum || !cozum.cities || !!calisiyor} style={dugme("#1e1b4b", !cozum || !cozum.cities || !!calisiyor)}>
          {calisiyor === "denetle" && <RefreshCw size={14} style={{ animation: "spin 1s linear infinite" }} />}
          Denetle
        </button>
        <button onClick={yayinla} disabled={!yayinlanabilir || !!calisiyor} title={yayinlanabilir ? "" : "Önce denetleyin; yalnızca geçen liste yayınlanabilir"}
          style={dugme("#dc2626", !yayinlanabilir || !!calisiyor)}>
          {calisiyor === "yayinla" && <RefreshCw size={14} style={{ animation: "spin 1s linear infinite" }} />}
          Yayınla
        </button>
      </div>

      {hata && (
        <div style={{ marginTop: "12px", background: "#fef2f2", border: "1px solid #fecaca", borderRadius: "10px", padding: "12px 14px", fontSize: "13px", color: "#991b1b" }}>
          <strong>Çağrı başarısız.</strong> Kod: <code>{hata.code}</code> · {hata.message}
        </div>
      )}
      {denetim && denetim.sonuc && sonucKutusu(denetim.sonuc, "Denetim")}
      {yayin && sonucKutusu(yayin, "Yayın")}
    </div>
  );
};

// Ayarlar sekmesi → settings belgesi (İçerik Filtresi ve İl / İlçe'nin kendi düğmeleri var)
const AYAR_SEKME_BELGESI = { general: "general", commission: "commission", premium: "premium", notifications: "notifications", security: "security", legal: "legal" };
// Belge yoksa ya da okunamazsa ekranda görünen koddaki varsayılanlar (okunamayan belgeye yazılmaz)
const AYAR_VARSAYILANLARI = {
  general: { siteName: "İşe Bak", siteDescription: "Türkiye'nin en güvenilir hizmet platformu", contactEmail: "destek@isebakapp.com", contactPhone: "0850 123 4567", address: "İstanbul, Türkiye", maintenanceMode: false },
  commission: { expertCommission: 10, premiumDiscount: 20, minJobPrice: 100, maxJobPrice: 50000 },
  premium: { monthlyPrice: 399, yearlyPrice: 3990, trialDays: 7, features: ["Öncelikli listeleme", "Sınırsız teklif gönderme", "Premium rozet", "Reklamsız deneyim"] },
  notifications: { emailNotifications: true, pushNotifications: true, smsNotifications: false, newExpertAlert: true, newJobAlert: true, complaintAlert: true, paymentAlert: true },
  security: { twoFactorAuth: false, loginAttempts: 5, sessionTimeout: 30, ipWhitelist: "" },
  legal: { termsOfService: "", privacyPolicy: "", expertAgreement: "" },
};
// Okunduğu andan beri değişen alanlar (diziler ve nesneler değer olarak karşılaştırılır)
const ayarDegisenAlanlar = (simdi, orijinal) =>
  Object.fromEntries(Object.entries(simdi || {}).filter(([k, v]) => JSON.stringify(v) !== JSON.stringify((orijinal || {})[k])));

const SettingsPage = () => {
  const [activeTab, setActiveTab] = useState("general");
  const [saving, setSaving] = useState(false);
  const [generalSettings, setGeneralSettings] = useState(AYAR_VARSAYILANLARI.general);
  const [commissionSettings, setCommissionSettings] = useState(AYAR_VARSAYILANLARI.commission);
  const [premiumSettings, setPremiumSettings] = useState(AYAR_VARSAYILANLARI.premium);
  const [notificationSettings, setNotificationSettings] = useState(AYAR_VARSAYILANLARI.notifications);
  const [securitySettings, setSecuritySettings] = useState(AYAR_VARSAYILANLARI.security);
  const [legalDocuments, setLegalDocuments] = useState(AYAR_VARSAYILANLARI.legal);

  // ====== SEKME BELGELERİ (settings/general, commission, premium, notifications, security, legal) ======
  // Her belge ayrı okunur; "Değişiklikleri Kaydet" yalnızca etkin sekmenin belgesine, merge ile ve yalnızca
  // okunduğu andan beri değişen alanları yazar (panelin göstermediği alanlar, ör. general.minVersion, ezilmez).
  // Okunamayan belgenin sekmesinde ekranda varsayılanlar durur ama kaydetme kapalıdır: varsayılan yazılmaz.
  const [ayarYukleme, setAyarYukleme] = useState({}); // { [belge]: { durum: "yukleniyor"|"tamam"|"yok"|"hata", orijinal, hata } }
  const ayarDegerleri = { general: generalSettings, commission: commissionSettings, premium: premiumSettings, notifications: notificationSettings, security: securitySettings, legal: legalDocuments };
  const ayarlariYukle = useCallback(async (belgeler) => {
    const ayarla = { general: setGeneralSettings, commission: setCommissionSettings, premium: setPremiumSettings, notifications: setNotificationSettings, security: setSecuritySettings, legal: setLegalDocuments };
    setAyarYukleme((o) => ({ ...o, ...Object.fromEntries(belgeler.map((b) => [b, { durum: "yukleniyor" }])) }));
    await Promise.all(belgeler.map(async (b) => {
      try {
        const s = await getDoc(doc(db, "settings", b));
        if (s.exists()) {
          const v = s.data() || {};
          ayarla[b](v);
          setAyarYukleme((o) => ({ ...o, [b]: { durum: "tamam", orijinal: v } }));
        } else {
          // Belge yok: varsayılanlar gösterilir; kaydette yalnızca admin'in değiştirdiği alanlar yazılır
          ayarla[b](AYAR_VARSAYILANLARI[b]);
          setAyarYukleme((o) => ({ ...o, [b]: { durum: "yok", orijinal: AYAR_VARSAYILANLARI[b] } }));
        }
      } catch (error) {
        console.error(`settings/${b} yüklenirken hata:`, error);
        setAyarYukleme((o) => ({ ...o, [b]: { durum: "hata", hata: (error && (error.code || error.message)) || "bilinmiyor" } }));
      }
    }));
  }, []);
  const ayarBekleyen = (belge) => {
    const y = ayarYukleme[belge];
    return y && (y.durum === "tamam" || y.durum === "yok") ? ayarDegisenAlanlar(ayarDegerleri[belge], y.orijinal) : {};
  };

  // ====== İÇERİK FİLTRESİ (settings/moderation) ======
  // DİKKAT: Bu doküman toplu "Değişiklikleri Kaydet"e DAHİL DEĞİL; kendi düğmesi var.
  // Yükleme hata verirse boş liste kaydedilip filtre sessizce devre dışı kalmasın diye ayrı yüklenir.
  const [bannedWords, setBannedWords] = useState([]);
  const [moderationLoaded, setModerationLoaded] = useState(false);
  const [moderationExists, setModerationExists] = useState(false);
  const [newWord, setNewWord] = useState("");
  const [savingModeration, setSavingModeration] = useState(false);

  const addBannedWord = () => {
    const w = normalizeBannedWord(newWord);
    if (!w) return;
    if (bannedWords.includes(w)) { alert(`"${w}" listede zaten var.`); setNewWord(""); return; }
    setBannedWords((prev) => [...prev, w]);
    setNewWord("");
  };
  const removeBannedWord = (w) => setBannedWords((prev) => prev.filter((x) => x !== w));
  // Eksik temel kelimeleri sona ekler; listedeki diğer kelimeler korunur
  const eksikTemel = TEMEL_BANNED_WORDS.filter((w) => !bannedWords.includes(w));
  const seedFromDefaults = () => setBannedWords((prev) => [...prev, ...TEMEL_BANNED_WORDS.filter((w) => !prev.includes(w))]);

  const saveBannedWords = async () => {
    if (!moderationLoaded) { alert("Liste henüz yüklenmedi, lütfen bekleyin."); return; }
    if (bannedWords.length === 0 && !window.confirm(
      "Liste BOŞ kaydedilecek.\n\nBoş listede 1.0.30 ve öncesi koddaki " + APP_DEFAULT_BANNED_WORDS.length +
      " kelimeye, 1.0.31 ve sonrası koddaki " + TEMEL_BANNED_WORDS.length + " kelimeye döner (filtre kapanmaz). Devam edilsin mi?"
    )) return;
    if (bannedWords.length > 0 && eksikTemel.length > 0 && !window.confirm(
      `Listede ${eksikTemel.length} temel kelime eksik: ${eksikTemel.join(", ")}.\n\n` +
      "1.0.30 ve öncesi bu listeyi koddakinin yerine kullandığı için bu kelimeler eski sürümlerde engellenmez. " +
      "Yine de kaydedilsin mi?"
    )) return;
    setSavingModeration(true);
    try {
      // merge:true — settings/moderation'a ileride başka alan eklenirse ezilmesin
      await setDoc(
        doc(db, "settings", "moderation"),
        { bannedWords, updatedAt: new Date().toISOString() },
        { merge: true }
      );
      setModerationExists(true);
      alert(`${bannedWords.length} kelimelik liste kaydedildi.`);
    } catch (error) {
      console.error("Yasaklı kelime kaydetme hatası:", error);
      alert("Hata oluştu! Liste kaydedilemedi.");
    } finally { setSavingModeration(false); }
  };

  // Yalnızca etkin sekmenin belgesi; merge ile ve yalnızca değişen alanlar
  const handleSave = async () => {
    const belge = AYAR_SEKME_BELGESI[activeTab];
    if (!belge) return;
    const y = ayarYukleme[belge];
    if (!y || (y.durum !== "tamam" && y.durum !== "yok")) {
      alert(`settings/${belge} okunamadığı için kaydedilemez. Sayfayı yenileyin ya da "Yeniden dene"ye basın.`);
      return;
    }
    const degisen = ayarDegisenAlanlar(ayarDegerleri[belge], y.orijinal);
    const alanlar = Object.keys(degisen);
    if (!alanlar.length) { alert("Bu sekmede değişiklik yok."); return; }
    setSaving(true);
    try {
      await setDoc(doc(db, "settings", belge), degisen, { merge: true });
      setAyarYukleme((o) => ({ ...o, [belge]: { durum: "tamam", orijinal: { ...((o[belge] && o[belge].orijinal) || {}), ...degisen } } }));
      alert(`settings/${belge} kaydedildi (${alanlar.length} alan: ${alanlar.join(", ")}).`);
    } catch (error) { console.error("Kaydetme hatası:", error); alert(`settings/${belge} kaydedilirken hata oluştu! Hiçbir alan yazılmadı.`); }
    finally { setSaving(false); }
  };

  useEffect(() => {
    ayarlariYukle(Object.values(AYAR_SEKME_BELGESI));
  }, [ayarlariYukle]);

  // İçerik filtresi ayrı yükleniyor: diğer ayarlar patlasa bile liste gelsin,
  // liste patlasa bile "yüklenmedi" bilinsin (kaydet butonu kilitli kalır).
  useEffect(() => {
    const loadModeration = async () => {
      try {
        const mDoc = await getDoc(doc(db, "settings", "moderation"));
        if (mDoc.exists() && Array.isArray(mDoc.data().bannedWords)) {
          setBannedWords(mDoc.data().bannedWords.map(normalizeBannedWord).filter(Boolean));
          setModerationExists(true);
        }
        setModerationLoaded(true);
      } catch (error) {
        console.error("İçerik filtresi yüklenirken hata:", error);
        // moderationLoaded false kalır → kaydet butonu kilitli, boş liste yazılamaz
      }
    };
    loadModeration();
  }, []);

  const tabs = [{ id: "general", label: "Genel", icon: Settings }, { id: "commission", label: "Komisyon", icon: DollarSign }, { id: "premium", label: "Premium", icon: Award }, { id: "moderation", label: "İçerik Filtresi", icon: Flag }, { id: "legal", label: "Yasal Belgeler", icon: FileText }, { id: "notifications", label: "Bildirimler", icon: Bell }, { id: "security", label: "Güvenlik", icon: Shield }, { id: "locations", label: "İl / İlçe", icon: MapPin }];
  const aktifBelge = AYAR_SEKME_BELGESI[activeTab] || null;
  const aktifYukleme = aktifBelge ? ayarYukleme[aktifBelge] : null;
  const aktifOkundu = !!aktifYukleme && (aktifYukleme.durum === "tamam" || aktifYukleme.durum === "yok");
  const aktifDegisenSayisi = aktifBelge ? Object.keys(ayarBekleyen(aktifBelge)).length : 0;
  const inputStyle = { width: "100%", padding: "12px 16px", border: "1px solid #e2e8f0", borderRadius: "10px", fontSize: "14px", outline: "none", boxSizing: "border-box" };
  const labelStyle = { display: "block", fontSize: "14px", fontWeight: "600", color: "#1e293b", marginBottom: "8px" };
  const toggleStyle = (on) => ({ width: "50px", height: "26px", background: on ? "#16a34a" : "#cbd5e1", borderRadius: "13px", position: "relative", cursor: "pointer", transition: "background 0.3s", border: "none" });
  const toggleCircle = (on) => ({ width: "22px", height: "22px", background: "white", borderRadius: "50%", position: "absolute", top: "2px", left: on ? "26px" : "2px", transition: "left 0.3s", boxShadow: "0 1px 3px rgba(0,0,0,0.2)" });

  return (
    <div>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "24px" }}>
        <div><h1 style={{ fontSize: "24px", fontWeight: "700", color: "#1e293b", margin: "0 0 4px 0" }}>Ayarlar</h1><p style={{ fontSize: "14px", color: "#64748b", margin: 0 }}>Sistem ayarlarını yönetin</p></div>
        {/* İçerik filtresinin ve il/ilçe listesinin KENDİ düğmeleri var — toplu kaydet burada
            gizlenir ki yanlışlıkla "Değişiklikleri Kaydet"e basıp listenin kaydedildiği sanılmasın */}
        {aktifBelge && (() => {
          const kapali = saving || !aktifOkundu || aktifDegisenSayisi === 0;
          return (
            <button onClick={handleSave} disabled={kapali}
              title={!aktifOkundu ? `settings/${aktifBelge} okunmadı; kaydetme kapalı` : aktifDegisenSayisi === 0 ? "Bu sekmede değişiklik yok" : `settings/${aktifBelge}: ${Object.keys(ayarBekleyen(aktifBelge)).join(", ")}`}
              style={{ padding: "12px 24px", background: kapali ? "#94a3b8" : "linear-gradient(135deg, #16a34a, #22c55e)", color: "white", border: "none", borderRadius: "10px", fontSize: "14px", fontWeight: "600", cursor: kapali ? "not-allowed" : "pointer", display: "flex", alignItems: "center", gap: "8px" }}>
              {saving || (aktifYukleme && aktifYukleme.durum === "yukleniyor") ? <RefreshCw size={18} style={{ animation: "spin 1s linear infinite" }} /> : <CheckCircle size={18} />}
              {saving ? "Kaydediliyor..."
                : !aktifYukleme || aktifYukleme.durum === "yukleniyor" ? "Yükleniyor..."
                : aktifYukleme.durum === "hata" ? "Kaydetme kapalı"
                : aktifDegisenSayisi === 0 ? "Değişiklik yok"
                : `Değişiklikleri Kaydet (${aktifDegisenSayisi})`}
            </button>
          );
        })()}
      </div>

      <div style={{ display: "flex", gap: "8px", marginBottom: "24px", flexWrap: "wrap" }}>
        {tabs.map((t) => {
          const b = AYAR_SEKME_BELGESI[t.id];
          const bekleyen = b ? Object.keys(ayarBekleyen(b)).length : 0;
          const hatali = b && ayarYukleme[b] && ayarYukleme[b].durum === "hata";
          return (
            <button key={t.id} onClick={() => setActiveTab(t.id)} title={hatali ? `settings/${b} okunamadı` : bekleyen ? `${bekleyen} kaydedilmemiş değişiklik` : ""}
              style={{ padding: "10px 20px", background: activeTab === t.id ? "#1e1b4b" : "white", color: activeTab === t.id ? "white" : "#64748b", border: "1px solid #e2e8f0", borderRadius: "10px", fontSize: "14px", fontWeight: "500", cursor: "pointer", display: "flex", alignItems: "center", gap: "8px" }}>
              <t.icon size={18} />{t.label}
              {hatali ? <AlertTriangle size={14} color="#dc2626" /> : bekleyen > 0 ? <span style={{ width: "8px", height: "8px", borderRadius: "50%", background: "#f59e0b" }} /> : null}
            </button>
          );
        })}
      </div>

      {aktifYukleme && aktifYukleme.durum === "hata" && (
        <div style={{ padding: "14px 16px", background: "#fef2f2", border: "1px solid #fecaca", borderRadius: "12px", marginBottom: "16px", display: "flex", gap: "10px", alignItems: "center", flexWrap: "wrap" }}>
          <AlertTriangle size={20} color="#dc2626" style={{ flexShrink: 0 }} />
          <div style={{ fontSize: "13px", color: "#991b1b", flex: "1 1 300px" }}>
            <strong>settings/{aktifBelge} okunamadı</strong> ({String(aktifYukleme.hata)}). Ekrandaki değerler koddaki varsayılanlar, canlı değerler değil. Bu sekmede kaydetme kapalı; varsayılanlar yazılmaz.
          </div>
          <button onClick={() => ayarlariYukle([aktifBelge])} style={{ padding: "8px 14px", background: "#dc2626", color: "white", border: "none", borderRadius: "10px", fontSize: "13px", fontWeight: "600", cursor: "pointer" }}>Yeniden dene</button>
        </div>
      )}
      {aktifYukleme && aktifYukleme.durum === "yok" && (
        <div style={{ padding: "12px 16px", background: "#f8fafc", border: "1px solid #e2e8f0", borderRadius: "12px", marginBottom: "16px", fontSize: "13px", color: "#475569" }}>
          settings/{aktifBelge} belgesi henüz yok; ekrandaki değerler koddaki varsayılanlar. Kaydedince belge yalnızca değiştirdiğiniz alanlarla oluşturulur.
        </div>
      )}

      <div style={{ background: "white", borderRadius: "16px", padding: "24px", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
        {activeTab === "general" && (
          <div>
            <h2 style={{ fontSize: "18px", fontWeight: "600", color: "#1e293b", margin: "0 0 20px 0" }}>Genel Ayarlar</h2>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))", gap: "20px" }}>
              <div><label style={labelStyle}>Site Adı</label><input type="text" value={generalSettings.siteName} onChange={(e) => setGeneralSettings({ ...generalSettings, siteName: e.target.value })} style={inputStyle} /></div>
              <div><label style={labelStyle}>İletişim E-posta</label><input type="email" value={generalSettings.contactEmail} onChange={(e) => setGeneralSettings({ ...generalSettings, contactEmail: e.target.value })} style={inputStyle} /></div>
              <div><label style={labelStyle}>İletişim Telefon</label><input type="text" value={generalSettings.contactPhone} onChange={(e) => setGeneralSettings({ ...generalSettings, contactPhone: e.target.value })} style={inputStyle} /></div>
              <div><label style={labelStyle}>Adres</label><input type="text" value={generalSettings.address} onChange={(e) => setGeneralSettings({ ...generalSettings, address: e.target.value })} style={inputStyle} /></div>
            </div>
            <div style={{ marginTop: "20px" }}><label style={labelStyle}>Site Açıklaması</label><textarea value={generalSettings.siteDescription} onChange={(e) => setGeneralSettings({ ...generalSettings, siteDescription: e.target.value })} rows={3} style={{ ...inputStyle, resize: "vertical" }} /></div>
            <div style={{ marginTop: "24px", padding: "16px", background: "#fef3c7", borderRadius: "10px", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
              <div><p style={{ fontSize: "14px", fontWeight: "600", color: "#92400e", margin: "0 0 4px 0" }}>Bakım Modu</p><p style={{ fontSize: "13px", color: "#a16207", margin: 0 }}>Aktif olduğunda site ziyaretçilere kapalı olur</p></div>
              <button style={toggleStyle(generalSettings.maintenanceMode)} onClick={() => setGeneralSettings({ ...generalSettings, maintenanceMode: !generalSettings.maintenanceMode })}><div style={toggleCircle(generalSettings.maintenanceMode)} /></button>
            </div>
          </div>
        )}

        {activeTab === "commission" && (
          <div>
            <h2 style={{ fontSize: "18px", fontWeight: "600", color: "#1e293b", margin: "0 0 20px 0" }}>Komisyon Ayarları</h2>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", gap: "20px" }}>
              {[
                { label: "Uzman Komisyon Oranı (%)", key: "expertCommission", desc: "Her tamamlanan işten alınacak komisyon" },
                { label: "Premium İndirim Oranı (%)", key: "premiumDiscount", desc: "Premium üyelere uygulanan indirim" },
                { label: "Minimum İş Ücreti (₺)", key: "minJobPrice", desc: "İlan verilebilecek minimum tutar" },
                { label: "Maksimum İş Ücreti (₺)", key: "maxJobPrice", desc: "İlan verilebilecek maksimum tutar" },
              ].map((item) => (
                <div key={item.key} style={{ padding: "20px", background: "#f8fafc", borderRadius: "12px" }}>
                  <label style={labelStyle}>{item.label}</label>
                  <input type="number" value={commissionSettings[item.key]} onChange={(e) => setCommissionSettings({ ...commissionSettings, [item.key]: parseInt(e.target.value) || 0 })} style={inputStyle} min="0" />
                  <p style={{ fontSize: "12px", color: "#64748b", margin: "8px 0 0 0" }}>{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        )}

        {activeTab === "premium" && (
          <div>
            <h2 style={{ fontSize: "18px", fontWeight: "600", color: "#1e293b", margin: "0 0 20px 0" }}>Premium Üyelik Ayarları</h2>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", gap: "20px", marginBottom: "24px" }}>
              <div style={{ padding: "20px", background: "linear-gradient(135deg, #fef3c7, #fde68a)", borderRadius: "12px" }}><label style={{ ...labelStyle, color: "#92400e" }}>Aylık Üyelik Ücreti (₺)</label><input type="number" value={premiumSettings.monthlyPrice} onChange={(e) => setPremiumSettings({ ...premiumSettings, monthlyPrice: parseInt(e.target.value) || 0 })} style={inputStyle} min="0" /></div>
              <div style={{ padding: "20px", background: "linear-gradient(135deg, #d4af37, #f4e4a6)", borderRadius: "12px" }}><label style={{ ...labelStyle, color: "#78350f" }}>Yıllık Üyelik Ücreti (₺)</label><input type="number" value={premiumSettings.yearlyPrice} onChange={(e) => setPremiumSettings({ ...premiumSettings, yearlyPrice: parseInt(e.target.value) || 0 })} style={inputStyle} min="0" /></div>
              <div style={{ padding: "20px", background: "#f8fafc", borderRadius: "12px" }}><label style={labelStyle}>Deneme Süresi (Gün)</label><input type="number" value={premiumSettings.trialDays} onChange={(e) => setPremiumSettings({ ...premiumSettings, trialDays: parseInt(e.target.value) || 0 })} style={inputStyle} min="0" /></div>
            </div>
            <div>
              <label style={labelStyle}>Premium Özellikleri</label>
              <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                {premiumSettings.features.map((f, i) => (
                  <div key={i} style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <CheckCircle size={16} color="#16a34a" />
                    <input type="text" value={f} onChange={(e) => { const nf = [...premiumSettings.features]; nf[i] = e.target.value; setPremiumSettings({ ...premiumSettings, features: nf }); }} style={{ ...inputStyle, flex: 1 }} />
                    <button onClick={() => setPremiumSettings({ ...premiumSettings, features: premiumSettings.features.filter((_, idx) => idx !== i) })} style={{ padding: "8px", background: "#fee2e2", border: "none", borderRadius: "8px", cursor: "pointer" }}><Trash2 size={16} color="#dc2626" /></button>
                  </div>
                ))}
                <button onClick={() => setPremiumSettings({ ...premiumSettings, features: [...premiumSettings.features, "Yeni özellik"] })} style={{ padding: "10px", background: "#f0fdf4", border: "1px dashed #16a34a", borderRadius: "8px", color: "#16a34a", fontSize: "14px", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", gap: "8px" }}>
                  <span style={{ fontSize: "20px" }}>+</span> Yeni Özellik Ekle
                </button>
              </div>
            </div>
          </div>
        )}

        {activeTab === "notifications" && (
          <div>
            <h2 style={{ fontSize: "18px", fontWeight: "600", color: "#1e293b", margin: "0 0 20px 0" }}>Bildirim Ayarları</h2>
            <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
              {[
                { key: "emailNotifications", label: "E-posta Bildirimleri", desc: "Önemli güncellemeler e-posta ile gönderilsin" },
                { key: "pushNotifications", label: "Push Bildirimleri", desc: "Anlık bildirimler gönderilsin" },
                { key: "smsNotifications", label: "SMS Bildirimleri", desc: "Kritik uyarılar SMS ile gönderilsin" },
                { key: "newExpertAlert", label: "Yeni Uzman Uyarısı", desc: "Yeni uzman başvurusu olduğunda bildir" },
                { key: "newJobAlert", label: "Yeni İş İlanı Uyarısı", desc: "Yeni iş ilanı verildiğinde bildir" },
                { key: "complaintAlert", label: "Şikayet Uyarısı", desc: "Yeni şikayet geldiğinde bildir" },
                { key: "paymentAlert", label: "Ödeme Uyarısı", desc: "Yeni ödeme yapıldığında bildir" },
              ].map((item) => (
                <div key={item.key} style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "16px", background: "#f8fafc", borderRadius: "10px" }}>
                  <div><p style={{ fontSize: "14px", fontWeight: "600", color: "#1e293b", margin: "0 0 4px 0" }}>{item.label}</p><p style={{ fontSize: "13px", color: "#64748b", margin: 0 }}>{item.desc}</p></div>
                  <button style={toggleStyle(notificationSettings[item.key])} onClick={() => setNotificationSettings({ ...notificationSettings, [item.key]: !notificationSettings[item.key] })}><div style={toggleCircle(notificationSettings[item.key])} /></button>
                </div>
              ))}
            </div>
          </div>
        )}

        {activeTab === "moderation" && (
          <div>
            <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: "16px", flexWrap: "wrap", marginBottom: "20px" }}>
              <div>
                <h2 style={{ fontSize: "18px", fontWeight: "600", color: "#1e293b", margin: "0 0 4px 0" }}>İçerik Filtresi — Yasaklı Kelimeler</h2>
                <p style={{ fontSize: "13px", color: "#64748b", margin: 0 }}>
                  İlan, mesaj ve yorumlarda engellenen kelimeler (App Store Guideline 1.2)
                </p>
              </div>
              <button onClick={saveBannedWords} disabled={savingModeration || !moderationLoaded}
                style={{ padding: "12px 24px", background: savingModeration || !moderationLoaded ? "#94a3b8" : "linear-gradient(135deg, #16a34a, #22c55e)", color: "white", border: "none", borderRadius: "10px", fontSize: "14px", fontWeight: "600", cursor: savingModeration || !moderationLoaded ? "not-allowed" : "pointer", display: "flex", alignItems: "center", gap: "8px" }}>
                {savingModeration ? <RefreshCw size={18} style={{ animation: "spin 1s linear infinite" }} /> : <CheckCircle size={18} />}
                {savingModeration ? "Kaydediliyor..." : "Kelime Listesini Kaydet"}
              </button>
            </div>

            {/* Kritik davranış uyarısı */}
            <div style={{ padding: "14px 16px", background: "#fffbeb", border: "1px solid #fde68a", borderRadius: "12px", marginBottom: "16px", display: "flex", gap: "10px" }}>
              <AlertTriangle size={20} color="#d97706" style={{ flexShrink: 0, marginTop: "2px" }} />
              <div style={{ fontSize: "13px", color: "#92400e", lineHeight: "1.6" }}>
                <strong>Bu listenin etkisi uygulama sürümüne göre değişir:</strong>
                <ul style={{ margin: "4px 0 6px", paddingLeft: "20px" }}>
                  <li><strong>1.0.30 ve öncesi:</strong> liste koddaki {APP_DEFAULT_BANNED_WORDS.length} kelimelik listenin <u>yerine geçer</u>; dolu kaydedilirse yalnızca buradaki kelimeler engellenir.</li>
                  <li><strong>1.0.31 ve sonrası:</strong> liste koddaki {TEMEL_BANNED_WORDS.length} kelimelik listeye <u>eklenir</u>. Sunucu denetimi de aynı {TEMEL_BANNED_WORDS.length} kelimeye bu listeyi ekler.</li>
                </ul>
                Eski sürümler hâlâ kullanıldığı için listede <strong>her zaman {TEMEL_BANNED_WORDS.length} temel kelimenin hepsi bulunmalı</strong>.
                Eksik varsa "Eksik temel kelimeleri ekle" düğmesiyle ekleyin; listedeki diğer kelimeler korunur.
                Liste boş kaydedilirse her sürüm kendi kod listesine döner (1.0.30 ve öncesinde {APP_DEFAULT_BANNED_WORDS.length} kelime).<br />
                <span style={{ display: "inline-block", marginTop: "6px" }}>
                  ⏱ Değişiklik <strong>açık uygulama oturumlarına yansımaz</strong>; kullanıcı uygulamayı kapatıp açtığında geçerli olur.
                </span>
              </div>
            </div>

            {!moderationLoaded ? (
              <div style={{ padding: "30px", textAlign: "center", color: "#64748b", fontSize: "14px" }}>
                <RefreshCw size={24} style={{ animation: "spin 1s linear infinite" }} />
                <p style={{ margin: "10px 0 0" }}>Liste yükleniyor…</p>
              </div>
            ) : (
              <>
                <div style={{ padding: "12px 16px", background: moderationExists ? "#eef2ff" : "#f8fafc", border: "1px solid #e2e8f0", borderRadius: "10px", marginBottom: "16px", fontSize: "13px", color: "#475569" }}>
                  {moderationExists
                    ? <>Firestore'da <strong>settings/moderation</strong> kaydı var: <strong>{bannedWords.length}</strong> kelime. 1.0.30 ve öncesi yalnızca bu listeyi, 1.0.31 ve sonrası koddaki {TEMEL_BANNED_WORDS.length} kelimeyle birlikte bu listeyi kullanıyor.</>
                    : <>Henüz özel liste kaydedilmemiş: 1.0.30 ve öncesi koddaki <strong>{APP_DEFAULT_BANNED_WORDS.length}</strong>, 1.0.31 ve sonrası koddaki <strong>{TEMEL_BANNED_WORDS.length}</strong> kelimeyi kullanıyor.</>}
                </div>
                {eksikTemel.length > 0 && (
                  <div style={{ padding: "12px 16px", background: "#fef2f2", border: "1px solid #fecaca", borderRadius: "10px", marginBottom: "16px", fontSize: "13px", color: "#991b1b" }}>
                    <strong>Listede {eksikTemel.length} temel kelime eksik:</strong> {eksikTemel.join(", ")}. Bunlar 1.0.30 ve öncesinde engellenmez.
                  </div>
                )}

                {/* Kelime ekleme */}
                <div style={{ display: "flex", gap: "8px", marginBottom: "16px", flexWrap: "wrap" }}>
                  <input type="text" value={newWord} onChange={(e) => setNewWord(e.target.value)}
                    onKeyDown={(e) => { if (e.key === "Enter") { e.preventDefault(); addBannedWord(); } }}
                    placeholder="Kelime yazıp Enter'a basın"
                    style={{ ...inputStyle, flex: "1 1 240px", width: "auto" }} />
                  <button onClick={addBannedWord} disabled={!normalizeBannedWord(newWord)}
                    style={{ padding: "12px 20px", background: normalizeBannedWord(newWord) ? "#1e1b4b" : "#e2e8f0", color: normalizeBannedWord(newWord) ? "white" : "#94a3b8", border: "none", borderRadius: "10px", fontSize: "14px", fontWeight: "600", cursor: normalizeBannedWord(newWord) ? "pointer" : "not-allowed", display: "flex", alignItems: "center", gap: "6px" }}>
                    <Plus size={18} /> Ekle
                  </button>
                  <button onClick={seedFromDefaults} disabled={eksikTemel.length === 0}
                    title={eksikTemel.length ? eksikTemel.join(", ") : "Temel kelimelerin hepsi listede"}
                    style={{ padding: "12px 20px", background: "white", color: eksikTemel.length ? "#4f46e5" : "#94a3b8", border: "1px solid #c7d2fe", borderRadius: "10px", fontSize: "14px", fontWeight: "600", cursor: eksikTemel.length ? "pointer" : "not-allowed" }}>
                    Eksik temel kelimeleri ekle ({eksikTemel.length})
                  </button>
                </div>

                {/* Kelime listesi */}
                <div style={{ padding: "16px", background: "#f8fafc", borderRadius: "12px", minHeight: "90px" }}>
                  {bannedWords.length === 0 ? (
                    <p style={{ margin: 0, fontSize: "14px", color: "#94a3b8", textAlign: "center", padding: "16px 0" }}>
                      Liste boş. Kelime ekleyin veya eksik temel kelimeleri ekleyin.
                    </p>
                  ) : (
                    <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
                      {bannedWords.map((w) => (
                        <span key={w} style={{ display: "inline-flex", alignItems: "center", gap: "6px", padding: "6px 8px 6px 12px", background: "white", border: "1px solid #e2e8f0", borderRadius: "20px", fontSize: "13px", color: "#1e293b", fontWeight: "500" }}>
                          {w}
                          <button onClick={() => removeBannedWord(w)} title={`"${w}" kelimesini çıkar`}
                            style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "20px", height: "20px", padding: 0, background: "#fee2e2", color: "#dc2626", border: "none", borderRadius: "50%", cursor: "pointer" }}>
                            <X size={12} />
                          </button>
                        </span>
                      ))}
                    </div>
                  )}
                </div>
                <p style={{ fontSize: "12px", color: "#94a3b8", margin: "10px 0 0" }}>
                  {bannedWords.length} kelime · Kelimeler otomatik küçük harfe çevrilir. Uygulama rakam ikamelerini
                  (0→o, 1→i, 3→e, 4→a, 5→s) ve tekrar eden harfleri kendisi normalleştirir — varyantları ayrıca eklemeye gerek yok.
                </p>
              </>
            )}
          </div>
        )}

        {activeTab === "legal" && (
          <div>
            <h2 style={{ fontSize: "18px", fontWeight: "600", color: "#1e293b", margin: "0 0 8px 0" }}>Yasal Belgeler</h2>
            <p style={{ fontSize: "13px", color: "#64748b", margin: "0 0 24px 0" }}>Kullanıcılara gösterilecek yasal belgeleri düzenleyin. Bu metinler kayıt ekranında ve ayarlar sayfasında görüntülenir.</p>
            
            <div style={{ display: "flex", flexDirection: "column", gap: "24px" }}>
              <div>
                <label style={labelStyle}>Kullanım Koşulları</label>
                <p style={{ fontSize: "12px", color: "#64748b", margin: "0 0 8px 0" }}>Müşteri ve uzman kayıt ekranında gösterilir</p>
                <textarea 
                  value={legalDocuments.termsOfService} 
                  onChange={(e) => setLegalDocuments({ ...legalDocuments, termsOfService: e.target.value })} 
                  placeholder="Kullanım koşulları metnini buraya yazın..." 
                  rows={10} 
                  style={{ ...inputStyle, resize: "vertical", fontFamily: "inherit", lineHeight: "1.6" }} 
                />
                <p style={{ fontSize: "11px", color: "#94a3b8", margin: "6px 0 0 0" }}>{legalDocuments.termsOfService.length} karakter</p>
              </div>
              
              <div>
                <label style={labelStyle}>Gizlilik Politikası</label>
                <p style={{ fontSize: "12px", color: "#64748b", margin: "0 0 8px 0" }}>KVKK uyumlu gizlilik politikası metni</p>
                <textarea 
                  value={legalDocuments.privacyPolicy} 
                  onChange={(e) => setLegalDocuments({ ...legalDocuments, privacyPolicy: e.target.value })} 
                  placeholder="Gizlilik politikası metnini buraya yazın..." 
                  rows={10} 
                  style={{ ...inputStyle, resize: "vertical", fontFamily: "inherit", lineHeight: "1.6" }} 
                />
                <p style={{ fontSize: "11px", color: "#94a3b8", margin: "6px 0 0 0" }}>{legalDocuments.privacyPolicy.length} karakter</p>
              </div>
              
              <div>
                <label style={labelStyle}>Uzman Sözleşmesi</label>
                <p style={{ fontSize: "12px", color: "#64748b", margin: "0 0 8px 0" }}>Sadece uzman kayıt ekranında gösterilir</p>
                <textarea 
                  value={legalDocuments.expertAgreement} 
                  onChange={(e) => setLegalDocuments({ ...legalDocuments, expertAgreement: e.target.value })} 
                  placeholder="Uzman sözleşmesi metnini buraya yazın..." 
                  rows={10} 
                  style={{ ...inputStyle, resize: "vertical", fontFamily: "inherit", lineHeight: "1.6" }} 
                />
                <p style={{ fontSize: "11px", color: "#94a3b8", margin: "6px 0 0 0" }}>{legalDocuments.expertAgreement.length} karakter</p>
              </div>
            </div>
          </div>
        )}

        {activeTab === "locations" && <IlIlceYayinPanel />}

        {activeTab === "security" && (
          <div>
            <h2 style={{ fontSize: "18px", fontWeight: "600", color: "#1e293b", margin: "0 0 20px 0" }}>Güvenlik Ayarları</h2>
            <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>

              {/* Şifre Değiştirme Bölümü */}
              <AdminPasswordChange />

              <div style={{ height: "1px", background: "#e2e8f0" }} />

              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "16px", background: "#f8fafc", borderRadius: "10px" }}>
                <div><p style={{ fontSize: "14px", fontWeight: "600", color: "#1e293b", margin: "0 0 4px 0" }}>İki Faktörlü Doğrulama</p><p style={{ fontSize: "13px", color: "#64748b", margin: 0 }}>Admin girişlerinde 2FA zorunlu olsun</p></div>
                <button style={toggleStyle(securitySettings.twoFactorAuth)} onClick={() => setSecuritySettings({ ...securitySettings, twoFactorAuth: !securitySettings.twoFactorAuth })}><div style={toggleCircle(securitySettings.twoFactorAuth)} /></button>
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", gap: "20px" }}>
                <div><label style={labelStyle}>Maksimum Giriş Denemesi</label><input type="number" value={securitySettings.loginAttempts} onChange={(e) => setSecuritySettings({ ...securitySettings, loginAttempts: parseInt(e.target.value) || 0 })} style={inputStyle} min="1" max="10" /><p style={{ fontSize: "12px", color: "#64748b", margin: "8px 0 0 0" }}>Başarısız deneme sonrası hesap kilitlenir</p></div>
                <div><label style={labelStyle}>Oturum Zaman Aşımı (Dakika)</label><input type="number" value={securitySettings.sessionTimeout} onChange={(e) => setSecuritySettings({ ...securitySettings, sessionTimeout: parseInt(e.target.value) || 0 })} style={inputStyle} min="5" max="120" /><p style={{ fontSize: "12px", color: "#64748b", margin: "8px 0 0 0" }}>İşlem yapılmazsa oturum sonlanır</p></div>
              </div>
              <div><label style={labelStyle}>IP Beyaz Listesi</label><textarea value={securitySettings.ipWhitelist} onChange={(e) => setSecuritySettings({ ...securitySettings, ipWhitelist: e.target.value })} placeholder="Her satıra bir IP adresi yazın" rows={4} style={{ ...inputStyle, resize: "vertical" }} /></div>
              <div style={{ padding: "16px", background: "#fef2f2", borderRadius: "10px", display: "flex", alignItems: "flex-start", gap: "12px" }}>
                <AlertTriangle size={20} color="#dc2626" style={{ flexShrink: 0, marginTop: "2px" }} />
                <div><p style={{ fontSize: "14px", fontWeight: "600", color: "#991b1b", margin: "0 0 4px 0" }}>Dikkat!</p><p style={{ fontSize: "13px", color: "#b91c1c", margin: 0 }}>Güvenlik ayarlarını değiştirmeden önce dikkatli olun. Yanlış yapılandırma sisteme erişiminizi engelleyebilir.</p></div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

// ==================== SUPPORT TICKETS PAGE ====================
const SupportTicketsPage = ({ tickets, allTickets, updateTicket, initialFilter = null }) => {
  const [filter, setFilter] = useState(initialFilter || "all");
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [responseText, setResponseText] = useState("");

  const getStatusInfo = (status) => {
    switch (status) {
      case "pending": return { bg: "#fef3c7", color: "#d97706", text: "Bekliyor" };
      case "in_progress": return { bg: "#dbeafe", color: "#2563eb", text: "İnceleniyor" };
      case "resolved": return { bg: "#dcfce7", color: "#16a34a", text: "Çözüldü" };
      case "closed": return { bg: "#f1f5f9", color: "#64748b", text: "Kapatıldı" };
      default: return { bg: "#f1f5f9", color: "#64748b", text: status };
    }
  };

  const getTypeInfo = (type) => {
    switch (type) {
      case "account_suspension": return { icon: "🔒", text: "Hesap Askıya Alındı" };
      case "document_rejected": return { icon: "📄", text: "Belge Reddedildi" };
      case "payment_issue": return { icon: "💳", text: "Ödeme Sorunu" };
      case "technical": return { icon: "🔧", text: "Teknik Sorun" };
      case "general": return { icon: "💬", text: "Genel" };
      default: return { icon: "📩", text: type || "Diğer" };
    }
  };

  const getPriorityInfo = (priority) => {
    switch (priority) {
      case "high": return { bg: "#fee2e2", color: "#dc2626", text: "Yüksek" };
      case "medium": return { bg: "#fef3c7", color: "#d97706", text: "Orta" };
      case "low": return { bg: "#dcfce7", color: "#16a34a", text: "Düşük" };
      default: return { bg: "#f1f5f9", color: "#64748b", text: "Normal" };
    }
  };

  const filtered = filter === "all" ? tickets : tickets.filter((t) => t.status === filter);
  const sorted = [...filtered].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

  const handleRespond = (ticketId, newStatus) => {
    updateTicket(ticketId, newStatus, responseText);
    setResponseText("");
    setSelectedTicket(null);
  };

  return (
    <div>
      {/* Header */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "24px", flexWrap: "wrap", gap: "16px" }}>
        <div>
          <h1 style={{ fontSize: "24px", fontWeight: "700", color: "#1e293b", margin: "0 0 4px 0" }}>Destek Talepleri</h1>
          <p style={{ fontSize: "14px", color: "#64748b", margin: 0 }}>
            {tickets.length !== allTickets.length ? `${tickets.length} / ${allTickets.length} talep (arama sonucu)` : `Toplam ${tickets.length} talep`}
          </p>
        </div>
        <div style={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
          {[
            { id: "all", label: "Tümü" },
            { id: "pending", label: "Bekleyen" },
            { id: "in_progress", label: "İncelenen" },
            { id: "resolved", label: "Çözülen" },
            { id: "closed", label: "Kapatılan" },
          ].map((f) => (
            <button
              key={f.id}
              onClick={() => setFilter(f.id)}
              style={{
                padding: "8px 16px",
                background: filter === f.id ? "#6366f1" : "white",
                color: filter === f.id ? "white" : "#64748b",
                border: "1px solid #e2e8f0",
                borderRadius: "8px",
                fontSize: "13px",
                fontWeight: "500",
                cursor: "pointer",
              }}
            >
              {f.label}
            </button>
          ))}
        </div>
      </div>

      {/* Tickets List */}
      {sorted.length === 0 ? (
        <div style={{ textAlign: "center", padding: "60px", background: "white", borderRadius: "16px" }}>
          <MessageSquare size={48} color="#cbd5e1" style={{ marginBottom: "16px" }} />
          <p style={{ fontSize: "16px", color: "#64748b" }}>Destek talebi bulunamadı</p>
        </div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          {sorted.map((ticket) => {
            const statusInfo = getStatusInfo(ticket.status);
            const typeInfo = getTypeInfo(ticket.type);
            const priorityInfo = getPriorityInfo(ticket.priority);
            
            return (
              <div
                key={ticket.id}
                style={{
                  background: "white",
                  borderRadius: "16px",
                  padding: "20px",
                  boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
                  border: ticket.priority === "high" ? "2px solid #fee2e2" : "1px solid #f1f5f9",
                }}
              >
                <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", marginBottom: "12px" }}>
                  <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                    <div style={{ fontSize: "24px" }}>{typeInfo.icon}</div>
                    <div>
                      <div style={{ display: "flex", alignItems: "center", gap: "8px", flexWrap: "wrap" }}>
                        <h3 style={{ fontSize: "16px", fontWeight: "600", color: "#1e293b", margin: 0 }}>
                          {ticket.subject || typeInfo.text}
                        </h3>
                        <span style={{ padding: "2px 8px", background: statusInfo.bg, color: statusInfo.color, borderRadius: "6px", fontSize: "11px", fontWeight: "600" }}>
                          {statusInfo.text}
                        </span>
                        <span style={{ padding: "2px 8px", background: priorityInfo.bg, color: priorityInfo.color, borderRadius: "6px", fontSize: "11px", fontWeight: "600" }}>
                          {priorityInfo.text}
                        </span>
                      </div>
                      <p style={{ fontSize: "12px", color: "#64748b", margin: "4px 0 0 0" }}>
                        #{ticket.id.slice(-6).toUpperCase()} • {ticket.userName || "Anonim"} • {ticket.userEmail || "-"}
                      </p>
                    </div>
                  </div>
                  <span style={{ fontSize: "12px", color: "#94a3b8" }}>
                    {ticket.createdAt ? new Date(ticket.createdAt).toLocaleDateString("tr-TR", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" }) : "-"}
                  </span>
                </div>

                {/* Message */}
                <div style={{ padding: "12px", background: "#f8fafc", borderRadius: "10px", marginBottom: "12px" }}>
                  <p style={{ fontSize: "14px", color: "#334155", margin: 0, lineHeight: "1.6" }}>
                    {ticket.message || "-"}
                  </p>
                </div>

                {/* Contact Info */}
                {(ticket.contactEmail || ticket.contactPhone) && (
                  <div style={{ display: "flex", gap: "16px", marginBottom: "12px", flexWrap: "wrap" }}>
                    {ticket.contactEmail && (
                      <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                        <Mail size={14} color="#64748b" />
                        <span style={{ fontSize: "13px", color: "#64748b" }}>{ticket.contactEmail}</span>
                      </div>
                    )}
                    {ticket.contactPhone && (
                      <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                        <Phone size={14} color="#64748b" />
                        <span style={{ fontSize: "13px", color: "#64748b" }}>{ticket.contactPhone}</span>
                      </div>
                    )}
                  </div>
                )}

                {/* Conversation History */}
                {ticket.messages && ticket.messages.length > 1 && (
                  <div style={{ marginBottom: "12px" }}>
                    <p style={{ fontSize: "12px", fontWeight: "600", color: "#64748b", marginBottom: "8px" }}>Mesaj Geçmişi:</p>
                    <div style={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                      {ticket.messages.slice(1).map((msg, i) => (
                        <div key={i} style={{ 
                          padding: "10px", 
                          background: msg.sender === "admin" ? "#e0e7ff" : "#f1f5f9", 
                          borderRadius: "8px",
                          borderLeft: msg.sender === "admin" ? "3px solid #6366f1" : "none",
                        }}>
                          <p style={{ fontSize: "11px", color: "#64748b", marginBottom: "4px" }}>
                            {msg.sender === "admin" ? "👤 Admin" : "📩 Kullanıcı"} • {new Date(msg.timestamp).toLocaleString("tr-TR")}
                          </p>
                          <p style={{ fontSize: "13px", color: "#334155", margin: 0 }}>{msg.message}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {/* Actions */}
                {ticket.status !== "closed" && (
                  <div style={{ display: "flex", gap: "8px", flexWrap: "wrap", paddingTop: "12px", borderTop: "1px solid #f1f5f9" }}>
                    {ticket.status === "pending" && (
                      <button
                        onClick={() => updateTicket(ticket.id, "in_progress", "")}
                        style={{ padding: "8px 16px", background: "#dbeafe", color: "#2563eb", border: "none", borderRadius: "8px", fontSize: "13px", fontWeight: "600", cursor: "pointer" }}
                      >
                        İncelemeye Al
                      </button>
                    )}
                    <button
                      onClick={() => setSelectedTicket(selectedTicket === ticket.id ? null : ticket.id)}
                      style={{ padding: "8px 16px", background: "#e0e7ff", color: "#4f46e5", border: "none", borderRadius: "8px", fontSize: "13px", fontWeight: "600", cursor: "pointer" }}
                    >
                      {selectedTicket === ticket.id ? "İptal" : "Yanıtla"}
                    </button>
                    {ticket.contactEmail && (
                      <a
                        href={`mailto:${ticket.contactEmail}?subject=${encodeURIComponent(`İşe Bak Destek - #${ticket.id.slice(-6).toUpperCase()}`)}&body=${encodeURIComponent(`Merhaba,\n\n${ticket.id.slice(-6).toUpperCase()} numaralı destek talebiniz hakkında:\n\nTalebiniz: "${ticket.message?.slice(0, 100)}${ticket.message?.length > 100 ? '...' : ''}"\n\nYanıtımız:\n\n\n---\nİşe Bak Destek Ekibi`)}`}
                        style={{ padding: "8px 16px", background: "#fef3c7", color: "#d97706", border: "none", borderRadius: "8px", fontSize: "13px", fontWeight: "600", cursor: "pointer", textDecoration: "none", display: "flex", alignItems: "center", gap: "4px" }}
                      >
                        <Mail size={14} />
                        E-posta
                      </a>
                    )}
                    <button
                      onClick={() => updateTicket(ticket.id, "resolved", "")}
                      style={{ padding: "8px 16px", background: "#dcfce7", color: "#16a34a", border: "none", borderRadius: "8px", fontSize: "13px", fontWeight: "600", cursor: "pointer" }}
                    >
                      Çözüldü
                    </button>
                    <button
                      onClick={() => updateTicket(ticket.id, "closed", "")}
                      style={{ padding: "8px 16px", background: "#f1f5f9", color: "#64748b", border: "none", borderRadius: "8px", fontSize: "13px", fontWeight: "600", cursor: "pointer" }}
                    >
                      Kapat
                    </button>
                  </div>
                )}

                {/* Response Form */}
                {selectedTicket === ticket.id && (
                  <div style={{ marginTop: "12px", padding: "16px", background: "#f8fafc", borderRadius: "12px" }}>
                    <textarea
                      value={responseText}
                      onChange={(e) => setResponseText(e.target.value)}
                      placeholder="Yanıtınızı yazın..."
                      rows={3}
                      style={{
                        width: "100%",
                        padding: "12px",
                        border: "1px solid #e2e8f0",
                        borderRadius: "10px",
                        fontSize: "14px",
                        resize: "vertical",
                        marginBottom: "12px",
                        boxSizing: "border-box",
                      }}
                    />
                    <div style={{ display: "flex", gap: "8px" }}>
                      <button
                        onClick={() => handleRespond(ticket.id, "in_progress")}
                        disabled={!responseText.trim()}
                        style={{
                          padding: "10px 20px",
                          background: responseText.trim() ? "linear-gradient(135deg, #6366f1, #8b5cf6)" : "#cbd5e1",
                          color: "white",
                          border: "none",
                          borderRadius: "8px",
                          fontSize: "14px",
                          fontWeight: "600",
                          cursor: responseText.trim() ? "pointer" : "not-allowed",
                        }}
                      >
                        Yanıt Gönder
                      </button>
                      <button
                        onClick={() => handleRespond(ticket.id, "resolved")}
                        disabled={!responseText.trim()}
                        style={{
                          padding: "10px 20px",
                          background: responseText.trim() ? "#dcfce7" : "#f1f5f9",
                          color: responseText.trim() ? "#16a34a" : "#94a3b8",
                          border: "none",
                          borderRadius: "8px",
                          fontSize: "14px",
                          fontWeight: "600",
                          cursor: responseText.trim() ? "pointer" : "not-allowed",
                        }}
                      >
                        Yanıtla & Çözüldü
                      </button>
                      {ticket.contactEmail && responseText.trim() && (
                        <a
                          href={`mailto:${ticket.contactEmail}?subject=${encodeURIComponent(`İşe Bak Destek Talebi #${ticket.id.slice(-6).toUpperCase()} - Yanıt`)}&body=${encodeURIComponent(`Merhaba,\n\n${ticket.id.slice(-6).toUpperCase()} numaralı destek talebinize yanıt:\n\n${responseText}\n\n---\nİşe Bak Destek Ekibi`)}`}
                          style={{
                            padding: "10px 20px",
                            background: "#fef3c7",
                            color: "#d97706",
                            border: "none",
                            borderRadius: "8px",
                            fontSize: "14px",
                            fontWeight: "600",
                            textDecoration: "none",
                            display: "flex",
                            alignItems: "center",
                            gap: "6px",
                          }}
                        >
                          <Mail size={16} />
                          E-posta Gönder
                        </a>
                      )}
                    </div>
                    {ticket.contactEmail && (
                      <p style={{ fontSize: "11px", color: "#94a3b8", marginTop: "8px", margin: "8px 0 0 0" }}>
                        💡 "E-posta Gönder" ile yanıtınızı doğrudan kullanıcıya iletebilirsiniz.
                      </p>
                    )}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

// ==================== CATEGORIES PAGE ====================
const CategoriesPage = () => {
  const [categories, setCategories] = useState([]);
  const [catLoading, setCatLoading] = useState(true);
  const [editingCat, setEditingCat] = useState(null);
  const [showAdd, setShowAdd] = useState(false);
  const [newCat, setNewCat] = useState({ name: "", icon: "📋", color: "#3b82f6", subCategories: [] });
  const [newSubName, setNewSubName] = useState("");
  const [newSubIcon, setNewSubIcon] = useState("🔧");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const loadCategories = async () => {
      try {
        const snapshot = await getDocs(collection(db, "categories"));
        const cats = snapshot.docs.map((d) => ({ docId: d.id, ...d.data() }));
        cats.sort((a, b) => (a.id || 0) - (b.id || 0));
        setCategories(cats);
      } catch (error) { console.error("Kategori yükleme hatası:", error); }
      finally { setCatLoading(false); }
    };
    loadCategories();
  }, []);

  const handleSaveCategory = async (catData, isNew) => {
    setSaving(true);
    try {
      if (isNew) {
        const newId = categories.length > 0 ? Math.max(...categories.map((c) => c.id || 0)) + 1 : 1;
        const subCats = (catData.subCategories || []).map((s, i) => ({
          id: newId * 100 + i + 1, name: s.name, icon: s.icon || "🔧",
        }));
        await addDoc(collection(db, "categories"), { ...catData, id: newId, subCategories: subCats });
      } else {
        await updateDoc(doc(db, "categories", catData.docId), {
          name: catData.name, icon: catData.icon, color: catData.color, subCategories: catData.subCategories || [],
        });
      }
      const snapshot = await getDocs(collection(db, "categories"));
      const cats = snapshot.docs.map((d) => ({ docId: d.id, ...d.data() }));
      cats.sort((a, b) => (a.id || 0) - (b.id || 0));
      setCategories(cats);
      setShowAdd(false); setEditingCat(null); setNewCat({ name: "", icon: "📋", color: "#3b82f6", subCategories: [] });
      alert(isNew ? "Kategori eklendi!" : "Kategori güncellendi!");
    } catch (error) { console.error("Kategori kaydetme hatası:", error); alert("Hata oluştu!"); }
    finally { setSaving(false); }
  };

  const handleDeleteCategory = async (catDocId) => {
    if (!window.confirm("Bu kategoriyi silmek istediğinizden emin misiniz?")) return;
    try {
      await deleteDoc(doc(db, "categories", catDocId));
      setCategories((prev) => prev.filter((c) => c.docId !== catDocId));
      alert("Kategori silindi!");
    } catch (error) { console.error("Kategori silme hatası:", error); alert("Hata oluştu!"); }
  };

  const inputStyle = { width: "100%", padding: "12px 16px", border: "1px solid #e2e8f0", borderRadius: "10px", fontSize: "14px", outline: "none", boxSizing: "border-box" };

  if (catLoading) return <div style={{ display: "flex", justifyContent: "center", padding: "60px" }}><RefreshCw size={36} color="#6366f1" style={{ animation: "spin 1s linear infinite" }} /></div>;

  return (
    <div>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "24px" }}>
        <div><h1 style={{ fontSize: "24px", fontWeight: "700", color: "#1e293b", margin: "0 0 4px 0" }}>Kategori Yönetimi</h1><p style={{ fontSize: "14px", color: "#64748b", margin: 0 }}>Hizmet kategorilerini yönetin — uygulama ile senkronize</p></div>
        <button onClick={() => setShowAdd(true)} style={{ padding: "12px 20px", background: "linear-gradient(135deg, #6366f1, #8b5cf6)", color: "white", border: "none", borderRadius: "10px", fontSize: "14px", fontWeight: "600", cursor: "pointer", display: "flex", alignItems: "center", gap: "8px" }}>
          <Plus size={18} /> Yeni Kategori
        </button>
      </div>

      {(showAdd || editingCat) && (
        <div style={{ background: "white", borderRadius: "16px", padding: "24px", marginBottom: "24px", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
          <h2 style={{ fontSize: "18px", fontWeight: "600", color: "#1e293b", margin: "0 0 20px 0" }}>{editingCat ? "Kategori Düzenle" : "Yeni Kategori"}</h2>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "16px", marginBottom: "20px" }}>
            <div><label style={{ display: "block", fontSize: "13px", fontWeight: "600", color: "#64748b", marginBottom: "6px" }}>Kategori Adı</label><input type="text" value={editingCat ? editingCat.name : newCat.name} onChange={(e) => editingCat ? setEditingCat({ ...editingCat, name: e.target.value }) : setNewCat({ ...newCat, name: e.target.value })} style={inputStyle} /></div>
            <div><label style={{ display: "block", fontSize: "13px", fontWeight: "600", color: "#64748b", marginBottom: "6px" }}>İkon (Emoji)</label><input type="text" value={editingCat ? editingCat.icon : newCat.icon} onChange={(e) => editingCat ? setEditingCat({ ...editingCat, icon: e.target.value }) : setNewCat({ ...newCat, icon: e.target.value })} style={inputStyle} /></div>
            <div><label style={{ display: "block", fontSize: "13px", fontWeight: "600", color: "#64748b", marginBottom: "6px" }}>Renk</label><input type="color" value={editingCat ? editingCat.color : newCat.color} onChange={(e) => editingCat ? setEditingCat({ ...editingCat, color: e.target.value }) : setNewCat({ ...newCat, color: e.target.value })} style={{ ...inputStyle, height: "44px", cursor: "pointer" }} /></div>
          </div>
          <div style={{ marginBottom: "20px" }}>
            <label style={{ display: "block", fontSize: "13px", fontWeight: "600", color: "#64748b", marginBottom: "8px" }}>Alt Kategoriler</label>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "8px", marginBottom: "12px" }}>
              {(editingCat ? editingCat.subCategories : newCat.subCategories || []).map((sub, i) => (
                <span key={i} style={{ display: "inline-flex", alignItems: "center", gap: "6px", padding: "6px 12px", background: "#f1f5f9", borderRadius: "8px", fontSize: "13px" }}>
                  {sub.icon} {sub.name}
                  <button onClick={() => { if (editingCat) setEditingCat({ ...editingCat, subCategories: editingCat.subCategories.filter((_, idx) => idx !== i) }); else setNewCat({ ...newCat, subCategories: newCat.subCategories.filter((_, idx) => idx !== i) }); }} style={{ background: "none", border: "none", cursor: "pointer", color: "#dc2626", fontSize: "14px", padding: "0 2px" }}>✕</button>
                </span>
              ))}
            </div>
            <div style={{ display: "flex", gap: "8px" }}>
              <input type="text" placeholder="İkon" value={newSubIcon} onChange={(e) => setNewSubIcon(e.target.value)} style={{ ...inputStyle, width: "80px" }} />
              <input type="text" placeholder="Alt kategori adı" value={newSubName} onChange={(e) => setNewSubName(e.target.value)} style={{ ...inputStyle, flex: 1 }} />
              <button onClick={() => { if (!newSubName.trim()) return; const sub = { name: newSubName, icon: newSubIcon || "🔧" }; if (editingCat) setEditingCat({ ...editingCat, subCategories: [...(editingCat.subCategories || []), sub] }); else setNewCat({ ...newCat, subCategories: [...(newCat.subCategories || []), sub] }); setNewSubName(""); setNewSubIcon("🔧"); }} style={{ padding: "10px 16px", background: "#e0e7ff", border: "none", borderRadius: "10px", cursor: "pointer", color: "#4f46e5", fontWeight: "600" }}>Ekle</button>
            </div>
          </div>
          <div style={{ display: "flex", gap: "10px" }}>
            <button onClick={() => handleSaveCategory(editingCat || newCat, !editingCat)} disabled={saving} style={{ padding: "12px 24px", background: saving ? "#94a3b8" : "linear-gradient(135deg, #16a34a, #22c55e)", color: "white", border: "none", borderRadius: "10px", fontWeight: "600", cursor: saving ? "not-allowed" : "pointer" }}>{saving ? "Kaydediliyor..." : "Kaydet"}</button>
            <button onClick={() => { setShowAdd(false); setEditingCat(null); }} style={{ padding: "12px 24px", background: "#f1f5f9", color: "#64748b", border: "none", borderRadius: "10px", fontWeight: "600", cursor: "pointer" }}>İptal</button>
          </div>
        </div>
      )}

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(320px, 1fr))", gap: "16px" }}>
        {categories.map((cat) => (
          <div key={cat.docId} style={{ background: "white", borderRadius: "16px", padding: "20px", boxShadow: "0 1px 3px rgba(0,0,0,0.05)", borderLeft: "4px solid " + (cat.color || "#6366f1") }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "12px" }}>
              <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <span style={{ fontSize: "28px" }}>{cat.icon}</span>
                <div><h3 style={{ fontSize: "16px", fontWeight: "700", color: "#1e293b", margin: 0 }}>{cat.name}</h3><span style={{ fontSize: "12px", color: "#64748b" }}>{(cat.subCategories || []).length} alt kategori</span></div>
              </div>
              <div style={{ display: "flex", gap: "6px" }}>
                <button onClick={() => setEditingCat({ ...cat })} style={{ padding: "8px", background: "#e0e7ff", border: "none", borderRadius: "8px", cursor: "pointer" }}><Edit3 size={16} color="#4f46e5" /></button>
                <button onClick={() => handleDeleteCategory(cat.docId)} style={{ padding: "8px", background: "#fee2e2", border: "none", borderRadius: "8px", cursor: "pointer" }}><Trash2 size={16} color="#dc2626" /></button>
              </div>
            </div>
            <div style={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
              {(cat.subCategories || []).map((sub, i) => (
                <span key={i} style={{ padding: "4px 10px", background: (cat.color || "#6366f1") + "15", borderRadius: "6px", fontSize: "12px", color: cat.color || "#6366f1", fontWeight: "500" }}>{sub.icon} {sub.name}</span>
              ))}
            </div>
          </div>
        ))}
      </div>
      {categories.length === 0 && <p style={{ textAlign: "center", color: "#94a3b8", padding: "40px", fontSize: "15px" }}>Henüz kategori eklenmemiş.</p>}
    </div>
  );
};